// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6.04 5.99%27%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23bec5cf;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3EAsset 1%3C/title%3E%3Cg id=%27Layer_2%27 data-name=%27Layer 2%27%3E%3Cg id=%27Layer_1-2%27 data-name=%27Layer 1%27%3E%3Crect class=%27cls-1%27 x=%271.01%27 y=%273.99%27 width=%271.01%27 height=%271%27/%3E%3Crect class=%27cls-1%27 y=%274.99%27 width=%271.01%27 height=%271%27/%3E%3Crect class=%27cls-1%27 x=%273.02%27 y=%272%27 width=%271.01%27 height=%271%27/%3E%3Crect class=%27cls-1%27 x=%272.01%27 y=%272.99%27 width=%271.01%27 height=%271%27/%3E%3Crect class=%27cls-1%27 x=%275.04%27 width=%271.01%27 height=%271%27/%3E%3Crect class=%27cls-1%27 x=%274.03%27 y=%271%27 width=%271.01%27 height=%271%27/%3E%3C/g%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg width=%2710%27 height=%2711%27 viewBox=%270 0 10 11%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M8.70383 0.5L5 4.20383L1.29617 0.5L0 1.79617L3.70386 5.5L0 9.20383L1.29617 10.5L5 6.79614L8.70383 10.5L10 9.20383L6.29617 5.5L10 1.79617L8.70383 0.5Z%27 fill=%27%238695A8%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278.07%27 height=%274.74%27 viewBox=%270 0 8.07 4.74%27%3E%3Cpolyline points=%277.57 0.5 4.04 4.04 0.5 0.5%27 fill=%27none%27 stroke=%27%236d7884%27 stroke-linecap=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278.07%27 height=%274.74%27 viewBox=%270 0 8.07 4.74%27%3E%3Cpolyline points=%277.57 0.5 4.04 4.04 0.5 0.5%27 fill=%27none%27 stroke=%27%23DB3434%27 stroke-linecap=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278.07%27 height=%274.74%27 viewBox=%270 0 8.07 4.74%27%3E%3Cpolyline points=%277.57 0.5 4.04 4.04 0.5 0.5%27 fill=%27none%27 stroke=%27%233CA854%27 stroke-linecap=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3E%3Ctitle%3E_%3C/title%3E%3Cpath fill=%27%23db3434%27 d=%27M12,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22ZM12,4a8,8,0,1,0,8,8A8,8,0,0,0,12,4ZM11,6h2v7H11V6Zm1,11.25A1.25,1.25,0,1,1,13.25,16,1.25,1.25,0,0,1,12,17.25Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27100%27 height=%2719%27 viewBox=%270 0 100 19%27 %3E%3Cpath d=%27M0,3.5c12.5,0,12.5,12,25,12s12.5-12,25-12,12.5,12,25,12,12.5-12,25-12%27 fill=%27none%27 stroke=%27%23d2d7dd%27 stroke-miterlimit=%2710%27 stroke-width=%276%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
[data-v-97867cb6]:root {
  --vl-theme-primary-color: #ffe615;
  --vl-theme-primary-color-60: rgb(100%, 94.1176470588%, 44.9411764706%);
  --vl-theme-primary-color-70: rgb(100%, 93.137254902%, 35.7647058824%);
  --vl-theme-primary-color-rgba-30: rgba(255, 230, 21, 0.3);
  --vl-theme-fg-color: #333332;
  --vl-theme-fg-color-60: rgb(52%, 52%, 51.7647058824%);
  --vl-theme-fg-color-70: rgb(44%, 44%, 43.7254901961%);
}
.vl-vi[data-v-97867cb6]::before, .vl-vi[data-v-97867cb6]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
  display: inline-block;
  vertical-align: middle;
}
.vl-vi.vl-vi-u-180deg[data-v-97867cb6]::before {
  display: inline-block;
  transform: rotate(180deg);
  vertical-align: middle;
}
.vl-vi-u-xs[data-v-97867cb6]::before {
  font-size: 0.8rem;
}
.vl-vi-u-s[data-v-97867cb6]::before {
  font-size: 1.3rem;
}
.vl-vi-u-m[data-v-97867cb6]::before {
  font-size: 1.7rem;
}
.vl-vi-u-l[data-v-97867cb6]::before {
  font-size: 2rem;
}
.vl-vi-u-xl[data-v-97867cb6]::before {
  font-size: 2.2rem;
}
.vl-vi-u-90deg[data-v-97867cb6]::before {
  display: inline-block;
  transform: rotate(90deg);
}
.vl-vi-u-180deg[data-v-97867cb6]::before {
  display: inline-block;
  transform: rotate(180deg);
}
html[data-v-97867cb6], body[data-v-97867cb6], div[data-v-97867cb6], span[data-v-97867cb6], applet[data-v-97867cb6], object[data-v-97867cb6], iframe[data-v-97867cb6],
h1[data-v-97867cb6], h2[data-v-97867cb6], h3[data-v-97867cb6], h4[data-v-97867cb6], h5[data-v-97867cb6], h6[data-v-97867cb6], p[data-v-97867cb6], blockquote[data-v-97867cb6], pre[data-v-97867cb6],
a[data-v-97867cb6], abbr[data-v-97867cb6], acronym[data-v-97867cb6], address[data-v-97867cb6], big[data-v-97867cb6], cite[data-v-97867cb6], code[data-v-97867cb6],
del[data-v-97867cb6], dfn[data-v-97867cb6], em[data-v-97867cb6], img[data-v-97867cb6], ins[data-v-97867cb6], kbd[data-v-97867cb6], q[data-v-97867cb6], s[data-v-97867cb6], samp[data-v-97867cb6],
small[data-v-97867cb6], strike[data-v-97867cb6], strong[data-v-97867cb6], sub[data-v-97867cb6], sup[data-v-97867cb6], tt[data-v-97867cb6], var[data-v-97867cb6],
b[data-v-97867cb6], u[data-v-97867cb6], i[data-v-97867cb6], center[data-v-97867cb6],
dl[data-v-97867cb6], dt[data-v-97867cb6], dd[data-v-97867cb6], ol[data-v-97867cb6], ul[data-v-97867cb6], li[data-v-97867cb6],
fieldset[data-v-97867cb6], form[data-v-97867cb6], label[data-v-97867cb6], legend[data-v-97867cb6],
table[data-v-97867cb6], caption[data-v-97867cb6], tbody[data-v-97867cb6], tfoot[data-v-97867cb6], thead[data-v-97867cb6], tr[data-v-97867cb6], th[data-v-97867cb6], td[data-v-97867cb6],
article[data-v-97867cb6], aside[data-v-97867cb6], canvas[data-v-97867cb6], details[data-v-97867cb6], embed[data-v-97867cb6],
figure[data-v-97867cb6], figcaption[data-v-97867cb6], footer[data-v-97867cb6], header[data-v-97867cb6], hgroup[data-v-97867cb6],
menu[data-v-97867cb6], nav[data-v-97867cb6], output[data-v-97867cb6], ruby[data-v-97867cb6], section[data-v-97867cb6], summary[data-v-97867cb6],
time[data-v-97867cb6], mark[data-v-97867cb6], audio[data-v-97867cb6], video[data-v-97867cb6] {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
strong[data-v-97867cb6] {
  font-weight: 500;
}

/* HTML5 display-role reset for older browsers */
article[data-v-97867cb6], aside[data-v-97867cb6], details[data-v-97867cb6], figcaption[data-v-97867cb6], figure[data-v-97867cb6],
footer[data-v-97867cb6], header[data-v-97867cb6], hgroup[data-v-97867cb6], menu[data-v-97867cb6], nav[data-v-97867cb6], section[data-v-97867cb6] {
  display: block;
}
body[data-v-97867cb6] {
  line-height: 1;
}
ol[data-v-97867cb6], ul[data-v-97867cb6] {
  list-style: none;
}
blockquote[data-v-97867cb6], q[data-v-97867cb6] {
  quotes: none;
}
blockquote[data-v-97867cb6]:before, blockquote[data-v-97867cb6]:after,
q[data-v-97867cb6]:before, q[data-v-97867cb6]:after {
  content: "";
  content: none;
}
table[data-v-97867cb6] {
  border-collapse: collapse;
  border-spacing: 0;
}
button[data-v-97867cb6] {
  background: transparent;
}
img[data-v-97867cb6] {
  max-width: 100%;
}
button[data-v-97867cb6]::-moz-focus-inner {
  border: 0;
}
[data-v-97867cb6]:-moz-submit-invalid {
  box-shadow: none;
}
[data-v-97867cb6]:-moz-ui-invalid {
  box-shadow: none;
}
*[data-v-97867cb6] {
  box-sizing: border-box;
}
*[data-v-97867cb6]::before, *[data-v-97867cb6]::after {
  box-sizing: inherit;
}
html[data-v-97867cb6] {
  min-height: 100%;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 62.5%;
}
body[data-v-97867cb6] {
  width: 100%;
  min-height: 100%;
  background: #fff;
  color: #333332;
  font-size: 1.8rem;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-text-size-adjust: none;
}
@media screen and (max-width: 767px) {
body[data-v-97867cb6] {
    font-size: 1.6rem;
    line-height: 1.33;
}
}
body[data-v-97867cb6]::before {
  display: none;
  content: "large";
}
@media screen and (max-width: 1023px) {
body[data-v-97867cb6]::before {
    content: "medium";
}
}
@media screen and (min-width: 767px) {
body[data-v-97867cb6]::before {
    content: "medium-up";
}
}
@media screen and (max-width: 767px) {
body[data-v-97867cb6]::before {
    content: "small";
}
}
@media screen and (max-width: 500px) {
body[data-v-97867cb6]::before {
    content: "xsmall";
}
}
@media screen and (min-width: 1600px) {
body[data-v-97867cb6]::before {
    content: "xlarge";
}
}
@font-face {
  font-family: "Flanders Art Sans";
  src: url("/font/flanders/sans/FlandersArtSans-Light.woff2") format("woff2"), url("/font/flanders/sans/FlandersArtSans-Light.woff") format("woff");
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: "Flanders Art Sans";
  src: url("/font/flanders/sans/FlandersArtSans-Regular.woff2") format("woff2"), url("/font/flanders/sans/FlandersArtSans-Regular.woff") format("woff");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Flanders Art Sans";
  src: url("/font/flanders/sans/FlandersArtSans-Medium.woff2") format("woff2"), url("/font/flanders/sans/FlandersArtSans-Medium.woff") format("woff");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Flanders Art Sans";
  src: url("/font/flanders/sans/FlandersArtSans-Bold.woff2") format("woff2"), url("/font/flanders/sans/FlandersArtSans-Bold.woff") format("woff");
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "Flanders Art Sans";
  src: url("/font/flanders/italic/FlandersArtSans-Light.woff2") format("woff2"), url("/font/flanders/italic/FlandersArtSans-Light.woff") format("woff");
  font-weight: 300;
  font-style: italic;
}
@font-face {
  font-family: "Flanders Art Sans";
  src: url("/font/flanders/italic/FlandersArtSans-Regular.woff2") format("woff2"), url("/font/flanders/italic/FlandersArtSans-Regular.woff") format("woff");
  font-weight: 400;
  font-style: italic;
}
@font-face {
  font-family: "Flanders Art Sans";
  src: url("/font/flanders/italic/FlandersArtSans-Medium.woff2") format("woff2"), url("/font/flanders/italic/FlandersArtSans-Medium.woff") format("woff");
  font-weight: 500;
  font-style: italic;
}
@font-face {
  font-family: "Flanders Art Sans";
  src: url("/font/flanders/italic/FlandersArtSans-Bold.woff2") format("woff2"), url("/font/flanders/italic/FlandersArtSans-Bold.woff") format("woff");
  font-weight: 700;
  font-style: italic;
}
@font-face {
  font-family: "Flanders Art Serif";
  src: url("/font/flanders/serif/FlandersArtSerif-Light.woff2") format("woff2"), url("/font/flanders/serif/FlandersArtSerif-Light.woff") format("woff");
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: "Flanders Art Serif";
  src: url("/font/flanders/serif/FlandersArtSerif-Regular.woff2") format("woff2"), url("/font/flanders/serif/FlandersArtSerif-Regular.woff") format("woff");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Flanders Art Serif";
  src: url("/font/flanders/serif/FlandersArtSerif-Medium.woff2") format("woff2"), url("/font/flanders/serif/FlandersArtSerif-Medium.woff") format("woff");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Flanders Art Serif";
  src: url("/font/flanders/serif/FlandersArtSerif-Bold.woff2") format("woff2"), url("/font/flanders/serif/FlandersArtSerif-Bold.woff") format("woff");
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "vlaanderen-icon";
  src: url("/font/iconfont/vlaanderen-icon.woff2") format("woff2"), url("/font/iconfont/vlaanderen-icon.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}
.vl-vi-add[data-v-97867cb6]::before {
  content: "\\f101";
}
.vl-vi-add--after[data-v-97867cb6]::after {
  content: "\\f101";
}
.vl-vi-addressbook[data-v-97867cb6]::before {
  content: "\\f102";
}
.vl-vi-addressbook--after[data-v-97867cb6]::after {
  content: "\\f102";
}
.vl-vi-airplane[data-v-97867cb6]::before {
  content: "\\f103";
}
.vl-vi-airplane--after[data-v-97867cb6]::after {
  content: "\\f103";
}
.vl-vi-alarm-silent[data-v-97867cb6]::before {
  content: "\\f104";
}
.vl-vi-alarm-silent--after[data-v-97867cb6]::after {
  content: "\\f104";
}
.vl-vi-alarm[data-v-97867cb6]::before {
  content: "\\f105";
}
.vl-vi-alarm--after[data-v-97867cb6]::after {
  content: "\\f105";
}
.vl-vi-alert-circle-filled[data-v-97867cb6]::before {
  content: "\\f106";
}
.vl-vi-alert-circle-filled--after[data-v-97867cb6]::after {
  content: "\\f106";
}
.vl-vi-alert-circle[data-v-97867cb6]::before {
  content: "\\f107";
}
.vl-vi-alert-circle--after[data-v-97867cb6]::after {
  content: "\\f107";
}
.vl-vi-alert-small[data-v-97867cb6]::before {
  content: "\\f108";
}
.vl-vi-alert-small--after[data-v-97867cb6]::after {
  content: "\\f108";
}
.vl-vi-alert-triangle-filled[data-v-97867cb6]::before {
  content: "\\f109";
}
.vl-vi-alert-triangle-filled--after[data-v-97867cb6]::after {
  content: "\\f109";
}
.vl-vi-alert-triangle[data-v-97867cb6]::before {
  content: "\\f10a";
}
.vl-vi-alert-triangle--after[data-v-97867cb6]::after {
  content: "\\f10a";
}
.vl-vi-align-center[data-v-97867cb6]::before {
  content: "\\f10b";
}
.vl-vi-align-center--after[data-v-97867cb6]::after {
  content: "\\f10b";
}
.vl-vi-align-justify[data-v-97867cb6]::before {
  content: "\\f10c";
}
.vl-vi-align-justify--after[data-v-97867cb6]::after {
  content: "\\f10c";
}
.vl-vi-align-left[data-v-97867cb6]::before {
  content: "\\f10d";
}
.vl-vi-align-left--after[data-v-97867cb6]::after {
  content: "\\f10d";
}
.vl-vi-align-right[data-v-97867cb6]::before {
  content: "\\f10e";
}
.vl-vi-align-right--after[data-v-97867cb6]::after {
  content: "\\f10e";
}
.vl-vi-area[data-v-97867cb6]::before {
  content: "\\f10f";
}
.vl-vi-area--after[data-v-97867cb6]::after {
  content: "\\f10f";
}
.vl-vi-arrange-1-to-9[data-v-97867cb6]::before {
  content: "\\f110";
}
.vl-vi-arrange-1-to-9--after[data-v-97867cb6]::after {
  content: "\\f110";
}
.vl-vi-arrange-9-to-1[data-v-97867cb6]::before {
  content: "\\f111";
}
.vl-vi-arrange-9-to-1--after[data-v-97867cb6]::after {
  content: "\\f111";
}
.vl-vi-arrange-a-to-z[data-v-97867cb6]::before {
  content: "\\f112";
}
.vl-vi-arrange-a-to-z--after[data-v-97867cb6]::after {
  content: "\\f112";
}
.vl-vi-arrange-amount-large-to-small[data-v-97867cb6]::before {
  content: "\\f113";
}
.vl-vi-arrange-amount-large-to-small--after[data-v-97867cb6]::after {
  content: "\\f113";
}
.vl-vi-arrange-amount-small-to-large[data-v-97867cb6]::before {
  content: "\\f114";
}
.vl-vi-arrange-amount-small-to-large--after[data-v-97867cb6]::after {
  content: "\\f114";
}
.vl-vi-arrange-z-to-a[data-v-97867cb6]::before {
  content: "\\f115";
}
.vl-vi-arrange-z-to-a--after[data-v-97867cb6]::after {
  content: "\\f115";
}
.vl-vi-arrow-bottom[data-v-97867cb6]::before {
  content: "\\f116";
}
.vl-vi-arrow-bottom--after[data-v-97867cb6]::after {
  content: "\\f116";
}
.vl-vi-arrow-down-fat[data-v-97867cb6]::before {
  content: "\\f117";
}
.vl-vi-arrow-down-fat--after[data-v-97867cb6]::after {
  content: "\\f117";
}
.vl-vi-arrow-down-thin[data-v-97867cb6]::before {
  content: "\\f118";
}
.vl-vi-arrow-down-thin--after[data-v-97867cb6]::after {
  content: "\\f118";
}
.vl-vi-arrow-down[data-v-97867cb6]::before {
  content: "\\f119";
}
.vl-vi-arrow-down--after[data-v-97867cb6]::after {
  content: "\\f119";
}
.vl-vi-arrow-freemove[data-v-97867cb6]::before {
  content: "\\f11a";
}
.vl-vi-arrow-freemove--after[data-v-97867cb6]::after {
  content: "\\f11a";
}
.vl-vi-arrow-left-fat[data-v-97867cb6]::before {
  content: "\\f11b";
}
.vl-vi-arrow-left-fat--after[data-v-97867cb6]::after {
  content: "\\f11b";
}
.vl-vi-arrow-left-thin[data-v-97867cb6]::before {
  content: "\\f11c";
}
.vl-vi-arrow-left-thin--after[data-v-97867cb6]::after {
  content: "\\f11c";
}
.vl-vi-arrow-left[data-v-97867cb6]::before {
  content: "\\f11d";
}
.vl-vi-arrow-left--after[data-v-97867cb6]::after {
  content: "\\f11d";
}
.vl-vi-arrow-right-fat[data-v-97867cb6]::before {
  content: "\\f11e";
}
.vl-vi-arrow-right-fat--after[data-v-97867cb6]::after {
  content: "\\f11e";
}
.vl-vi-arrow-right-thin[data-v-97867cb6]::before {
  content: "\\f11f";
}
.vl-vi-arrow-right-thin--after[data-v-97867cb6]::after {
  content: "\\f11f";
}
.vl-vi-arrow-right[data-v-97867cb6]::before {
  content: "\\f120";
}
.vl-vi-arrow-right--after[data-v-97867cb6]::after {
  content: "\\f120";
}
.vl-vi-arrow-thin[data-v-97867cb6]::before {
  content: "\\f121";
}
.vl-vi-arrow-thin--after[data-v-97867cb6]::after {
  content: "\\f121";
}
.vl-vi-arrow-up-fat[data-v-97867cb6]::before {
  content: "\\f122";
}
.vl-vi-arrow-up-fat--after[data-v-97867cb6]::after {
  content: "\\f122";
}
.vl-vi-arrow-up-thin[data-v-97867cb6]::before {
  content: "\\f123";
}
.vl-vi-arrow-up-thin--after[data-v-97867cb6]::after {
  content: "\\f123";
}
.vl-vi-arrow-up[data-v-97867cb6]::before {
  content: "\\f124";
}
.vl-vi-arrow-up--after[data-v-97867cb6]::after {
  content: "\\f124";
}
.vl-vi-arrow[data-v-97867cb6]::before {
  content: "\\f125";
}
.vl-vi-arrow--after[data-v-97867cb6]::after {
  content: "\\f125";
}
.vl-vi-asterisk[data-v-97867cb6]::before {
  content: "\\f126";
}
.vl-vi-asterisk--after[data-v-97867cb6]::after {
  content: "\\f126";
}
.vl-vi-audio-description[data-v-97867cb6]::before {
  content: "\\f127";
}
.vl-vi-audio-description--after[data-v-97867cb6]::after {
  content: "\\f127";
}
.vl-vi-back[data-v-97867cb6]::before {
  content: "\\f128";
}
.vl-vi-back--after[data-v-97867cb6]::after {
  content: "\\f128";
}
.vl-vi-ban[data-v-97867cb6]::before {
  content: "\\f129";
}
.vl-vi-ban--after[data-v-97867cb6]::after {
  content: "\\f129";
}
.vl-vi-banking-bill-euro[data-v-97867cb6]::before {
  content: "\\f12a";
}
.vl-vi-banking-bill-euro--after[data-v-97867cb6]::after {
  content: "\\f12a";
}
.vl-vi-battery-charging[data-v-97867cb6]::before {
  content: "\\f12b";
}
.vl-vi-battery-charging--after[data-v-97867cb6]::after {
  content: "\\f12b";
}
.vl-vi-bell[data-v-97867cb6]::before {
  content: "\\f12c";
}
.vl-vi-bell--after[data-v-97867cb6]::after {
  content: "\\f12c";
}
.vl-vi-bike-closed-criterium[data-v-97867cb6]::before {
  content: "\\f12d";
}
.vl-vi-bike-closed-criterium--after[data-v-97867cb6]::after {
  content: "\\f12d";
}
.vl-vi-bike-open-criterium[data-v-97867cb6]::before {
  content: "\\f12e";
}
.vl-vi-bike-open-criterium--after[data-v-97867cb6]::after {
  content: "\\f12e";
}
.vl-vi-bike[data-v-97867cb6]::before {
  content: "\\f12f";
}
.vl-vi-bike--after[data-v-97867cb6]::after {
  content: "\\f12f";
}
.vl-vi-bin[data-v-97867cb6]::before {
  content: "\\f130";
}
.vl-vi-bin--after[data-v-97867cb6]::after {
  content: "\\f130";
}
.vl-vi-binoculars[data-v-97867cb6]::before {
  content: "\\f131";
}
.vl-vi-binoculars--after[data-v-97867cb6]::after {
  content: "\\f131";
}
.vl-vi-boat-ship[data-v-97867cb6]::before {
  content: "\\f132";
}
.vl-vi-boat-ship--after[data-v-97867cb6]::after {
  content: "\\f132";
}
.vl-vi-bold[data-v-97867cb6]::before {
  content: "\\f133";
}
.vl-vi-bold--after[data-v-97867cb6]::after {
  content: "\\f133";
}
.vl-vi-book[data-v-97867cb6]::before {
  content: "\\f134";
}
.vl-vi-book--after[data-v-97867cb6]::after {
  content: "\\f134";
}
.vl-vi-bookmark-alt-1[data-v-97867cb6]::before {
  content: "\\f135";
}
.vl-vi-bookmark-alt-1--after[data-v-97867cb6]::after {
  content: "\\f135";
}
.vl-vi-bookmark-alt-2[data-v-97867cb6]::before {
  content: "\\f136";
}
.vl-vi-bookmark-alt-2--after[data-v-97867cb6]::after {
  content: "\\f136";
}
.vl-vi-bookmark[data-v-97867cb6]::before {
  content: "\\f137";
}
.vl-vi-bookmark--after[data-v-97867cb6]::after {
  content: "\\f137";
}
.vl-vi-breadcrumb-separator[data-v-97867cb6]::before {
  content: "\\f138";
}
.vl-vi-breadcrumb-separator--after[data-v-97867cb6]::after {
  content: "\\f138";
}
.vl-vi-briefcase[data-v-97867cb6]::before {
  content: "\\f139";
}
.vl-vi-briefcase--after[data-v-97867cb6]::after {
  content: "\\f139";
}
.vl-vi-building-2[data-v-97867cb6]::before {
  content: "\\f13a";
}
.vl-vi-building-2--after[data-v-97867cb6]::after {
  content: "\\f13a";
}
.vl-vi-building-big[data-v-97867cb6]::before {
  content: "\\f13b";
}
.vl-vi-building-big--after[data-v-97867cb6]::after {
  content: "\\f13b";
}
.vl-vi-building[data-v-97867cb6]::before {
  content: "\\f13c";
}
.vl-vi-building--after[data-v-97867cb6]::after {
  content: "\\f13c";
}
.vl-vi-bullet[data-v-97867cb6]::before {
  content: "\\f13d";
}
.vl-vi-bullet--after[data-v-97867cb6]::after {
  content: "\\f13d";
}
.vl-vi-burger-alt[data-v-97867cb6]::before {
  content: "\\f13e";
}
.vl-vi-burger-alt--after[data-v-97867cb6]::after {
  content: "\\f13e";
}
.vl-vi-burger[data-v-97867cb6]::before {
  content: "\\f13f";
}
.vl-vi-burger--after[data-v-97867cb6]::after {
  content: "\\f13f";
}
.vl-vi-burgerprofiel[data-v-97867cb6]::before {
  content: "\\f140";
}
.vl-vi-burgerprofiel--after[data-v-97867cb6]::after {
  content: "\\f140";
}
.vl-vi-bus[data-v-97867cb6]::before {
  content: "\\f141";
}
.vl-vi-bus--after[data-v-97867cb6]::after {
  content: "\\f141";
}
.vl-vi-business-graph-bar[data-v-97867cb6]::before {
  content: "\\f142";
}
.vl-vi-business-graph-bar--after[data-v-97867cb6]::after {
  content: "\\f142";
}
.vl-vi-business-graph-pie[data-v-97867cb6]::before {
  content: "\\f143";
}
.vl-vi-business-graph-pie--after[data-v-97867cb6]::after {
  content: "\\f143";
}
.vl-vi-cabinet[data-v-97867cb6]::before {
  content: "\\f144";
}
.vl-vi-cabinet--after[data-v-97867cb6]::after {
  content: "\\f144";
}
.vl-vi-cake[data-v-97867cb6]::before {
  content: "\\f145";
}
.vl-vi-cake--after[data-v-97867cb6]::after {
  content: "\\f145";
}
.vl-vi-calculator[data-v-97867cb6]::before {
  content: "\\f146";
}
.vl-vi-calculator--after[data-v-97867cb6]::after {
  content: "\\f146";
}
.vl-vi-calendar-add[data-v-97867cb6]::before {
  content: "\\f147";
}
.vl-vi-calendar-add--after[data-v-97867cb6]::after {
  content: "\\f147";
}
.vl-vi-calendar-check[data-v-97867cb6]::before {
  content: "\\f148";
}
.vl-vi-calendar-check--after[data-v-97867cb6]::after {
  content: "\\f148";
}
.vl-vi-calendar-subtract[data-v-97867cb6]::before {
  content: "\\f149";
}
.vl-vi-calendar-subtract--after[data-v-97867cb6]::after {
  content: "\\f149";
}
.vl-vi-calendar[data-v-97867cb6]::before {
  content: "\\f14a";
}
.vl-vi-calendar--after[data-v-97867cb6]::after {
  content: "\\f14a";
}
.vl-vi-calendar_check[data-v-97867cb6]::before {
  content: "\\f14b";
}
.vl-vi-calendar_check--after[data-v-97867cb6]::after {
  content: "\\f14b";
}
.vl-vi-calendar_date[data-v-97867cb6]::before {
  content: "\\f14c";
}
.vl-vi-calendar_date--after[data-v-97867cb6]::after {
  content: "\\f14c";
}
.vl-vi-camera[data-v-97867cb6]::before {
  content: "\\f14d";
}
.vl-vi-camera--after[data-v-97867cb6]::after {
  content: "\\f14d";
}
.vl-vi-car-wheel[data-v-97867cb6]::before {
  content: "\\f14e";
}
.vl-vi-car-wheel--after[data-v-97867cb6]::after {
  content: "\\f14e";
}
.vl-vi-car[data-v-97867cb6]::before {
  content: "\\f14f";
}
.vl-vi-car--after[data-v-97867cb6]::after {
  content: "\\f14f";
}
.vl-vi-chat-bubble-square-alert[data-v-97867cb6]::before {
  content: "\\f150";
}
.vl-vi-chat-bubble-square-alert--after[data-v-97867cb6]::after {
  content: "\\f150";
}
.vl-vi-chat-bubble-square-alt[data-v-97867cb6]::before {
  content: "\\f151";
}
.vl-vi-chat-bubble-square-alt--after[data-v-97867cb6]::after {
  content: "\\f151";
}
.vl-vi-chat-bubble-square[data-v-97867cb6]::before {
  content: "\\f152";
}
.vl-vi-chat-bubble-square--after[data-v-97867cb6]::after {
  content: "\\f152";
}
.vl-vi-chat-help[data-v-97867cb6]::before {
  content: "\\f153";
}
.vl-vi-chat-help--after[data-v-97867cb6]::after {
  content: "\\f153";
}
.vl-vi-chat[data-v-97867cb6]::before {
  content: "\\f154";
}
.vl-vi-chat--after[data-v-97867cb6]::after {
  content: "\\f154";
}
.vl-vi-check-circle[data-v-97867cb6]::before {
  content: "\\f155";
}
.vl-vi-check-circle--after[data-v-97867cb6]::after {
  content: "\\f155";
}
.vl-vi-check-filled[data-v-97867cb6]::before {
  content: "\\f156";
}
.vl-vi-check-filled--after[data-v-97867cb6]::after {
  content: "\\f156";
}
.vl-vi-check-naked[data-v-97867cb6]::before {
  content: "\\f157";
}
.vl-vi-check-naked--after[data-v-97867cb6]::after {
  content: "\\f157";
}
.vl-vi-check-small[data-v-97867cb6]::before {
  content: "\\f158";
}
.vl-vi-check-small--after[data-v-97867cb6]::after {
  content: "\\f158";
}
.vl-vi-check-thin[data-v-97867cb6]::before {
  content: "\\f159";
}
.vl-vi-check-thin--after[data-v-97867cb6]::after {
  content: "\\f159";
}
.vl-vi-check[data-v-97867cb6]::before {
  content: "\\f15a";
}
.vl-vi-check--after[data-v-97867cb6]::after {
  content: "\\f15a";
}
.vl-vi-child[data-v-97867cb6]::before {
  content: "\\f15b";
}
.vl-vi-child--after[data-v-97867cb6]::after {
  content: "\\f15b";
}
.vl-vi-clock[data-v-97867cb6]::before {
  content: "\\f15c";
}
.vl-vi-clock--after[data-v-97867cb6]::after {
  content: "\\f15c";
}
.vl-vi-close-filled[data-v-97867cb6]::before {
  content: "\\f15d";
}
.vl-vi-close-filled--after[data-v-97867cb6]::after {
  content: "\\f15d";
}
.vl-vi-close-light[data-v-97867cb6]::before {
  content: "\\f15e";
}
.vl-vi-close-light--after[data-v-97867cb6]::after {
  content: "\\f15e";
}
.vl-vi-close-naked[data-v-97867cb6]::before {
  content: "\\f15f";
}
.vl-vi-close-naked--after[data-v-97867cb6]::after {
  content: "\\f15f";
}
.vl-vi-close[data-v-97867cb6]::before {
  content: "\\f160";
}
.vl-vi-close--after[data-v-97867cb6]::after {
  content: "\\f160";
}
.vl-vi-cloud-download[data-v-97867cb6]::before {
  content: "\\f161";
}
.vl-vi-cloud-download--after[data-v-97867cb6]::after {
  content: "\\f161";
}
.vl-vi-cloud-upload[data-v-97867cb6]::before {
  content: "\\f162";
}
.vl-vi-cloud-upload--after[data-v-97867cb6]::after {
  content: "\\f162";
}
.vl-vi-cloud[data-v-97867cb6]::before {
  content: "\\f163";
}
.vl-vi-cloud--after[data-v-97867cb6]::after {
  content: "\\f163";
}
.vl-vi-code-branch[data-v-97867cb6]::before {
  content: "\\f164";
}
.vl-vi-code-branch--after[data-v-97867cb6]::after {
  content: "\\f164";
}
.vl-vi-coffee-cup[data-v-97867cb6]::before {
  content: "\\f165";
}
.vl-vi-coffee-cup--after[data-v-97867cb6]::after {
  content: "\\f165";
}
.vl-vi-cog[data-v-97867cb6]::before {
  content: "\\f166";
}
.vl-vi-cog--after[data-v-97867cb6]::after {
  content: "\\f166";
}
.vl-vi-coin-stack[data-v-97867cb6]::before {
  content: "\\f167";
}
.vl-vi-coin-stack--after[data-v-97867cb6]::after {
  content: "\\f167";
}
.vl-vi-compass[data-v-97867cb6]::before {
  content: "\\f168";
}
.vl-vi-compass--after[data-v-97867cb6]::after {
  content: "\\f168";
}
.vl-vi-computer-screen[data-v-97867cb6]::before {
  content: "\\f169";
}
.vl-vi-computer-screen--after[data-v-97867cb6]::after {
  content: "\\f169";
}
.vl-vi-confluence[data-v-97867cb6]::before {
  content: "\\f16a";
}
.vl-vi-confluence--after[data-v-97867cb6]::after {
  content: "\\f16a";
}
.vl-vi-construction-crane[data-v-97867cb6]::before {
  content: "\\f16b";
}
.vl-vi-construction-crane--after[data-v-97867cb6]::after {
  content: "\\f16b";
}
.vl-vi-construction-shack[data-v-97867cb6]::before {
  content: "\\f16c";
}
.vl-vi-construction-shack--after[data-v-97867cb6]::after {
  content: "\\f16c";
}
.vl-vi-contactbook[data-v-97867cb6]::before {
  content: "\\f16d";
}
.vl-vi-contactbook--after[data-v-97867cb6]::after {
  content: "\\f16d";
}
.vl-vi-contacts[data-v-97867cb6]::before {
  content: "\\f16e";
}
.vl-vi-contacts--after[data-v-97867cb6]::after {
  content: "\\f16e";
}
.vl-vi-content-book-favorite-star[data-v-97867cb6]::before {
  content: "\\f16f";
}
.vl-vi-content-book-favorite-star--after[data-v-97867cb6]::after {
  content: "\\f16f";
}
.vl-vi-content-book[data-v-97867cb6]::before {
  content: "\\f170";
}
.vl-vi-content-book--after[data-v-97867cb6]::after {
  content: "\\f170";
}
.vl-vi-content-box[data-v-97867cb6]::before {
  content: "\\f171";
}
.vl-vi-content-box--after[data-v-97867cb6]::after {
  content: "\\f171";
}
.vl-vi-content-filter[data-v-97867cb6]::before {
  content: "\\f172";
}
.vl-vi-content-filter--after[data-v-97867cb6]::after {
  content: "\\f172";
}
.vl-vi-content-layers-hide[data-v-97867cb6]::before {
  content: "\\f173";
}
.vl-vi-content-layers-hide--after[data-v-97867cb6]::after {
  content: "\\f173";
}
.vl-vi-content-layers-show[data-v-97867cb6]::before {
  content: "\\f174";
}
.vl-vi-content-layers-show--after[data-v-97867cb6]::after {
  content: "\\f174";
}
.vl-vi-content-note[data-v-97867cb6]::before {
  content: "\\f175";
}
.vl-vi-content-note--after[data-v-97867cb6]::after {
  content: "\\f175";
}
.vl-vi-content-view-column[data-v-97867cb6]::before {
  content: "\\f176";
}
.vl-vi-content-view-column--after[data-v-97867cb6]::after {
  content: "\\f176";
}
.vl-vi-content-view-module[data-v-97867cb6]::before {
  content: "\\f177";
}
.vl-vi-content-view-module--after[data-v-97867cb6]::after {
  content: "\\f177";
}
.vl-vi-contract[data-v-97867cb6]::before {
  content: "\\f178";
}
.vl-vi-contract--after[data-v-97867cb6]::after {
  content: "\\f178";
}
.vl-vi-control-cross-over[data-v-97867cb6]::before {
  content: "\\f179";
}
.vl-vi-control-cross-over--after[data-v-97867cb6]::after {
  content: "\\f179";
}
.vl-vi-copy-paste[data-v-97867cb6]::before {
  content: "\\f17a";
}
.vl-vi-copy-paste--after[data-v-97867cb6]::after {
  content: "\\f17a";
}
.vl-vi-copyright[data-v-97867cb6]::before {
  content: "\\f17b";
}
.vl-vi-copyright--after[data-v-97867cb6]::after {
  content: "\\f17b";
}
.vl-vi-credit-card[data-v-97867cb6]::before {
  content: "\\f17c";
}
.vl-vi-credit-card--after[data-v-97867cb6]::after {
  content: "\\f17c";
}
.vl-vi-crop[data-v-97867cb6]::before {
  content: "\\f17d";
}
.vl-vi-crop--after[data-v-97867cb6]::after {
  content: "\\f17d";
}
.vl-vi-cross-thin[data-v-97867cb6]::before {
  content: "\\f17e";
}
.vl-vi-cross-thin--after[data-v-97867cb6]::after {
  content: "\\f17e";
}
.vl-vi-cross[data-v-97867cb6]::before {
  content: "\\f17f";
}
.vl-vi-cross--after[data-v-97867cb6]::after {
  content: "\\f17f";
}
.vl-vi-cursor-arrow-big[data-v-97867cb6]::before {
  content: "\\f180";
}
.vl-vi-cursor-arrow-big--after[data-v-97867cb6]::after {
  content: "\\f180";
}
.vl-vi-cursor-arrow-small[data-v-97867cb6]::before {
  content: "\\f181";
}
.vl-vi-cursor-arrow-small--after[data-v-97867cb6]::after {
  content: "\\f181";
}
.vl-vi-cursor-finger-down[data-v-97867cb6]::before {
  content: "\\f182";
}
.vl-vi-cursor-finger-down--after[data-v-97867cb6]::after {
  content: "\\f182";
}
.vl-vi-cursor-finger-left[data-v-97867cb6]::before {
  content: "\\f183";
}
.vl-vi-cursor-finger-left--after[data-v-97867cb6]::after {
  content: "\\f183";
}
.vl-vi-cursor-finger-right[data-v-97867cb6]::before {
  content: "\\f184";
}
.vl-vi-cursor-finger-right--after[data-v-97867cb6]::after {
  content: "\\f184";
}
.vl-vi-cursor-finger-up[data-v-97867cb6]::before {
  content: "\\f185";
}
.vl-vi-cursor-finger-up--after[data-v-97867cb6]::after {
  content: "\\f185";
}
.vl-vi-cursor-hand[data-v-97867cb6]::before {
  content: "\\f186";
}
.vl-vi-cursor-hand--after[data-v-97867cb6]::after {
  content: "\\f186";
}
.vl-vi-cursor-hold[data-v-97867cb6]::before {
  content: "\\f187";
}
.vl-vi-cursor-hold--after[data-v-97867cb6]::after {
  content: "\\f187";
}
.vl-vi-dashboard[data-v-97867cb6]::before {
  content: "\\f188";
}
.vl-vi-dashboard--after[data-v-97867cb6]::after {
  content: "\\f188";
}
.vl-vi-data-download[data-v-97867cb6]::before {
  content: "\\f189";
}
.vl-vi-data-download--after[data-v-97867cb6]::after {
  content: "\\f189";
}
.vl-vi-data-transfer[data-v-97867cb6]::before {
  content: "\\f18a";
}
.vl-vi-data-transfer--after[data-v-97867cb6]::after {
  content: "\\f18a";
}
.vl-vi-data-upload[data-v-97867cb6]::before {
  content: "\\f18b";
}
.vl-vi-data-upload--after[data-v-97867cb6]::after {
  content: "\\f18b";
}
.vl-vi-demonstration[data-v-97867cb6]::before {
  content: "\\f18c";
}
.vl-vi-demonstration--after[data-v-97867cb6]::after {
  content: "\\f18c";
}
.vl-vi-diagram[data-v-97867cb6]::before {
  content: "\\f18d";
}
.vl-vi-diagram--after[data-v-97867cb6]::after {
  content: "\\f18d";
}
.vl-vi-direction-sign[data-v-97867cb6]::before {
  content: "\\f18e";
}
.vl-vi-direction-sign--after[data-v-97867cb6]::after {
  content: "\\f18e";
}
.vl-vi-document-small[data-v-97867cb6]::before {
  content: "\\f18f";
}
.vl-vi-document-small--after[data-v-97867cb6]::after {
  content: "\\f18f";
}
.vl-vi-document[data-v-97867cb6]::before {
  content: "\\f190";
}
.vl-vi-document--after[data-v-97867cb6]::after {
  content: "\\f190";
}
.vl-vi-double-arrow[data-v-97867cb6]::before {
  content: "\\f191";
}
.vl-vi-double-arrow--after[data-v-97867cb6]::after {
  content: "\\f191";
}
.vl-vi-download-harddisk[data-v-97867cb6]::before {
  content: "\\f192";
}
.vl-vi-download-harddisk--after[data-v-97867cb6]::after {
  content: "\\f192";
}
.vl-vi-drawer-down[data-v-97867cb6]::before {
  content: "\\f193";
}
.vl-vi-drawer-down--after[data-v-97867cb6]::after {
  content: "\\f193";
}
.vl-vi-drawer[data-v-97867cb6]::before {
  content: "\\f194";
}
.vl-vi-drawer--after[data-v-97867cb6]::after {
  content: "\\f194";
}
.vl-vi-drink-bottle[data-v-97867cb6]::before {
  content: "\\f195";
}
.vl-vi-drink-bottle--after[data-v-97867cb6]::after {
  content: "\\f195";
}
.vl-vi-eco-throw-trash[data-v-97867cb6]::before {
  content: "\\f196";
}
.vl-vi-eco-throw-trash--after[data-v-97867cb6]::after {
  content: "\\f196";
}
.vl-vi-edit[data-v-97867cb6]::before {
  content: "\\f197";
}
.vl-vi-edit--after[data-v-97867cb6]::after {
  content: "\\f197";
}
.vl-vi-eloket[data-v-97867cb6]::before {
  content: "\\f198";
}
.vl-vi-eloket--after[data-v-97867cb6]::after {
  content: "\\f198";
}
.vl-vi-email-read[data-v-97867cb6]::before {
  content: "\\f199";
}
.vl-vi-email-read--after[data-v-97867cb6]::after {
  content: "\\f199";
}
.vl-vi-email[data-v-97867cb6]::before {
  content: "\\f19a";
}
.vl-vi-email--after[data-v-97867cb6]::after {
  content: "\\f19a";
}
.vl-vi-enlarge[data-v-97867cb6]::before {
  content: "\\f19b";
}
.vl-vi-enlarge--after[data-v-97867cb6]::after {
  content: "\\f19b";
}
.vl-vi-envelope[data-v-97867cb6]::before {
  content: "\\f19c";
}
.vl-vi-envelope--after[data-v-97867cb6]::after {
  content: "\\f19c";
}
.vl-vi-expand-horizontal-alt[data-v-97867cb6]::before {
  content: "\\f19d";
}
.vl-vi-expand-horizontal-alt--after[data-v-97867cb6]::after {
  content: "\\f19d";
}
.vl-vi-expand-horizontal[data-v-97867cb6]::before {
  content: "\\f19e";
}
.vl-vi-expand-horizontal--after[data-v-97867cb6]::after {
  content: "\\f19e";
}
.vl-vi-expand-vertical[data-v-97867cb6]::before {
  content: "\\f19f";
}
.vl-vi-expand-vertical--after[data-v-97867cb6]::after {
  content: "\\f19f";
}
.vl-vi-expand[data-v-97867cb6]::before {
  content: "\\f1a0";
}
.vl-vi-expand--after[data-v-97867cb6]::after {
  content: "\\f1a0";
}
.vl-vi-external[data-v-97867cb6]::before {
  content: "\\f1a1";
}
.vl-vi-external--after[data-v-97867cb6]::after {
  content: "\\f1a1";
}
.vl-vi-face-id[data-v-97867cb6]::before {
  content: "\\f1a2";
}
.vl-vi-face-id--after[data-v-97867cb6]::after {
  content: "\\f1a2";
}
.vl-vi-facebook[data-v-97867cb6]::before {
  content: "\\f1a3";
}
.vl-vi-facebook--after[data-v-97867cb6]::after {
  content: "\\f1a3";
}
.vl-vi-faq[data-v-97867cb6]::before {
  content: "\\f1a4";
}
.vl-vi-faq--after[data-v-97867cb6]::after {
  content: "\\f1a4";
}
.vl-vi-fastback[data-v-97867cb6]::before {
  content: "\\f1a5";
}
.vl-vi-fastback--after[data-v-97867cb6]::after {
  content: "\\f1a5";
}
.vl-vi-fastforward[data-v-97867cb6]::before {
  content: "\\f1a6";
}
.vl-vi-fastforward--after[data-v-97867cb6]::after {
  content: "\\f1a6";
}
.vl-vi-fax[data-v-97867cb6]::before {
  content: "\\f1a7";
}
.vl-vi-fax--after[data-v-97867cb6]::after {
  content: "\\f1a7";
}
.vl-vi-field[data-v-97867cb6]::before {
  content: "\\f1a8";
}
.vl-vi-field--after[data-v-97867cb6]::after {
  content: "\\f1a8";
}
.vl-vi-file-audio[data-v-97867cb6]::before {
  content: "\\f1a9";
}
.vl-vi-file-audio--after[data-v-97867cb6]::after {
  content: "\\f1a9";
}
.vl-vi-file-copy[data-v-97867cb6]::before {
  content: "\\f1aa";
}
.vl-vi-file-copy--after[data-v-97867cb6]::after {
  content: "\\f1aa";
}
.vl-vi-file-download[data-v-97867cb6]::before {
  content: "\\f1ab";
}
.vl-vi-file-download--after[data-v-97867cb6]::after {
  content: "\\f1ab";
}
.vl-vi-file-edit[data-v-97867cb6]::before {
  content: "\\f1ac";
}
.vl-vi-file-edit--after[data-v-97867cb6]::after {
  content: "\\f1ac";
}
.vl-vi-file-image[data-v-97867cb6]::before {
  content: "\\f1ad";
}
.vl-vi-file-image--after[data-v-97867cb6]::after {
  content: "\\f1ad";
}
.vl-vi-file-new[data-v-97867cb6]::before {
  content: "\\f1ae";
}
.vl-vi-file-new--after[data-v-97867cb6]::after {
  content: "\\f1ae";
}
.vl-vi-file-office-doc[data-v-97867cb6]::before {
  content: "\\f1af";
}
.vl-vi-file-office-doc--after[data-v-97867cb6]::after {
  content: "\\f1af";
}
.vl-vi-file-office-pdf[data-v-97867cb6]::before {
  content: "\\f1b0";
}
.vl-vi-file-office-pdf--after[data-v-97867cb6]::after {
  content: "\\f1b0";
}
.vl-vi-file-office-ppt[data-v-97867cb6]::before {
  content: "\\f1b1";
}
.vl-vi-file-office-ppt--after[data-v-97867cb6]::after {
  content: "\\f1b1";
}
.vl-vi-file-office-xls[data-v-97867cb6]::before {
  content: "\\f1b2";
}
.vl-vi-file-office-xls--after[data-v-97867cb6]::after {
  content: "\\f1b2";
}
.vl-vi-file-swap[data-v-97867cb6]::before {
  content: "\\f1b3";
}
.vl-vi-file-swap--after[data-v-97867cb6]::after {
  content: "\\f1b3";
}
.vl-vi-file-tasks-check[data-v-97867cb6]::before {
  content: "\\f1b4";
}
.vl-vi-file-tasks-check--after[data-v-97867cb6]::after {
  content: "\\f1b4";
}
.vl-vi-file-upload[data-v-97867cb6]::before {
  content: "\\f1b5";
}
.vl-vi-file-upload--after[data-v-97867cb6]::after {
  content: "\\f1b5";
}
.vl-vi-file-video[data-v-97867cb6]::before {
  content: "\\f1b6";
}
.vl-vi-file-video--after[data-v-97867cb6]::after {
  content: "\\f1b6";
}
.vl-vi-file-zipped-new[data-v-97867cb6]::before {
  content: "\\f1b7";
}
.vl-vi-file-zipped-new--after[data-v-97867cb6]::after {
  content: "\\f1b7";
}
.vl-vi-file-zipped-vice[data-v-97867cb6]::before {
  content: "\\f1b8";
}
.vl-vi-file-zipped-vice--after[data-v-97867cb6]::after {
  content: "\\f1b8";
}
.vl-vi-file[data-v-97867cb6]::before {
  content: "\\f1b9";
}
.vl-vi-file--after[data-v-97867cb6]::after {
  content: "\\f1b9";
}
.vl-vi-files-coding[data-v-97867cb6]::before {
  content: "\\f1ba";
}
.vl-vi-files-coding--after[data-v-97867cb6]::after {
  content: "\\f1ba";
}
.vl-vi-film[data-v-97867cb6]::before {
  content: "\\f1bb";
}
.vl-vi-film--after[data-v-97867cb6]::after {
  content: "\\f1bb";
}
.vl-vi-fingerprint[data-v-97867cb6]::before {
  content: "\\f1bc";
}
.vl-vi-fingerprint--after[data-v-97867cb6]::after {
  content: "\\f1bc";
}
.vl-vi-flickr[data-v-97867cb6]::before {
  content: "\\f1bd";
}
.vl-vi-flickr--after[data-v-97867cb6]::after {
  content: "\\f1bd";
}
.vl-vi-focus[data-v-97867cb6]::before {
  content: "\\f1be";
}
.vl-vi-focus--after[data-v-97867cb6]::after {
  content: "\\f1be";
}
.vl-vi-folder[data-v-97867cb6]::before {
  content: "\\f1bf";
}
.vl-vi-folder--after[data-v-97867cb6]::after {
  content: "\\f1bf";
}
.vl-vi-font[data-v-97867cb6]::before {
  content: "\\f1c0";
}
.vl-vi-font--after[data-v-97867cb6]::after {
  content: "\\f1c0";
}
.vl-vi-food-apple[data-v-97867cb6]::before {
  content: "\\f1c1";
}
.vl-vi-food-apple--after[data-v-97867cb6]::after {
  content: "\\f1c1";
}
.vl-vi-food-grain[data-v-97867cb6]::before {
  content: "\\f1c2";
}
.vl-vi-food-grain--after[data-v-97867cb6]::after {
  content: "\\f1c2";
}
.vl-vi-gender-female-male[data-v-97867cb6]::before {
  content: "\\f1c3";
}
.vl-vi-gender-female-male--after[data-v-97867cb6]::after {
  content: "\\f1c3";
}
.vl-vi-gender-female[data-v-97867cb6]::before {
  content: "\\f1c4";
}
.vl-vi-gender-female--after[data-v-97867cb6]::after {
  content: "\\f1c4";
}
.vl-vi-gender-male[data-v-97867cb6]::before {
  content: "\\f1c5";
}
.vl-vi-gender-male--after[data-v-97867cb6]::after {
  content: "\\f1c5";
}
.vl-vi-gender-transgender[data-v-97867cb6]::before {
  content: "\\f1c6";
}
.vl-vi-gender-transgender--after[data-v-97867cb6]::after {
  content: "\\f1c6";
}
.vl-vi-globe-alt[data-v-97867cb6]::before {
  content: "\\f1c7";
}
.vl-vi-globe-alt--after[data-v-97867cb6]::after {
  content: "\\f1c7";
}
.vl-vi-globe[data-v-97867cb6]::before {
  content: "\\f1c8";
}
.vl-vi-globe--after[data-v-97867cb6]::after {
  content: "\\f1c8";
}
.vl-vi-googleplus[data-v-97867cb6]::before {
  content: "\\f1c9";
}
.vl-vi-googleplus--after[data-v-97867cb6]::after {
  content: "\\f1c9";
}
.vl-vi-graduate[data-v-97867cb6]::before {
  content: "\\f1ca";
}
.vl-vi-graduate--after[data-v-97867cb6]::after {
  content: "\\f1ca";
}
.vl-vi-graduation-hat[data-v-97867cb6]::before {
  content: "\\f1cb";
}
.vl-vi-graduation-hat--after[data-v-97867cb6]::after {
  content: "\\f1cb";
}
.vl-vi-hammer-anvil[data-v-97867cb6]::before {
  content: "\\f1cc";
}
.vl-vi-hammer-anvil--after[data-v-97867cb6]::after {
  content: "\\f1cc";
}
.vl-vi-hammer[data-v-97867cb6]::before {
  content: "\\f1cd";
}
.vl-vi-hammer--after[data-v-97867cb6]::after {
  content: "\\f1cd";
}
.vl-vi-hand-hint[data-v-97867cb6]::before {
  content: "\\f1ce";
}
.vl-vi-hand-hint--after[data-v-97867cb6]::after {
  content: "\\f1ce";
}
.vl-vi-harddisk[data-v-97867cb6]::before {
  content: "\\f1cf";
}
.vl-vi-harddisk--after[data-v-97867cb6]::after {
  content: "\\f1cf";
}
.vl-vi-headphone[data-v-97867cb6]::before {
  content: "\\f1d0";
}
.vl-vi-headphone--after[data-v-97867cb6]::after {
  content: "\\f1d0";
}
.vl-vi-health-first-aid-kit[data-v-97867cb6]::before {
  content: "\\f1d1";
}
.vl-vi-health-first-aid-kit--after[data-v-97867cb6]::after {
  content: "\\f1d1";
}
.vl-vi-health-heart-pulse[data-v-97867cb6]::before {
  content: "\\f1d2";
}
.vl-vi-health-heart-pulse--after[data-v-97867cb6]::after {
  content: "\\f1d2";
}
.vl-vi-health-hospital[data-v-97867cb6]::before {
  content: "\\f1d3";
}
.vl-vi-health-hospital--after[data-v-97867cb6]::after {
  content: "\\f1d3";
}
.vl-vi-hide[data-v-97867cb6]::before {
  content: "\\f1d4";
}
.vl-vi-hide--after[data-v-97867cb6]::after {
  content: "\\f1d4";
}
.vl-vi-hierarchy[data-v-97867cb6]::before {
  content: "\\f1d5";
}
.vl-vi-hierarchy--after[data-v-97867cb6]::after {
  content: "\\f1d5";
}
.vl-vi-hotel-bath-shower[data-v-97867cb6]::before {
  content: "\\f1d6";
}
.vl-vi-hotel-bath-shower--after[data-v-97867cb6]::after {
  content: "\\f1d6";
}
.vl-vi-hotel-bed[data-v-97867cb6]::before {
  content: "\\f1d7";
}
.vl-vi-hotel-bed--after[data-v-97867cb6]::after {
  content: "\\f1d7";
}
.vl-vi-hotel-fire-alarm[data-v-97867cb6]::before {
  content: "\\f1d8";
}
.vl-vi-hotel-fire-alarm--after[data-v-97867cb6]::after {
  content: "\\f1d8";
}
.vl-vi-hotel-shower[data-v-97867cb6]::before {
  content: "\\f1d9";
}
.vl-vi-hotel-shower--after[data-v-97867cb6]::after {
  content: "\\f1d9";
}
.vl-vi-hourglass[data-v-97867cb6]::before {
  content: "\\f1da";
}
.vl-vi-hourglass--after[data-v-97867cb6]::after {
  content: "\\f1da";
}
.vl-vi-id-card[data-v-97867cb6]::before {
  content: "\\f1db";
}
.vl-vi-id-card--after[data-v-97867cb6]::after {
  content: "\\f1db";
}
.vl-vi-id[data-v-97867cb6]::before {
  content: "\\f1dc";
}
.vl-vi-id--after[data-v-97867cb6]::after {
  content: "\\f1dc";
}
.vl-vi-images-copy[data-v-97867cb6]::before {
  content: "\\f1dd";
}
.vl-vi-images-copy--after[data-v-97867cb6]::after {
  content: "\\f1dd";
}
.vl-vi-images[data-v-97867cb6]::before {
  content: "\\f1de";
}
.vl-vi-images--after[data-v-97867cb6]::after {
  content: "\\f1de";
}
.vl-vi-inbox[data-v-97867cb6]::before {
  content: "\\f1df";
}
.vl-vi-inbox--after[data-v-97867cb6]::after {
  content: "\\f1df";
}
.vl-vi-indent-left[data-v-97867cb6]::before {
  content: "\\f1e0";
}
.vl-vi-indent-left--after[data-v-97867cb6]::after {
  content: "\\f1e0";
}
.vl-vi-indent-right[data-v-97867cb6]::before {
  content: "\\f1e1";
}
.vl-vi-indent-right--after[data-v-97867cb6]::after {
  content: "\\f1e1";
}
.vl-vi-info-circle[data-v-97867cb6]::before {
  content: "\\f1e2";
}
.vl-vi-info-circle--after[data-v-97867cb6]::after {
  content: "\\f1e2";
}
.vl-vi-info-filled[data-v-97867cb6]::before {
  content: "\\f1e3";
}
.vl-vi-info-filled--after[data-v-97867cb6]::after {
  content: "\\f1e3";
}
.vl-vi-info-naked[data-v-97867cb6]::before {
  content: "\\f1e4";
}
.vl-vi-info-naked--after[data-v-97867cb6]::after {
  content: "\\f1e4";
}
.vl-vi-info[data-v-97867cb6]::before {
  content: "\\f1e5";
}
.vl-vi-info--after[data-v-97867cb6]::after {
  content: "\\f1e5";
}
.vl-vi-instagram[data-v-97867cb6]::before {
  content: "\\f1e6";
}
.vl-vi-instagram--after[data-v-97867cb6]::after {
  content: "\\f1e6";
}
.vl-vi-ironing[data-v-97867cb6]::before {
  content: "\\f1e7";
}
.vl-vi-ironing--after[data-v-97867cb6]::after {
  content: "\\f1e7";
}
.vl-vi-italic[data-v-97867cb6]::before {
  content: "\\f1e8";
}
.vl-vi-italic--after[data-v-97867cb6]::after {
  content: "\\f1e8";
}
.vl-vi-jira[data-v-97867cb6]::before {
  content: "\\f1e9";
}
.vl-vi-jira--after[data-v-97867cb6]::after {
  content: "\\f1e9";
}
.vl-vi-key[data-v-97867cb6]::before {
  content: "\\f1ea";
}
.vl-vi-key--after[data-v-97867cb6]::after {
  content: "\\f1ea";
}
.vl-vi-keyboard[data-v-97867cb6]::before {
  content: "\\f1eb";
}
.vl-vi-keyboard--after[data-v-97867cb6]::after {
  content: "\\f1eb";
}
.vl-vi-laptop[data-v-97867cb6]::before {
  content: "\\f1ec";
}
.vl-vi-laptop--after[data-v-97867cb6]::after {
  content: "\\f1ec";
}
.vl-vi-leisure-ticket[data-v-97867cb6]::before {
  content: "\\f1ed";
}
.vl-vi-leisure-ticket--after[data-v-97867cb6]::after {
  content: "\\f1ed";
}
.vl-vi-lightbulb[data-v-97867cb6]::before {
  content: "\\f1ee";
}
.vl-vi-lightbulb--after[data-v-97867cb6]::after {
  content: "\\f1ee";
}
.vl-vi-link-broken[data-v-97867cb6]::before {
  content: "\\f1ef";
}
.vl-vi-link-broken--after[data-v-97867cb6]::after {
  content: "\\f1ef";
}
.vl-vi-link[data-v-97867cb6]::before {
  content: "\\f1f0";
}
.vl-vi-link--after[data-v-97867cb6]::after {
  content: "\\f1f0";
}
.vl-vi-linkedin[data-v-97867cb6]::before {
  content: "\\f1f1";
}
.vl-vi-linkedin--after[data-v-97867cb6]::after {
  content: "\\f1f1";
}
.vl-vi-list-add[data-v-97867cb6]::before {
  content: "\\f1f2";
}
.vl-vi-list-add--after[data-v-97867cb6]::after {
  content: "\\f1f2";
}
.vl-vi-list-bullets-alt[data-v-97867cb6]::before {
  content: "\\f1f3";
}
.vl-vi-list-bullets-alt--after[data-v-97867cb6]::after {
  content: "\\f1f3";
}
.vl-vi-list-bullets[data-v-97867cb6]::before {
  content: "\\f1f4";
}
.vl-vi-list-bullets--after[data-v-97867cb6]::after {
  content: "\\f1f4";
}
.vl-vi-list-numbers[data-v-97867cb6]::before {
  content: "\\f1f5";
}
.vl-vi-list-numbers--after[data-v-97867cb6]::after {
  content: "\\f1f5";
}
.vl-vi-list[data-v-97867cb6]::before {
  content: "\\f1f6";
}
.vl-vi-list--after[data-v-97867cb6]::after {
  content: "\\f1f6";
}
.vl-vi-loader[data-v-97867cb6]::before {
  content: "\\f1f7";
}
.vl-vi-loader--after[data-v-97867cb6]::after {
  content: "\\f1f7";
}
.vl-vi-location-direction-arrow[data-v-97867cb6]::before {
  content: "\\f1f8";
}
.vl-vi-location-direction-arrow--after[data-v-97867cb6]::after {
  content: "\\f1f8";
}
.vl-vi-location-gps[data-v-97867cb6]::before {
  content: "\\f1f9";
}
.vl-vi-location-gps--after[data-v-97867cb6]::after {
  content: "\\f1f9";
}
.vl-vi-location-map[data-v-97867cb6]::before {
  content: "\\f1fa";
}
.vl-vi-location-map--after[data-v-97867cb6]::after {
  content: "\\f1fa";
}
.vl-vi-location[data-v-97867cb6]::before {
  content: "\\f1fb";
}
.vl-vi-location--after[data-v-97867cb6]::after {
  content: "\\f1fb";
}
.vl-vi-lock-unlock[data-v-97867cb6]::before {
  content: "\\f1fc";
}
.vl-vi-lock-unlock--after[data-v-97867cb6]::after {
  content: "\\f1fc";
}
.vl-vi-lock[data-v-97867cb6]::before {
  content: "\\f1fd";
}
.vl-vi-lock--after[data-v-97867cb6]::after {
  content: "\\f1fd";
}
.vl-vi-login[data-v-97867cb6]::before {
  content: "\\f1fe";
}
.vl-vi-login--after[data-v-97867cb6]::after {
  content: "\\f1fe";
}
.vl-vi-logout[data-v-97867cb6]::before {
  content: "\\f1ff";
}
.vl-vi-logout--after[data-v-97867cb6]::after {
  content: "\\f1ff";
}
.vl-vi-long-arrow[data-v-97867cb6]::before {
  content: "\\f200";
}
.vl-vi-long-arrow--after[data-v-97867cb6]::after {
  content: "\\f200";
}
.vl-vi-magic-wand[data-v-97867cb6]::before {
  content: "\\f201";
}
.vl-vi-magic-wand--after[data-v-97867cb6]::after {
  content: "\\f201";
}
.vl-vi-magnifier[data-v-97867cb6]::before {
  content: "\\f202";
}
.vl-vi-magnifier--after[data-v-97867cb6]::after {
  content: "\\f202";
}
.vl-vi-mail[data-v-97867cb6]::before {
  content: "\\f203";
}
.vl-vi-mail--after[data-v-97867cb6]::after {
  content: "\\f203";
}
.vl-vi-market[data-v-97867cb6]::before {
  content: "\\f204";
}
.vl-vi-market--after[data-v-97867cb6]::after {
  content: "\\f204";
}
.vl-vi-menu[data-v-97867cb6]::before {
  content: "\\f205";
}
.vl-vi-menu--after[data-v-97867cb6]::after {
  content: "\\f205";
}
.vl-vi-messenger[data-v-97867cb6]::before {
  content: "\\f206";
}
.vl-vi-messenger--after[data-v-97867cb6]::after {
  content: "\\f206";
}
.vl-vi-microphone-off[data-v-97867cb6]::before {
  content: "\\f207";
}
.vl-vi-microphone-off--after[data-v-97867cb6]::after {
  content: "\\f207";
}
.vl-vi-microphone[data-v-97867cb6]::before {
  content: "\\f208";
}
.vl-vi-microphone--after[data-v-97867cb6]::after {
  content: "\\f208";
}
.vl-vi-milk-carton[data-v-97867cb6]::before {
  content: "\\f209";
}
.vl-vi-milk-carton--after[data-v-97867cb6]::after {
  content: "\\f209";
}
.vl-vi-minus-circle[data-v-97867cb6]::before {
  content: "\\f20a";
}
.vl-vi-minus-circle--after[data-v-97867cb6]::after {
  content: "\\f20a";
}
.vl-vi-minus[data-v-97867cb6]::before {
  content: "\\f20b";
}
.vl-vi-minus--after[data-v-97867cb6]::after {
  content: "\\f20b";
}
.vl-vi-mobile-phone[data-v-97867cb6]::before {
  content: "\\f20c";
}
.vl-vi-mobile-phone--after[data-v-97867cb6]::after {
  content: "\\f20c";
}
.vl-vi-money-note[data-v-97867cb6]::before {
  content: "\\f20d";
}
.vl-vi-money-note--after[data-v-97867cb6]::after {
  content: "\\f20d";
}
.vl-vi-move-down[data-v-97867cb6]::before {
  content: "\\f20e";
}
.vl-vi-move-down--after[data-v-97867cb6]::after {
  content: "\\f20e";
}
.vl-vi-move-left-right[data-v-97867cb6]::before {
  content: "\\f20f";
}
.vl-vi-move-left-right--after[data-v-97867cb6]::after {
  content: "\\f20f";
}
.vl-vi-move-up[data-v-97867cb6]::before {
  content: "\\f210";
}
.vl-vi-move-up--after[data-v-97867cb6]::after {
  content: "\\f210";
}
.vl-vi-moving-elevator[data-v-97867cb6]::before {
  content: "\\f211";
}
.vl-vi-moving-elevator--after[data-v-97867cb6]::after {
  content: "\\f211";
}
.vl-vi-music-note[data-v-97867cb6]::before {
  content: "\\f212";
}
.vl-vi-music-note--after[data-v-97867cb6]::after {
  content: "\\f212";
}
.vl-vi-nature-leaf[data-v-97867cb6]::before {
  content: "\\f213";
}
.vl-vi-nature-leaf--after[data-v-97867cb6]::after {
  content: "\\f213";
}
.vl-vi-nature-tree[data-v-97867cb6]::before {
  content: "\\f214";
}
.vl-vi-nature-tree--after[data-v-97867cb6]::after {
  content: "\\f214";
}
.vl-vi-nav-down-double[data-v-97867cb6]::before {
  content: "\\f215";
}
.vl-vi-nav-down-double--after[data-v-97867cb6]::after {
  content: "\\f215";
}
.vl-vi-nav-down-light[data-v-97867cb6]::before {
  content: "\\f216";
}
.vl-vi-nav-down-light--after[data-v-97867cb6]::after {
  content: "\\f216";
}
.vl-vi-nav-down[data-v-97867cb6]::before {
  content: "\\f217";
}
.vl-vi-nav-down--after[data-v-97867cb6]::after {
  content: "\\f217";
}
.vl-vi-nav-left-double[data-v-97867cb6]::before {
  content: "\\f218";
}
.vl-vi-nav-left-double--after[data-v-97867cb6]::after {
  content: "\\f218";
}
.vl-vi-nav-left-light[data-v-97867cb6]::before {
  content: "\\f219";
}
.vl-vi-nav-left-light--after[data-v-97867cb6]::after {
  content: "\\f219";
}
.vl-vi-nav-left[data-v-97867cb6]::before {
  content: "\\f21a";
}
.vl-vi-nav-left--after[data-v-97867cb6]::after {
  content: "\\f21a";
}
.vl-vi-nav-right-double[data-v-97867cb6]::before {
  content: "\\f21b";
}
.vl-vi-nav-right-double--after[data-v-97867cb6]::after {
  content: "\\f21b";
}
.vl-vi-nav-right-light[data-v-97867cb6]::before {
  content: "\\f21c";
}
.vl-vi-nav-right-light--after[data-v-97867cb6]::after {
  content: "\\f21c";
}
.vl-vi-nav-right[data-v-97867cb6]::before {
  content: "\\f21d";
}
.vl-vi-nav-right--after[data-v-97867cb6]::after {
  content: "\\f21d";
}
.vl-vi-nav-show-more-horizontal[data-v-97867cb6]::before {
  content: "\\f21e";
}
.vl-vi-nav-show-more-horizontal--after[data-v-97867cb6]::after {
  content: "\\f21e";
}
.vl-vi-nav-show-more-vertical[data-v-97867cb6]::before {
  content: "\\f21f";
}
.vl-vi-nav-show-more-vertical--after[data-v-97867cb6]::after {
  content: "\\f21f";
}
.vl-vi-nav-up-double[data-v-97867cb6]::before {
  content: "\\f220";
}
.vl-vi-nav-up-double--after[data-v-97867cb6]::after {
  content: "\\f220";
}
.vl-vi-nav-up-light[data-v-97867cb6]::before {
  content: "\\f221";
}
.vl-vi-nav-up-light--after[data-v-97867cb6]::after {
  content: "\\f221";
}
.vl-vi-nav-up[data-v-97867cb6]::before {
  content: "\\f222";
}
.vl-vi-nav-up--after[data-v-97867cb6]::after {
  content: "\\f222";
}
.vl-vi-news[data-v-97867cb6]::before {
  content: "\\f223";
}
.vl-vi-news--after[data-v-97867cb6]::after {
  content: "\\f223";
}
.vl-vi-newsletter[data-v-97867cb6]::before {
  content: "\\f224";
}
.vl-vi-newsletter--after[data-v-97867cb6]::after {
  content: "\\f224";
}
.vl-vi-newspaper[data-v-97867cb6]::before {
  content: "\\f225";
}
.vl-vi-newspaper--after[data-v-97867cb6]::after {
  content: "\\f225";
}
.vl-vi-next[data-v-97867cb6]::before {
  content: "\\f226";
}
.vl-vi-next--after[data-v-97867cb6]::after {
  content: "\\f226";
}
.vl-vi-organization-network[data-v-97867cb6]::before {
  content: "\\f227";
}
.vl-vi-organization-network--after[data-v-97867cb6]::after {
  content: "\\f227";
}
.vl-vi-other-annoyances-alt[data-v-97867cb6]::before {
  content: "\\f228";
}
.vl-vi-other-annoyances-alt--after[data-v-97867cb6]::after {
  content: "\\f228";
}
.vl-vi-other-annoyances[data-v-97867cb6]::before {
  content: "\\f229";
}
.vl-vi-other-annoyances--after[data-v-97867cb6]::after {
  content: "\\f229";
}
.vl-vi-paint-brush[data-v-97867cb6]::before {
  content: "\\f22a";
}
.vl-vi-paint-brush--after[data-v-97867cb6]::after {
  content: "\\f22a";
}
.vl-vi-paper[data-v-97867cb6]::before {
  content: "\\f22b";
}
.vl-vi-paper--after[data-v-97867cb6]::after {
  content: "\\f22b";
}
.vl-vi-paperclip[data-v-97867cb6]::before {
  content: "\\f22c";
}
.vl-vi-paperclip--after[data-v-97867cb6]::after {
  content: "\\f22c";
}
.vl-vi-paperplane[data-v-97867cb6]::before {
  content: "\\f22d";
}
.vl-vi-paperplane--after[data-v-97867cb6]::after {
  content: "\\f22d";
}
.vl-vi-paragraph[data-v-97867cb6]::before {
  content: "\\f22e";
}
.vl-vi-paragraph--after[data-v-97867cb6]::after {
  content: "\\f22e";
}
.vl-vi-pause[data-v-97867cb6]::before {
  content: "\\f22f";
}
.vl-vi-pause--after[data-v-97867cb6]::after {
  content: "\\f22f";
}
.vl-vi-pencil-ruler[data-v-97867cb6]::before {
  content: "\\f230";
}
.vl-vi-pencil-ruler--after[data-v-97867cb6]::after {
  content: "\\f230";
}
.vl-vi-pencil-write[data-v-97867cb6]::before {
  content: "\\f231";
}
.vl-vi-pencil-write--after[data-v-97867cb6]::after {
  content: "\\f231";
}
.vl-vi-pencil[data-v-97867cb6]::before {
  content: "\\f232";
}
.vl-vi-pencil--after[data-v-97867cb6]::after {
  content: "\\f232";
}
.vl-vi-pennants[data-v-97867cb6]::before {
  content: "\\f233";
}
.vl-vi-pennants--after[data-v-97867cb6]::after {
  content: "\\f233";
}
.vl-vi-phone-incoming[data-v-97867cb6]::before {
  content: "\\f234";
}
.vl-vi-phone-incoming--after[data-v-97867cb6]::after {
  content: "\\f234";
}
.vl-vi-phone-off[data-v-97867cb6]::before {
  content: "\\f235";
}
.vl-vi-phone-off--after[data-v-97867cb6]::after {
  content: "\\f235";
}
.vl-vi-phone-outgoing[data-v-97867cb6]::before {
  content: "\\f236";
}
.vl-vi-phone-outgoing--after[data-v-97867cb6]::after {
  content: "\\f236";
}
.vl-vi-phone-record[data-v-97867cb6]::before {
  content: "\\f237";
}
.vl-vi-phone-record--after[data-v-97867cb6]::after {
  content: "\\f237";
}
.vl-vi-phone-signal-low[data-v-97867cb6]::before {
  content: "\\f238";
}
.vl-vi-phone-signal-low--after[data-v-97867cb6]::after {
  content: "\\f238";
}
.vl-vi-phone-speaker[data-v-97867cb6]::before {
  content: "\\f239";
}
.vl-vi-phone-speaker--after[data-v-97867cb6]::after {
  content: "\\f239";
}
.vl-vi-phone[data-v-97867cb6]::before {
  content: "\\f23a";
}
.vl-vi-phone--after[data-v-97867cb6]::after {
  content: "\\f23a";
}
.vl-vi-pick-up[data-v-97867cb6]::before {
  content: "\\f23b";
}
.vl-vi-pick-up--after[data-v-97867cb6]::after {
  content: "\\f23b";
}
.vl-vi-pin-paper[data-v-97867cb6]::before {
  content: "\\f23c";
}
.vl-vi-pin-paper--after[data-v-97867cb6]::after {
  content: "\\f23c";
}
.vl-vi-pin[data-v-97867cb6]::before {
  content: "\\f23d";
}
.vl-vi-pin--after[data-v-97867cb6]::after {
  content: "\\f23d";
}
.vl-vi-pinterest[data-v-97867cb6]::before {
  content: "\\f23e";
}
.vl-vi-pinterest--after[data-v-97867cb6]::after {
  content: "\\f23e";
}
.vl-vi-places-factory[data-v-97867cb6]::before {
  content: "\\f23f";
}
.vl-vi-places-factory--after[data-v-97867cb6]::after {
  content: "\\f23f";
}
.vl-vi-places-home[data-v-97867cb6]::before {
  content: "\\f240";
}
.vl-vi-places-home--after[data-v-97867cb6]::after {
  content: "\\f240";
}
.vl-vi-play[data-v-97867cb6]::before {
  content: "\\f241";
}
.vl-vi-play--after[data-v-97867cb6]::after {
  content: "\\f241";
}
.vl-vi-playstreet[data-v-97867cb6]::before {
  content: "\\f242";
}
.vl-vi-playstreet--after[data-v-97867cb6]::after {
  content: "\\f242";
}
.vl-vi-plug[data-v-97867cb6]::before {
  content: "\\f243";
}
.vl-vi-plug--after[data-v-97867cb6]::after {
  content: "\\f243";
}
.vl-vi-plus-circle-filled[data-v-97867cb6]::before {
  content: "\\f244";
}
.vl-vi-plus-circle-filled--after[data-v-97867cb6]::after {
  content: "\\f244";
}
.vl-vi-plus-circle[data-v-97867cb6]::before {
  content: "\\f245";
}
.vl-vi-plus-circle--after[data-v-97867cb6]::after {
  content: "\\f245";
}
.vl-vi-plus-naked[data-v-97867cb6]::before {
  content: "\\f246";
}
.vl-vi-plus-naked--after[data-v-97867cb6]::after {
  content: "\\f246";
}
.vl-vi-plus[data-v-97867cb6]::before {
  content: "\\f247";
}
.vl-vi-plus--after[data-v-97867cb6]::after {
  content: "\\f247";
}
.vl-vi-power-button[data-v-97867cb6]::before {
  content: "\\f248";
}
.vl-vi-power-button--after[data-v-97867cb6]::after {
  content: "\\f248";
}
.vl-vi-printer-view[data-v-97867cb6]::before {
  content: "\\f249";
}
.vl-vi-printer-view--after[data-v-97867cb6]::after {
  content: "\\f249";
}
.vl-vi-printer[data-v-97867cb6]::before {
  content: "\\f24a";
}
.vl-vi-printer--after[data-v-97867cb6]::after {
  content: "\\f24a";
}
.vl-vi-profile-active[data-v-97867cb6]::before {
  content: "\\f24b";
}
.vl-vi-profile-active--after[data-v-97867cb6]::after {
  content: "\\f24b";
}
.vl-vi-programming-bug[data-v-97867cb6]::before {
  content: "\\f24c";
}
.vl-vi-programming-bug--after[data-v-97867cb6]::after {
  content: "\\f24c";
}
.vl-vi-programming-jigsaw[data-v-97867cb6]::before {
  content: "\\f24d";
}
.vl-vi-programming-jigsaw--after[data-v-97867cb6]::after {
  content: "\\f24d";
}
.vl-vi-publication[data-v-97867cb6]::before {
  content: "\\f24e";
}
.vl-vi-publication--after[data-v-97867cb6]::after {
  content: "\\f24e";
}
.vl-vi-question-mark-filled[data-v-97867cb6]::before {
  content: "\\f24f";
}
.vl-vi-question-mark-filled--after[data-v-97867cb6]::after {
  content: "\\f24f";
}
.vl-vi-question-mark-small[data-v-97867cb6]::before {
  content: "\\f250";
}
.vl-vi-question-mark-small--after[data-v-97867cb6]::after {
  content: "\\f250";
}
.vl-vi-question-mark[data-v-97867cb6]::before {
  content: "\\f251";
}
.vl-vi-question-mark--after[data-v-97867cb6]::after {
  content: "\\f251";
}
.vl-vi-question[data-v-97867cb6]::before {
  content: "\\f252";
}
.vl-vi-question--after[data-v-97867cb6]::after {
  content: "\\f252";
}
.vl-vi-recreation[data-v-97867cb6]::before {
  content: "\\f253";
}
.vl-vi-recreation--after[data-v-97867cb6]::after {
  content: "\\f253";
}
.vl-vi-reply-all[data-v-97867cb6]::before {
  content: "\\f254";
}
.vl-vi-reply-all--after[data-v-97867cb6]::after {
  content: "\\f254";
}
.vl-vi-reply[data-v-97867cb6]::before {
  content: "\\f255";
}
.vl-vi-reply--after[data-v-97867cb6]::after {
  content: "\\f255";
}
.vl-vi-rewards-certified-badge[data-v-97867cb6]::before {
  content: "\\f256";
}
.vl-vi-rewards-certified-badge--after[data-v-97867cb6]::after {
  content: "\\f256";
}
.vl-vi-rewards-gift[data-v-97867cb6]::before {
  content: "\\f257";
}
.vl-vi-rewards-gift--after[data-v-97867cb6]::after {
  content: "\\f257";
}
.vl-vi-road-block[data-v-97867cb6]::before {
  content: "\\f258";
}
.vl-vi-road-block--after[data-v-97867cb6]::after {
  content: "\\f258";
}
.vl-vi-road[data-v-97867cb6]::before {
  content: "\\f259";
}
.vl-vi-road--after[data-v-97867cb6]::after {
  content: "\\f259";
}
.vl-vi-romance-marriage-license[data-v-97867cb6]::before {
  content: "\\f25a";
}
.vl-vi-romance-marriage-license--after[data-v-97867cb6]::after {
  content: "\\f25a";
}
.vl-vi-ruler[data-v-97867cb6]::before {
  content: "\\f25b";
}
.vl-vi-ruler--after[data-v-97867cb6]::after {
  content: "\\f25b";
}
.vl-vi-safe[data-v-97867cb6]::before {
  content: "\\f25c";
}
.vl-vi-safe--after[data-v-97867cb6]::after {
  content: "\\f25c";
}
.vl-vi-save[data-v-97867cb6]::before {
  content: "\\f25d";
}
.vl-vi-save--after[data-v-97867cb6]::after {
  content: "\\f25d";
}
.vl-vi-scaffold[data-v-97867cb6]::before {
  content: "\\f25e";
}
.vl-vi-scaffold--after[data-v-97867cb6]::after {
  content: "\\f25e";
}
.vl-vi-scan[data-v-97867cb6]::before {
  content: "\\f25f";
}
.vl-vi-scan--after[data-v-97867cb6]::after {
  content: "\\f25f";
}
.vl-vi-scissors[data-v-97867cb6]::before {
  content: "\\f260";
}
.vl-vi-scissors--after[data-v-97867cb6]::after {
  content: "\\f260";
}
.vl-vi-search[data-v-97867cb6]::before {
  content: "\\f261";
}
.vl-vi-search--after[data-v-97867cb6]::after {
  content: "\\f261";
}
.vl-vi-server[data-v-97867cb6]::before {
  content: "\\f262";
}
.vl-vi-server--after[data-v-97867cb6]::after {
  content: "\\f262";
}
.vl-vi-settings[data-v-97867cb6]::before {
  content: "\\f263";
}
.vl-vi-settings--after[data-v-97867cb6]::after {
  content: "\\f263";
}
.vl-vi-share-megaphone[data-v-97867cb6]::before {
  content: "\\f264";
}
.vl-vi-share-megaphone--after[data-v-97867cb6]::after {
  content: "\\f264";
}
.vl-vi-share-rss-feed[data-v-97867cb6]::before {
  content: "\\f265";
}
.vl-vi-share-rss-feed--after[data-v-97867cb6]::after {
  content: "\\f265";
}
.vl-vi-share[data-v-97867cb6]::before {
  content: "\\f266";
}
.vl-vi-share--after[data-v-97867cb6]::after {
  content: "\\f266";
}
.vl-vi-shipping-truck[data-v-97867cb6]::before {
  content: "\\f267";
}
.vl-vi-shipping-truck--after[data-v-97867cb6]::after {
  content: "\\f267";
}
.vl-vi-shopping-basket-add[data-v-97867cb6]::before {
  content: "\\f268";
}
.vl-vi-shopping-basket-add--after[data-v-97867cb6]::after {
  content: "\\f268";
}
.vl-vi-shopping-basket-subtract[data-v-97867cb6]::before {
  content: "\\f269";
}
.vl-vi-shopping-basket-subtract--after[data-v-97867cb6]::after {
  content: "\\f269";
}
.vl-vi-shopping-basket[data-v-97867cb6]::before {
  content: "\\f26a";
}
.vl-vi-shopping-basket--after[data-v-97867cb6]::after {
  content: "\\f26a";
}
.vl-vi-shopping-cart[data-v-97867cb6]::before {
  content: "\\f26b";
}
.vl-vi-shopping-cart--after[data-v-97867cb6]::after {
  content: "\\f26b";
}
.vl-vi-shopping[data-v-97867cb6]::before {
  content: "\\f26c";
}
.vl-vi-shopping--after[data-v-97867cb6]::after {
  content: "\\f26c";
}
.vl-vi-shrink[data-v-97867cb6]::before {
  content: "\\f26d";
}
.vl-vi-shrink--after[data-v-97867cb6]::after {
  content: "\\f26d";
}
.vl-vi-sign-disable[data-v-97867cb6]::before {
  content: "\\f26e";
}
.vl-vi-sign-disable--after[data-v-97867cb6]::after {
  content: "\\f26e";
}
.vl-vi-sign-recycle[data-v-97867cb6]::before {
  content: "\\f26f";
}
.vl-vi-sign-recycle--after[data-v-97867cb6]::after {
  content: "\\f26f";
}
.vl-vi-sitemap[data-v-97867cb6]::before {
  content: "\\f270";
}
.vl-vi-sitemap--after[data-v-97867cb6]::after {
  content: "\\f270";
}
.vl-vi-skype[data-v-97867cb6]::before {
  content: "\\f271";
}
.vl-vi-skype--after[data-v-97867cb6]::after {
  content: "\\f271";
}
.vl-vi-smiley-poker-face[data-v-97867cb6]::before {
  content: "\\f272";
}
.vl-vi-smiley-poker-face--after[data-v-97867cb6]::after {
  content: "\\f272";
}
.vl-vi-smiley-smile[data-v-97867cb6]::before {
  content: "\\f273";
}
.vl-vi-smiley-smile--after[data-v-97867cb6]::after {
  content: "\\f273";
}
.vl-vi-snapchat[data-v-97867cb6]::before {
  content: "\\f274";
}
.vl-vi-snapchat--after[data-v-97867cb6]::after {
  content: "\\f274";
}
.vl-vi-snippet[data-v-97867cb6]::before {
  content: "\\f275";
}
.vl-vi-snippet--after[data-v-97867cb6]::after {
  content: "\\f275";
}
.vl-vi-sort[data-v-97867cb6]::before {
  content: "\\f276";
}
.vl-vi-sort--after[data-v-97867cb6]::after {
  content: "\\f276";
}
.vl-vi-speaker-volume-decrease[data-v-97867cb6]::before {
  content: "\\f277";
}
.vl-vi-speaker-volume-decrease--after[data-v-97867cb6]::after {
  content: "\\f277";
}
.vl-vi-speaker-volume-high[data-v-97867cb6]::before {
  content: "\\f278";
}
.vl-vi-speaker-volume-high--after[data-v-97867cb6]::after {
  content: "\\f278";
}
.vl-vi-speaker-volume-increase[data-v-97867cb6]::before {
  content: "\\f279";
}
.vl-vi-speaker-volume-increase--after[data-v-97867cb6]::after {
  content: "\\f279";
}
.vl-vi-speaker-volume-low[data-v-97867cb6]::before {
  content: "\\f27a";
}
.vl-vi-speaker-volume-low--after[data-v-97867cb6]::after {
  content: "\\f27a";
}
.vl-vi-speaker-volume-medium[data-v-97867cb6]::before {
  content: "\\f27b";
}
.vl-vi-speaker-volume-medium--after[data-v-97867cb6]::after {
  content: "\\f27b";
}
.vl-vi-speaker-volume-off[data-v-97867cb6]::before {
  content: "\\f27c";
}
.vl-vi-speaker-volume-off--after[data-v-97867cb6]::after {
  content: "\\f27c";
}
.vl-vi-sports-competition[data-v-97867cb6]::before {
  content: "\\f27d";
}
.vl-vi-sports-competition--after[data-v-97867cb6]::after {
  content: "\\f27d";
}
.vl-vi-spotify[data-v-97867cb6]::before {
  content: "\\f27e";
}
.vl-vi-spotify--after[data-v-97867cb6]::after {
  content: "\\f27e";
}
.vl-vi-stop[data-v-97867cb6]::before {
  content: "\\f27f";
}
.vl-vi-stop--after[data-v-97867cb6]::after {
  content: "\\f27f";
}
.vl-vi-subtract-filled[data-v-97867cb6]::before {
  content: "\\f280";
}
.vl-vi-subtract-filled--after[data-v-97867cb6]::after {
  content: "\\f280";
}
.vl-vi-subtract-naked[data-v-97867cb6]::before {
  content: "\\f281";
}
.vl-vi-subtract-naked--after[data-v-97867cb6]::after {
  content: "\\f281";
}
.vl-vi-subtract[data-v-97867cb6]::before {
  content: "\\f282";
}
.vl-vi-subtract--after[data-v-97867cb6]::after {
  content: "\\f282";
}
.vl-vi-subway[data-v-97867cb6]::before {
  content: "\\f283";
}
.vl-vi-subway--after[data-v-97867cb6]::after {
  content: "\\f283";
}
.vl-vi-suitcase[data-v-97867cb6]::before {
  content: "\\f284";
}
.vl-vi-suitcase--after[data-v-97867cb6]::after {
  content: "\\f284";
}
.vl-vi-switches[data-v-97867cb6]::before {
  content: "\\f285";
}
.vl-vi-switches--after[data-v-97867cb6]::after {
  content: "\\f285";
}
.vl-vi-symbol-wifi-check[data-v-97867cb6]::before {
  content: "\\f286";
}
.vl-vi-symbol-wifi-check--after[data-v-97867cb6]::after {
  content: "\\f286";
}
.vl-vi-symbol-wifi-close[data-v-97867cb6]::before {
  content: "\\f287";
}
.vl-vi-symbol-wifi-close--after[data-v-97867cb6]::after {
  content: "\\f287";
}
.vl-vi-symbol-wifi[data-v-97867cb6]::before {
  content: "\\f288";
}
.vl-vi-symbol-wifi--after[data-v-97867cb6]::after {
  content: "\\f288";
}
.vl-vi-synchronize-timeout[data-v-97867cb6]::before {
  content: "\\f289";
}
.vl-vi-synchronize-timeout--after[data-v-97867cb6]::after {
  content: "\\f289";
}
.vl-vi-synchronize[data-v-97867cb6]::before {
  content: "\\f28a";
}
.vl-vi-synchronize--after[data-v-97867cb6]::after {
  content: "\\f28a";
}
.vl-vi-t-shirt[data-v-97867cb6]::before {
  content: "\\f28b";
}
.vl-vi-t-shirt--after[data-v-97867cb6]::after {
  content: "\\f28b";
}
.vl-vi-tablet[data-v-97867cb6]::before {
  content: "\\f28c";
}
.vl-vi-tablet--after[data-v-97867cb6]::after {
  content: "\\f28c";
}
.vl-vi-tag-add[data-v-97867cb6]::before {
  content: "\\f28d";
}
.vl-vi-tag-add--after[data-v-97867cb6]::after {
  content: "\\f28d";
}
.vl-vi-tag-check[data-v-97867cb6]::before {
  content: "\\f28e";
}
.vl-vi-tag-check--after[data-v-97867cb6]::after {
  content: "\\f28e";
}
.vl-vi-tag-close[data-v-97867cb6]::before {
  content: "\\f28f";
}
.vl-vi-tag-close--after[data-v-97867cb6]::after {
  content: "\\f28f";
}
.vl-vi-tag-double[data-v-97867cb6]::before {
  content: "\\f290";
}
.vl-vi-tag-double--after[data-v-97867cb6]::after {
  content: "\\f290";
}
.vl-vi-tag-edit[data-v-97867cb6]::before {
  content: "\\f291";
}
.vl-vi-tag-edit--after[data-v-97867cb6]::after {
  content: "\\f291";
}
.vl-vi-tag-subtract[data-v-97867cb6]::before {
  content: "\\f292";
}
.vl-vi-tag-subtract--after[data-v-97867cb6]::after {
  content: "\\f292";
}
.vl-vi-tag-view[data-v-97867cb6]::before {
  content: "\\f293";
}
.vl-vi-tag-view--after[data-v-97867cb6]::after {
  content: "\\f293";
}
.vl-vi-tag[data-v-97867cb6]::before {
  content: "\\f294";
}
.vl-vi-tag--after[data-v-97867cb6]::after {
  content: "\\f294";
}
.vl-vi-taxi[data-v-97867cb6]::before {
  content: "\\f295";
}
.vl-vi-taxi--after[data-v-97867cb6]::after {
  content: "\\f295";
}
.vl-vi-television[data-v-97867cb6]::before {
  content: "\\f296";
}
.vl-vi-television--after[data-v-97867cb6]::after {
  content: "\\f296";
}
.vl-vi-terrace[data-v-97867cb6]::before {
  content: "\\f297";
}
.vl-vi-terrace--after[data-v-97867cb6]::after {
  content: "\\f297";
}
.vl-vi-text-cursor[data-v-97867cb6]::before {
  content: "\\f298";
}
.vl-vi-text-cursor--after[data-v-97867cb6]::after {
  content: "\\f298";
}
.vl-vi-text-eraser[data-v-97867cb6]::before {
  content: "\\f299";
}
.vl-vi-text-eraser--after[data-v-97867cb6]::after {
  content: "\\f299";
}
.vl-vi-text-redo[data-v-97867cb6]::before {
  content: "\\f29a";
}
.vl-vi-text-redo--after[data-v-97867cb6]::after {
  content: "\\f29a";
}
.vl-vi-text-undo[data-v-97867cb6]::before {
  content: "\\f29b";
}
.vl-vi-text-undo--after[data-v-97867cb6]::after {
  content: "\\f29b";
}
.vl-vi-timeline[data-v-97867cb6]::before {
  content: "\\f29c";
}
.vl-vi-timeline--after[data-v-97867cb6]::after {
  content: "\\f29c";
}
.vl-vi-tint[data-v-97867cb6]::before {
  content: "\\f29d";
}
.vl-vi-tint--after[data-v-97867cb6]::after {
  content: "\\f29d";
}
.vl-vi-train[data-v-97867cb6]::before {
  content: "\\f29e";
}
.vl-vi-train--after[data-v-97867cb6]::after {
  content: "\\f29e";
}
.vl-vi-trash[data-v-97867cb6]::before {
  content: "\\f29f";
}
.vl-vi-trash--after[data-v-97867cb6]::after {
  content: "\\f29f";
}
.vl-vi-trophy[data-v-97867cb6]::before {
  content: "\\f2a0";
}
.vl-vi-trophy--after[data-v-97867cb6]::after {
  content: "\\f2a0";
}
.vl-vi-twitter[data-v-97867cb6]::before {
  content: "\\f2a1";
}
.vl-vi-twitter--after[data-v-97867cb6]::after {
  content: "\\f2a1";
}
.vl-vi-underline[data-v-97867cb6]::before {
  content: "\\f2a2";
}
.vl-vi-underline--after[data-v-97867cb6]::after {
  content: "\\f2a2";
}
.vl-vi-university[data-v-97867cb6]::before {
  content: "\\f2a3";
}
.vl-vi-university--after[data-v-97867cb6]::after {
  content: "\\f2a3";
}
.vl-vi-up-down-arrows[data-v-97867cb6]::before {
  content: "\\f2a4";
}
.vl-vi-up-down-arrows--after[data-v-97867cb6]::after {
  content: "\\f2a4";
}
.vl-vi-upload-harddisk[data-v-97867cb6]::before {
  content: "\\f2a5";
}
.vl-vi-upload-harddisk--after[data-v-97867cb6]::after {
  content: "\\f2a5";
}
.vl-vi-usb[data-v-97867cb6]::before {
  content: "\\f2a6";
}
.vl-vi-usb--after[data-v-97867cb6]::after {
  content: "\\f2a6";
}
.vl-vi-user-alt[data-v-97867cb6]::before {
  content: "\\f2a7";
}
.vl-vi-user-alt--after[data-v-97867cb6]::after {
  content: "\\f2a7";
}
.vl-vi-user-box[data-v-97867cb6]::before {
  content: "\\f2a8";
}
.vl-vi-user-box--after[data-v-97867cb6]::after {
  content: "\\f2a8";
}
.vl-vi-user-download[data-v-97867cb6]::before {
  content: "\\f2a9";
}
.vl-vi-user-download--after[data-v-97867cb6]::after {
  content: "\\f2a9";
}
.vl-vi-user-email[data-v-97867cb6]::before {
  content: "\\f2aa";
}
.vl-vi-user-email--after[data-v-97867cb6]::after {
  content: "\\f2aa";
}
.vl-vi-user-female[data-v-97867cb6]::before {
  content: "\\f2ab";
}
.vl-vi-user-female--after[data-v-97867cb6]::after {
  content: "\\f2ab";
}
.vl-vi-user-group[data-v-97867cb6]::before {
  content: "\\f2ac";
}
.vl-vi-user-group--after[data-v-97867cb6]::after {
  content: "\\f2ac";
}
.vl-vi-user-male[data-v-97867cb6]::before {
  content: "\\f2ad";
}
.vl-vi-user-male--after[data-v-97867cb6]::after {
  content: "\\f2ad";
}
.vl-vi-user-reception[data-v-97867cb6]::before {
  content: "\\f2ae";
}
.vl-vi-user-reception--after[data-v-97867cb6]::after {
  content: "\\f2ae";
}
.vl-vi-user-redirect[data-v-97867cb6]::before {
  content: "\\f2af";
}
.vl-vi-user-redirect--after[data-v-97867cb6]::after {
  content: "\\f2af";
}
.vl-vi-user-remove[data-v-97867cb6]::before {
  content: "\\f2b0";
}
.vl-vi-user-remove--after[data-v-97867cb6]::after {
  content: "\\f2b0";
}
.vl-vi-user-setting[data-v-97867cb6]::before {
  content: "\\f2b1";
}
.vl-vi-user-setting--after[data-v-97867cb6]::after {
  content: "\\f2b1";
}
.vl-vi-user-signup[data-v-97867cb6]::before {
  content: "\\f2b2";
}
.vl-vi-user-signup--after[data-v-97867cb6]::after {
  content: "\\f2b2";
}
.vl-vi-user[data-v-97867cb6]::before {
  content: "\\f2b3";
}
.vl-vi-user--after[data-v-97867cb6]::after {
  content: "\\f2b3";
}
.vl-vi-vaccum-cleaner[data-v-97867cb6]::before {
  content: "\\f2b4";
}
.vl-vi-vaccum-cleaner--after[data-v-97867cb6]::after {
  content: "\\f2b4";
}
.vl-vi-video-subtitle[data-v-97867cb6]::before {
  content: "\\f2b5";
}
.vl-vi-video-subtitle--after[data-v-97867cb6]::after {
  content: "\\f2b5";
}
.vl-vi-view-add[data-v-97867cb6]::before {
  content: "\\f2b6";
}
.vl-vi-view-add--after[data-v-97867cb6]::after {
  content: "\\f2b6";
}
.vl-vi-view-hide[data-v-97867cb6]::before {
  content: "\\f2b7";
}
.vl-vi-view-hide--after[data-v-97867cb6]::after {
  content: "\\f2b7";
}
.vl-vi-vlaanderen[data-v-97867cb6]::before {
  content: "\\f2b8";
}
.vl-vi-vlaanderen--after[data-v-97867cb6]::after {
  content: "\\f2b8";
}
.vl-vi-vote-flag[data-v-97867cb6]::before {
  content: "\\f2b9";
}
.vl-vi-vote-flag--after[data-v-97867cb6]::after {
  content: "\\f2b9";
}
.vl-vi-vote-heart[data-v-97867cb6]::before {
  content: "\\f2ba";
}
.vl-vi-vote-heart--after[data-v-97867cb6]::after {
  content: "\\f2ba";
}
.vl-vi-vote-star-filled[data-v-97867cb6]::before {
  content: "\\f2bb";
}
.vl-vi-vote-star-filled--after[data-v-97867cb6]::after {
  content: "\\f2bb";
}
.vl-vi-vote-star[data-v-97867cb6]::before {
  content: "\\f2bc";
}
.vl-vi-vote-star--after[data-v-97867cb6]::after {
  content: "\\f2bc";
}
.vl-vi-vote-thumbs-down[data-v-97867cb6]::before {
  content: "\\f2bd";
}
.vl-vi-vote-thumbs-down--after[data-v-97867cb6]::after {
  content: "\\f2bd";
}
.vl-vi-vote-thumbs-up[data-v-97867cb6]::before {
  content: "\\f2be";
}
.vl-vi-vote-thumbs-up--after[data-v-97867cb6]::after {
  content: "\\f2be";
}
.vl-vi-voucher-check[data-v-97867cb6]::before {
  content: "\\f2bf";
}
.vl-vi-voucher-check--after[data-v-97867cb6]::after {
  content: "\\f2bf";
}
.vl-vi-voucher-download[data-v-97867cb6]::before {
  content: "\\f2c0";
}
.vl-vi-voucher-download--after[data-v-97867cb6]::after {
  content: "\\f2c0";
}
.vl-vi-voucher-scissors[data-v-97867cb6]::before {
  content: "\\f2c1";
}
.vl-vi-voucher-scissors--after[data-v-97867cb6]::after {
  content: "\\f2c1";
}
.vl-vi-vouchers-list[data-v-97867cb6]::before {
  content: "\\f2c2";
}
.vl-vi-vouchers-list--after[data-v-97867cb6]::after {
  content: "\\f2c2";
}
.vl-vi-wallet[data-v-97867cb6]::before {
  content: "\\f2c3";
}
.vl-vi-wallet--after[data-v-97867cb6]::after {
  content: "\\f2c3";
}
.vl-vi-warning[data-v-97867cb6]::before {
  content: "\\f2c4";
}
.vl-vi-warning--after[data-v-97867cb6]::after {
  content: "\\f2c4";
}
.vl-vi-whatsapp[data-v-97867cb6]::before {
  content: "\\f2c5";
}
.vl-vi-whatsapp--after[data-v-97867cb6]::after {
  content: "\\f2c5";
}
.vl-vi-whiskey-bottle-glass[data-v-97867cb6]::before {
  content: "\\f2c6";
}
.vl-vi-whiskey-bottle-glass--after[data-v-97867cb6]::after {
  content: "\\f2c6";
}
.vl-vi-window-forward[data-v-97867cb6]::before {
  content: "\\f2c7";
}
.vl-vi-window-forward--after[data-v-97867cb6]::after {
  content: "\\f2c7";
}
.vl-vi-wrench[data-v-97867cb6]::before {
  content: "\\f2c8";
}
.vl-vi-wrench--after[data-v-97867cb6]::after {
  content: "\\f2c8";
}
.vl-vi-www[data-v-97867cb6]::before {
  content: "\\f2c9";
}
.vl-vi-www--after[data-v-97867cb6]::after {
  content: "\\f2c9";
}
.vl-vi-youtube[data-v-97867cb6]::before {
  content: "\\f2ca";
}
.vl-vi-youtube--after[data-v-97867cb6]::after {
  content: "\\f2ca";
}
.vl-vi-zoom-in[data-v-97867cb6]::before {
  content: "\\f2cb";
}
.vl-vi-zoom-in--after[data-v-97867cb6]::after {
  content: "\\f2cb";
}
.vl-vi-zoom-out[data-v-97867cb6]::before {
  content: "\\f2cc";
}
.vl-vi-zoom-out--after[data-v-97867cb6]::after {
  content: "\\f2cc";
}
a[data-v-97867cb6] {
  color: var(--vl-theme-action-color, #05c);
  text-decoration: underline;
  -webkit-text-decoration-skip: ink;
          text-decoration-skip-ink: auto;
}
a[data-v-97867cb6]:hover, a[data-v-97867cb6]:focus {
  text-decoration: none;
  color: var(--vl-theme-action-hover-color, #003bb0);
}
a[data-v-97867cb6]:focus {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
a[data-v-97867cb6]:focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
@supports (outline-offset: 2px) {
a[data-v-97867cb6]:focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
a[data-v-97867cb6]:visited {
  color: #660599;
}
button[data-v-97867cb6] {
  font-family: "Flanders Art Sans", sans-serif;
  cursor: pointer;
}
button[data-v-97867cb6]:focus {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
button[data-v-97867cb6]:focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
img.vl-image--error[data-v-97867cb6] {
  overflow-wrap: break-word;
  padding: 10px;
  line-height: 1.25;
  font-size: 1.6rem;
  color: var(--vl-theme-fg-color);
  background-color: #f7f9fc;
}
sub[data-v-97867cb6] {
  vertical-align: sub;
  font-size: 1.2rem;
}
sup[data-v-97867cb6] {
  vertical-align: super;
  font-size: 1.2rem;
}
.vl-grid[data-v-97867cb6] {
  position: relative;
  box-sizing: border-box;
  display: flex;
  margin-left: -3rem;
  flex-direction: row;
  flex: 0 1 auto;
  flex-wrap: wrap;
}
.vl-grid > *[data-v-97867cb6] {
  box-sizing: border-box;
  padding-left: 3rem;
  position: relative;
}
.vl-grid--no-gutter[data-v-97867cb6] {
  margin-left: 0;
}
.vl-grid--no-gutter > *[data-v-97867cb6] {
  padding-left: 0;
}
.vl-grid--v-top[data-v-97867cb6] {
  align-items: flex-start;
}
.vl-grid--v-center[data-v-97867cb6] {
  align-items: center;
}
.vl-grid--v-bottom[data-v-97867cb6] {
  align-items: flex-end;
}
.vl-grid--v-stretch[data-v-97867cb6] {
  align-items: stretch;
}
.vl-grid--v-baseline[data-v-97867cb6] {
  align-items: stretch;
}
.vl-grid--align-start[data-v-97867cb6] {
  justify-content: flex-start;
}
.vl-grid--align-end[data-v-97867cb6] {
  justify-content: flex-end;
}
.vl-grid--align-center[data-v-97867cb6] {
  justify-content: center;
}
.vl-grid--align-space-between[data-v-97867cb6] {
  justify-content: space-between;
}
.vl-grid--align-space-around[data-v-97867cb6] {
  justify-content: space-around;
}
.vl-col--fit[data-v-97867cb6] {
  flex: 1 0;
}
.vl-col--flex[data-v-97867cb6] {
  display: flex;
}
.vl-col--1-12[data-v-97867cb6] {
  flex-basis: 8.3333333333%;
  max-width: 8.3333333333%;
  min-width: 8.3333333333%;
}
.vl-col--1-6[data-v-97867cb6], .vl-col--2-12[data-v-97867cb6] {
  flex-basis: 16.6666666667%;
  max-width: 16.6666666667%;
  min-width: 16.6666666667%;
}
.vl-col--1-4[data-v-97867cb6], .vl-col--3-12[data-v-97867cb6] {
  flex-basis: 25%;
  max-width: 25%;
  min-width: 25%;
}
.vl-col--1-3[data-v-97867cb6], .vl-col--2-6[data-v-97867cb6], .vl-col--4-12[data-v-97867cb6] {
  flex-basis: 33.3333333333%;
  max-width: 33.3333333333%;
  min-width: 33.3333333333%;
}
.vl-col--5-12[data-v-97867cb6] {
  flex-basis: 41.6666666667%;
  max-width: 41.6666666667%;
  min-width: 41.6666666667%;
}
.vl-col--1-2[data-v-97867cb6], .vl-col--2-4[data-v-97867cb6], .vl-col--3-6[data-v-97867cb6], .vl-col--6-12[data-v-97867cb6] {
  flex-basis: 50%;
  max-width: 50%;
  min-width: 50%;
}
.vl-col--7-12[data-v-97867cb6] {
  flex-basis: 58.3333333333%;
  max-width: 58.3333333333%;
  min-width: 58.3333333333%;
}
.vl-col--2-3[data-v-97867cb6], .vl-col--4-6[data-v-97867cb6], .vl-col--8-12[data-v-97867cb6] {
  flex-basis: 66.6666666667%;
  max-width: 66.6666666667%;
  min-width: 66.6666666667%;
}
.vl-col--3-4[data-v-97867cb6], .vl-col--9-12[data-v-97867cb6] {
  flex-basis: 75%;
  max-width: 75%;
  min-width: 75%;
}
.vl-col--5-6[data-v-97867cb6], .vl-col--10-12[data-v-97867cb6] {
  flex-basis: 83.3333333333%;
  max-width: 83.3333333333%;
  min-width: 83.3333333333%;
}
.vl-col--11-12[data-v-97867cb6] {
  flex-basis: 91.6666666667%;
  max-width: 91.6666666667%;
  min-width: 91.6666666667%;
}
.vl-col--1-1[data-v-97867cb6], .vl-col--2-2[data-v-97867cb6], .vl-col--3-3[data-v-97867cb6], .vl-col--4-4[data-v-97867cb6], .vl-col--6-6[data-v-97867cb6], .vl-col--12-12[data-v-97867cb6] {
  flex-basis: 100%;
  max-width: 100%;
  min-width: 100%;
}
.vl-grid--is-stacked[data-v-97867cb6] {
  margin-top: -3rem;
}
.vl-grid--is-stacked > *[data-v-97867cb6] {
  margin-top: 3rem;
}
.vl-push--reset[data-v-97867cb6] {
  margin-left: 0;
}
.vl-push--1-12[data-v-97867cb6] {
  margin-left: 8.3333333333%;
}
.vl-push--1-6[data-v-97867cb6], .vl-push--2-12[data-v-97867cb6] {
  margin-left: 16.6666666667%;
}
.vl-push--1-4[data-v-97867cb6], .vl-push--3-12[data-v-97867cb6] {
  margin-left: 25%;
}
.vl-push--1-3[data-v-97867cb6], .vl-push--2-6[data-v-97867cb6], .vl-push--4-12[data-v-97867cb6] {
  margin-left: 33.3333333333%;
}
.vl-push--5-12[data-v-97867cb6] {
  margin-left: 41.6666666667%;
}
.vl-push--1-2[data-v-97867cb6], .vl-push--2-4[data-v-97867cb6], .vl-push--3-6[data-v-97867cb6], .vl-push--6-12[data-v-97867cb6] {
  margin-left: 50%;
}
.vl-push--7-12[data-v-97867cb6] {
  margin-left: 58.3333333333%;
}
.vl-push--2-3[data-v-97867cb6], .vl-push--4-6[data-v-97867cb6], .vl-push--8-12[data-v-97867cb6] {
  margin-left: 66.6666666667%;
}
.vl-push--3-4[data-v-97867cb6], .vl-push--9-12[data-v-97867cb6] {
  margin-left: 75%;
}
.vl-push--5-6[data-v-97867cb6], .vl-push--10-12[data-v-97867cb6] {
  margin-left: 83.3333333333%;
}
.vl-push--11-12[data-v-97867cb6] {
  margin-left: 91.6666666667%;
}
.vl-col--omega[data-v-97867cb6] {
  margin-left: auto;
}
@media screen and (min-width: 1024px) {
.vl-grid[data-v-97867cb6] {
    position: relative;
    box-sizing: border-box;
    display: flex;
    margin-left: -3rem;
    flex-direction: row;
    flex: 0 1 auto;
    flex-wrap: wrap;
}
.vl-grid > *[data-v-97867cb6] {
    box-sizing: border-box;
    padding-left: 3rem;
    position: relative;
}
.vl-grid--no-gutter--l[data-v-97867cb6] {
    margin-left: 0;
}
.vl-grid--no-gutter--l > *[data-v-97867cb6] {
    padding-left: 0;
}
.vl-grid--v-top--l[data-v-97867cb6] {
    align-items: flex-start;
}
.vl-grid--v-center--l[data-v-97867cb6] {
    align-items: center;
}
.vl-grid--v-bottom--l[data-v-97867cb6] {
    align-items: flex-end;
}
.vl-grid--v-stretch--l[data-v-97867cb6] {
    align-items: stretch;
}
.vl-grid--v-baseline--l[data-v-97867cb6] {
    align-items: stretch;
}
.vl-grid--align-start--l[data-v-97867cb6] {
    justify-content: flex-start;
}
.vl-grid--align-end--l[data-v-97867cb6] {
    justify-content: flex-end;
}
.vl-grid--align-center--l[data-v-97867cb6] {
    justify-content: center;
}
.vl-grid--align-space-between--l[data-v-97867cb6] {
    justify-content: space-between;
}
.vl-grid--align-space-around--l[data-v-97867cb6] {
    justify-content: space-around;
}
.vl-col--fit--l[data-v-97867cb6] {
    flex: 1 0;
}
.vl-col--flex--l[data-v-97867cb6] {
    display: flex;
}
.vl-col--1-12--l[data-v-97867cb6] {
    flex-basis: 8.3333333333%;
    max-width: 8.3333333333%;
    min-width: 8.3333333333%;
}
.vl-col--1-6--l[data-v-97867cb6], .vl-col--2-12--l[data-v-97867cb6] {
    flex-basis: 16.6666666667%;
    max-width: 16.6666666667%;
    min-width: 16.6666666667%;
}
.vl-col--1-4--l[data-v-97867cb6], .vl-col--3-12--l[data-v-97867cb6] {
    flex-basis: 25%;
    max-width: 25%;
    min-width: 25%;
}
.vl-col--1-3--l[data-v-97867cb6], .vl-col--2-6--l[data-v-97867cb6], .vl-col--4-12--l[data-v-97867cb6] {
    flex-basis: 33.3333333333%;
    max-width: 33.3333333333%;
    min-width: 33.3333333333%;
}
.vl-col--5-12--l[data-v-97867cb6] {
    flex-basis: 41.6666666667%;
    max-width: 41.6666666667%;
    min-width: 41.6666666667%;
}
.vl-col--1-2--l[data-v-97867cb6], .vl-col--2-4--l[data-v-97867cb6], .vl-col--3-6--l[data-v-97867cb6], .vl-col--6-12--l[data-v-97867cb6] {
    flex-basis: 50%;
    max-width: 50%;
    min-width: 50%;
}
.vl-col--7-12--l[data-v-97867cb6] {
    flex-basis: 58.3333333333%;
    max-width: 58.3333333333%;
    min-width: 58.3333333333%;
}
.vl-col--2-3--l[data-v-97867cb6], .vl-col--4-6--l[data-v-97867cb6], .vl-col--8-12--l[data-v-97867cb6] {
    flex-basis: 66.6666666667%;
    max-width: 66.6666666667%;
    min-width: 66.6666666667%;
}
.vl-col--3-4--l[data-v-97867cb6], .vl-col--9-12--l[data-v-97867cb6] {
    flex-basis: 75%;
    max-width: 75%;
    min-width: 75%;
}
.vl-col--5-6--l[data-v-97867cb6], .vl-col--10-12--l[data-v-97867cb6] {
    flex-basis: 83.3333333333%;
    max-width: 83.3333333333%;
    min-width: 83.3333333333%;
}
.vl-col--11-12--l[data-v-97867cb6] {
    flex-basis: 91.6666666667%;
    max-width: 91.6666666667%;
    min-width: 91.6666666667%;
}
.vl-col--1-1--l[data-v-97867cb6], .vl-col--2-2--l[data-v-97867cb6], .vl-col--3-3--l[data-v-97867cb6], .vl-col--4-4--l[data-v-97867cb6], .vl-col--6-6--l[data-v-97867cb6], .vl-col--12-12--l[data-v-97867cb6] {
    flex-basis: 100%;
    max-width: 100%;
    min-width: 100%;
}
.vl-grid--is-stacked[data-v-97867cb6] {
    margin-top: -3rem;
}
.vl-grid--is-stacked > *[data-v-97867cb6] {
    margin-top: 3rem;
}
.vl-push--reset--l[data-v-97867cb6] {
    margin-left: 0;
}
.vl-push--1-12--l[data-v-97867cb6] {
    margin-left: 8.3333333333%;
}
.vl-push--1-6--l[data-v-97867cb6], .vl-push--2-12--l[data-v-97867cb6] {
    margin-left: 16.6666666667%;
}
.vl-push--1-4--l[data-v-97867cb6], .vl-push--3-12--l[data-v-97867cb6] {
    margin-left: 25%;
}
.vl-push--1-3--l[data-v-97867cb6], .vl-push--2-6--l[data-v-97867cb6], .vl-push--4-12--l[data-v-97867cb6] {
    margin-left: 33.3333333333%;
}
.vl-push--5-12--l[data-v-97867cb6] {
    margin-left: 41.6666666667%;
}
.vl-push--1-2--l[data-v-97867cb6], .vl-push--2-4--l[data-v-97867cb6], .vl-push--3-6--l[data-v-97867cb6], .vl-push--6-12--l[data-v-97867cb6] {
    margin-left: 50%;
}
.vl-push--7-12--l[data-v-97867cb6] {
    margin-left: 58.3333333333%;
}
.vl-push--2-3--l[data-v-97867cb6], .vl-push--4-6--l[data-v-97867cb6], .vl-push--8-12--l[data-v-97867cb6] {
    margin-left: 66.6666666667%;
}
.vl-push--3-4--l[data-v-97867cb6], .vl-push--9-12--l[data-v-97867cb6] {
    margin-left: 75%;
}
.vl-push--5-6--l[data-v-97867cb6], .vl-push--10-12--l[data-v-97867cb6] {
    margin-left: 83.3333333333%;
}
.vl-push--11-12--l[data-v-97867cb6] {
    margin-left: 91.6666666667%;
}
.vl-col--omega--l[data-v-97867cb6] {
    margin-left: auto;
}
}
@media screen and (min-width: 1601px) {
.vl-grid[data-v-97867cb6] {
    position: relative;
    box-sizing: border-box;
    display: flex;
    margin-left: -3rem;
    flex-direction: row;
    flex: 0 1 auto;
    flex-wrap: wrap;
}
.vl-grid > *[data-v-97867cb6] {
    box-sizing: border-box;
    padding-left: 3rem;
    position: relative;
}
.vl-grid--no-gutter--xl[data-v-97867cb6] {
    margin-left: 0;
}
.vl-grid--no-gutter--xl > *[data-v-97867cb6] {
    padding-left: 0;
}
.vl-grid--v-top--xl[data-v-97867cb6] {
    align-items: flex-start;
}
.vl-grid--v-center--xl[data-v-97867cb6] {
    align-items: center;
}
.vl-grid--v-bottom--xl[data-v-97867cb6] {
    align-items: flex-end;
}
.vl-grid--v-stretch--xl[data-v-97867cb6] {
    align-items: stretch;
}
.vl-grid--v-baseline--xl[data-v-97867cb6] {
    align-items: stretch;
}
.vl-grid--align-start--xl[data-v-97867cb6] {
    justify-content: flex-start;
}
.vl-grid--align-end--xl[data-v-97867cb6] {
    justify-content: flex-end;
}
.vl-grid--align-center--xl[data-v-97867cb6] {
    justify-content: center;
}
.vl-grid--align-space-between--xl[data-v-97867cb6] {
    justify-content: space-between;
}
.vl-grid--align-space-around--xl[data-v-97867cb6] {
    justify-content: space-around;
}
.vl-col--fit--xl[data-v-97867cb6] {
    flex: 1 0;
}
.vl-col--flex--xl[data-v-97867cb6] {
    display: flex;
}
.vl-col--1-12--xl[data-v-97867cb6] {
    flex-basis: 8.3333333333%;
    max-width: 8.3333333333%;
    min-width: 8.3333333333%;
}
.vl-col--1-6--xl[data-v-97867cb6], .vl-col--2-12--xl[data-v-97867cb6] {
    flex-basis: 16.6666666667%;
    max-width: 16.6666666667%;
    min-width: 16.6666666667%;
}
.vl-col--1-4--xl[data-v-97867cb6], .vl-col--3-12--xl[data-v-97867cb6] {
    flex-basis: 25%;
    max-width: 25%;
    min-width: 25%;
}
.vl-col--1-3--xl[data-v-97867cb6], .vl-col--2-6--xl[data-v-97867cb6], .vl-col--4-12--xl[data-v-97867cb6] {
    flex-basis: 33.3333333333%;
    max-width: 33.3333333333%;
    min-width: 33.3333333333%;
}
.vl-col--5-12--xl[data-v-97867cb6] {
    flex-basis: 41.6666666667%;
    max-width: 41.6666666667%;
    min-width: 41.6666666667%;
}
.vl-col--1-2--xl[data-v-97867cb6], .vl-col--2-4--xl[data-v-97867cb6], .vl-col--3-6--xl[data-v-97867cb6], .vl-col--6-12--xl[data-v-97867cb6] {
    flex-basis: 50%;
    max-width: 50%;
    min-width: 50%;
}
.vl-col--7-12--xl[data-v-97867cb6] {
    flex-basis: 58.3333333333%;
    max-width: 58.3333333333%;
    min-width: 58.3333333333%;
}
.vl-col--2-3--xl[data-v-97867cb6], .vl-col--4-6--xl[data-v-97867cb6], .vl-col--8-12--xl[data-v-97867cb6] {
    flex-basis: 66.6666666667%;
    max-width: 66.6666666667%;
    min-width: 66.6666666667%;
}
.vl-col--3-4--xl[data-v-97867cb6], .vl-col--9-12--xl[data-v-97867cb6] {
    flex-basis: 75%;
    max-width: 75%;
    min-width: 75%;
}
.vl-col--5-6--xl[data-v-97867cb6], .vl-col--10-12--xl[data-v-97867cb6] {
    flex-basis: 83.3333333333%;
    max-width: 83.3333333333%;
    min-width: 83.3333333333%;
}
.vl-col--11-12--xl[data-v-97867cb6] {
    flex-basis: 91.6666666667%;
    max-width: 91.6666666667%;
    min-width: 91.6666666667%;
}
.vl-col--1-1--xl[data-v-97867cb6], .vl-col--2-2--xl[data-v-97867cb6], .vl-col--3-3--xl[data-v-97867cb6], .vl-col--4-4--xl[data-v-97867cb6], .vl-col--6-6--xl[data-v-97867cb6], .vl-col--12-12--xl[data-v-97867cb6] {
    flex-basis: 100%;
    max-width: 100%;
    min-width: 100%;
}
.vl-grid--is-stacked[data-v-97867cb6] {
    margin-top: -3rem;
}
.vl-grid--is-stacked > *[data-v-97867cb6] {
    margin-top: 3rem;
}
.vl-push--reset--xl[data-v-97867cb6] {
    margin-left: 0;
}
.vl-push--1-12--xl[data-v-97867cb6] {
    margin-left: 8.3333333333%;
}
.vl-push--1-6--xl[data-v-97867cb6], .vl-push--2-12--xl[data-v-97867cb6] {
    margin-left: 16.6666666667%;
}
.vl-push--1-4--xl[data-v-97867cb6], .vl-push--3-12--xl[data-v-97867cb6] {
    margin-left: 25%;
}
.vl-push--1-3--xl[data-v-97867cb6], .vl-push--2-6--xl[data-v-97867cb6], .vl-push--4-12--xl[data-v-97867cb6] {
    margin-left: 33.3333333333%;
}
.vl-push--5-12--xl[data-v-97867cb6] {
    margin-left: 41.6666666667%;
}
.vl-push--1-2--xl[data-v-97867cb6], .vl-push--2-4--xl[data-v-97867cb6], .vl-push--3-6--xl[data-v-97867cb6], .vl-push--6-12--xl[data-v-97867cb6] {
    margin-left: 50%;
}
.vl-push--7-12--xl[data-v-97867cb6] {
    margin-left: 58.3333333333%;
}
.vl-push--2-3--xl[data-v-97867cb6], .vl-push--4-6--xl[data-v-97867cb6], .vl-push--8-12--xl[data-v-97867cb6] {
    margin-left: 66.6666666667%;
}
.vl-push--3-4--xl[data-v-97867cb6], .vl-push--9-12--xl[data-v-97867cb6] {
    margin-left: 75%;
}
.vl-push--5-6--xl[data-v-97867cb6], .vl-push--10-12--xl[data-v-97867cb6] {
    margin-left: 83.3333333333%;
}
.vl-push--11-12--xl[data-v-97867cb6] {
    margin-left: 91.6666666667%;
}
.vl-col--omega--xl[data-v-97867cb6] {
    margin-left: auto;
}
}
@media screen and (max-width: 1023px) {
.vl-grid[data-v-97867cb6] {
    position: relative;
    box-sizing: border-box;
    display: flex;
    margin-left: -3rem;
    flex-direction: row;
    flex: 0 1 auto;
    flex-wrap: wrap;
}
.vl-grid > *[data-v-97867cb6] {
    box-sizing: border-box;
    padding-left: 3rem;
    position: relative;
}
.vl-grid--no-gutter--m[data-v-97867cb6] {
    margin-left: 0;
}
.vl-grid--no-gutter--m > *[data-v-97867cb6] {
    padding-left: 0;
}
.vl-grid--v-top--m[data-v-97867cb6] {
    align-items: flex-start;
}
.vl-grid--v-center--m[data-v-97867cb6] {
    align-items: center;
}
.vl-grid--v-bottom--m[data-v-97867cb6] {
    align-items: flex-end;
}
.vl-grid--v-stretch--m[data-v-97867cb6] {
    align-items: stretch;
}
.vl-grid--v-baseline--m[data-v-97867cb6] {
    align-items: stretch;
}
.vl-grid--align-start--m[data-v-97867cb6] {
    justify-content: flex-start;
}
.vl-grid--align-end--m[data-v-97867cb6] {
    justify-content: flex-end;
}
.vl-grid--align-center--m[data-v-97867cb6] {
    justify-content: center;
}
.vl-grid--align-space-between--m[data-v-97867cb6] {
    justify-content: space-between;
}
.vl-grid--align-space-around--m[data-v-97867cb6] {
    justify-content: space-around;
}
.vl-col--fit--m[data-v-97867cb6] {
    flex: 1 0;
}
.vl-col--flex--m[data-v-97867cb6] {
    display: flex;
}
.vl-col--1-12--m[data-v-97867cb6] {
    flex-basis: 8.3333333333%;
    max-width: 8.3333333333%;
    min-width: 8.3333333333%;
}
.vl-col--1-6--m[data-v-97867cb6], .vl-col--2-12--m[data-v-97867cb6] {
    flex-basis: 16.6666666667%;
    max-width: 16.6666666667%;
    min-width: 16.6666666667%;
}
.vl-col--1-4--m[data-v-97867cb6], .vl-col--3-12--m[data-v-97867cb6] {
    flex-basis: 25%;
    max-width: 25%;
    min-width: 25%;
}
.vl-col--1-3--m[data-v-97867cb6], .vl-col--2-6--m[data-v-97867cb6], .vl-col--4-12--m[data-v-97867cb6] {
    flex-basis: 33.3333333333%;
    max-width: 33.3333333333%;
    min-width: 33.3333333333%;
}
.vl-col--5-12--m[data-v-97867cb6] {
    flex-basis: 41.6666666667%;
    max-width: 41.6666666667%;
    min-width: 41.6666666667%;
}
.vl-col--1-2--m[data-v-97867cb6], .vl-col--2-4--m[data-v-97867cb6], .vl-col--3-6--m[data-v-97867cb6], .vl-col--6-12--m[data-v-97867cb6] {
    flex-basis: 50%;
    max-width: 50%;
    min-width: 50%;
}
.vl-col--7-12--m[data-v-97867cb6] {
    flex-basis: 58.3333333333%;
    max-width: 58.3333333333%;
    min-width: 58.3333333333%;
}
.vl-col--2-3--m[data-v-97867cb6], .vl-col--4-6--m[data-v-97867cb6], .vl-col--8-12--m[data-v-97867cb6] {
    flex-basis: 66.6666666667%;
    max-width: 66.6666666667%;
    min-width: 66.6666666667%;
}
.vl-col--3-4--m[data-v-97867cb6], .vl-col--9-12--m[data-v-97867cb6] {
    flex-basis: 75%;
    max-width: 75%;
    min-width: 75%;
}
.vl-col--5-6--m[data-v-97867cb6], .vl-col--10-12--m[data-v-97867cb6] {
    flex-basis: 83.3333333333%;
    max-width: 83.3333333333%;
    min-width: 83.3333333333%;
}
.vl-col--11-12--m[data-v-97867cb6] {
    flex-basis: 91.6666666667%;
    max-width: 91.6666666667%;
    min-width: 91.6666666667%;
}
.vl-col--1-1--m[data-v-97867cb6], .vl-col--2-2--m[data-v-97867cb6], .vl-col--3-3--m[data-v-97867cb6], .vl-col--4-4--m[data-v-97867cb6], .vl-col--6-6--m[data-v-97867cb6], .vl-col--12-12--m[data-v-97867cb6] {
    flex-basis: 100%;
    max-width: 100%;
    min-width: 100%;
}
.vl-grid--is-stacked[data-v-97867cb6] {
    margin-top: -3rem;
}
.vl-grid--is-stacked > *[data-v-97867cb6] {
    margin-top: 3rem;
}
.vl-push--reset--m[data-v-97867cb6] {
    margin-left: 0;
}
.vl-push--1-12--m[data-v-97867cb6] {
    margin-left: 8.3333333333%;
}
.vl-push--1-6--m[data-v-97867cb6], .vl-push--2-12--m[data-v-97867cb6] {
    margin-left: 16.6666666667%;
}
.vl-push--1-4--m[data-v-97867cb6], .vl-push--3-12--m[data-v-97867cb6] {
    margin-left: 25%;
}
.vl-push--1-3--m[data-v-97867cb6], .vl-push--2-6--m[data-v-97867cb6], .vl-push--4-12--m[data-v-97867cb6] {
    margin-left: 33.3333333333%;
}
.vl-push--5-12--m[data-v-97867cb6] {
    margin-left: 41.6666666667%;
}
.vl-push--1-2--m[data-v-97867cb6], .vl-push--2-4--m[data-v-97867cb6], .vl-push--3-6--m[data-v-97867cb6], .vl-push--6-12--m[data-v-97867cb6] {
    margin-left: 50%;
}
.vl-push--7-12--m[data-v-97867cb6] {
    margin-left: 58.3333333333%;
}
.vl-push--2-3--m[data-v-97867cb6], .vl-push--4-6--m[data-v-97867cb6], .vl-push--8-12--m[data-v-97867cb6] {
    margin-left: 66.6666666667%;
}
.vl-push--3-4--m[data-v-97867cb6], .vl-push--9-12--m[data-v-97867cb6] {
    margin-left: 75%;
}
.vl-push--5-6--m[data-v-97867cb6], .vl-push--10-12--m[data-v-97867cb6] {
    margin-left: 83.3333333333%;
}
.vl-push--11-12--m[data-v-97867cb6] {
    margin-left: 91.6666666667%;
}
.vl-col--omega--m[data-v-97867cb6] {
    margin-left: auto;
}
}
@media screen and (max-width: 767px) {
.vl-grid[data-v-97867cb6] {
    position: relative;
    box-sizing: border-box;
    display: flex;
    margin-left: -1.5rem;
    flex-direction: row;
    flex: 0 1 auto;
    flex-wrap: wrap;
}
.vl-grid > *[data-v-97867cb6] {
    box-sizing: border-box;
    padding-left: 1.5rem;
    position: relative;
}
.vl-grid--no-gutter--s[data-v-97867cb6] {
    margin-left: 0;
}
.vl-grid--no-gutter--s > *[data-v-97867cb6] {
    padding-left: 0;
}
.vl-grid--v-top--s[data-v-97867cb6] {
    align-items: flex-start;
}
.vl-grid--v-center--s[data-v-97867cb6] {
    align-items: center;
}
.vl-grid--v-bottom--s[data-v-97867cb6] {
    align-items: flex-end;
}
.vl-grid--v-stretch--s[data-v-97867cb6] {
    align-items: stretch;
}
.vl-grid--v-baseline--s[data-v-97867cb6] {
    align-items: stretch;
}
.vl-grid--align-start--s[data-v-97867cb6] {
    justify-content: flex-start;
}
.vl-grid--align-end--s[data-v-97867cb6] {
    justify-content: flex-end;
}
.vl-grid--align-center--s[data-v-97867cb6] {
    justify-content: center;
}
.vl-grid--align-space-between--s[data-v-97867cb6] {
    justify-content: space-between;
}
.vl-grid--align-space-around--s[data-v-97867cb6] {
    justify-content: space-around;
}
.vl-col--fit--s[data-v-97867cb6] {
    flex: 1 0;
}
.vl-col--flex--s[data-v-97867cb6] {
    display: flex;
}
.vl-col--1-12--s[data-v-97867cb6] {
    flex-basis: 8.3333333333%;
    max-width: 8.3333333333%;
    min-width: 8.3333333333%;
}
.vl-col--1-6--s[data-v-97867cb6], .vl-col--2-12--s[data-v-97867cb6] {
    flex-basis: 16.6666666667%;
    max-width: 16.6666666667%;
    min-width: 16.6666666667%;
}
.vl-col--1-4--s[data-v-97867cb6], .vl-col--3-12--s[data-v-97867cb6] {
    flex-basis: 25%;
    max-width: 25%;
    min-width: 25%;
}
.vl-col--1-3--s[data-v-97867cb6], .vl-col--2-6--s[data-v-97867cb6], .vl-col--4-12--s[data-v-97867cb6] {
    flex-basis: 33.3333333333%;
    max-width: 33.3333333333%;
    min-width: 33.3333333333%;
}
.vl-col--5-12--s[data-v-97867cb6] {
    flex-basis: 41.6666666667%;
    max-width: 41.6666666667%;
    min-width: 41.6666666667%;
}
.vl-col--1-2--s[data-v-97867cb6], .vl-col--2-4--s[data-v-97867cb6], .vl-col--3-6--s[data-v-97867cb6], .vl-col--6-12--s[data-v-97867cb6] {
    flex-basis: 50%;
    max-width: 50%;
    min-width: 50%;
}
.vl-col--7-12--s[data-v-97867cb6] {
    flex-basis: 58.3333333333%;
    max-width: 58.3333333333%;
    min-width: 58.3333333333%;
}
.vl-col--2-3--s[data-v-97867cb6], .vl-col--4-6--s[data-v-97867cb6], .vl-col--8-12--s[data-v-97867cb6] {
    flex-basis: 66.6666666667%;
    max-width: 66.6666666667%;
    min-width: 66.6666666667%;
}
.vl-col--3-4--s[data-v-97867cb6], .vl-col--9-12--s[data-v-97867cb6] {
    flex-basis: 75%;
    max-width: 75%;
    min-width: 75%;
}
.vl-col--5-6--s[data-v-97867cb6], .vl-col--10-12--s[data-v-97867cb6] {
    flex-basis: 83.3333333333%;
    max-width: 83.3333333333%;
    min-width: 83.3333333333%;
}
.vl-col--11-12--s[data-v-97867cb6] {
    flex-basis: 91.6666666667%;
    max-width: 91.6666666667%;
    min-width: 91.6666666667%;
}
.vl-col--1-1--s[data-v-97867cb6], .vl-col--2-2--s[data-v-97867cb6], .vl-col--3-3--s[data-v-97867cb6], .vl-col--4-4--s[data-v-97867cb6], .vl-col--6-6--s[data-v-97867cb6], .vl-col--12-12--s[data-v-97867cb6] {
    flex-basis: 100%;
    max-width: 100%;
    min-width: 100%;
}
.vl-grid--is-stacked[data-v-97867cb6] {
    margin-top: -1.5rem;
}
.vl-grid--is-stacked > *[data-v-97867cb6] {
    margin-top: 1.5rem;
}
.vl-push--reset--s[data-v-97867cb6] {
    margin-left: 0;
}
.vl-push--1-12--s[data-v-97867cb6] {
    margin-left: 8.3333333333%;
}
.vl-push--1-6--s[data-v-97867cb6], .vl-push--2-12--s[data-v-97867cb6] {
    margin-left: 16.6666666667%;
}
.vl-push--1-4--s[data-v-97867cb6], .vl-push--3-12--s[data-v-97867cb6] {
    margin-left: 25%;
}
.vl-push--1-3--s[data-v-97867cb6], .vl-push--2-6--s[data-v-97867cb6], .vl-push--4-12--s[data-v-97867cb6] {
    margin-left: 33.3333333333%;
}
.vl-push--5-12--s[data-v-97867cb6] {
    margin-left: 41.6666666667%;
}
.vl-push--1-2--s[data-v-97867cb6], .vl-push--2-4--s[data-v-97867cb6], .vl-push--3-6--s[data-v-97867cb6], .vl-push--6-12--s[data-v-97867cb6] {
    margin-left: 50%;
}
.vl-push--7-12--s[data-v-97867cb6] {
    margin-left: 58.3333333333%;
}
.vl-push--2-3--s[data-v-97867cb6], .vl-push--4-6--s[data-v-97867cb6], .vl-push--8-12--s[data-v-97867cb6] {
    margin-left: 66.6666666667%;
}
.vl-push--3-4--s[data-v-97867cb6], .vl-push--9-12--s[data-v-97867cb6] {
    margin-left: 75%;
}
.vl-push--5-6--s[data-v-97867cb6], .vl-push--10-12--s[data-v-97867cb6] {
    margin-left: 83.3333333333%;
}
.vl-push--11-12--s[data-v-97867cb6] {
    margin-left: 91.6666666667%;
}
.vl-col--omega--s[data-v-97867cb6] {
    margin-left: auto;
}
}
@media screen and (max-width: 500px) {
.vl-grid[data-v-97867cb6] {
    position: relative;
    box-sizing: border-box;
    display: flex;
    margin-left: -1.5rem;
    flex-direction: row;
    flex: 0 1 auto;
    flex-wrap: wrap;
}
.vl-grid > *[data-v-97867cb6] {
    box-sizing: border-box;
    padding-left: 1.5rem;
    position: relative;
}
.vl-grid--no-gutter--xs[data-v-97867cb6] {
    margin-left: 0;
}
.vl-grid--no-gutter--xs > *[data-v-97867cb6] {
    padding-left: 0;
}
.vl-grid--v-top--xs[data-v-97867cb6] {
    align-items: flex-start;
}
.vl-grid--v-center--xs[data-v-97867cb6] {
    align-items: center;
}
.vl-grid--v-bottom--xs[data-v-97867cb6] {
    align-items: flex-end;
}
.vl-grid--v-stretch--xs[data-v-97867cb6] {
    align-items: stretch;
}
.vl-grid--v-baseline--xs[data-v-97867cb6] {
    align-items: stretch;
}
.vl-grid--align-start--xs[data-v-97867cb6] {
    justify-content: flex-start;
}
.vl-grid--align-end--xs[data-v-97867cb6] {
    justify-content: flex-end;
}
.vl-grid--align-center--xs[data-v-97867cb6] {
    justify-content: center;
}
.vl-grid--align-space-between--xs[data-v-97867cb6] {
    justify-content: space-between;
}
.vl-grid--align-space-around--xs[data-v-97867cb6] {
    justify-content: space-around;
}
.vl-col--fit--xs[data-v-97867cb6] {
    flex: 1 0;
}
.vl-col--flex--xs[data-v-97867cb6] {
    display: flex;
}
.vl-col--1-12--xs[data-v-97867cb6] {
    flex-basis: 8.3333333333%;
    max-width: 8.3333333333%;
    min-width: 8.3333333333%;
}
.vl-col--1-6--xs[data-v-97867cb6], .vl-col--2-12--xs[data-v-97867cb6] {
    flex-basis: 16.6666666667%;
    max-width: 16.6666666667%;
    min-width: 16.6666666667%;
}
.vl-col--1-4--xs[data-v-97867cb6], .vl-col--3-12--xs[data-v-97867cb6] {
    flex-basis: 25%;
    max-width: 25%;
    min-width: 25%;
}
.vl-col--1-3--xs[data-v-97867cb6], .vl-col--2-6--xs[data-v-97867cb6], .vl-col--4-12--xs[data-v-97867cb6] {
    flex-basis: 33.3333333333%;
    max-width: 33.3333333333%;
    min-width: 33.3333333333%;
}
.vl-col--5-12--xs[data-v-97867cb6] {
    flex-basis: 41.6666666667%;
    max-width: 41.6666666667%;
    min-width: 41.6666666667%;
}
.vl-col--1-2--xs[data-v-97867cb6], .vl-col--2-4--xs[data-v-97867cb6], .vl-col--3-6--xs[data-v-97867cb6], .vl-col--6-12--xs[data-v-97867cb6] {
    flex-basis: 50%;
    max-width: 50%;
    min-width: 50%;
}
.vl-col--7-12--xs[data-v-97867cb6] {
    flex-basis: 58.3333333333%;
    max-width: 58.3333333333%;
    min-width: 58.3333333333%;
}
.vl-col--2-3--xs[data-v-97867cb6], .vl-col--4-6--xs[data-v-97867cb6], .vl-col--8-12--xs[data-v-97867cb6] {
    flex-basis: 66.6666666667%;
    max-width: 66.6666666667%;
    min-width: 66.6666666667%;
}
.vl-col--3-4--xs[data-v-97867cb6], .vl-col--9-12--xs[data-v-97867cb6] {
    flex-basis: 75%;
    max-width: 75%;
    min-width: 75%;
}
.vl-col--5-6--xs[data-v-97867cb6], .vl-col--10-12--xs[data-v-97867cb6] {
    flex-basis: 83.3333333333%;
    max-width: 83.3333333333%;
    min-width: 83.3333333333%;
}
.vl-col--11-12--xs[data-v-97867cb6] {
    flex-basis: 91.6666666667%;
    max-width: 91.6666666667%;
    min-width: 91.6666666667%;
}
.vl-col--1-1--xs[data-v-97867cb6], .vl-col--2-2--xs[data-v-97867cb6], .vl-col--3-3--xs[data-v-97867cb6], .vl-col--4-4--xs[data-v-97867cb6], .vl-col--6-6--xs[data-v-97867cb6], .vl-col--12-12--xs[data-v-97867cb6] {
    flex-basis: 100%;
    max-width: 100%;
    min-width: 100%;
}
.vl-grid--is-stacked[data-v-97867cb6] {
    margin-top: -1.5rem;
}
.vl-grid--is-stacked > *[data-v-97867cb6] {
    margin-top: 1.5rem;
}
.vl-push--reset--xs[data-v-97867cb6] {
    margin-left: 0;
}
.vl-push--1-12--xs[data-v-97867cb6] {
    margin-left: 8.3333333333%;
}
.vl-push--1-6--xs[data-v-97867cb6], .vl-push--2-12--xs[data-v-97867cb6] {
    margin-left: 16.6666666667%;
}
.vl-push--1-4--xs[data-v-97867cb6], .vl-push--3-12--xs[data-v-97867cb6] {
    margin-left: 25%;
}
.vl-push--1-3--xs[data-v-97867cb6], .vl-push--2-6--xs[data-v-97867cb6], .vl-push--4-12--xs[data-v-97867cb6] {
    margin-left: 33.3333333333%;
}
.vl-push--5-12--xs[data-v-97867cb6] {
    margin-left: 41.6666666667%;
}
.vl-push--1-2--xs[data-v-97867cb6], .vl-push--2-4--xs[data-v-97867cb6], .vl-push--3-6--xs[data-v-97867cb6], .vl-push--6-12--xs[data-v-97867cb6] {
    margin-left: 50%;
}
.vl-push--7-12--xs[data-v-97867cb6] {
    margin-left: 58.3333333333%;
}
.vl-push--2-3--xs[data-v-97867cb6], .vl-push--4-6--xs[data-v-97867cb6], .vl-push--8-12--xs[data-v-97867cb6] {
    margin-left: 66.6666666667%;
}
.vl-push--3-4--xs[data-v-97867cb6], .vl-push--9-12--xs[data-v-97867cb6] {
    margin-left: 75%;
}
.vl-push--5-6--xs[data-v-97867cb6], .vl-push--10-12--xs[data-v-97867cb6] {
    margin-left: 83.3333333333%;
}
.vl-push--11-12--xs[data-v-97867cb6] {
    margin-left: 91.6666666667%;
}
.vl-col--omega--xs[data-v-97867cb6] {
    margin-left: auto;
}
}
@media screen and (min-width: 1280px) {
.vl-grid--wide[data-v-97867cb6] {
    margin-left: calc(-4.1666666667% - 3rem);
    margin-right: -4.1666666667%;
}
}
.vl-form-grid[data-v-97867cb6] {
  position: relative;
  box-sizing: border-box;
  display: flex;
  margin-left: -1.5rem;
  flex-direction: row;
  flex: 0 1 auto;
  flex-wrap: wrap;
}
.vl-form-grid > *[data-v-97867cb6] {
  box-sizing: border-box;
  padding-left: 1.5rem;
  position: relative;
}
.vl-form-grid--no-gutter[data-v-97867cb6] {
  margin-left: 0;
}
.vl-form-grid--no-gutter > *[data-v-97867cb6] {
  padding-left: 0;
}
.vl-form-grid--v-top[data-v-97867cb6] {
  align-items: flex-start;
}
.vl-form-grid--v-center[data-v-97867cb6] {
  align-items: center;
}
.vl-form-grid--v-bottom[data-v-97867cb6] {
  align-items: flex-end;
}
.vl-form-grid--v-stretch[data-v-97867cb6] {
  align-items: stretch;
}
.vl-form-grid--v-baseline[data-v-97867cb6] {
  align-items: stretch;
}
.vl-form-grid--align-start[data-v-97867cb6] {
  justify-content: flex-start;
}
.vl-form-grid--align-end[data-v-97867cb6] {
  justify-content: flex-end;
}
.vl-form-grid--align-center[data-v-97867cb6] {
  justify-content: center;
}
.vl-form-grid--align-space-between[data-v-97867cb6] {
  justify-content: space-between;
}
.vl-form-grid--align-space-around[data-v-97867cb6] {
  justify-content: space-around;
}
.vl-form-col--fit[data-v-97867cb6] {
  flex: 1 0;
}
.vl-form-col--flex[data-v-97867cb6] {
  display: flex;
}
.vl-form-col--1-12[data-v-97867cb6] {
  flex-basis: 8.3333333333%;
  max-width: 8.3333333333%;
  min-width: 8.3333333333%;
}
.vl-form-col--1-6[data-v-97867cb6], .vl-form-col--2-12[data-v-97867cb6] {
  flex-basis: 16.6666666667%;
  max-width: 16.6666666667%;
  min-width: 16.6666666667%;
}
.vl-form-col--1-4[data-v-97867cb6], .vl-form-col--3-12[data-v-97867cb6] {
  flex-basis: 25%;
  max-width: 25%;
  min-width: 25%;
}
.vl-form-col--1-3[data-v-97867cb6], .vl-form-col--2-6[data-v-97867cb6], .vl-form-col--4-12[data-v-97867cb6] {
  flex-basis: 33.3333333333%;
  max-width: 33.3333333333%;
  min-width: 33.3333333333%;
}
.vl-form-col--5-12[data-v-97867cb6] {
  flex-basis: 41.6666666667%;
  max-width: 41.6666666667%;
  min-width: 41.6666666667%;
}
.vl-form-col--1-2[data-v-97867cb6], .vl-form-col--2-4[data-v-97867cb6], .vl-form-col--3-6[data-v-97867cb6], .vl-form-col--6-12[data-v-97867cb6] {
  flex-basis: 50%;
  max-width: 50%;
  min-width: 50%;
}
.vl-form-col--7-12[data-v-97867cb6] {
  flex-basis: 58.3333333333%;
  max-width: 58.3333333333%;
  min-width: 58.3333333333%;
}
.vl-form-col--2-3[data-v-97867cb6], .vl-form-col--4-6[data-v-97867cb6], .vl-form-col--8-12[data-v-97867cb6] {
  flex-basis: 66.6666666667%;
  max-width: 66.6666666667%;
  min-width: 66.6666666667%;
}
.vl-form-col--3-4[data-v-97867cb6], .vl-form-col--9-12[data-v-97867cb6] {
  flex-basis: 75%;
  max-width: 75%;
  min-width: 75%;
}
.vl-form-col--5-6[data-v-97867cb6], .vl-form-col--10-12[data-v-97867cb6] {
  flex-basis: 83.3333333333%;
  max-width: 83.3333333333%;
  min-width: 83.3333333333%;
}
.vl-form-col--11-12[data-v-97867cb6] {
  flex-basis: 91.6666666667%;
  max-width: 91.6666666667%;
  min-width: 91.6666666667%;
}
.vl-form-col--1-1[data-v-97867cb6], .vl-form-col--2-2[data-v-97867cb6], .vl-form-col--3-3[data-v-97867cb6], .vl-form-col--4-4[data-v-97867cb6], .vl-form-col--6-6[data-v-97867cb6], .vl-form-col--12-12[data-v-97867cb6] {
  flex-basis: 100%;
  max-width: 100%;
  min-width: 100%;
}
.vl-form-grid--is-stacked[data-v-97867cb6] {
  margin-top: -1.5rem;
}
.vl-form-grid--is-stacked > *[data-v-97867cb6] {
  margin-top: 1.5rem;
}
.vl-form-push--reset[data-v-97867cb6] {
  margin-left: 0;
}
.vl-form-push--1-12[data-v-97867cb6] {
  margin-left: 8.3333333333%;
}
.vl-form-push--1-6[data-v-97867cb6], .vl-form-push--2-12[data-v-97867cb6] {
  margin-left: 16.6666666667%;
}
.vl-form-push--1-4[data-v-97867cb6], .vl-form-push--3-12[data-v-97867cb6] {
  margin-left: 25%;
}
.vl-form-push--1-3[data-v-97867cb6], .vl-form-push--2-6[data-v-97867cb6], .vl-form-push--4-12[data-v-97867cb6] {
  margin-left: 33.3333333333%;
}
.vl-form-push--5-12[data-v-97867cb6] {
  margin-left: 41.6666666667%;
}
.vl-form-push--1-2[data-v-97867cb6], .vl-form-push--2-4[data-v-97867cb6], .vl-form-push--3-6[data-v-97867cb6], .vl-form-push--6-12[data-v-97867cb6] {
  margin-left: 50%;
}
.vl-form-push--7-12[data-v-97867cb6] {
  margin-left: 58.3333333333%;
}
.vl-form-push--2-3[data-v-97867cb6], .vl-form-push--4-6[data-v-97867cb6], .vl-form-push--8-12[data-v-97867cb6] {
  margin-left: 66.6666666667%;
}
.vl-form-push--3-4[data-v-97867cb6], .vl-form-push--9-12[data-v-97867cb6] {
  margin-left: 75%;
}
.vl-form-push--5-6[data-v-97867cb6], .vl-form-push--10-12[data-v-97867cb6] {
  margin-left: 83.3333333333%;
}
.vl-form-push--11-12[data-v-97867cb6] {
  margin-left: 91.6666666667%;
}
.vl-form-col--omega[data-v-97867cb6] {
  margin-left: auto;
}
@media screen and (max-width: 767px) {
.vl-form-grid[data-v-97867cb6] {
    position: relative;
    box-sizing: border-box;
    display: flex;
    margin-left: -1.5rem;
    flex-direction: row;
    flex: 0 1 auto;
    flex-wrap: wrap;
}
.vl-form-grid > *[data-v-97867cb6] {
    box-sizing: border-box;
    padding-left: 1.5rem;
    position: relative;
}
.vl-form-grid--no-gutter--s[data-v-97867cb6] {
    margin-left: 0;
}
.vl-form-grid--no-gutter--s > *[data-v-97867cb6] {
    padding-left: 0;
}
.vl-form-grid--v-top--s[data-v-97867cb6] {
    align-items: flex-start;
}
.vl-form-grid--v-center--s[data-v-97867cb6] {
    align-items: center;
}
.vl-form-grid--v-bottom--s[data-v-97867cb6] {
    align-items: flex-end;
}
.vl-form-grid--v-stretch--s[data-v-97867cb6] {
    align-items: stretch;
}
.vl-form-grid--v-baseline--s[data-v-97867cb6] {
    align-items: stretch;
}
.vl-form-grid--align-start--s[data-v-97867cb6] {
    justify-content: flex-start;
}
.vl-form-grid--align-end--s[data-v-97867cb6] {
    justify-content: flex-end;
}
.vl-form-grid--align-center--s[data-v-97867cb6] {
    justify-content: center;
}
.vl-form-grid--align-space-between--s[data-v-97867cb6] {
    justify-content: space-between;
}
.vl-form-grid--align-space-around--s[data-v-97867cb6] {
    justify-content: space-around;
}
.vl-form-col--fit--s[data-v-97867cb6] {
    flex: 1 0;
}
.vl-form-col--flex--s[data-v-97867cb6] {
    display: flex;
}
.vl-form-col--1-12--s[data-v-97867cb6] {
    flex-basis: 8.3333333333%;
    max-width: 8.3333333333%;
    min-width: 8.3333333333%;
}
.vl-form-col--1-6--s[data-v-97867cb6], .vl-form-col--2-12--s[data-v-97867cb6] {
    flex-basis: 16.6666666667%;
    max-width: 16.6666666667%;
    min-width: 16.6666666667%;
}
.vl-form-col--1-4--s[data-v-97867cb6], .vl-form-col--3-12--s[data-v-97867cb6] {
    flex-basis: 25%;
    max-width: 25%;
    min-width: 25%;
}
.vl-form-col--1-3--s[data-v-97867cb6], .vl-form-col--2-6--s[data-v-97867cb6], .vl-form-col--4-12--s[data-v-97867cb6] {
    flex-basis: 33.3333333333%;
    max-width: 33.3333333333%;
    min-width: 33.3333333333%;
}
.vl-form-col--5-12--s[data-v-97867cb6] {
    flex-basis: 41.6666666667%;
    max-width: 41.6666666667%;
    min-width: 41.6666666667%;
}
.vl-form-col--1-2--s[data-v-97867cb6], .vl-form-col--2-4--s[data-v-97867cb6], .vl-form-col--3-6--s[data-v-97867cb6], .vl-form-col--6-12--s[data-v-97867cb6] {
    flex-basis: 50%;
    max-width: 50%;
    min-width: 50%;
}
.vl-form-col--7-12--s[data-v-97867cb6] {
    flex-basis: 58.3333333333%;
    max-width: 58.3333333333%;
    min-width: 58.3333333333%;
}
.vl-form-col--2-3--s[data-v-97867cb6], .vl-form-col--4-6--s[data-v-97867cb6], .vl-form-col--8-12--s[data-v-97867cb6] {
    flex-basis: 66.6666666667%;
    max-width: 66.6666666667%;
    min-width: 66.6666666667%;
}
.vl-form-col--3-4--s[data-v-97867cb6], .vl-form-col--9-12--s[data-v-97867cb6] {
    flex-basis: 75%;
    max-width: 75%;
    min-width: 75%;
}
.vl-form-col--5-6--s[data-v-97867cb6], .vl-form-col--10-12--s[data-v-97867cb6] {
    flex-basis: 83.3333333333%;
    max-width: 83.3333333333%;
    min-width: 83.3333333333%;
}
.vl-form-col--11-12--s[data-v-97867cb6] {
    flex-basis: 91.6666666667%;
    max-width: 91.6666666667%;
    min-width: 91.6666666667%;
}
.vl-form-col--1-1--s[data-v-97867cb6], .vl-form-col--2-2--s[data-v-97867cb6], .vl-form-col--3-3--s[data-v-97867cb6], .vl-form-col--4-4--s[data-v-97867cb6], .vl-form-col--6-6--s[data-v-97867cb6], .vl-form-col--12-12--s[data-v-97867cb6] {
    flex-basis: 100%;
    max-width: 100%;
    min-width: 100%;
}
.vl-form-grid--is-stacked[data-v-97867cb6] {
    margin-top: -1.5rem;
}
.vl-form-grid--is-stacked > *[data-v-97867cb6] {
    margin-top: 1.5rem;
}
.vl-form-push--reset--s[data-v-97867cb6] {
    margin-left: 0;
}
.vl-form-push--1-12--s[data-v-97867cb6] {
    margin-left: 8.3333333333%;
}
.vl-form-push--1-6--s[data-v-97867cb6], .vl-form-push--2-12--s[data-v-97867cb6] {
    margin-left: 16.6666666667%;
}
.vl-form-push--1-4--s[data-v-97867cb6], .vl-form-push--3-12--s[data-v-97867cb6] {
    margin-left: 25%;
}
.vl-form-push--1-3--s[data-v-97867cb6], .vl-form-push--2-6--s[data-v-97867cb6], .vl-form-push--4-12--s[data-v-97867cb6] {
    margin-left: 33.3333333333%;
}
.vl-form-push--5-12--s[data-v-97867cb6] {
    margin-left: 41.6666666667%;
}
.vl-form-push--1-2--s[data-v-97867cb6], .vl-form-push--2-4--s[data-v-97867cb6], .vl-form-push--3-6--s[data-v-97867cb6], .vl-form-push--6-12--s[data-v-97867cb6] {
    margin-left: 50%;
}
.vl-form-push--7-12--s[data-v-97867cb6] {
    margin-left: 58.3333333333%;
}
.vl-form-push--2-3--s[data-v-97867cb6], .vl-form-push--4-6--s[data-v-97867cb6], .vl-form-push--8-12--s[data-v-97867cb6] {
    margin-left: 66.6666666667%;
}
.vl-form-push--3-4--s[data-v-97867cb6], .vl-form-push--9-12--s[data-v-97867cb6] {
    margin-left: 75%;
}
.vl-form-push--5-6--s[data-v-97867cb6], .vl-form-push--10-12--s[data-v-97867cb6] {
    margin-left: 83.3333333333%;
}
.vl-form-push--11-12--s[data-v-97867cb6] {
    margin-left: 91.6666666667%;
}
.vl-form-col--omega--s[data-v-97867cb6] {
    margin-left: auto;
}
}
@media screen and (min-width: 1280px) {
.vl-form-grid--wide[data-v-97867cb6] {
    margin-left: calc(-4.1666666667% - 3rem);
    margin-right: -4.1666666667%;
}
}
.vl-grid--is-stacked-large[data-v-97867cb6] {
  margin-bottom: -6rem;
}
@media screen and (max-width: 767px) {
.vl-grid--is-stacked-large[data-v-97867cb6] {
    margin-bottom: -3rem;
}
}
.vl-grid--is-stacked-large > *[data-v-97867cb6] {
  margin-bottom: 6rem;
}
@media screen and (max-width: 767px) {
.vl-grid--is-stacked-large > *[data-v-97867cb6] {
    margin-bottom: 3rem;
}
}
.vl-grid--is-stacked-small[data-v-97867cb6] {
  margin-bottom: -1.5rem;
}
.vl-grid--is-stacked-small > *[data-v-97867cb6] {
  margin-bottom: 1.5rem;
}
.vl-form-grid--is-stacked-large[data-v-97867cb6] {
  margin-bottom: -3rem;
}
.vl-form-grid--is-stacked-large > *[data-v-97867cb6] {
  margin-bottom: 3rem;
}
.vl-form-grid--is-stacked-small[data-v-97867cb6] {
  margin-bottom: -1rem;
}
.vl-form-grid--is-stacked-small > *[data-v-97867cb6] {
  margin-bottom: 1rem;
}
.vl-page[data-v-97867cb6] {
  position: relative;
  width: 100%;
  background-color: #fff;
}
.vl-page .vl-main-content > .vl-region[data-v-97867cb6]:last-child {
  padding-bottom: 10rem;
}
@media screen and (max-width: 767px) {
.vl-page .vl-main-content > .vl-region[data-v-97867cb6]:last-child {
    padding-bottom: 7rem;
}
}
.vl-main-content[data-v-97867cb6] {
  outline: none;
  position: relative;
}
.vl-region[data-v-97867cb6] {
  margin: 0 auto;
  padding: 3rem 0 6rem;
}
@media screen and (max-width: 767px) {
.vl-region[data-v-97867cb6] {
    padding: 3rem 0;
}
}
.vl-region:not(.vl-region--alt) + .vl-region[data-v-97867cb6]:not(.vl-region--alt) {
  padding-top: 0;
}
.vl-region--alt[data-v-97867cb6] {
  background-color: #f7f9fc;
}
.vl-region--overlap[data-v-97867cb6] {
  background: linear-gradient(to bottom, transparent calc(50% - 30px), #f7f9fc calc(50% - 30px), #f7f9fc 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#000000',GradientType=0 );
}
.vl-region--overlap .vl-layout[data-v-97867cb6] {
  border: 1px #cbd2da solid;
  padding-top: 50px;
  padding-bottom: 50px;
  background: #fff;
}
@media only screen and (max-width: 1295px) {
.vl-region--overlap .vl-layout[data-v-97867cb6] {
    margin: 15px;
}
}
@media screen and (max-width: 1023px) {
.vl-region--overlap .vl-layout[data-v-97867cb6] {
    padding-top: 20px;
    padding-bottom: 20px;
}
}
.vl-region--overlap + .vl-region--alt[data-v-97867cb6] {
  padding-top: 0 !important;
}
.vl-region:not(.vl-region--alt) + .vl-region--alt[data-v-97867cb6],
.vl-region--alt + .vl-region[data-v-97867cb6]:not(.vl-region--alt) {
  padding-top: 6rem;
}
@media screen and (max-width: 767px) {
.vl-region:not(.vl-region--alt) + .vl-region--alt[data-v-97867cb6],
  .vl-region--alt + .vl-region[data-v-97867cb6]:not(.vl-region--alt) {
    padding-top: 3rem;
}
}
.vl-region[data-v-97867cb6]:first-child {
  padding-top: 6rem;
}
@media screen and (max-width: 767px) {
.vl-region[data-v-97867cb6]:first-child {
    padding-top: 2rem;
}
}
.vl-region--small[data-v-97867cb6] {
  padding: 1.5rem 0;
}
@media screen and (max-width: 767px) {
.vl-region--small[data-v-97867cb6] {
    padding: 2rem 0;
}
}
.vl-region--medium[data-v-97867cb6] {
  padding: 3rem 0;
}
@media screen and (max-width: 767px) {
.vl-region--medium[data-v-97867cb6] {
    padding: 2rem 0;
}
}
.vl-region--bordered + .vl-region--bordered[data-v-97867cb6] {
  border-top: 1px solid #f7f9fc;
}
.vl-region--bordered + .vl-region--bordered.vl-region--alt[data-v-97867cb6] {
  border-top-color: #fff;
}
.vl-region.vl-region--no-space[data-v-97867cb6] {
  padding: 0;
}
.vl-region.vl-region--no-space-bottom[data-v-97867cb6] {
  padding-bottom: 0;
}
.vl-region.vl-region--no-space-top[data-v-97867cb6] {
  padding-top: 0;
}
.vl-layout[data-v-97867cb6] {
  position: relative;
  margin: 0 auto;
  min-width: 1024px;
  max-width: 1280px;
  padding: 0 3rem;
}
@media screen and (max-width: 1023px) {
.vl-layout[data-v-97867cb6] {
    width: auto;
    min-width: 768px;
    max-width: 1280px;
}
}
@media screen and (max-width: 767px) {
.vl-layout[data-v-97867cb6] {
    width: auto;
    min-width: 0;
    padding: 0 1.5rem;
}
}
.js-vl-accordion[data-v-97867cb6] {
  position: relative;
}
.js-vl-accordion--flex-reverse[data-v-97867cb6] {
  display: flex;
  flex-direction: column-reverse;
}
.vl-accordion-list--bordered .vl-accordion-list__item[data-v-97867cb6] {
  padding: 3rem 0;
  border-bottom: 1px solid #cbd2da;
  margin-bottom: 0;
}
@media screen and (max-width: 1023px) {
.vl-accordion-list--bordered .vl-accordion-list__item[data-v-97867cb6] {
    padding: 2rem 0;
}
}
@media screen and (max-width: 767px) {
.vl-accordion-list--bordered .vl-accordion-list__item[data-v-97867cb6] {
    padding: 1.5rem 0;
}
}
.vl-accordion-list--bordered .vl-accordion-list__item[data-v-97867cb6]:first-child {
  border-top: 1px solid #cbd2da;
}
.vl-accordion-list__item[data-v-97867cb6] {
  margin-bottom: 10px;
}
.vl-accordion-list__item .vl-accordion-list--bordered[data-v-97867cb6] {
  margin-bottom: 0;
}
.vl-accordion__icon[data-v-97867cb6] {
  flex: 0 0 22px;
  flex-shrink: 0;
  top: 5px;
  align-self: flex-start;
}
.vl-accordion__title[data-v-97867cb6] {
  font-size: 20px;
}
@media screen and (max-width: 767px) {
.vl-accordion__title[data-v-97867cb6] {
    font-size: 18px;
}
}
.vl-accordion__subtitle[data-v-97867cb6] {
  margin-top: 5px;
  padding: 0 0 0 22px;
}
.vl-accordion__summary[data-v-97867cb6] {
  position: relative;
}
.vl-accordion__summary[data-v-97867cb6]:focus {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.vl-accordion__summary[data-v-97867cb6]:focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
@supports (outline-offset: 2px) {
.vl-accordion__summary[data-v-97867cb6]:focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
.vl-accordion__summary--no-toggle .vl-accordion__toggle[data-v-97867cb6] {
  border: none;
  padding: 0px;
}
.vl-accordion__summary--no-toggle .vl-accordion__subtitle[data-v-97867cb6] {
  padding: 0;
}
.vl-accordion__content[data-v-97867cb6] {
  position: relative;
}
.js .vl-accordion__content[data-v-97867cb6] {
  visibility: hidden;
  max-height: 0;
}
.js .js-vl-accordion--open > .vl-accordion__content[data-v-97867cb6] {
  visibility: visible;
  max-height: none;
}
.vl-accordion__image-container .vl-image--full-width[data-v-97867cb6] {
  margin-left: -2.2rem;
  width: calc(100% + 2.2rem * 2);
  max-width: calc(100% + 2.2rem * 2);
  margin-top: -2.2rem;
  margin-bottom: 2.2rem;
  max-height: 19rem;
  -o-object-fit: cover;
     object-fit: cover;
}
@media screen and (max-width: 767px) {
.vl-accordion__image-container .vl-image--full-width[data-v-97867cb6] {
    margin-left: -1rem;
    width: calc(100% + 1rem * 2);
    max-width: calc(100% + 1rem * 2);
    margin-top: -1rem;
    margin-bottom: 1rem;
}
}
.vl-accordion__footer[data-v-97867cb6] {
  min-height: 6px;
  border: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) repeat-x;
  background-size: 6px 6px;
  padding: 3rem 0;
}
@media screen and (max-width: 767px) {
.vl-accordion__footer[data-v-97867cb6] {
    padding: 1.5rem 0;
}
}
.vl-accordion-list--bordered .vl-accordion__footer[data-v-97867cb6] {
  padding-bottom: 0;
}
.vl-accordion__panel[data-v-97867cb6] {
  padding: 2.2rem;
}
@media screen and (max-width: 500px) {
.vl-accordion__panel[data-v-97867cb6] {
    padding: 1rem;
}
}
.vl-accordion__panel--xsmall[data-v-97867cb6] {
  padding: 1rem;
}
.vl-accordion__panel--alt[data-v-97867cb6] {
  margin-top: 1rem;
  background-color: #f7f9fc;
  padding-top: 2.2rem;
}
@media screen and (max-width: 767px) {
.vl-accordion__panel--alt[data-v-97867cb6] {
    padding: 1rem;
}
}
.vl-accordion__panel--no-indent[data-v-97867cb6] {
  padding-left: 0;
  padding-right: 0;
}
.vl-accordion__panel--overflow[data-v-97867cb6] {
  overflow: auto;
}
.vl-accordion-list--bordered .vl-accordion__panel[data-v-97867cb6]:not(.vl-accordion__panel--with-footer) {
  padding-bottom: 0;
}
.vl-action-group[data-v-97867cb6] {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.vl-action-group a[data-v-97867cb6],
.vl-action-group button[data-v-97867cb6],
.vl-action-group .vl-button[data-v-97867cb6] {
  margin-right: 1.4rem;
}
.vl-action-group a[data-v-97867cb6]:last-child,
.vl-action-group button[data-v-97867cb6]:last-child,
.vl-action-group .vl-button[data-v-97867cb6]:last-child {
  margin-right: 0;
}
.vl-action-group--align-right[data-v-97867cb6] {
  justify-content: flex-end;
}
.vl-action-group--align-center[data-v-97867cb6] {
  justify-content: center;
}
.vl-action-group--space-between[data-v-97867cb6] {
  justify-content: space-between;
}
.vl-action-group .vl-link[data-v-97867cb6], .vl-action-group .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6], .vl-sidebar-panel-list-item__button .vl-action-group .vl-icon[data-v-97867cb6], .vl-action-group .vl-sidebar-header__toggle[data-v-97867cb6] {
  white-space: nowrap;
}
.vl-action-group--bordered > *[data-v-97867cb6] {
  position: relative;
  margin: 0 1.6rem;
}
.vl-action-group--bordered > *[data-v-97867cb6]:not(:last-child) {
  margin-right: 1.6rem;
}
.vl-action-group--bordered > *[data-v-97867cb6]:last-child {
  border: 0;
}
.vl-action-group--bordered > *[data-v-97867cb6]:first-child {
  margin-left: 0;
}
.vl-action-group--bordered > *[data-v-97867cb6]:not(:last-child)::after {
  content: "";
  background-color: #cbd2da;
  height: 1.5rem;
  width: 0.1rem;
  right: -1.6rem;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
}
@media screen and (min-width: 1023px) {
.vl-action-group--collapse--l[data-v-97867cb6] {
    flex-direction: column;
    align-items: flex-start;
}
.vl-action-group--collapse--l > *[data-v-97867cb6]:not(:last-child) {
    margin-bottom: 1rem;
}
.vl-action-group--collapse--l.vl-action-group--align-center[data-v-97867cb6], .vl-action-group--collapse--l.vl-action-group--align-right[data-v-97867cb6] {
    align-items: center;
}
.vl-action-group--collapse--l.vl-action-group--align-center .vl-button[data-v-97867cb6], .vl-action-group--collapse--l.vl-action-group--align-right .vl-button[data-v-97867cb6] {
    margin-right: 0;
}
.vl-action-group--collapse--l.vl-action-group--align-right[data-v-97867cb6] {
    align-items: flex-end;
}
.vl-action-group--collapse--l .vl-link[data-v-97867cb6], .vl-action-group--collapse--l .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6], .vl-sidebar-panel-list-item__button .vl-action-group--collapse--l .vl-icon[data-v-97867cb6], .vl-action-group--collapse--l .vl-sidebar-header__toggle[data-v-97867cb6] {
    border-right: 0;
    display: block;
    padding-right: 0;
    text-align: left;
    flex: 1 0 100%;
    margin: 0;
}
.vl-action-group--collapse--l .vl-link[data-v-97867cb6]:not(:last-child), .vl-action-group--collapse--l .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6]:not(:last-child), .vl-sidebar-panel-list-item__button .vl-action-group--collapse--l .vl-icon[data-v-97867cb6]:not(:last-child), .vl-action-group--collapse--l .vl-sidebar-header__toggle[data-v-97867cb6]:not(:last-child) {
    margin-bottom: 0.5rem;
}
.vl-action-group--collapse--l .vl-link[data-v-97867cb6]:not(:last-child)::after, .vl-action-group--collapse--l .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6]:not(:last-child)::after, .vl-sidebar-panel-list-item__button .vl-action-group--collapse--l .vl-icon[data-v-97867cb6]:not(:last-child)::after, .vl-action-group--collapse--l .vl-sidebar-header__toggle[data-v-97867cb6]:not(:last-child)::after {
    display: none;
}
}
@media screen and (max-width: 1023px) {
.vl-action-group--collapse--m[data-v-97867cb6] {
    flex-direction: column;
    align-items: flex-start;
}
.vl-action-group--collapse--m > *[data-v-97867cb6]:not(:last-child) {
    margin-bottom: 1rem;
}
.vl-action-group--collapse--m.vl-action-group--align-center[data-v-97867cb6], .vl-action-group--collapse--m.vl-action-group--align-right[data-v-97867cb6] {
    align-items: center;
}
.vl-action-group--collapse--m.vl-action-group--align-center .vl-button[data-v-97867cb6], .vl-action-group--collapse--m.vl-action-group--align-right .vl-button[data-v-97867cb6] {
    margin-right: 0;
}
.vl-action-group--collapse--m.vl-action-group--align-right[data-v-97867cb6] {
    align-items: flex-end;
}
.vl-action-group--collapse--m .vl-link[data-v-97867cb6], .vl-action-group--collapse--m .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6], .vl-sidebar-panel-list-item__button .vl-action-group--collapse--m .vl-icon[data-v-97867cb6], .vl-action-group--collapse--m .vl-sidebar-header__toggle[data-v-97867cb6] {
    border-right: 0;
    display: block;
    padding-right: 0;
    text-align: left;
    flex: 1 0 100%;
    margin: 0;
}
.vl-action-group--collapse--m .vl-link[data-v-97867cb6]:not(:last-child), .vl-action-group--collapse--m .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6]:not(:last-child), .vl-sidebar-panel-list-item__button .vl-action-group--collapse--m .vl-icon[data-v-97867cb6]:not(:last-child), .vl-action-group--collapse--m .vl-sidebar-header__toggle[data-v-97867cb6]:not(:last-child) {
    margin-bottom: 0.5rem;
}
.vl-action-group--collapse--m .vl-link[data-v-97867cb6]:not(:last-child)::after, .vl-action-group--collapse--m .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6]:not(:last-child)::after, .vl-sidebar-panel-list-item__button .vl-action-group--collapse--m .vl-icon[data-v-97867cb6]:not(:last-child)::after, .vl-action-group--collapse--m .vl-sidebar-header__toggle[data-v-97867cb6]:not(:last-child)::after {
    display: none;
}
}
@media screen and (max-width: 767px) {
.vl-action-group--collapse--s[data-v-97867cb6] {
    flex-direction: column;
    align-items: flex-start;
}
.vl-action-group--collapse--s > *[data-v-97867cb6]:not(:last-child) {
    margin-bottom: 1rem;
}
.vl-action-group--collapse--s.vl-action-group--align-center[data-v-97867cb6], .vl-action-group--collapse--s.vl-action-group--align-right[data-v-97867cb6] {
    align-items: center;
}
.vl-action-group--collapse--s.vl-action-group--align-center .vl-button[data-v-97867cb6], .vl-action-group--collapse--s.vl-action-group--align-right .vl-button[data-v-97867cb6] {
    margin-right: 0;
}
.vl-action-group--collapse--s.vl-action-group--align-right[data-v-97867cb6] {
    align-items: flex-end;
}
.vl-action-group--collapse--s .vl-link[data-v-97867cb6], .vl-action-group--collapse--s .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6], .vl-sidebar-panel-list-item__button .vl-action-group--collapse--s .vl-icon[data-v-97867cb6], .vl-action-group--collapse--s .vl-sidebar-header__toggle[data-v-97867cb6] {
    border-right: 0;
    display: block;
    padding-right: 0;
    text-align: left;
    flex: 1 0 100%;
    margin: 0;
}
.vl-action-group--collapse--s .vl-link[data-v-97867cb6]:not(:last-child), .vl-action-group--collapse--s .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6]:not(:last-child), .vl-sidebar-panel-list-item__button .vl-action-group--collapse--s .vl-icon[data-v-97867cb6]:not(:last-child), .vl-action-group--collapse--s .vl-sidebar-header__toggle[data-v-97867cb6]:not(:last-child) {
    margin-bottom: 0.5rem;
}
.vl-action-group--collapse--s .vl-link[data-v-97867cb6]:not(:last-child)::after, .vl-action-group--collapse--s .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6]:not(:last-child)::after, .vl-sidebar-panel-list-item__button .vl-action-group--collapse--s .vl-icon[data-v-97867cb6]:not(:last-child)::after, .vl-action-group--collapse--s .vl-sidebar-header__toggle[data-v-97867cb6]:not(:last-child)::after {
    display: none;
}
}
@media screen and (max-width: 500px) {
.vl-action-group--collapse--xs[data-v-97867cb6] {
    flex-direction: column;
    align-items: flex-start;
}
.vl-action-group--collapse--xs > *[data-v-97867cb6]:not(:last-child) {
    margin-bottom: 1rem;
}
.vl-action-group--collapse--xs.vl-action-group--align-center[data-v-97867cb6], .vl-action-group--collapse--xs.vl-action-group--align-right[data-v-97867cb6] {
    align-items: center;
}
.vl-action-group--collapse--xs.vl-action-group--align-center .vl-button[data-v-97867cb6], .vl-action-group--collapse--xs.vl-action-group--align-right .vl-button[data-v-97867cb6] {
    margin-right: 0;
}
.vl-action-group--collapse--xs.vl-action-group--align-right[data-v-97867cb6] {
    align-items: flex-end;
}
.vl-action-group--collapse--xs .vl-link[data-v-97867cb6], .vl-action-group--collapse--xs .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6], .vl-sidebar-panel-list-item__button .vl-action-group--collapse--xs .vl-icon[data-v-97867cb6], .vl-action-group--collapse--xs .vl-sidebar-header__toggle[data-v-97867cb6] {
    border-right: 0;
    display: block;
    padding-right: 0;
    text-align: left;
    flex: 1 0 100%;
    margin: 0;
}
.vl-action-group--collapse--xs .vl-link[data-v-97867cb6]:not(:last-child), .vl-action-group--collapse--xs .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6]:not(:last-child), .vl-sidebar-panel-list-item__button .vl-action-group--collapse--xs .vl-icon[data-v-97867cb6]:not(:last-child), .vl-action-group--collapse--xs .vl-sidebar-header__toggle[data-v-97867cb6]:not(:last-child) {
    margin-bottom: 0.5rem;
}
.vl-action-group--collapse--xs .vl-link[data-v-97867cb6]:not(:last-child)::after, .vl-action-group--collapse--xs .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6]:not(:last-child)::after, .vl-sidebar-panel-list-item__button .vl-action-group--collapse--xs .vl-icon[data-v-97867cb6]:not(:last-child)::after, .vl-action-group--collapse--xs .vl-sidebar-header__toggle[data-v-97867cb6]:not(:last-child)::after {
    display: none;
}
}
.vl-alert[data-v-97867cb6] {
  display: flex;
  position: relative;
  background-color: #e8ebee;
  border: 0.1rem solid #cfd5dd;
  padding: 2.5rem 3rem;
  border-radius: 0.3rem;
}
@media screen and (max-width: 767px) {
.vl-alert[data-v-97867cb6] {
    padding: 1.5rem;
}
}
.vl-alert__close[data-v-97867cb6] {
  display: flex;
  position: absolute;
  border: 0;
  cursor: pointer;
  top: 0.9rem;
  right: 0.9rem;
  padding: 0.5rem;
  font-size: 1.6rem;
  overflow: hidden;
}
.vl-alert__close[data-v-97867cb6]:hover, .vl-alert__close[data-v-97867cb6]:focus {
  color: #003bb0;
}
.vl-alert__close > .vl-vi[data-v-97867cb6] {
  display: inline-flex;
}
.vl-alert__content-wrapper[data-v-97867cb6] {
  display: flex;
  flex: 1;
  overflow: hidden;
}
@media screen and (max-width: 767px) {
.vl-alert__content-wrapper[data-v-97867cb6] {
    flex-wrap: wrap;
}
}
.vl-alert__content[data-v-97867cb6] {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex-basis: 100%;
}
@media screen and (max-width: 767px) {
.vl-alert__content[data-v-97867cb6] {
    flex-basis: auto;
    flex-grow: 1;
}
}
.vl-alert__icon[data-v-97867cb6] {
  flex: 0 0 auto;
  margin-right: 2.5rem;
  font-size: 2.4rem;
  line-height: 1;
}
@media screen and (max-width: 767px) {
.vl-alert__icon[data-v-97867cb6] {
    margin-right: 1.5rem;
    font-size: 1.6rem;
    margin-top: 3px;
}
}
.vl-alert__title[data-v-97867cb6] {
  font-size: 1.8rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 1.4rem;
  line-height: 1.44;
}
@media screen and (max-width: 767px) {
.vl-alert__title[data-v-97867cb6] {
    font-size: 1.8rem;
    margin-bottom: 1rem;
}
}
.vl-alert__title[data-v-97867cb6] {
  margin-bottom: 0.3rem;
}
.vl-alert__actions[data-v-97867cb6] {
  margin-top: 1.5rem;
}
.vl-alert__message[data-v-97867cb6] {
  color: #333332;
}
.vl-alert--cta[data-v-97867cb6]::before {
  content: "";
  position: absolute;
  top: -0.1rem;
  left: -0.1rem;
  width: calc(100% + 0.2rem);
  height: 0.3rem;
  background: #05c;
}
.vl-alert--accent[data-v-97867cb6] {
  background-color: rgba(var(--vl-theme-primary-color-rgb, 255, 230, 21), 0.1);
  border-color: rgba(var(--vl-theme-primary-color-rgb, 255, 230, 21), 0.3);
}
.vl-alert--accent .vl-alert__icon[data-v-97867cb6] {
  color: #000;
}
.vl-alert--error[data-v-97867cb6] {
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
  border-color: #edafb1;
}
.vl-alert--error .vl-alert__icon[data-v-97867cb6] {
  color: #aa2729;
}
.vl-alert--warning[data-v-97867cb6] {
  background-color: rgb(100%, 96.3137254902%, 90.3921568627%);
  border-color: rgb(100%, 85.2549019608%, 61.568627451%);
}
.vl-alert--warning .vl-alert__icon[data-v-97867cb6] {
  color: #d07b06;
}
.vl-alert--success[data-v-97867cb6] {
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
  border-color: rgb(60%, 84.7843137255%, 71.137254902%);
}
.vl-alert--success .vl-alert__icon[data-v-97867cb6] {
  color: #007a37;
}
.vl-alert--info[data-v-97867cb6] {
  background-color: #f7f9fc;
  border-color: #e8ebee;
}
.vl-alert--naked[data-v-97867cb6] {
  background: transparent;
  padding: 0;
  border: 0;
  border-radius: 0;
}
.vl-alert--naked .vl-alert__icon[data-v-97867cb6] {
  margin-right: 1.5rem;
}
.vl-alert--naked .vl-alert__content[data-v-97867cb6] {
  display: block;
}
.vl-alert--naked .vl-alert__title[data-v-97867cb6] {
  margin-bottom: 0;
}
.vl-alert--naked .vl-alert__title > *[data-v-97867cb6] {
  display: inline;
}
.vl-alert--naked.vl-alert--error .vl-alert__icon[data-v-97867cb6] {
  color: #d2373c;
}
.vl-alert--naked p[data-v-97867cb6] {
  display: inline;
}
.vl-alert--small[data-v-97867cb6] {
  font-size: 1.4rem;
  line-height: 1.2;
  padding: 1.5rem;
}
.vl-alert--small .vl-alert__title[data-v-97867cb6] {
  font-size: 1.6rem;
}
.vl-alert--small .vl-alert__icon[data-v-97867cb6] {
  width: 2rem;
  height: 2rem;
  font-size: 2rem;
  margin-right: 1.5rem;
}
.vl-alert--small .vl-alert__actions[data-v-97867cb6] {
  margin-top: 1rem;
}
.vl-alert--large[data-v-97867cb6] {
  padding: 5rem 5.5rem;
}
@media screen and (max-width: 767px) {
.vl-alert--large[data-v-97867cb6] {
    padding: 1.5rem;
}
}
.vl-alert--large .vl-alert__title[data-v-97867cb6] {
  font-size: 2.2rem;
}
@media screen and (max-width: 767px) {
.vl-alert--large .vl-alert__title[data-v-97867cb6] {
    font-size: 2rem;
}
}
.vl-alert--center[data-v-97867cb6] {
  align-items: center;
}
.vl-alert__image[data-v-97867cb6] {
  width: 8rem;
  height: auto;
  margin-right: 4rem;
}
@media screen and (max-width: 767px) {
.vl-alert__image[data-v-97867cb6] {
    width: 7rem;
    margin-right: 1rem;
    margin-bottom: 1rem;
}
.vl-alert__image + .vl-alert__content[data-v-97867cb6] {
    max-width: calc(100% - 8rem);
}
}
@media screen and (max-width: 500px) {
.vl-alert__image + .vl-alert__content[data-v-97867cb6] {
    max-width: none;
}
}
.vl-annotation[data-v-97867cb6] {
  color: #687483;
  font-weight: 400;
  font-size: inherit;
}
.vl-annotation--small[data-v-97867cb6] {
  font-size: 0.65em;
}
.vl-annotation__list-item[data-v-97867cb6] {
  display: list-item;
  list-style-type: disc;
  float: left;
  margin-left: 3rem;
}
.vl-annotation__list-item[data-v-97867cb6]:first-of-type {
  margin-left: 0;
  list-style-type: none;
}
.vl-annotation__list-item--iconless[data-v-97867cb6] {
  list-style-type: none;
  margin-left: 1rem;
}
.vl-badge[data-v-97867cb6] {
  width: 4.5rem;
  height: 4.5rem;
  border-radius: 2.25rem;
  display: inline-block;
  border: 0;
  flex-shrink: 0;
  position: relative;
  background-color: #fff;
}
.vl-badge--initials[data-v-97867cb6] {
  position: relative;
}
.vl-badge--initials span[data-v-97867cb6] {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.25rem;
  text-transform: uppercase;
  color: #333332;
  font-weight: 500;
  margin: 0 0.5px;
}
.vl-badge--initials.vl-badge--action span[data-v-97867cb6], .vl-badge--initials.vl-badge--success span[data-v-97867cb6], .vl-badge--initials.vl-badge--error span[data-v-97867cb6] {
  color: #fff;
}
.vl-badge--bullet[data-v-97867cb6] {
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 0.4rem;
}
.vl-badge--bullet.vl-badge--icon .vl-vi[data-v-97867cb6] {
  display: none;
}
.vl-badge--bullet.vl-badge--initials span[data-v-97867cb6] {
  display: none;
}
.vl-badge--inline .vl-badge--bullet[data-v-97867cb6] {
  margin-right: 10px;
}
@media screen and (max-width: 767px) {
.vl-badge--inline .vl-badge--bullet[data-v-97867cb6] {
    margin-right: 7px;
}
}
.vl-badge--alt[data-v-97867cb6] {
  background-color: #f7f9fc;
}
.vl-badge--white[data-v-97867cb6] {
  background-color: #fff;
}
.vl-badge--accent[data-v-97867cb6] {
  color: var(--vl-theme-accent-fg-color, var(--vl-theme-fg-color));
  background-color: var(--vl-theme-accent-color, var(--vl-theme-primary-color));
}
.vl-badge--accent[data-v-97867cb6] ::before {
  color: var(--vl-theme-accent-fg-color);
}
.vl-badge--accent span[data-v-97867cb6] {
  color: var(--vl-theme-accent-fg-color, #333332);
}
.vl-badge--action[data-v-97867cb6] {
  color: var(--vl-theme-action-fg-color, #fff);
  background-color: var(--vl-theme-action-color, #05c);
}
.vl-badge--action span[data-v-97867cb6] {
  color: var(--vl-theme-action-fg-color, #333332);
}
.vl-badge--success[data-v-97867cb6] {
  color: #fff;
  background-color: #007a37;
}
.vl-badge--success span[data-v-97867cb6] {
  color: #fff;
}
.vl-badge--error[data-v-97867cb6] {
  color: #fff;
  background-color: #d2373c;
}
.vl-badge--error span[data-v-97867cb6] {
  color: #fff;
}
.vl-badge--warning[data-v-97867cb6] {
  background-color: #ffA10a;
}
.vl-badge--border[data-v-97867cb6] {
  border: 1px solid #cbd2da;
}
.vl-badge--block[data-v-97867cb6] {
  display: block;
}
.vl-badge__img[data-v-97867cb6] {
  border-radius: 50%;
}
.vl-badge--icon[data-v-97867cb6] {
  position: relative;
}
.vl-badge--icon.vl-badge--action .vl-badge__icon[data-v-97867cb6], .vl-badge--icon.vl-badge--success .vl-badge__icon[data-v-97867cb6], .vl-badge--icon.vl-badge--error .vl-badge__icon[data-v-97867cb6] {
  color: #fff;
}
.vl-badge__icon[data-v-97867cb6] {
  margin: -0.5px 0.5px;
}
.vl-badge--icon .vl-badge__icon[data-v-97867cb6], .vl-badge--icon .vl-badge__image-icon img[data-v-97867cb6] {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.25rem;
  color: #333332;
  fill: #333332;
}
.vl-badge img[data-v-97867cb6] {
  border-radius: 50%;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
}
.vl-badge img.vl-badge__icon[data-v-97867cb6] {
  height: 70%;
}
.vl-badge--icon .vl-badge__image-icon img[data-v-97867cb6] {
  height: 70%;
  width: 70%;
  -o-object-fit: contain;
     object-fit: contain;
  border-radius: 0;
}
.vl-badge.vl-badge--icon > .vl-vi[data-v-97867cb6] {
  font-size: 1.8rem;
}
.vl-badge.vl-badge--icon .vl-badge__icon[data-v-97867cb6] {
  line-height: 2.4rem;
  font-size: 2.4rem;
}
.vl-badge.vl-badge--initials span[data-v-97867cb6] {
  font-size: 1.8rem;
}
.vl-badge--xxsmall[data-v-97867cb6], .vl-badge--medium .vl-badge__notification .vl-badge[data-v-97867cb6], .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge[data-v-97867cb6], .vl-badge--small .vl-badge__notification .vl-badge[data-v-97867cb6], .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge[data-v-97867cb6], .vl-badge--xsmall .vl-badge__notification .vl-badge[data-v-97867cb6], .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge[data-v-97867cb6], .vl-badge--xxsmall .vl-badge__notification .vl-badge[data-v-97867cb6] {
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 0.8rem;
}
.vl-badge--xxsmall.vl-badge--icon > .vl-vi[data-v-97867cb6], .vl-badge--medium .vl-badge__notification .vl-badge--icon.vl-badge > .vl-vi[data-v-97867cb6], .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge--icon.vl-badge > .vl-vi[data-v-97867cb6], .vl-badge--small .vl-badge__notification .vl-badge--icon.vl-badge > .vl-vi[data-v-97867cb6], .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge--icon.vl-badge > .vl-vi[data-v-97867cb6], .vl-badge--xsmall .vl-badge__notification .vl-badge--icon.vl-badge > .vl-vi[data-v-97867cb6], .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge--icon.vl-badge > .vl-vi[data-v-97867cb6], .vl-badge--xxsmall .vl-badge__notification .vl-badge--icon.vl-badge > .vl-vi[data-v-97867cb6] {
  font-size: 1rem;
}
.vl-badge--xxsmall.vl-badge--icon .vl-badge__icon[data-v-97867cb6], .vl-badge--medium .vl-badge__notification .vl-badge--icon.vl-badge .vl-badge__icon[data-v-97867cb6], .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge--icon.vl-badge .vl-badge__icon[data-v-97867cb6], .vl-badge--small .vl-badge__notification .vl-badge--icon.vl-badge .vl-badge__icon[data-v-97867cb6], .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge--icon.vl-badge .vl-badge__icon[data-v-97867cb6], .vl-badge--xsmall .vl-badge__notification .vl-badge--icon.vl-badge .vl-badge__icon[data-v-97867cb6], .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge--icon.vl-badge .vl-badge__icon[data-v-97867cb6], .vl-badge--xxsmall .vl-badge__notification .vl-badge--icon.vl-badge .vl-badge__icon[data-v-97867cb6] {
  line-height: 0.8rem;
  font-size: 0.8rem;
}
.vl-badge--xxsmall.vl-badge--initials span[data-v-97867cb6], .vl-badge--medium .vl-badge__notification .vl-badge--initials.vl-badge span[data-v-97867cb6], .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge--initials.vl-badge span[data-v-97867cb6], .vl-badge--small .vl-badge__notification .vl-badge--initials.vl-badge span[data-v-97867cb6], .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge--initials.vl-badge span[data-v-97867cb6], .vl-badge--xsmall .vl-badge__notification .vl-badge--initials.vl-badge span[data-v-97867cb6], .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge--initials.vl-badge span[data-v-97867cb6], .vl-badge--xxsmall .vl-badge__notification .vl-badge--initials.vl-badge span[data-v-97867cb6] {
  font-size: 1rem;
}
.vl-badge--xxsmall .vl-badge__notification[data-v-97867cb6], .vl-badge--medium .vl-badge__notification .vl-badge .vl-badge__notification[data-v-97867cb6], .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification[data-v-97867cb6], .vl-badge--small .vl-badge__notification .vl-badge .vl-badge__notification[data-v-97867cb6], .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification[data-v-97867cb6], .vl-badge--xsmall .vl-badge__notification .vl-badge .vl-badge__notification[data-v-97867cb6], .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification[data-v-97867cb6], .vl-badge--xxsmall .vl-badge__notification .vl-badge .vl-badge__notification[data-v-97867cb6] {
  position: absolute;
  top: 0rem;
  right: -0.5rem;
  line-height: 1;
}
.vl-badge--xxsmall .vl-badge__notification--top[data-v-97867cb6], .vl-badge--medium .vl-badge__notification .vl-badge .vl-badge__notification--top[data-v-97867cb6], .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification--top[data-v-97867cb6], .vl-badge--small .vl-badge__notification .vl-badge .vl-badge__notification--top[data-v-97867cb6], .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification--top[data-v-97867cb6], .vl-badge--xsmall .vl-badge__notification .vl-badge .vl-badge__notification--top[data-v-97867cb6], .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification--top[data-v-97867cb6], .vl-badge--xxsmall .vl-badge__notification .vl-badge .vl-badge__notification--top[data-v-97867cb6] {
  top: 0rem;
}
.vl-badge--xxsmall .vl-badge__notification--right[data-v-97867cb6], .vl-badge--medium .vl-badge__notification .vl-badge .vl-badge__notification--right[data-v-97867cb6], .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification--right[data-v-97867cb6], .vl-badge--small .vl-badge__notification .vl-badge .vl-badge__notification--right[data-v-97867cb6], .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification--right[data-v-97867cb6], .vl-badge--xsmall .vl-badge__notification .vl-badge .vl-badge__notification--right[data-v-97867cb6], .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification--right[data-v-97867cb6], .vl-badge--xxsmall .vl-badge__notification .vl-badge .vl-badge__notification--right[data-v-97867cb6] {
  right: -0.5rem;
}
.vl-badge--xxsmall .vl-badge__notification--bottom[data-v-97867cb6], .vl-badge--medium .vl-badge__notification .vl-badge .vl-badge__notification--bottom[data-v-97867cb6], .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification--bottom[data-v-97867cb6], .vl-badge--small .vl-badge__notification .vl-badge .vl-badge__notification--bottom[data-v-97867cb6], .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification--bottom[data-v-97867cb6], .vl-badge--xsmall .vl-badge__notification .vl-badge .vl-badge__notification--bottom[data-v-97867cb6], .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification--bottom[data-v-97867cb6], .vl-badge--xxsmall .vl-badge__notification .vl-badge .vl-badge__notification--bottom[data-v-97867cb6] {
  top: initial;
  bottom: 0rem;
}
.vl-badge--xxsmall .vl-badge__notification--left[data-v-97867cb6], .vl-badge--medium .vl-badge__notification .vl-badge .vl-badge__notification--left[data-v-97867cb6], .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification--left[data-v-97867cb6], .vl-badge--small .vl-badge__notification .vl-badge .vl-badge__notification--left[data-v-97867cb6], .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification--left[data-v-97867cb6], .vl-badge--xsmall .vl-badge__notification .vl-badge .vl-badge__notification--left[data-v-97867cb6], .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification--left[data-v-97867cb6], .vl-badge--xxsmall .vl-badge__notification .vl-badge .vl-badge__notification--left[data-v-97867cb6] {
  right: initial;
  left: -0.5rem;
}
.vl-badge--xsmall[data-v-97867cb6], .vl-badge--large .vl-badge__notification .vl-badge[data-v-97867cb6] {
  width: 2rem;
  height: 2rem;
  border-radius: 1rem;
}
.vl-badge--xsmall.vl-badge--icon > .vl-vi[data-v-97867cb6], .vl-badge--large .vl-badge__notification .vl-badge--icon.vl-badge > .vl-vi[data-v-97867cb6] {
  font-size: 1rem;
}
.vl-badge--xsmall.vl-badge--icon .vl-badge__icon[data-v-97867cb6], .vl-badge--large .vl-badge__notification .vl-badge--icon.vl-badge .vl-badge__icon[data-v-97867cb6] {
  line-height: 1.2rem;
  font-size: 1.2rem;
}
.vl-badge--xsmall.vl-badge--initials span[data-v-97867cb6], .vl-badge--large .vl-badge__notification .vl-badge--initials.vl-badge span[data-v-97867cb6] {
  font-size: 1rem;
}
.vl-badge--xsmall .vl-badge__notification[data-v-97867cb6], .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification[data-v-97867cb6] {
  position: absolute;
  top: 0rem;
  right: -0.5rem;
  line-height: 1;
}
.vl-badge--xsmall .vl-badge__notification--top[data-v-97867cb6], .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification--top[data-v-97867cb6] {
  top: 0rem;
}
.vl-badge--xsmall .vl-badge__notification--right[data-v-97867cb6], .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification--right[data-v-97867cb6] {
  right: -0.5rem;
}
.vl-badge--xsmall .vl-badge__notification--bottom[data-v-97867cb6], .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification--bottom[data-v-97867cb6] {
  top: initial;
  bottom: 0rem;
}
.vl-badge--xsmall .vl-badge__notification--left[data-v-97867cb6], .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification--left[data-v-97867cb6] {
  right: initial;
  left: -0.5rem;
}
.vl-badge--small[data-v-97867cb6], .vl-badge--xlarge .vl-badge__notification .vl-badge[data-v-97867cb6] {
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 1.375rem;
}
.vl-badge--small.vl-badge--icon > .vl-vi[data-v-97867cb6], .vl-badge--xlarge .vl-badge__notification .vl-badge--icon.vl-badge > .vl-vi[data-v-97867cb6] {
  font-size: 1.4rem;
}
.vl-badge--small.vl-badge--icon .vl-badge__icon[data-v-97867cb6], .vl-badge--xlarge .vl-badge__notification .vl-badge--icon.vl-badge .vl-badge__icon[data-v-97867cb6] {
  line-height: 1.6rem;
  font-size: 1.6rem;
}
.vl-badge--small.vl-badge--initials span[data-v-97867cb6], .vl-badge--xlarge .vl-badge__notification .vl-badge--initials.vl-badge span[data-v-97867cb6] {
  font-size: 1.4rem;
}
.vl-badge--small .vl-badge__notification[data-v-97867cb6], .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification[data-v-97867cb6] {
  position: absolute;
  top: 0rem;
  right: -0.5rem;
  line-height: 1;
}
.vl-badge--small .vl-badge__notification--top[data-v-97867cb6], .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification--top[data-v-97867cb6] {
  top: 0rem;
}
.vl-badge--small .vl-badge__notification--right[data-v-97867cb6], .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification--right[data-v-97867cb6] {
  right: -0.5rem;
}
.vl-badge--small .vl-badge__notification--bottom[data-v-97867cb6], .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification--bottom[data-v-97867cb6] {
  top: initial;
  bottom: 0rem;
}
.vl-badge--small .vl-badge__notification--left[data-v-97867cb6], .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification--left[data-v-97867cb6] {
  right: initial;
  left: -0.5rem;
}
.vl-badge--medium[data-v-97867cb6], .vl-badge--xxlarge .vl-badge__notification .vl-badge[data-v-97867cb6] {
  width: 4.5rem;
  height: 4.5rem;
  border-radius: 2.25rem;
}
.vl-badge--medium.vl-badge--icon > .vl-vi[data-v-97867cb6], .vl-badge--xxlarge .vl-badge__notification .vl-badge--icon.vl-badge > .vl-vi[data-v-97867cb6] {
  font-size: 1.8rem;
}
.vl-badge--medium.vl-badge--icon .vl-badge__icon[data-v-97867cb6], .vl-badge--xxlarge .vl-badge__notification .vl-badge--icon.vl-badge .vl-badge__icon[data-v-97867cb6] {
  line-height: 2.4rem;
  font-size: 2.4rem;
}
.vl-badge--medium.vl-badge--initials span[data-v-97867cb6], .vl-badge--xxlarge .vl-badge__notification .vl-badge--initials.vl-badge span[data-v-97867cb6] {
  font-size: 1.8rem;
}
.vl-badge--medium .vl-badge__notification[data-v-97867cb6], .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification[data-v-97867cb6] {
  position: absolute;
  top: 0rem;
  right: -0.5rem;
  line-height: 1;
}
.vl-badge--medium .vl-badge__notification--top[data-v-97867cb6], .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification--top[data-v-97867cb6] {
  top: 0rem;
}
.vl-badge--medium .vl-badge__notification--right[data-v-97867cb6], .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification--right[data-v-97867cb6] {
  right: -0.5rem;
}
.vl-badge--medium .vl-badge__notification--bottom[data-v-97867cb6], .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification--bottom[data-v-97867cb6] {
  top: initial;
  bottom: 0rem;
}
.vl-badge--medium .vl-badge__notification--left[data-v-97867cb6], .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification--left[data-v-97867cb6] {
  right: initial;
  left: -0.5rem;
}
.vl-badge--large[data-v-97867cb6] {
  width: 5.75rem;
  height: 5.75rem;
  border-radius: 2.875rem;
}
.vl-badge--large.vl-badge--icon > .vl-vi[data-v-97867cb6] {
  font-size: 2.2rem;
}
.vl-badge--large.vl-badge--icon .vl-badge__icon[data-v-97867cb6] {
  line-height: 3.2rem;
  font-size: 3.2rem;
}
.vl-badge--large.vl-badge--initials span[data-v-97867cb6] {
  font-size: 2.2rem;
}
.vl-badge--large .vl-badge__notification[data-v-97867cb6] {
  position: absolute;
  top: 0rem;
  right: -0.5rem;
  line-height: 1;
}
.vl-badge--large .vl-badge__notification--top[data-v-97867cb6] {
  top: 0rem;
}
.vl-badge--large .vl-badge__notification--right[data-v-97867cb6] {
  right: -0.5rem;
}
.vl-badge--large .vl-badge__notification--bottom[data-v-97867cb6] {
  top: initial;
  bottom: 0rem;
}
.vl-badge--large .vl-badge__notification--left[data-v-97867cb6] {
  right: initial;
  left: -0.5rem;
}
.vl-badge--xlarge[data-v-97867cb6] {
  width: 10rem;
  height: 10rem;
  border-radius: 5rem;
}
.vl-badge--xlarge.vl-badge--icon > .vl-vi[data-v-97867cb6] {
  font-size: 3.2rem;
}
.vl-badge--xlarge.vl-badge--icon .vl-badge__icon[data-v-97867cb6] {
  line-height: 4.2rem;
  font-size: 4.2rem;
}
.vl-badge--xlarge.vl-badge--initials span[data-v-97867cb6] {
  font-size: 3.2rem;
}
.vl-badge--xlarge .vl-badge__notification[data-v-97867cb6] {
  position: absolute;
  top: 0rem;
  right: -0.5rem;
  line-height: 1;
}
.vl-badge--xlarge .vl-badge__notification--top[data-v-97867cb6] {
  top: 0rem;
}
.vl-badge--xlarge .vl-badge__notification--right[data-v-97867cb6] {
  right: -0.5rem;
}
.vl-badge--xlarge .vl-badge__notification--bottom[data-v-97867cb6] {
  top: initial;
  bottom: 0rem;
}
.vl-badge--xlarge .vl-badge__notification--left[data-v-97867cb6] {
  right: initial;
  left: -0.5rem;
}
.vl-badge--xxlarge[data-v-97867cb6] {
  width: 15rem;
  height: 15rem;
  border-radius: 7.5rem;
}
.vl-badge--xxlarge.vl-badge--icon > .vl-vi[data-v-97867cb6] {
  font-size: 4.4rem;
}
.vl-badge--xxlarge.vl-badge--icon .vl-badge__icon[data-v-97867cb6] {
  line-height: 6.3rem;
  font-size: 6.3rem;
}
.vl-badge--xxlarge.vl-badge--initials span[data-v-97867cb6] {
  font-size: 4.4rem;
}
.vl-badge--xxlarge .vl-badge__notification[data-v-97867cb6] {
  position: absolute;
  top: 0rem;
  right: -0.5rem;
  line-height: 1;
}
.vl-badge--xxlarge .vl-badge__notification--top[data-v-97867cb6] {
  top: 0rem;
}
.vl-badge--xxlarge .vl-badge__notification--right[data-v-97867cb6] {
  right: -0.5rem;
}
.vl-badge--xxlarge .vl-badge__notification--bottom[data-v-97867cb6] {
  top: initial;
  bottom: 0rem;
}
.vl-badge--xxlarge .vl-badge__notification--left[data-v-97867cb6] {
  right: initial;
  left: -0.5rem;
}
.vl-badge-container--condensed .vl-badge[data-v-97867cb6] {
  margin-left: -1.625rem;
}
.vl-badge-container--condensed .vl-badge--xxsmall[data-v-97867cb6], .vl-badge-container--condensed .vl-badge--xxsmall .vl-badge__notification .vl-badge[data-v-97867cb6], .vl-badge--xxsmall .vl-badge__notification .vl-badge-container--condensed .vl-badge[data-v-97867cb6], .vl-badge-container--condensed .vl-badge--xsmall .vl-badge__notification .vl-badge[data-v-97867cb6], .vl-badge--xsmall .vl-badge__notification .vl-badge-container--condensed .vl-badge[data-v-97867cb6], .vl-badge-container--condensed .vl-badge--small .vl-badge__notification .vl-badge[data-v-97867cb6], .vl-badge--small .vl-badge__notification .vl-badge-container--condensed .vl-badge[data-v-97867cb6], .vl-badge-container--condensed .vl-badge--medium .vl-badge__notification .vl-badge[data-v-97867cb6], .vl-badge--medium .vl-badge__notification .vl-badge-container--condensed .vl-badge[data-v-97867cb6], .vl-badge-container--condensed .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge[data-v-97867cb6], .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge-container--condensed .vl-badge[data-v-97867cb6], .vl-badge-container--condensed .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge[data-v-97867cb6], .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge-container--condensed .vl-badge[data-v-97867cb6], .vl-badge-container--condensed .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge[data-v-97867cb6], .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge-container--condensed .vl-badge[data-v-97867cb6] {
  margin-left: -0.9rem;
}
.vl-badge-container--condensed .vl-badge--xsmall[data-v-97867cb6], .vl-badge-container--condensed .vl-badge--large .vl-badge__notification .vl-badge[data-v-97867cb6], .vl-badge--large .vl-badge__notification .vl-badge-container--condensed .vl-badge[data-v-97867cb6] {
  margin-left: -1rem;
}
.vl-badge-container--condensed .vl-badge--small[data-v-97867cb6], .vl-badge-container--condensed .vl-badge--xlarge .vl-badge__notification .vl-badge[data-v-97867cb6], .vl-badge--xlarge .vl-badge__notification .vl-badge-container--condensed .vl-badge[data-v-97867cb6] {
  margin-left: -1.1875rem;
}
.vl-badge-container--condensed .vl-badge--medium[data-v-97867cb6], .vl-badge-container--condensed .vl-badge--xxlarge .vl-badge__notification .vl-badge[data-v-97867cb6], .vl-badge--xxlarge .vl-badge__notification .vl-badge-container--condensed .vl-badge[data-v-97867cb6] {
  margin-left: -1.625rem;
}
.vl-badge-container--condensed .vl-badge--large[data-v-97867cb6] {
  margin-left: -1.9375rem;
}
.vl-badge-container--condensed .vl-badge--xlarge[data-v-97867cb6] {
  margin-left: -3rem;
}
.vl-badge-container--condensed .vl-badge--xxlarge[data-v-97867cb6] {
  margin-left: -4.25rem;
}
.vl-badge-container--condensed .vl-badge[data-v-97867cb6]:first-child {
  margin-left: auto;
}
a.vl-button[data-v-97867cb6] {
  cursor: pointer;
}
.vl-button[data-v-97867cb6] {
  border-radius: 0;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  border: 0;
  background-color: transparent;
  padding: 0;
  display: inline-flex;
  align-items: center;
  min-height: 3.5rem;
  font-size: 1.6rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  padding: 0.5rem 2rem;
  background-color: var(--vl-theme-action-color, #05c);
  text-decoration: none;
  border-radius: 0.3rem;
  color: #fff;
  text-align: center;
  outline: 0;
  max-width: 100%;
  cursor: default;
}
@media screen and (max-width: 767px) {
.vl-button[data-v-97867cb6] {
    font-size: 1.6rem;
    padding: 1rem;
}
}
.vl-button[data-v-97867cb6]:hover, .vl-button[data-v-97867cb6]:focus {
  color: #fff;
}
.vl-button[data-v-97867cb6]:hover {
  background-color: var(--vl-theme-action-hover-color, #003bb0);
  text-decoration: none;
}
.vl-button[data-v-97867cb6]:focus {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.vl-button[data-v-97867cb6]:focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
.vl-button[data-v-97867cb6]:active {
  background-color: var(--vl-theme-action-active-color, rgb(0%, 25%, 60%));
}
.vl-button[data-v-97867cb6]:visited {
  color: #fff;
}
.vl-button--ellipse[data-v-97867cb6] {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vl-button--ellipse .vl-button__label[data-v-97867cb6] {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vl-button--secondary[data-v-97867cb6] {
  background-color: transparent;
  color: var(--vl-theme-action-color, #05c);
  border: 0.2rem solid currentColor;
  transition: color 0.2s, border-color 0.2s, box-shadow 0.2s;
}
.vl-button--secondary[data-v-97867cb6]:visited {
  color: #05c;
}
.vl-button--secondary[data-v-97867cb6]:focus {
  color: var(--vl-theme-action-active-color, #05c);
}
.vl-button--secondary[data-v-97867cb6]:hover, .vl-button--secondary[data-v-97867cb6]:active {
  color: var(--vl-theme-action-hover-color, #003bb0);
  background-color: transparent;
  border-color: var(--vl-theme-action-hover-color, #003bb0);
}
.vl-button--tertiary[data-v-97867cb6] {
  background-color: transparent;
  color: var(--vl-theme-action-color, #05c);
  border: 0.1rem #c6cdd3 solid;
  transition: background-color 0.2s, box-shadow 0.2s;
}
.vl-button--tertiary[data-v-97867cb6]:visited {
  color: var(--vl-theme-action-color, #05c);
}
.vl-button--tertiary[data-v-97867cb6]:focus {
  color: var(--vl-theme-action-hover-color, #05c);
  border-color: var(--vl-theme-action-hover-color, #c6cdd3);
}
.vl-button--tertiary[data-v-97867cb6]:hover, .vl-button--tertiary[data-v-97867cb6]:active {
  color: var(--vl-theme-action-hover-color, #05c);
  background-color: transparent;
  border-color: var(--vl-theme-action-hover-color, #5990de);
  border-width: 0.2rem;
  padding: 0 calc(2rem - 0.1rem);
}
@media screen and (max-width: 767px) {
.vl-button--tertiary[data-v-97867cb6]:hover, .vl-button--tertiary[data-v-97867cb6]:active {
    padding: calc(1rem - 0.1rem);
}
}
.vl-button--tertiary.vl-button--large[data-v-97867cb6]:hover, .vl-button--tertiary.vl-button--large[data-v-97867cb6]:active {
  padding: calc(2rem - 0.1rem);
  padding-top: calc(1.5rem - 0.1rem);
  padding-bottom: calc(1.5rem - 0.1rem);
}
@media screen and (max-width: 767px) {
.vl-button--tertiary.vl-button--large[data-v-97867cb6]:hover, .vl-button--tertiary.vl-button--large[data-v-97867cb6]:active {
    padding-left: calc(1rem - 0.1rem);
    padding-right: calc(1rem - 0.1rem);
}
}
.vl-button--tertiary.vl-button--loading[data-v-97867cb6]:hover, .vl-button--tertiary.vl-button--loading[data-v-97867cb6]:active {
  padding: 0 calc(8rem - 0.1rem) 0 calc(4rem - 0.1rem);
}
@media screen and (max-width: 767px) {
.vl-button--tertiary.vl-button--loading[data-v-97867cb6]:hover, .vl-button--tertiary.vl-button--loading[data-v-97867cb6]:active {
    padding: 0 calc(8rem - 0.1rem) 0 calc(4rem - 0.1rem);
}
}
.vl-button--tertiary.vl-button--loading[data-v-97867cb6]:focus {
  color: #fff;
}
.vl-button--block[data-v-97867cb6] {
  display: flex;
  justify-content: center;
  width: 100%;
}
.vl-button--block.vl-button--icon-after[data-v-97867cb6], .vl-button--block.vl-button--icon-before[data-v-97867cb6] {
  width: 100%;
}
.vl-button--icon[data-v-97867cb6] {
  width: 3.5rem;
}
.vl-button--icon.vl-button[data-v-97867cb6] {
  padding: 0;
}
.vl-button--icon.vl-button .vl-button__icon[data-v-97867cb6] {
  margin: auto;
}
.vl-button--error[data-v-97867cb6] {
  background-color: #d2373c;
}
.vl-button--error.vl-button--secondary[data-v-97867cb6] {
  background-color: #fff;
  color: #d2373c;
}
.vl-button--error.vl-button--secondary[data-v-97867cb6]:visited {
  color: #d2373c;
}
.vl-button--error.vl-button--secondary[data-v-97867cb6]:hover, .vl-button--error.vl-button--secondary[data-v-97867cb6]:active {
  color: #aa2729;
  border-color: #aa2729;
  background-color: transparent;
}
.vl-button--error.vl-button--tertiary[data-v-97867cb6] {
  background-color: #fff;
  color: #d2373c;
  border-color: #d2373c;
}
.vl-button--error.vl-button--tertiary[data-v-97867cb6]:visited {
  color: #d2373c;
}
.vl-button--error.vl-button--tertiary[data-v-97867cb6]:hover, .vl-button--error.vl-button--tertiary[data-v-97867cb6]:active {
  color: #aa2729;
  border-color: #aa2729;
  background-color: transparent;
}
.vl-button--error[data-v-97867cb6]:hover, .vl-button--error[data-v-97867cb6]:active {
  color: #fff;
  background-color: #aa2729;
}
.vl-button--large[data-v-97867cb6] {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  font-size: 1.8rem;
}
.vl-button--wide[data-v-97867cb6] {
  padding-left: 6rem;
  padding-right: 6rem;
}
.vl-button--narrow[data-v-97867cb6] {
  padding-left: 1rem;
  padding-right: 1rem;
}
.vl-button--narrow.vl-button--tertiary[data-v-97867cb6]:hover, .vl-button--narrow.vl-button--tertiary[data-v-97867cb6]:active {
  padding: 0 calc(1rem - 0.1rem);
}
.vl-button--disabled[data-v-97867cb6] {
  background-color: #cbd2d9;
  border-color: #cbd2d9;
  color: #687483;
  cursor: not-allowed;
}
.vl-button--disabled[data-v-97867cb6]:hover, .vl-button--disabled[data-v-97867cb6]:active {
  background-color: #cbd2d9;
  border-color: #cbd2d9;
  color: #687483;
}
.vl-button--loading[data-v-97867cb6] {
  background-color: #cbd2d9;
  position: relative;
  color: #fff;
  padding: 0 8rem 0 4rem;
}
.vl-button--loading[data-v-97867cb6]:hover, .vl-button--loading[data-v-97867cb6]:active {
  background-color: #cbd2d9;
  color: #fff;
}
.vl-button--loading[data-v-97867cb6]:focus {
  color: #fff;
}
.vl-button--loading[data-v-97867cb6]::after {
  animation: waving-light-97867cb6 infinite 1s linear;
}
@keyframes waving-light-97867cb6 {
0% {
    box-shadow: 10px -0px #687483, 20px -0px #687483, 30px 0px #687483;
}
10% {
    box-shadow: 10px -3px #687483, 20px -0px #687483, 30px -0px #687483;
}
20% {
    box-shadow: 10px -6px #687483, 20px -3px #687483, 30px -0px #687483;
}
30% {
    box-shadow: 10px -3px #687483, 20px -6px #687483, 30px -3px #687483;
}
40% {
    box-shadow: 10px -0px #687483, 20px -3px #687483, 30px -6px #687483;
}
50% {
    box-shadow: 10px -0px #687483, 20px -0px #687483, 30px -3px #687483;
}
60% {
    box-shadow: 10px -0px #687483, 20px -0px #687483, 30px -0px #687483;
}
100% {
    box-shadow: 10px -0px #687483, 20px -0px #687483, 30px -0px #687483;
}
}
.vl-button--loading[data-v-97867cb6]::after {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  right: 4rem;
  margin-top: -0.2rem;
  margin-right: 3.2rem;
  width: 0.4rem;
  height: 0.4rem;
  background-color: #cbd2d9;
  border-radius: 50%;
  box-shadow: 1rem 0 #fff, 2rem 0 #fff, 3rem 0 #fff;
}
.vl-button--naked[data-v-97867cb6], .vl-button--naked-action[data-v-97867cb6] {
  background-color: transparent;
  border: 0;
  color: #333332;
}
.vl-button--naked[data-v-97867cb6]:hover, .vl-button--naked[data-v-97867cb6]:focus, .vl-button--naked[data-v-97867cb6]:active, .vl-button--naked[data-v-97867cb6]:visited, .vl-button--naked-action[data-v-97867cb6]:hover, .vl-button--naked-action[data-v-97867cb6]:focus, .vl-button--naked-action[data-v-97867cb6]:active, .vl-button--naked-action[data-v-97867cb6]:visited {
  border: 0;
  color: #333332;
  background-color: transparent;
}
.vl-button--naked.vl-button--disabled[data-v-97867cb6], .vl-button--naked-action.vl-button--disabled[data-v-97867cb6] {
  color: #687483;
}
.vl-button--naked.vl-button--disabled[data-v-97867cb6]:hover, .vl-button--naked.vl-button--disabled[data-v-97867cb6]:focus, .vl-button--naked.vl-button--disabled[data-v-97867cb6]:active, .vl-button--naked.vl-button--disabled[data-v-97867cb6]:visited, .vl-button--naked-action.vl-button--disabled[data-v-97867cb6]:hover, .vl-button--naked-action.vl-button--disabled[data-v-97867cb6]:focus, .vl-button--naked-action.vl-button--disabled[data-v-97867cb6]:active, .vl-button--naked-action.vl-button--disabled[data-v-97867cb6]:visited {
  color: #687483;
}
.vl-button--naked-action[data-v-97867cb6] {
  color: var(--vl-theme-action-color, #05c);
}
.vl-button--naked-action[data-v-97867cb6]:hover, .vl-button--naked-action[data-v-97867cb6]:focus, .vl-button--naked-action[data-v-97867cb6]:active, .vl-button--naked-action[data-v-97867cb6]:visited {
  color: var(--vl-theme-action-color, #05c);
}
.vl-button__icon[data-v-97867cb6] {
  display: inline-flex;
}
.vl-button__icon.vl-icon[data-v-97867cb6] {
  display: inline-flex;
}
.vl-button__icon--before[data-v-97867cb6] {
  margin-right: 0.8rem;
}
.vl-button__icon--after[data-v-97867cb6] {
  margin-left: 0.8rem;
}
.vl-button-group[data-v-97867cb6] {
  display: flex;
  flex-wrap: wrap;
}
.vl-button-group .vl-button[data-v-97867cb6] {
  margin-right: 1rem;
  margin-bottom: 1rem;
}
.vl-checkbox[data-v-97867cb6] {
  position: relative;
  display: inline-block;
  max-width: 100%;
}
.vl-checkbox[data-v-97867cb6]:not(.vl-checkbox--block):not(:last-of-type) {
  margin-right: 1.5rem;
}
.vl-checkbox__label[data-v-97867cb6] {
  display: flex;
  flex: 0 0 auto;
  font-size: 1.6rem;
  line-height: 2.4rem;
}
@media screen and (max-width: 767px) {
.vl-checkbox__label[data-v-97867cb6] {
    line-height: 2.2rem;
}
}
.vl-checkbox__label .vl-checkbox__box[data-v-97867cb6]::before, .vl-checkbox__label .vl-checkbox__box[data-v-97867cb6]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-checkbox__label .vl-checkbox__box[data-v-97867cb6]::before {
  content: "\\f15a";
}
.vl-checkbox__label .vl-checkbox__box[data-v-97867cb6] {
  position: relative;
  flex: 0 0 1.8rem;
  width: 1.8rem;
  height: 1.8rem;
  margin-top: 0.3rem;
  margin-right: 1rem;
  line-height: 1;
}
@media screen and (max-width: 767px) {
.vl-checkbox__label .vl-checkbox__box[data-v-97867cb6] {
    margin-top: 0.2rem;
}
}
.vl-checkbox__label .vl-checkbox__box[data-v-97867cb6]::before {
  position: absolute;
  display: block;
  font-size: 0.8rem;
  color: #8695a8;
  line-height: 1;
  text-align: center;
  transform: translateZ(0) translate(-50%, -50%) scale(0);
  transition: all 0.2s cubic-bezier(1, 0.1, 0, 0.9);
  top: 0.9rem;
  left: 0.9rem;
  z-index: 2;
}
.vl-checkbox__label .vl-checkbox__box[data-v-97867cb6]::after {
  display: inline-block;
  content: "";
  background: #fff;
  width: 1.8rem;
  height: 1.8rem;
  border: 0.1rem #8695a8 solid;
  outline: 0.2rem transparent solid;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  transition: all 0.2s cubic-bezier(1, 0.1, 0, 0.9);
  z-index: 1;
  border-radius: 0.3rem;
}
.vl-checkbox__toggle[data-v-97867cb6] {
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  width: 0.1rem;
  height: 0.1rem;
  padding: 0;
  margin: -0.1rem;
}
.vl-checkbox__toggle:focus + .vl-checkbox__label .vl-checkbox__box[data-v-97867cb6]::after {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.vl-checkbox__toggle:focus + .vl-checkbox__label .vl-checkbox__box[data-v-97867cb6]::after {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
@supports (outline-offset: 2px) {
.vl-checkbox__toggle:focus + .vl-checkbox__label .vl-checkbox__box[data-v-97867cb6]::after {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
.vl-checkbox__toggle:checked + .vl-checkbox__label .vl-checkbox__box[data-v-97867cb6]::before {
  transform: translateZ(0) translate(-50%, -50%) scale(1);
  color: #fff;
}
.vl-checkbox__toggle:checked + .vl-checkbox__label .vl-checkbox__box[data-v-97867cb6]::after {
  background: #05c;
  border: 0.1rem #05c solid;
}
.vl-checkbox--block[data-v-97867cb6] {
  display: block;
  margin: 0;
}
.vl-checkbox--disabled .vl-checkbox__label[data-v-97867cb6] {
  color: #687483;
}
.vl-checkbox--disabled .vl-checkbox__label .vl-checkbox__box[data-v-97867cb6]::after {
  background-color: #8695a8;
  border-color: #8695a8;
  cursor: auto;
}
.vl-checkbox--disabled .vl-checkbox__toggle:checked + .vl-checkbox__label .vl-checkbox__box[data-v-97867cb6]::after {
  background: #8695a8;
  border: 0.1rem #8695a8 solid;
}
.vl-checkbox--single[data-v-97867cb6] {
  margin: 0;
}
.vl-checkbox--single .vl-checkbox__label[data-v-97867cb6] {
  padding: 0;
}
.vl-checkbox--single .vl-checkbox__label .vl-checkbox__box[data-v-97867cb6] {
  margin: 0;
}
.vl-checkbox--single .vl-checkbox__label .vl-checkbox__box[data-v-97867cb6]::after {
  position: relative;
  top: auto;
  left: auto;
}
.vl-checkbox--single .vl-checkbox--switch + .vl-checkbox__label .vl-checkbox--switch__label[data-v-97867cb6] {
  margin: 0;
}
.vl-checkbox--error .vl-checkbox__label .vl-checkbox__box[data-v-97867cb6]::after, .vl-checkbox.invalid.validated .vl-checkbox__label .vl-checkbox__box[data-v-97867cb6]::after {
  background-color: #fff;
  border-color: #d2373c;
}
.vl-checkbox--error .vl-checkbox__toggle:checked + .vl-checkbox__label .vl-checkbox__box[data-v-97867cb6]::before, .vl-checkbox.invalid.validated .vl-checkbox__toggle:checked + .vl-checkbox__label .vl-checkbox__box[data-v-97867cb6]::before {
  color: #d2373c;
}
.vl-checkbox--error .vl-checkbox__toggle:checked + .vl-checkbox__label .vl-checkbox__box[data-v-97867cb6]::after, .vl-checkbox.invalid.validated .vl-checkbox__toggle:checked + .vl-checkbox__label .vl-checkbox__box[data-v-97867cb6]::after {
  background-color: #fff;
  border: 0.1rem #d2373c solid;
}
.vl-checkbox--success .vl-checkbox__label .vl-checkbox__box[data-v-97867cb6]::after {
  background-color: #fff;
  border-color: #009e47;
}
.vl-checkbox--success .vl-checkbox__toggle:checked + .vl-checkbox__label .vl-checkbox__box[data-v-97867cb6]::before {
  color: #009e47;
}
.vl-checkbox--success .vl-checkbox__toggle:checked + .vl-checkbox__label .vl-checkbox__box[data-v-97867cb6]::after {
  background-color: #fff;
  border: 0.1rem #009e47 solid;
}
.vl-checkbox--empty[data-v-97867cb6] {
  margin-top: 0;
}
.vl-checkbox--switch[data-v-97867cb6] {
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  width: 0.1rem;
  height: 0.1rem;
  padding: 0;
  margin: -0.1rem;
}
.vl-checkbox--switch:focus + .vl-checkbox__label .vl-checkbox--switch__label[data-v-97867cb6] {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
}
.vl-checkbox--switch:checked + .vl-checkbox__label .vl-checkbox--switch__label[data-v-97867cb6] {
  background: #05c;
  border-color: #05c;
  position: relative;
}
.vl-checkbox--switch:checked + .vl-checkbox__label .vl-checkbox--switch__label[data-v-97867cb6]::before, .vl-checkbox--switch:checked + .vl-checkbox__label .vl-checkbox--switch__label span[data-v-97867cb6]::before {
  margin-left: calc(50% + 0.3rem);
  transform: translate(0.1rem, 0.1rem) scale(1);
  visibility: visible;
  opacity: 1;
}
.vl-checkbox--switch:checked + .vl-checkbox__label .vl-checkbox--switch__label[data-v-97867cb6]::after {
  width: 2rem;
  height: 2rem;
  margin-left: 50%;
  background-color: #fff;
  border-color: #05c;
  transform: translate(-0.1rem, -0.1rem);
}
.vl-checkbox--switch:checked:disabled + .vl-checkbox__label .vl-checkbox--switch__label[data-v-97867cb6] {
  border-color: #8695a8;
}
.vl-checkbox--switch:checked:disabled + .vl-checkbox__label .vl-checkbox--switch__label[data-v-97867cb6]::after {
  border-color: #8695a8;
}
.vl-checkbox--switch + .vl-checkbox__label[data-v-97867cb6] {
  align-items: center;
}
.vl-checkbox--switch + .vl-checkbox__label .vl-checkbox--switch__label[data-v-97867cb6] {
  position: relative;
  display: inline-block;
  width: 4rem;
  height: 2.2rem;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  vertical-align: middle;
  outline: transparent solid 0.2rem;
  margin: 0 1rem 0 0;
  background: #fff;
  border: 0.1rem solid #8695a8;
  border-radius: 2em;
  padding: 0.1rem;
  transition: box-shadow 0.1s cubic-bezier(1, 0.1, 0, 0.9);
  line-height: 1rem;
}
.vl-checkbox--switch + .vl-checkbox__label .vl-checkbox--switch__label span[data-v-97867cb6]::before, .vl-checkbox--switch + .vl-checkbox__label .vl-checkbox--switch__label span[data-v-97867cb6]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-checkbox--switch + .vl-checkbox__label .vl-checkbox--switch__label span[data-v-97867cb6]::before {
  content: "\\f15a";
}
.vl-checkbox--switch + .vl-checkbox__label .vl-checkbox--switch__label span[data-v-97867cb6]::before {
  font-size: 0.8rem;
}
.vl-checkbox--switch + .vl-checkbox__label .vl-checkbox--switch__label span[data-v-97867cb6]::before {
  display: block;
  position: absolute;
  left: 0;
  margin: 0.3rem 0 0 0.3rem;
  transform: translate(0.4rem, 0.4rem) scale(0.6);
  transform-origin: 50%;
  transition: margin 0.2s cubic-bezier(1, 0.1, 0, 0.9), opacity 0.2s cubic-bezier(1, 0.1, 0, 0.9);
  opacity: 0;
  visibility: hidden;
  z-index: 2;
}
.vl-checkbox--switch + .vl-checkbox__label .vl-checkbox--switch__label[data-v-97867cb6]::after {
  position: relative;
  display: block;
  margin-left: 0;
  content: "";
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 2em;
  background: #8695a8;
  border: 0.1rem #8695a8 solid;
  transition: padding 0.3s ease, margin 0.2s cubic-bezier(1, 0.1, 0, 0.9);
}
.vl-checkbox--switch:disabled + .vl-checkbox__label[data-v-97867cb6] {
  color: #687483;
}
.vl-checkbox--switch:disabled + .vl-checkbox__label .vl-checkbox--switch__label[data-v-97867cb6] {
  background-color: #8695a8;
  border-color: #8695a8;
  cursor: default;
}
.vl-checkbox--switch:disabled + .vl-checkbox__label .vl-checkbox--switch__label[data-v-97867cb6]::after {
  border-color: #f3f5f6;
}
.vl-checkbox__annotation[data-v-97867cb6] {
  margin-left: auto;
  font-size: 1.5rem;
}
.vl-content-header[data-v-97867cb6] {
  background-color: var(--vl-theme-primary-color);
  min-width: 768px;
  overflow: hidden;
  max-height: 40rem;
  min-height: 10rem;
  position: relative;
  color: #333332;
}
@media screen and (max-width: 767px) {
.vl-content-header > .vl-layout[data-v-97867cb6] {
    position: static;
}
}
.vl-content-header__logo-wrapper[data-v-97867cb6] {
  display: flex;
  align-items: center;
}
.vl-content-header__logo-wrapper + *[data-v-97867cb6] {
  margin-top: 0.4rem;
}
.vl-content-header__wrapper[data-v-97867cb6] {
  overflow: hidden;
}
.vl-content-header--has-logo[data-v-97867cb6] {
  background-color: #fff;
}
.vl-content-header--no-image[data-v-97867cb6] {
  border-bottom: 1px solid #cbd2da;
}
@media screen and (max-width: 767px) {
.vl-content-header[data-v-97867cb6] {
    min-width: 0;
    max-height: none;
    display: none;
}
.vl-content-header.vl-content-header--show-mobile[data-v-97867cb6] {
    display: block;
}
}
@media screen and (max-width: 767px) {
.vl-content-header:not(.vl-content-header--show-mobile) .vl-content-header__context[data-v-97867cb6] {
    position: absolute;
    float: none;
    left: 0;
    max-width: 100%;
    bottom: 100%;
    margin-bottom: 1rem;
    padding: 0.3rem 1rem 0.4rem;
}
}
.vl-content-header--alt .vl-content-header__context__content[data-v-97867cb6], .vl-content-header--alt .vl-content-header__context__link[data-v-97867cb6],
.vl-content-header--alt .vl-content-header__title__content[data-v-97867cb6],
.vl-content-header--alt .vl-content-header__title__link[data-v-97867cb6] {
  color: #333332;
}
.vl-content-header--alt .vl-content-header__context__content[data-v-97867cb6]:hover, .vl-content-header--alt .vl-content-header__context__content[data-v-97867cb6]:focus, .vl-content-header--alt .vl-content-header__context__link[data-v-97867cb6]:hover, .vl-content-header--alt .vl-content-header__context__link[data-v-97867cb6]:focus,
.vl-content-header--alt .vl-content-header__title__content[data-v-97867cb6]:hover,
.vl-content-header--alt .vl-content-header__title__content[data-v-97867cb6]:focus,
.vl-content-header--alt .vl-content-header__title__link[data-v-97867cb6]:hover,
.vl-content-header--alt .vl-content-header__title__link[data-v-97867cb6]:focus {
  color: #333332;
  background: linear-gradient(-110deg, transparent 20px, var(--vl-theme-primary-color-70) 21px);
}
.vl-content-header--alt .vl-content-header__context__content[data-v-97867cb6],
.vl-content-header--alt .vl-content-header__title__content[data-v-97867cb6] {
  background-color: var(--vl-theme-primary-color);
}
.vl-content-header--alt .vl-content-header__context__content[data-v-97867cb6]:hover, .vl-content-header--alt .vl-content-header__context__content[data-v-97867cb6]:focus,
.vl-content-header--alt .vl-content-header__title__content[data-v-97867cb6]:hover,
.vl-content-header--alt .vl-content-header__title__content[data-v-97867cb6]:focus {
  background: var(--vl-theme-primary-color-70);
}
.vl-content-header--alt.vl-content-header--has-context .vl-content-header__title__link[data-v-97867cb6] {
  background: linear-gradient(70deg, transparent 20px, var(--vl-theme-primary-color) 21px);
}
.vl-content-header--alt.vl-content-header--has-context .vl-content-header__title__link[data-v-97867cb6]:hover, .vl-content-header--alt.vl-content-header--has-context .vl-content-header__title__link[data-v-97867cb6]:focus {
  background: linear-gradient(70deg, transparent 20px, var(--vl-theme-primary-color-70) 21px);
}
.vl-content-header__bg[data-v-97867cb6] {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  max-height: 40rem;
}
.vl-content-header__bg img[data-v-97867cb6] {
  position: absolute;
  top: -9999px;
  bottom: -9999px;
  left: -9999px;
  right: -9999px;
  margin: auto;
  width: auto;
  height: auto;
  min-width: 100%;
  min-height: 100%;
}
@supports ((-o-object-fit: cover) or (object-fit: cover)) {
.vl-content-header__bg img[data-v-97867cb6] {
    -o-object-fit: cover;
       object-fit: cover;
    -o-object-position: center;
       object-position: center;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
}
.vl-content-header__bg img[data-v-97867cb6] {
  display: block;
  max-width: none;
}
.vl-content-header--half-image .vl-content-header__bg[data-v-97867cb6] {
  position: absolute;
  left: 50%;
  right: -20%;
  transform: skew(20deg);
  overflow: hidden;
  transform-origin: 100% 50%;
}
.vl-content-header--half-image .vl-content-header__bg img[data-v-97867cb6] {
  transform-origin: 100% 0%;
  transform: skew(-20deg);
}
.vl-content-header--large[data-v-97867cb6], .vl-content-header--small[data-v-97867cb6], .vl-content-header--xsmall[data-v-97867cb6] {
  max-height: none;
}
.vl-content-header--large .vl-content-header__wrapper[data-v-97867cb6], .vl-content-header--small .vl-content-header__wrapper[data-v-97867cb6], .vl-content-header--xsmall .vl-content-header__wrapper[data-v-97867cb6] {
  display: flex;
  flex-direction: row;
}
.vl-content-header--large .vl-content-header__wrapper > .vl-layout[data-v-97867cb6], .vl-content-header--small .vl-content-header__wrapper > .vl-layout[data-v-97867cb6], .vl-content-header--xsmall .vl-content-header__wrapper > .vl-layout[data-v-97867cb6] {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex: 1 1 auto;
}
.vl-content-header--large .vl-content-header__content[data-v-97867cb6], .vl-content-header--small .vl-content-header__content[data-v-97867cb6], .vl-content-header--xsmall .vl-content-header__content[data-v-97867cb6] {
  position: relative;
  bottom: auto;
}
.vl-content-header--large .vl-content-header__content > *[data-v-97867cb6], .vl-content-header--small .vl-content-header__content > *[data-v-97867cb6], .vl-content-header--xsmall .vl-content-header__content > *[data-v-97867cb6] {
  vertical-align: bottom;
}
.vl-content-header--small .vl-content-header__wrapper > .vl-layout[data-v-97867cb6] {
  min-height: 15rem;
  padding-top: 4rem;
  padding-bottom: 4rem;
}
@media screen and (max-width: 1023px) {
.vl-content-header--small .vl-content-header__wrapper > .vl-layout[data-v-97867cb6] {
    min-height: 11rem;
    padding-bottom: 2rem;
    padding-top: 2rem;
}
}
@media screen and (max-width: 767px) {
.vl-content-header--small .vl-content-header__wrapper > .vl-layout[data-v-97867cb6] {
    min-height: 8rem;
    padding-bottom: 1rem;
    padding-top: 1rem;
}
}
.vl-content-header--large .vl-content-header__wrapper > .vl-layout[data-v-97867cb6] {
  min-height: 31.5rem;
  padding-bottom: 6rem;
  padding-top: 6rem;
}
@media screen and (max-width: 1023px) {
.vl-content-header--large .vl-content-header__wrapper > .vl-layout[data-v-97867cb6] {
    min-height: 25.5rem;
    padding-bottom: 3rem;
    padding-top: 3rem;
}
}
@media screen and (max-width: 767px) {
.vl-content-header--large .vl-content-header__wrapper > .vl-layout[data-v-97867cb6] {
    min-height: 11rem;
    padding-bottom: 2rem;
    padding-top: 2rem;
}
}
.vl-content-header--xsmall[data-v-97867cb6] {
  min-height: 9.5rem;
}
@media screen and (max-width: 767px) {
.vl-content-header--xsmall[data-v-97867cb6] {
    min-height: 5.5rem;
}
}
.vl-content-header--xsmall .vl-content-header[data-v-97867cb6] {
  min-height: 9.5rem;
}
.vl-content-header--xsmall .vl-content-header__wrapper > .vl-layout[data-v-97867cb6] {
  min-height: 9.5rem;
  padding-bottom: 2.5rem;
  padding-top: 2.5rem;
}
@media screen and (max-width: 767px) {
.vl-content-header--xsmall .vl-content-header__wrapper > .vl-layout[data-v-97867cb6] {
    min-height: 5.5rem;
    padding-bottom: 1.5rem;
    padding-top: 1.5rem;
}
}
.vl-content-header__logo[data-v-97867cb6] {
  background-color: #fff;
  white-space: nowrap;
  position: relative;
  color: #333332;
  display: inline-block;
  vertical-align: middle;
}
.vl-content-header__logo__img[data-v-97867cb6] {
  background-color: var(--vl-theme-primary-color);
  width: 8rem;
  height: 9rem;
  display: inline-block;
  vertical-align: middle;
  position: relative;
}
@media screen and (max-width: 767px) {
.vl-content-header__logo__img[data-v-97867cb6] {
    width: 4.5rem;
    height: 5rem;
}
}
.vl-content-header__logo__img svg[data-v-97867cb6] {
  width: 3.9rem;
  height: 6rem;
  margin-top: 1.5rem;
  margin-left: 1.5rem;
  fill: #333332;
}
@media screen and (max-width: 767px) {
.vl-content-header__logo__img svg[data-v-97867cb6] {
    width: 2.9rem;
    height: 3rem;
    margin-top: 1rem;
    margin-left: 0.3rem;
}
}
.vl-content-header__logo__img[data-v-97867cb6]::after {
  display: block;
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  border-top: 9rem solid #fff;
  border-left: 3.0781812899rem solid transparent;
}
@media screen and (max-width: 767px) {
.vl-content-header__logo__img[data-v-97867cb6]::after {
    border-top: 5rem solid #fff;
    border-left: 1.7101007166rem solid transparent;
}
}
.vl-content-header--no-image .vl-content-header__logo__img[data-v-97867cb6], .vl-content-header--half-image .vl-content-header__logo__img[data-v-97867cb6] {
  background-color: transparent;
}
.vl-content-header--no-image .vl-content-header__logo__img[data-v-97867cb6]::after, .vl-content-header--half-image .vl-content-header__logo__img[data-v-97867cb6]::after {
  height: 100%;
  border: 0;
  width: 1px;
  background-color: #333332;
  transform: rotate(-20deg);
  transform-origin: 100% 80%;
}
.vl-content-header--no-image .vl-content-header__logo[data-v-97867cb6], .vl-content-header--half-image .vl-content-header__logo[data-v-97867cb6] {
  background-color: transparent;
  color: #333332;
}
.vl-content-header__logo__text[data-v-97867cb6] {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-right: 2rem;
  margin-left: -0.2rem;
  line-height: 1;
}
@media screen and (max-width: 767px) {
.vl-content-header__logo__text[data-v-97867cb6] {
    padding-right: 1rem;
}
}
.vl-content-header__logo__title[data-v-97867cb6] {
  font-weight: 500;
  font-size: 3rem;
  margin-bottom: 0.3rem;
}
@media screen and (max-width: 1023px) {
.vl-content-header__logo__title[data-v-97867cb6] {
    font-size: 2.4rem;
}
}
@media screen and (max-width: 767px) {
.vl-content-header__logo__title[data-v-97867cb6] {
    font-size: 1.6rem;
}
}
.vl-content-header__logo__tagline[data-v-97867cb6] {
  display: block;
  font-size: 1.7rem;
  margin-left: 5px;
  font-weight: normal;
  margin-top: 2px;
}
@media screen and (max-width: 1023px) {
.vl-content-header__logo__tagline[data-v-97867cb6] {
    font-size: 1.35rem;
}
}
@media screen and (max-width: 767px) {
.vl-content-header__logo__tagline[data-v-97867cb6] {
    margin-left: 3px;
    font-size: 1.1rem;
}
}
.vl-content-header__entity-logo + .vl-content-header__logo[data-v-97867cb6] {
  vertical-align: top;
  margin-left: -1.5rem;
}
@media screen and (max-width: 1023px) {
.vl-content-header__entity-logo + .vl-content-header__logo[data-v-97867cb6] {
    margin-left: -1.5rem;
}
}
@media screen and (max-width: 767px) {
.vl-content-header__entity-logo + .vl-content-header__logo[data-v-97867cb6] {
    display: none;
}
}
.vl-content-header__entity-logo[data-v-97867cb6] {
  display: inline-block;
  vertical-align: top;
  padding: 1rem 2rem;
  font-size: 2.6rem;
  line-height: 0.95;
  text-transform: uppercase;
  background-color: var(--vl-theme-primary-color);
  color: #333332;
  text-decoration: none;
}
.vl-content-header__entity-logo--right[data-v-97867cb6] {
  text-align: right;
}
.vl-content-header__entity-logo--lowercase[data-v-97867cb6] {
  text-transform: none;
}
.vl-content-header__entity-logo--serif[data-v-97867cb6] {
  font-family: "Flanders Art Serif", serif;
}
.vl-content-header__entity-logo--neutral[data-v-97867cb6] {
  color: #333332;
}
@media screen and (max-width: 1023px) {
.vl-content-header__entity-logo[data-v-97867cb6] {
    font-size: 2rem;
}
}
@media screen and (max-width: 767px) {
.vl-content-header__entity-logo[data-v-97867cb6] {
    font-size: 1.6rem;
    padding: 0.5rem 1rem;
    text-align: left;
}
}
.vl-content-header__entity-logo__prefix[data-v-97867cb6], .vl-content-header__entity-logo__title[data-v-97867cb6] {
  display: block;
}
.vl-content-header__entity-logo__title[data-v-97867cb6] {
  font-weight: 500;
}
.vl-content-header__entity-logo--small[data-v-97867cb6] {
  font-size: 1.6rem;
}
.vl-content-header--alt .vl-content-header__entity-logo[data-v-97867cb6] {
  color: #333332;
  background-color: #fff;
}
.vl-content-header--has-logo .vl-content-header__entity-logo[data-v-97867cb6] {
  height: 9rem;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
}
@media screen and (max-width: 767px) {
.vl-content-header--has-logo .vl-content-header__entity-logo[data-v-97867cb6] {
    height: 5rem;
}
}
.vl-content-header--has-logo .vl-content-header__entity-logo + .vl-content-header__logo[data-v-97867cb6] {
  vertical-align: top;
  margin-left: -1.5rem;
}
a.vl-content-header__entity-logo[data-v-97867cb6]:hover, a.vl-content-header__entity-logo[data-v-97867cb6]:focus {
  background-color: var(--vl-theme-primary-color);
  color: #333332;
}
.vl-content-header--alt a.vl-content-header__entity-logo[data-v-97867cb6]:hover, .vl-content-header--alt a.vl-content-header__entity-logo[data-v-97867cb6]:focus {
  background-color: white;
  color: #003bb0;
}
.vl-content-header__img-logo[data-v-97867cb6] {
  display: inline-block;
}
.vl-content-header__img-logo__img[data-v-97867cb6] {
  max-width: 30rem;
  max-height: 7.5rem;
  width: auto;
  height: auto;
}
@media screen and (max-width: 767px) {
.vl-content-header__img-logo__img[data-v-97867cb6] {
    max-width: 15rem;
    max-height: 3.5rem;
}
}
.vl-content-header--has-actions[data-v-97867cb6]::before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 0.3rem;
  background-color: #f7f9fc;
  z-index: 2;
}
@media screen and (max-width: 767px) {
.vl-content-header--has-actions[data-v-97867cb6]::before {
    display: none;
}
}
.vl-content-header__actions[data-v-97867cb6] {
  background-color: #f7f9fc;
}
.vl-content-header .vl-content-header__action[data-v-97867cb6] {
  color: #333332;
}
.vl-content-header .vl-content-header__action + .vl-content-header__action[data-v-97867cb6] {
  border-left: 1px solid #333332;
}
.vl-content-header .vl-content-header__action a[data-v-97867cb6],
.vl-content-header .vl-content-header__action button[data-v-97867cb6] {
  color: #333332;
}
.vl-content-header .vl-content-header__action a[data-v-97867cb6]:hover, .vl-content-header .vl-content-header__action a[data-v-97867cb6]:focus,
.vl-content-header .vl-content-header__action button[data-v-97867cb6]:hover,
.vl-content-header .vl-content-header__action button[data-v-97867cb6]:focus {
  color: #05c;
}
.vl-content-header__actions[data-v-97867cb6]::before, .vl-content-header__actions[data-v-97867cb6]::after {
  content: "";
  display: table;
}
.vl-content-header__actions[data-v-97867cb6]::after {
  clear: both;
}
.vl-content-header__actions[data-v-97867cb6] {
  padding: 1.5rem 0.5rem 1rem;
  float: right;
  display: flex;
  background-color: #f7f9fc;
}
@media screen and (max-width: 767px) {
.vl-content-header__actions[data-v-97867cb6] {
    display: none;
}
}
.vl-content-header__actions[data-v-97867cb6] {
  position: absolute;
  top: 0;
  right: 3rem;
}
.vl-content-header .vl-content-header__action[data-v-97867cb6] {
  padding: 0 0.5rem;
  font-size: 1.4rem;
  line-height: 1;
  color: #333332;
}
.vl-content-header .vl-content-header__action + .vl-content-header__action[data-v-97867cb6] {
  border-left: 1px solid #333332;
}
.vl-content-header .vl-content-header__action a[data-v-97867cb6],
.vl-content-header .vl-content-header__action button[data-v-97867cb6] {
  line-height: inherit;
  color: #333332;
  margin: 0;
}
.vl-content-header__title[data-v-97867cb6] {
  display: block;
  color: #333332;
}
.vl-content-header__context--has-link + .vl-content-header__title .vl-content-header__title__content[data-v-97867cb6] {
  padding: 0.5rem 2rem 1.1rem;
  font-family: "Flanders Art Serif", serif;
  font-weight: 400;
  font-size: 4.8rem;
  line-height: 1.1;
  margin-top: 1px;
  background: white;
}
.vl-content-header__title--has-link[data-v-97867cb6] {
  display: inline-block;
}
@media screen and (max-width: 767px) {
.vl-content-header__title--has-link[data-v-97867cb6] {
    display: none;
}
}
.vl-content-header__title__content[data-v-97867cb6], .vl-content-header__title__link[data-v-97867cb6] {
  padding: 0.4rem 2rem 0.7rem;
  font-family: "Flanders Art Serif", serif;
  font-weight: 500;
  font-size: 3.4rem;
  line-height: 1.2;
}
@media screen and (max-width: 767px) {
.vl-content-header__title__content[data-v-97867cb6], .vl-content-header__title__link[data-v-97867cb6] {
    font-size: 1.8rem;
    padding: 0.3rem 1rem 0.4rem;
    font-weight: 500;
}
}
.vl-content-header__title__content[data-v-97867cb6], .vl-content-header__title__link[data-v-97867cb6] {
  display: inline-block;
  background-color: white;
  color: #333332;
  text-decoration: none;
}
.vl-content-header--has-context .vl-content-header__title__content[data-v-97867cb6], .vl-content-header--has-context .vl-content-header__title__link[data-v-97867cb6] {
  font-family: "Flanders Art Serif", serif;
  font-size: 2.3rem;
  line-height: 1.1;
  font-weight: 300;
  padding: 0.9rem 2rem 0.9rem 3.5rem;
  font-size: 2.4rem;
  line-height: 1.1;
  background: linear-gradient(70deg, transparent 20px, white 21px);
}
.vl-content-header__subtitle[data-v-97867cb6] {
  background-color: white;
  font-family: "Flanders Art Serif", serif;
}
.vl-content-header__context[data-v-97867cb6] {
  font-family: "Flanders Art Serif", serif;
  font-size: 2.3rem;
  line-height: 1.1;
  font-weight: 500;
  background: linear-gradient(-110deg, transparent 20px, white 21px);
  display: inline-block;
}
.vl-content-header--alt .vl-content-header__context[data-v-97867cb6] {
  background: linear-gradient(-110deg, transparent 20px, var(--vl-theme-primary-color) 21px);
}
.vl-content-header__context__link[data-v-97867cb6] {
  font-family: "Flanders Art Serif", serif;
  font-size: 2.3rem;
  line-height: 1.1;
  font-weight: 500;
  font-size: 2.4rem;
  line-height: 1.1;
  display: block;
  padding: 0.9rem 3.5rem 0.9rem 2rem;
  background: linear-gradient(-110deg, transparent 20px, white 21px);
  color: #333332;
  text-decoration: none;
}
@media screen and (max-width: 767px) {
.vl-content-header__context__link[data-v-97867cb6] {
    background: white;
    font-size: 1.8rem;
    font-weight: 500;
    padding: 0.3rem 1rem 0.4rem;
}
}
.vl-content-header--alt .vl-content-header__context__link[data-v-97867cb6] {
  background: linear-gradient(-110deg, transparent 20px, var(--vl-theme-primary-color) 21px);
  color: #333332;
}
.vl-content-header__context--has-link[data-v-97867cb6] {
  margin-right: -2.6rem;
}
@media screen and (max-width: 767px) {
.vl-content-header__context--has-link[data-v-97867cb6] {
    margin-right: 0;
}
}
.vl-content-header__line[data-v-97867cb6] {
  position: absolute;
  bottom: 0;
  transform-origin: 100%;
  transition: transform 0.1s;
}
.vl-content-header__line[data-v-97867cb6]::before {
  display: block;
  content: "";
  height: 2px;
  background-color: var(--vl-theme-primary-color);
  width: 1000vw;
  transform-origin: 50%;
}
.vl-content-header__line-1[data-v-97867cb6] {
  left: 8rem;
}
@media screen and (max-width: 767px) {
.vl-content-header__line-1[data-v-97867cb6] {
    left: 1rem;
}
}
.vl-content-header__line-1[data-v-97867cb6]::before {
  transform: translateX(-50%) rotate(71deg);
  background-color: #c6cdd3;
}
.vl-content-header__line-2[data-v-97867cb6] {
  left: -977vw;
  bottom: 3.5rem;
}
@media screen and (max-width: 767px) {
.vl-content-header__line-2[data-v-97867cb6] {
    bottom: 0;
}
}
.vl-content-header__line-2[data-v-97867cb6]::before {
  transform: translateX(50%) rotate(-25deg);
}
.vl-content-header__line-3[data-v-97867cb6] {
  left: -970vw;
  bottom: 0;
}
@media screen and (max-width: 767px) {
.vl-content-header__line-3[data-v-97867cb6] {
    right: 31rem;
}
}
.vl-content-header__line-3[data-v-97867cb6]::before {
  transform: translateX(50%) rotate(-40deg);
  background-color: rgba(198, 205, 211, 0.6);
}
.vl-data-table[data-v-97867cb6] {
  width: 100%;
  max-width: 100%;
}
.vl-data-table caption[data-v-97867cb6] {
  text-align: left;
  margin: 15px 0 5px 0;
  font-size: 1.8rem;
  font-weight: 500;
}
.vl-data-table thead tr[data-v-97867cb6] {
  border-bottom: 0.2rem #cbd2da solid;
}
.vl-data-table tfoot tr[data-v-97867cb6] {
  border-top: 0.2rem #cbd2da solid;
}
.vl-data-table tfoot td[data-v-97867cb6] {
  font-weight: 500;
  white-space: nowrap;
}
.vl-data-table tfoot td[data-v-97867cb6]:first-child {
  padding-left: 0;
}
.vl-data-table tfoot td[data-v-97867cb6]:last-child {
  padding-right: 0;
}
.vl-data-table tbody tr.vl-data-table__element--error[data-v-97867cb6],
.vl-data-table tbody td.vl-data-table__element--error[data-v-97867cb6] {
  background: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
  border-bottom: 1px solid #d2373c;
}
.vl-data-table tbody tr.vl-data-table__element--warning[data-v-97867cb6],
.vl-data-table tbody td.vl-data-table__element--warning[data-v-97867cb6] {
  background: rgb(100%, 96.3137254902%, 90.3921568627%);
  border-bottom: 1px solid #ffA10a;
}
.vl-data-table tbody tr.vl-data-table__element--success[data-v-97867cb6],
.vl-data-table tbody td.vl-data-table__element--success[data-v-97867cb6] {
  background: rgb(90%, 96.1960784314%, 92.7843137255%);
  border-bottom: 1px solid #009e47;
}
.vl-data-table tbody tr[data-v-97867cb6] {
  border-bottom: 0.1rem #cbd2da solid;
}
.vl-data-table tbody tr[data-vl-table-selectable][data-v-97867cb6] {
  cursor: pointer;
  transition: background 0.2s ease-in-out;
}
.vl-data-table tbody tr[data-vl-table-selectable][data-v-97867cb6]:hover {
  background: #f3f5f6;
}
.vl-data-table tbody tr.vl-data-table__grouped-row[data-v-97867cb6]:not(.vl-data-table__grouped-row--last) {
  border-bottom: 0;
}
.vl-data-table tbody tr th[data-v-97867cb6] {
  border-left: 0.2rem #cbd2da solid;
  border-right: 0.2rem #cbd2da solid;
}
.vl-data-table tbody tr th[data-v-97867cb6]:first-child {
  border-left: none;
}
.vl-data-table tbody tr th[data-v-97867cb6]:last-child {
  border-right: none;
}
.vl-data-table td[data-v-97867cb6],
.vl-data-table th[data-v-97867cb6] {
  font-size: 1.6rem;
  line-height: 1.3;
  text-align: left;
  vertical-align: top;
  padding: 1.2rem 1rem;
}
@media screen and (max-width: 767px) {
.vl-data-table td[data-v-97867cb6],
  .vl-data-table th[data-v-97867cb6] {
    font-size: 1.4rem;
    padding: 1rem;
}
}
.vl-data-table td.vl-data-table__icon-container[data-v-97867cb6],
.vl-data-table th.vl-data-table__icon-container[data-v-97867cb6] {
  background-color: #f3f5f6;
  color: #333332;
}
.vl-data-table td.vl-data-table__icon-container .vl-vi[data-v-97867cb6],
.vl-data-table th.vl-data-table__icon-container .vl-vi[data-v-97867cb6] {
  color: #687483;
  font-size: 3rem;
}
.vl-vi .vl-data-table td.vl-data-table__icon-container[data-v-97867cb6],
.vl-vi .vl-data-table th.vl-data-table__icon-container[data-v-97867cb6] {
  text-align: center;
}
.vl-data-table th[data-v-97867cb6] {
  font-weight: 500;
  white-space: nowrap;
}
.vl-data-table th > *[data-v-97867cb6] {
  white-space: normal;
}
.vl-data-table .vl-data-table__grouped-row td[data-v-97867cb6] {
  padding: 0.3rem 1rem 0.3rem 0;
}
@media screen and (max-width: 767px) {
.vl-data-table .vl-data-table__grouped-row td[data-v-97867cb6] {
    padding: 0.3rem 1rem 0.3rem 0;
}
}
.vl-data-table .vl-data-table__grouped-row--first td[data-v-97867cb6] {
  padding-top: 1.2rem;
}
@media screen and (max-width: 767px) {
.vl-data-table .vl-data-table__grouped-row--first td[data-v-97867cb6] {
    padding-top: 1rem;
}
}
.vl-data-table .vl-data-table__grouped-row--last td[data-v-97867cb6] {
  padding-bottom: 1.2rem;
}
@media screen and (max-width: 767px) {
.vl-data-table .vl-data-table__grouped-row--last td[data-v-97867cb6] {
    padding-bottom: 1rem;
}
}
.vl-data-table__header-title--sortable[data-v-97867cb6] {
  text-decoration: none;
}
.vl-data-table__header-title--sortable .vl-data-table__header-title__sort-icon[data-v-97867cb6] {
  opacity: 0;
}
.vl-data-table__header-title--sortable[data-v-97867cb6]:hover, .vl-data-table__header-title--sortable[data-v-97867cb6]:focus {
  text-decoration: underline;
}
.vl-data-table__header-title--sortable:hover .vl-data-table__header-title__sort-icon[data-v-97867cb6], .vl-data-table__header-title--sortable:focus .vl-data-table__header-title__sort-icon[data-v-97867cb6] {
  opacity: 0.5;
}
.vl-data-table__header-title--sortable-active .vl-data-table__header-title__sort-icon[data-v-97867cb6] {
  opacity: 1;
}
.vl-data-table__body-title[data-v-97867cb6] {
  max-width: 30rem;
}
.vl-data-table--alt tr th[data-v-97867cb6],
.vl-data-table--alt tr td[data-v-97867cb6] {
  border-left: 0.2rem #cbd2da solid;
  border-right: 0.2rem #cbd2da solid;
}
.vl-data-table--alt tr th[data-v-97867cb6]:first-child,
.vl-data-table--alt tr td[data-v-97867cb6]:first-child {
  border-left: none;
}
.vl-data-table--alt tr th[data-v-97867cb6]:last-child,
.vl-data-table--alt tr td[data-v-97867cb6]:last-child {
  border-right: none;
}
.vl-data-table--alt tr th[data-v-97867cb6]:not(:first-child) {
  padding: 0 1.2rem 1.2rem;
}
.vl-data-table--alt tr td[data-v-97867cb6]:not(:first-child) {
  padding: 1.2rem;
}
.vl-data-table--double-spacing tr td[data-v-97867cb6],
.vl-data-table--double-spacing tr th[data-v-97867cb6] {
  padding: 1.2rem 3rem;
}
.vl-data-table--no-header tbody tr[data-v-97867cb6]:first-child {
  border-top: 3px #cbd2da solid;
}
.vl-data-table .vl-pill[data-v-97867cb6] {
  vertical-align: middle;
}
@media screen and (max-width: 767px) {
.vl-data-table .vl-pill[data-v-97867cb6] {
    font-size: 1.4rem;
    height: 2rem;
    line-height: 2rem;
    padding: 0 0.5rem;
}
}
.vl-u-table-overflow[data-v-97867cb6] {
  width: 100%;
  overflow-x: auto;
}
.vl-u-table-overflow .vl-data-table[data-v-97867cb6] {
  overflow: auto;
}
.no-js [data-vl-table-check-all] + span[data-v-97867cb6] {
  display: none !important;
}
.vl-data-table--hover tbody tr[data-v-97867cb6] {
  transition: background 0.2s ease-in-out;
}
.vl-data-table--hover tbody tr[data-v-97867cb6]:hover {
  background: #f3f5f6;
}
.vl-data-table--matrix tr th[data-v-97867cb6] {
  border-left: 0.2rem #cbd2da solid;
  border-right: 0.2rem #cbd2da solid;
}
.vl-data-table--matrix tr th[data-v-97867cb6]:first-child {
  border-left: none;
}
.vl-data-table--matrix tr th[data-v-97867cb6]:last-child {
  border-right: none;
}
.vl-data-table--grid td[data-v-97867cb6],
.vl-data-table--grid th[data-v-97867cb6] {
  padding: 1.2rem;
  border-left: 0.1rem #cbd2da solid;
  border-right: 0.1rem #cbd2da solid;
}
.vl-data-table--grid td[data-v-97867cb6]:first-child,
.vl-data-table--grid th[data-v-97867cb6]:first-child {
  border-left: none;
}
.vl-data-table--grid td[data-v-97867cb6]:last-child,
.vl-data-table--grid th[data-v-97867cb6]:last-child {
  border-right: none;
}
.vl-data-table--grid th[scope=row][data-v-97867cb6] {
  border-width: 0.2rem;
}
.vl-data-table--zebra tbody tr[data-v-97867cb6]:not(.vl-data-table__element--warning):not(.vl-data-table__element--error):not(.vl-data-table__element--success):nth-child(odd) {
  background-color: #f3f5f6;
}
.vl-data-table--zebra tbody tr[data-v-97867cb6]:not(.vl-data-table__element--warning):not(.vl-data-table__element--error):not(.vl-data-table__element--success):nth-child(odd):hover {
  background-color: rgb(93.0084033613%, 94.1736694678%, 94.756302521%);
}
.vl-data-table__actions--top[data-v-97867cb6] {
  margin: 0 0 2rem;
}
.vl-data-table__actions--bottom[data-v-97867cb6] {
  margin: 2rem 0 0;
}
@media screen and (max-width: 500px) {
.vl-data-table__actions--bottom .vl-data-table__actions__list[data-v-97867cb6] {
    margin: 0 0 1rem;
}
}
.vl-data-table__actions__list .vl-data-table__action[data-v-97867cb6]:not(:last-child) {
  margin-right: 0.6rem;
}
.vl-data-table__action[data-v-97867cb6] {
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 0.6rem;
}
.vl-data-table__action__toggle[data-v-97867cb6] {
  display: flex;
  align-items: center;
  background: none;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 1;
  color: #333332;
  border: 0.1rem #cbd2da solid;
  text-decoration: none;
  text-align: left;
  cursor: pointer;
  padding: 0.9rem 1.5rem 0.8rem;
}
@media screen and (max-width: 767px) {
.vl-data-table__action__toggle[data-v-97867cb6] {
    font-size: 1.5rem;
}
}
[data-vl-disable=true] .vl-data-table__action__toggle[data-v-97867cb6] {
  color: #687483;
  cursor: default;
}
.vl-data-table__action__toggle__icon[data-v-97867cb6] {
  font-size: 1.2rem;
}
.vl-data-table__action__toggle__icon[data-v-97867cb6]:first-child {
  margin-right: 0.5rem;
}
.vl-data-table__action__toggle__icon[data-v-97867cb6]:last-child {
  margin-left: 0.5rem;
}
@media screen and (max-width: 500px) {
.vl-data-table__action__toggle--contract-xs span[data-v-97867cb6] {
    display: none;
}
.vl-data-table__action__toggle--contract-xs .vl-vi[data-v-97867cb6]::before {
    margin: 0;
}
}
@media screen and (max-width: 500px) {
.vl-data-table--collapsed-xs[data-v-97867cb6] {
    position: relative;
}
.vl-data-table--collapsed-xs table[data-v-97867cb6],
  .vl-data-table--collapsed-xs thead[data-v-97867cb6],
  .vl-data-table--collapsed-xs tbody[data-v-97867cb6],
  .vl-data-table--collapsed-xs th[data-v-97867cb6],
  .vl-data-table--collapsed-xs td[data-v-97867cb6],
  .vl-data-table--collapsed-xs tr[data-v-97867cb6] {
    display: block;
}
.vl-data-table--collapsed-xs thead tr[data-v-97867cb6] {
    position: absolute;
    top: -9999px;
    left: -9999px;
}
.vl-data-table--collapsed-xs td[data-v-97867cb6] {
    border-bottom: 1px solid #cbd2da;
    position: relative;
    padding-left: 40%;
    white-space: normal;
    text-align: left;
}
.vl-data-table--collapsed-xs td[data-v-97867cb6]::before,
  .vl-data-table--collapsed-xs th[data-v-97867cb6]::before {
    content: attr(data-title);
    position: absolute;
    top: 10px;
    left: 10px;
    width: 35%;
    padding-right: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
    font-weight: 500;
}
}
@media screen and (max-width: 767px) {
.vl-data-table--collapsed-s[data-v-97867cb6] {
    position: relative;
}
.vl-data-table--collapsed-s table[data-v-97867cb6],
  .vl-data-table--collapsed-s thead[data-v-97867cb6],
  .vl-data-table--collapsed-s tbody[data-v-97867cb6],
  .vl-data-table--collapsed-s th[data-v-97867cb6],
  .vl-data-table--collapsed-s td[data-v-97867cb6],
  .vl-data-table--collapsed-s tr[data-v-97867cb6] {
    display: block;
}
.vl-data-table--collapsed-s thead tr[data-v-97867cb6] {
    position: absolute;
    top: -9999px;
    left: -9999px;
}
.vl-data-table--collapsed-s td[data-v-97867cb6] {
    border-bottom: 1px solid #cbd2da;
    position: relative;
    padding-left: 40%;
    white-space: normal;
    text-align: left;
}
.vl-data-table--collapsed-s td[data-v-97867cb6]::before,
  .vl-data-table--collapsed-s th[data-v-97867cb6]::before {
    content: attr(data-title);
    position: absolute;
    top: 10px;
    left: 10px;
    width: 35%;
    padding-right: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
    font-weight: 500;
}
}
@media screen and (max-width: 1023px) {
.vl-data-table--collapsed-m[data-v-97867cb6] {
    position: relative;
}
.vl-data-table--collapsed-m table[data-v-97867cb6],
  .vl-data-table--collapsed-m thead[data-v-97867cb6],
  .vl-data-table--collapsed-m tbody[data-v-97867cb6],
  .vl-data-table--collapsed-m th[data-v-97867cb6],
  .vl-data-table--collapsed-m td[data-v-97867cb6],
  .vl-data-table--collapsed-m tr[data-v-97867cb6] {
    display: block;
}
.vl-data-table--collapsed-m thead tr[data-v-97867cb6] {
    position: absolute;
    top: -9999px;
    left: -9999px;
}
.vl-data-table--collapsed-m td[data-v-97867cb6] {
    border-bottom: 1px solid #cbd2da;
    position: relative;
    padding-left: 40%;
    white-space: normal;
    text-align: left;
}
.vl-data-table--collapsed-m td[data-v-97867cb6]::before,
  .vl-data-table--collapsed-m th[data-v-97867cb6]::before {
    content: attr(data-title);
    position: absolute;
    top: 10px;
    left: 10px;
    width: 35%;
    padding-right: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
    font-weight: 500;
}
}
.vl-data-table--sticky[data-v-97867cb6] {
  table-layout: auto;
}
.vl-data-table--sticky .vl-data-table__cell--sticky[data-v-97867cb6] {
  position: sticky;
  left: 0;
  background-color: inherit;
  border: 0;
  z-index: 1;
}
.vl-data-table--sticky thead .vl-data-table__cell--sticky[data-v-97867cb6] {
  top: 0;
  z-index: 2;
}
.vl-data-table--sticky thead .vl-data-table__cell--sticky[data-v-97867cb6]::before {
  display: block;
  position: absolute;
  bottom: -3px;
  left: 0;
  right: 0;
  height: 3px;
  background-color: #cbd2da;
  content: "";
}
.vl-data-table--sticky tbody .vl-data-table__cell--sticky[data-v-97867cb6]::before {
  display: block;
  position: absolute;
  bottom: 0;
  top: 0;
  right: -1px;
  width: 1px;
  background-color: #cbd2da;
  content: "";
}
.vl-data-table--sticky th[data-v-97867cb6],
.vl-data-table--sticky td[data-v-97867cb6] {
  min-width: 200px;
}
.vl-data-table--sticky tr[data-v-97867cb6] {
  background-color: #fff;
}
.vl-data-table__sticky-wrapper[data-v-97867cb6] {
  width: 100%;
  max-height: 75vh;
  overflow-x: auto;
  overflow-y: auto;
}
.vl-u-table-overflow[data-v-97867cb6] {
  background: linear-gradient(to right, white, white, rgba(255, 255, 255, 0) 30px), radial-gradient(farthest-side at 0 50%, rgba(0, 0, 0, 0.3), rgba(255, 255, 255, 0)), linear-gradient(to left, white, white, rgba(255, 255, 255, 0) 30px), radial-gradient(farthest-side at 100% 50%, rgba(0, 0, 0, 0.3), rgba(255, 255, 255, 0)) 100%;
  background-color: white;
  background-repeat: no-repeat;
  background-attachment: local, scroll, local, scroll;
  background-size: 100% 100%, 15px 100%, 100% 100%, 15px 100%;
}
.vl-data-table__navigation[data-v-97867cb6] {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: flex-end;
}
.flatpickr-calendar[data-v-97867cb6] {
  background: transparent;
  opacity: 0;
  display: none;
  text-align: center;
  visibility: hidden;
  padding: 0;
  animation: none;
  direction: ltr;
  border: 0;
  font-size: 14px;
  line-height: 24px;
  border-radius: 5px;
  position: absolute;
  width: 307.875px;
  box-sizing: border-box;
  touch-action: manipulation;
  box-shadow: 0 3px 13px rgba(0, 0, 0, 0.08);
}
.flatpickr-calendar.open[data-v-97867cb6],
.flatpickr-calendar.inline[data-v-97867cb6] {
  opacity: 1;
  max-height: 640px;
  visibility: visible;
}
.flatpickr-calendar.open[data-v-97867cb6] {
  display: inline-block;
  z-index: 100021;
}
.flatpickr-calendar.animate.open[data-v-97867cb6] {
  animation: fpFadeInDown-97867cb6 300ms cubic-bezier(0.23, 1, 0.32, 1);
}
.flatpickr-calendar.inline[data-v-97867cb6] {
  display: block;
  position: relative;
  top: 2px;
}
.flatpickr-calendar.static[data-v-97867cb6] {
  position: absolute;
  top: calc(100% + 2px);
}
.flatpickr-calendar.static.open[data-v-97867cb6] {
  z-index: 999;
  display: block;
}
.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange[data-v-97867cb6]:nth-child(7n+7) {
  box-shadow: none !important;
}
.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange[data-v-97867cb6]:nth-child(7n+1) {
  box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;
}
.flatpickr-calendar .hasWeeks .dayContainer[data-v-97867cb6],
.flatpickr-calendar .hasTime .dayContainer[data-v-97867cb6] {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.flatpickr-calendar .hasWeeks .dayContainer[data-v-97867cb6] {
  border-left: 0;
}
.flatpickr-calendar.hasTime .flatpickr-time[data-v-97867cb6] {
  height: 40px;
  border-top: 1px solid #eceef1;
}
.flatpickr-calendar.hasTime .flatpickr-innerContainer[data-v-97867cb6] {
  border-bottom: 0;
}
.flatpickr-calendar.hasTime .flatpickr-time[data-v-97867cb6] {
  border: 1px solid #eceef1;
}
.flatpickr-calendar.noCalendar.hasTime .flatpickr-time[data-v-97867cb6] {
  height: auto;
}
.flatpickr-calendar[data-v-97867cb6]:before,
.flatpickr-calendar[data-v-97867cb6]:after {
  position: absolute;
  display: block;
  pointer-events: none;
  border: solid transparent;
  content: "";
  height: 0;
  width: 0;
  left: 22px;
}
.flatpickr-calendar.rightMost[data-v-97867cb6]:before,
.flatpickr-calendar.arrowRight[data-v-97867cb6]:before,
.flatpickr-calendar.rightMost[data-v-97867cb6]:after,
.flatpickr-calendar.arrowRight[data-v-97867cb6]:after {
  left: auto;
  right: 22px;
}
.flatpickr-calendar.arrowCenter[data-v-97867cb6]:before,
.flatpickr-calendar.arrowCenter[data-v-97867cb6]:after {
  left: 50%;
  right: 50%;
}
.flatpickr-calendar[data-v-97867cb6]:before {
  border-width: 5px;
  margin: 0 -5px;
}
.flatpickr-calendar[data-v-97867cb6]:after {
  border-width: 4px;
  margin: 0 -4px;
}
.flatpickr-calendar.arrowTop[data-v-97867cb6]:before,
.flatpickr-calendar.arrowTop[data-v-97867cb6]:after {
  bottom: 100%;
}
.flatpickr-calendar.arrowTop[data-v-97867cb6]:before {
  border-bottom-color: #eceef1;
}
.flatpickr-calendar.arrowTop[data-v-97867cb6]:after {
  border-bottom-color: #eceef1;
}
.flatpickr-calendar.arrowBottom[data-v-97867cb6]:before,
.flatpickr-calendar.arrowBottom[data-v-97867cb6]:after {
  top: 100%;
}
.flatpickr-calendar.arrowBottom[data-v-97867cb6]:before {
  border-top-color: #eceef1;
}
.flatpickr-calendar.arrowBottom[data-v-97867cb6]:after {
  border-top-color: #eceef1;
}
.flatpickr-calendar[data-v-97867cb6]:focus {
  outline: 0;
}
.flatpickr-wrapper[data-v-97867cb6] {
  position: relative;
  display: inline-block;
}
.flatpickr-months[data-v-97867cb6] {
  display: flex;
}
.flatpickr-months .flatpickr-month[data-v-97867cb6] {
  border-radius: 5px 5px 0 0;
  background: #eceef1;
  color: #5a6171;
  fill: #5a6171;
  height: 34px;
  line-height: 1;
  text-align: center;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  overflow: hidden;
  flex: 1;
}
.flatpickr-months .flatpickr-prev-month[data-v-97867cb6],
.flatpickr-months .flatpickr-next-month[data-v-97867cb6] {
  text-decoration: none;
  cursor: pointer;
  position: absolute;
  top: 0;
  height: 34px;
  padding: 10px;
  z-index: 3;
  color: #5a6171;
  fill: #5a6171;
}
.flatpickr-months .flatpickr-prev-month.flatpickr-disabled[data-v-97867cb6],
.flatpickr-months .flatpickr-next-month.flatpickr-disabled[data-v-97867cb6] {
  display: none;
}
.flatpickr-months .flatpickr-prev-month i[data-v-97867cb6],
.flatpickr-months .flatpickr-next-month i[data-v-97867cb6] {
  position: relative;
}
.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month[data-v-97867cb6],
.flatpickr-months .flatpickr-next-month.flatpickr-prev-month[data-v-97867cb6] {
  /*
        /*rtl:begin:ignore*/
  /*
        */
  left: 0;
  /*
        /*rtl:end:ignore*/
  /*
        */
}

/*
      /*rtl:begin:ignore*/
/*
      /*rtl:end:ignore*/
.flatpickr-months .flatpickr-prev-month.flatpickr-next-month[data-v-97867cb6],
.flatpickr-months .flatpickr-next-month.flatpickr-next-month[data-v-97867cb6] {
  /*
        /*rtl:begin:ignore*/
  /*
        */
  right: 0;
  /*
        /*rtl:end:ignore*/
  /*
        */
}

/*
      /*rtl:begin:ignore*/
/*
      /*rtl:end:ignore*/
.flatpickr-months .flatpickr-prev-month[data-v-97867cb6]:hover,
.flatpickr-months .flatpickr-next-month[data-v-97867cb6]:hover {
  color: #bbb;
}
.flatpickr-months .flatpickr-prev-month:hover svg[data-v-97867cb6],
.flatpickr-months .flatpickr-next-month:hover svg[data-v-97867cb6] {
  fill: #f64747;
}
.flatpickr-months .flatpickr-prev-month svg[data-v-97867cb6],
.flatpickr-months .flatpickr-next-month svg[data-v-97867cb6] {
  width: 14px;
  height: 14px;
}
.flatpickr-months .flatpickr-prev-month svg path[data-v-97867cb6],
.flatpickr-months .flatpickr-next-month svg path[data-v-97867cb6] {
  transition: fill 0.1s;
  fill: inherit;
}
.numInputWrapper[data-v-97867cb6] {
  position: relative;
  height: auto;
}
.numInputWrapper input[data-v-97867cb6],
.numInputWrapper span[data-v-97867cb6] {
  display: inline-block;
}
.numInputWrapper input[data-v-97867cb6] {
  width: 100%;
}
.numInputWrapper input[data-v-97867cb6]::-ms-clear {
  display: none;
}
.numInputWrapper input[data-v-97867cb6]::-webkit-outer-spin-button,
.numInputWrapper input[data-v-97867cb6]::-webkit-inner-spin-button {
  margin: 0;
  -webkit-appearance: none;
}
.numInputWrapper span[data-v-97867cb6] {
  position: absolute;
  right: 0;
  width: 14px;
  padding: 0 4px 0 2px;
  height: 50%;
  line-height: 50%;
  opacity: 0;
  cursor: pointer;
  border: 1px solid rgba(72, 72, 72, 0.15);
  box-sizing: border-box;
}
.numInputWrapper span[data-v-97867cb6]:hover {
  background: rgba(0, 0, 0, 0.1);
}
.numInputWrapper span[data-v-97867cb6]:active {
  background: rgba(0, 0, 0, 0.2);
}
.numInputWrapper span[data-v-97867cb6]:after {
  display: block;
  content: "";
  position: absolute;
}
.numInputWrapper span.arrowUp[data-v-97867cb6] {
  top: 0;
  border-bottom: 0;
}
.numInputWrapper span.arrowUp[data-v-97867cb6]:after {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid rgba(72, 72, 72, 0.6);
  top: 26%;
}
.numInputWrapper span.arrowDown[data-v-97867cb6] {
  top: 50%;
}
.numInputWrapper span.arrowDown[data-v-97867cb6]:after {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid rgba(72, 72, 72, 0.6);
  top: 40%;
}
.numInputWrapper span svg[data-v-97867cb6] {
  width: inherit;
  height: auto;
}
.numInputWrapper span svg path[data-v-97867cb6] {
  fill: rgba(90, 97, 113, 0.5);
}
.numInputWrapper[data-v-97867cb6]:hover {
  background: rgba(0, 0, 0, 0.05);
}
.numInputWrapper:hover span[data-v-97867cb6] {
  opacity: 1;
}
.flatpickr-current-month[data-v-97867cb6] {
  font-size: 135%;
  line-height: inherit;
  font-weight: 300;
  color: inherit;
  position: absolute;
  width: 75%;
  left: 12.5%;
  padding: 7.48px 0 0 0;
  line-height: 1;
  height: 34px;
  display: inline-block;
  text-align: center;
  transform: translate3d(0px, 0px, 0px);
}
.flatpickr-current-month span.cur-month[data-v-97867cb6] {
  font-family: inherit;
  font-weight: 700;
  color: inherit;
  display: inline-block;
  margin-left: 0.5ch;
  padding: 0;
}
.flatpickr-current-month span.cur-month[data-v-97867cb6]:hover {
  background: rgba(0, 0, 0, 0.05);
}
.flatpickr-current-month .numInputWrapper[data-v-97867cb6] {
  width: 6ch;
  width: 7ch�;
  display: inline-block;
}
.flatpickr-current-month .numInputWrapper span.arrowUp[data-v-97867cb6]:after {
  border-bottom-color: #5a6171;
}
.flatpickr-current-month .numInputWrapper span.arrowDown[data-v-97867cb6]:after {
  border-top-color: #5a6171;
}
.flatpickr-current-month input.cur-year[data-v-97867cb6] {
  background: transparent;
  box-sizing: border-box;
  color: inherit;
  cursor: text;
  padding: 0 0 0 0.5ch;
  margin: 0;
  display: inline-block;
  font-size: inherit;
  font-family: inherit;
  font-weight: 300;
  line-height: inherit;
  height: auto;
  border: 0;
  border-radius: 0;
  vertical-align: initial;
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  appearance: textfield;
}
.flatpickr-current-month input.cur-year[data-v-97867cb6]:focus {
  outline: 0;
}
.flatpickr-current-month input.cur-year[disabled][data-v-97867cb6],
.flatpickr-current-month input.cur-year[disabled][data-v-97867cb6]:hover {
  font-size: 100%;
  color: rgba(90, 97, 113, 0.5);
  background: transparent;
  pointer-events: none;
}
.flatpickr-current-month .flatpickr-monthDropdown-months[data-v-97867cb6] {
  appearance: menulist;
  background: #eceef1;
  border: none;
  border-radius: 0;
  box-sizing: border-box;
  color: inherit;
  cursor: pointer;
  font-size: inherit;
  font-family: inherit;
  font-weight: 300;
  height: auto;
  line-height: inherit;
  margin: -1px 0 0 0;
  outline: none;
  padding: 0 0 0 0.5ch;
  position: relative;
  vertical-align: initial;
  -webkit-box-sizing: border-box;
  -webkit-appearance: menulist;
  -moz-appearance: menulist;
  width: auto;
}
.flatpickr-current-month .flatpickr-monthDropdown-months[data-v-97867cb6]:focus,
.flatpickr-current-month .flatpickr-monthDropdown-months[data-v-97867cb6]:active {
  outline: none;
}
.flatpickr-current-month .flatpickr-monthDropdown-months[data-v-97867cb6]:hover {
  background: rgba(0, 0, 0, 0.05);
}
.flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month[data-v-97867cb6] {
  background-color: #eceef1;
  outline: none;
  padding: 0;
}
.flatpickr-weekdays[data-v-97867cb6] {
  background: #eceef1;
  text-align: center;
  overflow: hidden;
  width: 100%;
  display: flex;
  align-items: center;
  height: 28px;
}
.flatpickr-weekdays .flatpickr-weekdaycontainer[data-v-97867cb6] {
  display: flex;
  flex: 1;
}
span.flatpickr-weekday[data-v-97867cb6] {
  cursor: default;
  font-size: 90%;
  background: #eceef1;
  color: #5a6171;
  line-height: 1;
  margin: 0;
  text-align: center;
  display: block;
  flex: 1;
  font-weight: bolder;
}
.dayContainer[data-v-97867cb6],
.flatpickr-weeks[data-v-97867cb6] {
  padding: 1px 0 0 0;
}
.flatpickr-days[data-v-97867cb6] {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  width: 307.875px;
  border-left: 1px solid #eceef1;
  border-right: 1px solid #eceef1;
}
.flatpickr-days[data-v-97867cb6]:focus {
  outline: 0;
}
.dayContainer[data-v-97867cb6] {
  padding: 0;
  outline: 0;
  text-align: left;
  width: 307.875px;
  min-width: 307.875px;
  max-width: 307.875px;
  box-sizing: border-box;
  display: inline-block;
  display: flex;
  flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  justify-content: space-around;
  transform: translate3d(0px, 0px, 0px);
  opacity: 1;
}
.dayContainer + .dayContainer[data-v-97867cb6] {
  box-shadow: -1px 0 0 #eceef1;
}
.flatpickr-day[data-v-97867cb6] {
  background: none;
  border: 1px solid transparent;
  border-radius: 150px;
  box-sizing: border-box;
  color: #484848;
  cursor: pointer;
  font-weight: 400;
  width: 14.2857143%;
  flex-basis: 14.2857143%;
  max-width: 39px;
  height: 39px;
  line-height: 39px;
  margin: 0;
  display: inline-block;
  position: relative;
  justify-content: center;
  text-align: center;
}
.flatpickr-day.inRange[data-v-97867cb6],
.flatpickr-day.prevMonthDay.inRange[data-v-97867cb6],
.flatpickr-day.nextMonthDay.inRange[data-v-97867cb6],
.flatpickr-day.today.inRange[data-v-97867cb6],
.flatpickr-day.prevMonthDay.today.inRange[data-v-97867cb6],
.flatpickr-day.nextMonthDay.today.inRange[data-v-97867cb6],
.flatpickr-day[data-v-97867cb6]:hover,
.flatpickr-day.prevMonthDay[data-v-97867cb6]:hover,
.flatpickr-day.nextMonthDay[data-v-97867cb6]:hover,
.flatpickr-day[data-v-97867cb6]:focus,
.flatpickr-day.prevMonthDay[data-v-97867cb6]:focus,
.flatpickr-day.nextMonthDay[data-v-97867cb6]:focus {
  cursor: pointer;
  outline: 0;
  background: #e2e2e2;
  border-color: #e2e2e2;
}
.flatpickr-day.today[data-v-97867cb6] {
  border-color: #bbb;
}
.flatpickr-day.today[data-v-97867cb6]:hover,
.flatpickr-day.today[data-v-97867cb6]:focus {
  border-color: #bbb;
  background: #bbb;
  color: #fff;
}
.flatpickr-day.selected[data-v-97867cb6],
.flatpickr-day.startRange[data-v-97867cb6],
.flatpickr-day.endRange[data-v-97867cb6],
.flatpickr-day.selected.inRange[data-v-97867cb6],
.flatpickr-day.startRange.inRange[data-v-97867cb6],
.flatpickr-day.endRange.inRange[data-v-97867cb6],
.flatpickr-day.selected[data-v-97867cb6]:focus,
.flatpickr-day.startRange[data-v-97867cb6]:focus,
.flatpickr-day.endRange[data-v-97867cb6]:focus,
.flatpickr-day.selected[data-v-97867cb6]:hover,
.flatpickr-day.startRange[data-v-97867cb6]:hover,
.flatpickr-day.endRange[data-v-97867cb6]:hover,
.flatpickr-day.selected.prevMonthDay[data-v-97867cb6],
.flatpickr-day.startRange.prevMonthDay[data-v-97867cb6],
.flatpickr-day.endRange.prevMonthDay[data-v-97867cb6],
.flatpickr-day.selected.nextMonthDay[data-v-97867cb6],
.flatpickr-day.startRange.nextMonthDay[data-v-97867cb6],
.flatpickr-day.endRange.nextMonthDay[data-v-97867cb6] {
  background: #ff5a5f;
  box-shadow: none;
  color: #fff;
  border-color: #ff5a5f;
}
.flatpickr-day.selected.startRange[data-v-97867cb6],
.flatpickr-day.startRange.startRange[data-v-97867cb6],
.flatpickr-day.endRange.startRange[data-v-97867cb6] {
  border-radius: 50px 0 0 50px;
}
.flatpickr-day.selected.endRange[data-v-97867cb6],
.flatpickr-day.startRange.endRange[data-v-97867cb6],
.flatpickr-day.endRange.endRange[data-v-97867cb6] {
  border-radius: 0 50px 50px 0;
}
.flatpickr-day.selected.startRange + .endRange[data-v-97867cb6]:not(:nth-child(7n+1)),
.flatpickr-day.startRange.startRange + .endRange[data-v-97867cb6]:not(:nth-child(7n+1)),
.flatpickr-day.endRange.startRange + .endRange[data-v-97867cb6]:not(:nth-child(7n+1)) {
  box-shadow: -10px 0 0 #ff5a5f;
}
.flatpickr-day.selected.startRange.endRange[data-v-97867cb6],
.flatpickr-day.startRange.startRange.endRange[data-v-97867cb6],
.flatpickr-day.endRange.startRange.endRange[data-v-97867cb6] {
  border-radius: 50px;
}
.flatpickr-day.inRange[data-v-97867cb6] {
  border-radius: 0;
  box-shadow: -5px 0 0 #e2e2e2, 5px 0 0 #e2e2e2;
}
.flatpickr-day.flatpickr-disabled[data-v-97867cb6],
.flatpickr-day.flatpickr-disabled[data-v-97867cb6]:hover,
.flatpickr-day.prevMonthDay[data-v-97867cb6],
.flatpickr-day.nextMonthDay[data-v-97867cb6],
.flatpickr-day.notAllowed[data-v-97867cb6],
.flatpickr-day.notAllowed.prevMonthDay[data-v-97867cb6],
.flatpickr-day.notAllowed.nextMonthDay[data-v-97867cb6] {
  color: rgba(72, 72, 72, 0.3);
  background: transparent;
  border-color: transparent;
  cursor: default;
}
.flatpickr-day.flatpickr-disabled[data-v-97867cb6],
.flatpickr-day.flatpickr-disabled[data-v-97867cb6]:hover {
  cursor: not-allowed;
  color: rgba(72, 72, 72, 0.1);
}
.flatpickr-day.week.selected[data-v-97867cb6] {
  border-radius: 0;
  box-shadow: -5px 0 0 #ff5a5f, 5px 0 0 #ff5a5f;
}
.flatpickr-day.hidden[data-v-97867cb6] {
  visibility: hidden;
}
.rangeMode .flatpickr-day[data-v-97867cb6] {
  margin-top: 1px;
}
.flatpickr-weekwrapper[data-v-97867cb6] {
  float: left;
}
.flatpickr-weekwrapper .flatpickr-weeks[data-v-97867cb6] {
  padding: 0 12px;
  border-left: 1px solid #eceef1;
}
.flatpickr-weekwrapper .flatpickr-weekday[data-v-97867cb6] {
  float: none;
  width: 100%;
  line-height: 28px;
}
.flatpickr-weekwrapper span.flatpickr-day[data-v-97867cb6],
.flatpickr-weekwrapper span.flatpickr-day[data-v-97867cb6]:hover {
  display: block;
  width: 100%;
  max-width: none;
  color: rgba(72, 72, 72, 0.3);
  background: transparent;
  cursor: default;
  border: none;
}
.flatpickr-innerContainer[data-v-97867cb6] {
  display: block;
  display: flex;
  box-sizing: border-box;
  overflow: hidden;
  background: #fff;
  border-bottom: 1px solid #eceef1;
}
.flatpickr-rContainer[data-v-97867cb6] {
  display: inline-block;
  padding: 0;
  box-sizing: border-box;
}
.flatpickr-time[data-v-97867cb6] {
  text-align: center;
  outline: 0;
  display: block;
  height: 0;
  line-height: 40px;
  max-height: 40px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  background: #fff;
  border-radius: 0 0 5px 5px;
}
.flatpickr-time[data-v-97867cb6]:after {
  content: "";
  display: table;
  clear: both;
}
.flatpickr-time .numInputWrapper[data-v-97867cb6] {
  flex: 1;
  width: 40%;
  height: 40px;
  float: left;
}
.flatpickr-time .numInputWrapper span.arrowUp[data-v-97867cb6]:after {
  border-bottom-color: #484848;
}
.flatpickr-time .numInputWrapper span.arrowDown[data-v-97867cb6]:after {
  border-top-color: #484848;
}
.flatpickr-time.hasSeconds .numInputWrapper[data-v-97867cb6] {
  width: 26%;
}
.flatpickr-time.time24hr .numInputWrapper[data-v-97867cb6] {
  width: 49%;
}
.flatpickr-time input[data-v-97867cb6] {
  background: transparent;
  box-shadow: none;
  border: 0;
  border-radius: 0;
  text-align: center;
  margin: 0;
  padding: 0;
  height: inherit;
  line-height: inherit;
  color: #484848;
  font-size: 14px;
  position: relative;
  box-sizing: border-box;
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  appearance: textfield;
}
.flatpickr-time input.flatpickr-hour[data-v-97867cb6] {
  font-weight: bold;
}
.flatpickr-time input.flatpickr-minute[data-v-97867cb6],
.flatpickr-time input.flatpickr-second[data-v-97867cb6] {
  font-weight: 400;
}
.flatpickr-time input[data-v-97867cb6]:focus {
  outline: 0;
  border: 0;
}
.flatpickr-time .flatpickr-time-separator[data-v-97867cb6],
.flatpickr-time .flatpickr-am-pm[data-v-97867cb6] {
  height: inherit;
  float: left;
  line-height: inherit;
  color: #484848;
  font-weight: bold;
  width: 2%;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  align-self: center;
}
.flatpickr-time .flatpickr-am-pm[data-v-97867cb6] {
  outline: 0;
  width: 18%;
  cursor: pointer;
  text-align: center;
  font-weight: 400;
}
.flatpickr-time input[data-v-97867cb6]:hover,
.flatpickr-time .flatpickr-am-pm[data-v-97867cb6]:hover,
.flatpickr-time input[data-v-97867cb6]:focus,
.flatpickr-time .flatpickr-am-pm[data-v-97867cb6]:focus {
  background: #eaeaea;
}
.flatpickr-input[readonly][data-v-97867cb6] {
  cursor: pointer;
}
@keyframes fpFadeInDown-97867cb6 {
from {
    opacity: 0;
    transform: translate3d(0, -20px, 0);
}
to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
}
}
span.flatpickr-day.selected[data-v-97867cb6] {
  font-weight: bold;
}
.flatpickr-calendar[data-v-97867cb6] {
  background: #fff;
  border-radius: 0.3rem;
  border: 0.1rem solid #8695a8;
  box-shadow: none;
  margin-top: 0.5rem;
}
.flatpickr-calendar.arrowTop[data-v-97867cb6]::before, .flatpickr-calendar.arrowTop[data-v-97867cb6]::after, .flatpickr-calendar.arrowBottom[data-v-97867cb6]::before, .flatpickr-calendar.arrowBottom[data-v-97867cb6]::after {
  display: none;
}
.flatpickr-calendar.arrowTop[data-v-97867cb6]::before, .flatpickr-calendar.arrowTop[data-v-97867cb6]::after {
  display: none;
}
.flatpickr-calendar.arrowBottom[data-v-97867cb6]::before, .flatpickr-calendar.arrowBottom[data-v-97867cb6]::after {
  display: none;
}
.flatpickr-calendar .numInput[type=number][data-v-97867cb6],
.flatpickr-calendar input[type=number][data-v-97867cb6] {
  -moz-appearance: textfield;
}
.flatpickr-calendar .numInput[type=number][data-v-97867cb6]::-webkit-inner-spin-button, .flatpickr-calendar .numInput[type=number][data-v-97867cb6]::-webkit-outer-spin-button,
.flatpickr-calendar input[type=number][data-v-97867cb6]::-webkit-inner-spin-button,
.flatpickr-calendar input[type=number][data-v-97867cb6]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.flatpickr-innerContainer[data-v-97867cb6] {
  border-bottom: 0;
}
.flatpickr-days[data-v-97867cb6] {
  border: 0;
  margin-bottom: 1.5rem;
}
.dayContainer[data-v-97867cb6] {
  padding: 0 1.5rem;
}
.flatpickr-day[data-v-97867cb6] {
  font-size: 1.6rem;
  line-height: 3rem;
  height: 3rem;
  max-width: 3rem;
  margin: 0.45rem;
}
.flatpickr-day.today[data-v-97867cb6] {
  border: 0;
}
.flatpickr-calendar.mark-today .flatpickr-day.today[data-v-97867cb6]:not(.selected) {
  background: #f4f4f4;
}
.flatpickr-day.prevMonthDay[data-v-97867cb6], .flatpickr-day.nextMonthDay[data-v-97867cb6] {
  color: #80807d;
}
.flatpickr-day.inRange.today[data-v-97867cb6] {
  background-color: #05c;
  font-weight: 500;
}
.flatpickr-day.inRange.today[data-v-97867cb6]::after {
  top: 0;
  right: 1.6rem;
}
.flatpickr-day.selected[data-v-97867cb6], .flatpickr-day.startRange[data-v-97867cb6], .flatpickr-day.endRange[data-v-97867cb6] {
  background-color: #05c;
  border-color: #05c;
}
.flatpickr-day.selected.prevMonthDay[data-v-97867cb6], .flatpickr-day.selected.nextMonthDay[data-v-97867cb6], .flatpickr-day.startRange.prevMonthDay[data-v-97867cb6], .flatpickr-day.startRange.nextMonthDay[data-v-97867cb6], .flatpickr-day.endRange.prevMonthDay[data-v-97867cb6], .flatpickr-day.endRange.nextMonthDay[data-v-97867cb6] {
  background-color: #05c;
  border-color: #05c;
}
.flatpickr-day.selected.inRange[data-v-97867cb6], .flatpickr-day.selected.selected[data-v-97867cb6], .flatpickr-day.startRange.inRange[data-v-97867cb6], .flatpickr-day.startRange.selected[data-v-97867cb6], .flatpickr-day.endRange.inRange[data-v-97867cb6], .flatpickr-day.endRange.selected[data-v-97867cb6] {
  background: #05c;
  border-color: #05c;
  border-radius: 50%;
  color: #fff;
  font-weight: 500;
}
.flatpickr-day.selected[data-v-97867cb6]::after, .flatpickr-day.startRange[data-v-97867cb6]::after, .flatpickr-day.endRange[data-v-97867cb6]::after {
  content: "";
  display: block;
  width: 3rem;
  height: 3rem;
  position: absolute;
  top: -0.1rem;
  background: rgb(50%, 66.6666666667%, 90%);
  z-index: -1;
}
.flatpickr-day.startRange[data-v-97867cb6]::after {
  left: 1.5rem;
}
.flatpickr-day.endRange[data-v-97867cb6]::after {
  right: 1.5rem;
}
.flatpickr-day:not(.inRange) + .flatpickr-day.selected[data-v-97867cb6]:not(.startRange)::after {
  display: none;
}
.flatpickr-day.startRange.startRange + .endRange[data-v-97867cb6], .flatpickr-day.endRange.startRange + .endRange[data-v-97867cb6] {
  box-shadow: none;
}
.flatpickr-day.inRange[data-v-97867cb6], .flatpickr-day.nextMonthDay.inRange[data-v-97867cb6], .flatpickr-day.prevMonthDay.inRange[data-v-97867cb6] {
  background: rgb(50%, 66.6666666667%, 90%);
  box-shadow: -5px 0 0 rgb(50%, 66.6666666667%, 90%), 5px 0 0 rgb(50%, 66.6666666667%, 90%);
  border-color: rgb(50%, 66.6666666667%, 90%);
}
.flatpickr-day.inRange.startRange[data-v-97867cb6], .flatpickr-day.inRange.endRange[data-v-97867cb6], .flatpickr-day.nextMonthDay.inRange.startRange[data-v-97867cb6], .flatpickr-day.nextMonthDay.inRange.endRange[data-v-97867cb6], .flatpickr-day.prevMonthDay.inRange.startRange[data-v-97867cb6], .flatpickr-day.prevMonthDay.inRange.endRange[data-v-97867cb6] {
  box-shadow: none;
}
.flatpickr-day[data-v-97867cb6]:hover, .flatpickr-day[data-v-97867cb6]:focus {
  color: #333332 !important;
  background: rgb(90%, 93.3333333333%, 98%) !important;
  border-color: transparent !important;
  font-weight: 400;
}
.flatpickr-day.selected.startRange + .endRange[data-v-97867cb6]:not(:nth-child(7n+1)), .flatpickr-day.startRange.startRange + .endRange[data-v-97867cb6]:not(:nth-child(7n+1)), .flatpickr-day.endRange.startRange + .endRange[data-v-97867cb6]:not(:nth-child(7n+1)) {
  box-shadow: -10px 0 0 rgb(50%, 66.6666666667%, 90%);
}
.flatpickr-day.flatpickr-disabled[data-v-97867cb6]::before {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translate(0, -50%) rotate(-45deg);
  content: "";
  border-top: 1px solid #80807d;
}
.flatpickr-day.flatpickr-disabled[data-v-97867cb6]:not(.nextMonthDay):not(.prevMonthDay) {
  color: #6a7686;
}
.flatpickr-day.flatpickr-disabled[data-v-97867cb6]:not(.nextMonthDay):not(.prevMonthDay)::before {
  border-color: #6a7686;
}
.flatpickr-months[data-v-97867cb6] {
  position: relative;
}
.flatpickr-months .flatpickr-month[data-v-97867cb6] {
  border-radius: 0;
  background: 0;
  border-bottom: 1px solid #cbd2da;
  height: 5.5rem;
}
.flatpickr-weekdays[data-v-97867cb6] {
  background: 0;
  padding: 2rem 1.5rem 2rem;
}
.flatpickr-weekdays span.flatpickr-weekday[data-v-97867cb6] {
  background: 0;
  font-size: 100%;
  color: inherit;
}
.flatpickr-current-month[data-v-97867cb6] {
  font-size: 125%;
  color: #333332;
  padding-top: 0;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  line-height: 3rem;
}
.flatpickr-current-month .flatpickr-monthDropdown-months[data-v-97867cb6] {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: 0;
  border-radius: 0;
  font-size: 1.8rem;
  font-weight: 500;
  font-family: "Flanders Art Sans", sans-serif;
  color: #05c;
  background: transparent;
}
.flatpickr-current-month .flatpickr-monthDropdown-months[data-v-97867cb6]:hover {
  background: none;
}
.flatpickr-current-month span.cur-year[data-v-97867cb6],
.flatpickr-current-month input.cur-year[data-v-97867cb6] {
  font-weight: 500;
  color: #05c;
}
.flatpickr-months .flatpickr-prev-month[data-v-97867cb6],
.flatpickr-months .flatpickr-next-month[data-v-97867cb6] {
  border-radius: 50%;
  width: 3.5rem;
  height: 3.5rem;
  top: 50%;
  transform: translateY(-50%);
}
.flatpickr-months .flatpickr-prev-month svg[data-v-97867cb6],
.flatpickr-months .flatpickr-next-month svg[data-v-97867cb6] {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: auto;
  fill: #05c;
  stroke: #05c;
  stroke-width: 0.15rem;
  width: 1.2rem;
  height: 1.2rem;
}
.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month[data-v-97867cb6] {
  left: 10px;
}
.flatpickr-months .flatpickr-next-month.flatpickr-next-month[data-v-97867cb6] {
  right: 10px;
}
.numInputWrapper[data-v-97867cb6]:hover {
  background-color: transparent;
}
.vl-datepicker .vl-datepicker__input-field[data-v-97867cb6] {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.vl-datepicker.validated.invalid .vl-datepicker__input-field[data-v-97867cb6],
.vl-datepicker.validated.invalid .vl-datepicker__input-addon[data-v-97867cb6] {
  border-color: #d2373c;
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
}
.vl-datepicker.validated.valid .vl-datepicker__input-field[data-v-97867cb6],
.vl-datepicker.validated.valid .vl-datepicker__input-addon[data-v-97867cb6] {
  border-color: #009e47;
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
}
.vl-document[data-v-97867cb6]::before, .vl-document[data-v-97867cb6]::after {
  content: "";
  display: table;
}
.vl-document[data-v-97867cb6]::after {
  clear: both;
}
.vl-document[data-v-97867cb6] {
  display: flex;
  align-items: center;
  text-decoration: none;
}
.vl-document__type[data-v-97867cb6] {
  min-height: 7.5rem;
  margin-right: 3rem;
  position: relative;
  padding: 3rem 0 0 2rem;
}
.vl-document__type .vl-vi[data-v-97867cb6] {
  font-size: 7.5rem;
  position: absolute;
  left: 0.5rem;
  transform: translateY(-50%);
  color: #b2b2b2;
  top: 50%;
}
.vl-document__type__text[data-v-97867cb6] {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  position: relative;
  border-radius: 100%;
  width: 40px;
  height: 40px;
  font-size: 1.5rem;
  line-height: 40px;
  font-weight: 500;
  color: #333332;
  background-color: var(--vl-theme-primary-color);
  text-align: center;
  top: 1rem;
  left: 2rem;
}
.vl-document__content[data-v-97867cb6] {
  overflow: hidden;
}
.vl-document__title[data-v-97867cb6] {
  font-weight: 500;
  line-height: 1.25;
}
.vl-document__metadata[data-v-97867cb6] {
  display: block;
  color: #687483;
  font-size: 1.6rem;
  margin-top: 0.6rem;
}
@media screen and (max-width: 767px) {
.vl-document__metadata[data-v-97867cb6] {
    font-size: 1.4rem;
}
}

/**
 * Webcomponents design refresh
 * This is still in alpha phase, don't touch & don't use!
*/
.vl-doormat[data-v-97867cb6] {
  display: flex;
  position: relative;
  padding: 1.5rem 2rem;
  background-color: #fff;
  text-decoration: none;
  border: 1px #cbd2da solid;
}
.vl-doormat[data-v-97867cb6]::before, .vl-doormat--graphic .vl-doormat__graphic-wrapper[data-v-97867cb6]::before {
  content: "";
  position: absolute;
  top: -1px;
  left: -1px;
  bottom: -1px;
  background-color: var(--vl-theme-primary-color);
  width: 0.5rem;
  height: 100%;
  margin-left: 1px;
  margin-top: 1px;
}
.vl-doormat--alt[data-v-97867cb6] {
  background-color: #f7f9fc;
}
.vl-doormat--graphic[data-v-97867cb6] {
  flex-direction: column;
  border-top: none;
}
.vl-doormat--graphic .vl-doormat__graphic-wrapper[data-v-97867cb6] {
  display: block;
  position: relative;
  margin-top: -1.5rem;
  margin-right: -2.1rem;
  margin-bottom: 1.6rem;
  margin-left: -2.1rem;
  overflow: hidden;
}
.vl-doormat--graphic .vl-doormat__graphic-wrapper[data-v-97867cb6]::before {
  background-color: rgba(51, 51, 50, 0.2);
  width: 0.6rem;
  z-index: 2;
}
.vl-doormat--graphic .vl-doormat__graphic-wrapper .vl-doormat__graphic[data-v-97867cb6] {
  width: 100%;
  display: block;
  transition: transform 0.2s;
}
.vl-doormat--graphic:hover .vl-doormat__graphic[data-v-97867cb6], .vl-doormat--graphic:focus .vl-doormat__graphic[data-v-97867cb6] {
  transform: scale(1.05);
}
.vl-doormat[href][data-v-97867cb6]::before {
  background-color: var(--vl-theme-primary-color);
  transition: background-color 0.2s;
}
.vl-doormat[href]:hover .vl-doormat__title[data-v-97867cb6], .vl-doormat[href]:focus .vl-doormat__title[data-v-97867cb6] {
  text-decoration: underline;
}
.vl-doormat[href][data-v-97867cb6]:hover::before {
  background-color: var(--vl-theme-primary-color);
}
.vl-doormat[href][data-v-97867cb6]:focus::before {
  background-color: var(--vl-theme-primary-color);
}
.vl-doormat[href][data-v-97867cb6]:visited::before {
  background: var(--vl-theme-primary-color);
}
.vl-doormat__title[data-v-97867cb6] {
  font-size: 2rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 1.6rem;
  line-height: 1.4;
}
@media screen and (max-width: 767px) {
.vl-doormat__title[data-v-97867cb6] {
    font-size: 1.8rem;
    margin-bottom: 1.2rem;
}
}
.vl-doormat__title[data-v-97867cb6] {
  margin-bottom: 0;
}
@media screen and (max-width: 767px) {
.vl-doormat__title[data-v-97867cb6] {
    margin-bottom: 0;
}
}
.vl-doormat__text[data-v-97867cb6], .vl-doormat__content[data-v-97867cb6] {
  font-size: 1.8rem;
  line-height: 1.5;
}
@media screen and (max-width: 767px) {
.vl-doormat__text[data-v-97867cb6], .vl-doormat__content[data-v-97867cb6] {
    font-size: 1.6rem;
    line-height: 1.33;
}
}
.vl-doormat__text[data-v-97867cb6] {
  color: #333332;
  margin-top: 1rem;
}
.vl-doormat__image[data-v-97867cb6] {
  max-width: 15rem;
  float: right;
  flex-shrink: 0;
  margin-left: 1.5rem;
}
.vl-form__label[data-v-97867cb6] {
  font-size: 1.6rem;
  font-weight: 500;
  color: #333332;
}
@media screen and (max-width: 767px) {
.vl-form__label[data-v-97867cb6] {
    font-size: 1.6rem;
}
}
.vl-form__label[data-v-97867cb6] {
  display: inline-block;
  line-height: 1;
  font-weight: 500;
  margin-right: 0.5rem;
  margin-bottom: 0.7rem;
}
.vl-form__label--block[data-v-97867cb6] {
  display: block;
  margin-right: 0;
  margin-bottom: 0.7rem;
}
.vl-form__label--offset[data-v-97867cb6] {
  margin-top: 1rem;
}
.vl-form__label--light[data-v-97867cb6] {
  color: #687483;
}
.vl-form__label__message[data-v-97867cb6] {
  font-weight: normal;
  color: #687483;
  font-size: 1.4rem;
  line-height: 2rem;
}
.vl-form__label--standalone[data-v-97867cb6] {
  margin-bottom: 0;
}
.vl-form__error[data-v-97867cb6],
.vl-form__success[data-v-97867cb6] {
  font-size: 1.6rem;
  font-weight: 500;
  color: #333332;
}
@media screen and (max-width: 767px) {
.vl-form__error[data-v-97867cb6],
  .vl-form__success[data-v-97867cb6] {
    font-size: 1.6rem;
}
}
.vl-form__error[data-v-97867cb6],
.vl-form__success[data-v-97867cb6] {
  font-size: 1.4rem;
  color: #d2373c;
  margin-bottom: 0.5rem;
}
.vl-form__error--block[data-v-97867cb6],
.vl-form__success--block[data-v-97867cb6] {
  display: block;
}
.vl-form__error .vl-vi[data-v-97867cb6],
.vl-form__success .vl-vi[data-v-97867cb6] {
  margin-left: 0.5rem;
  font-size: 0.8rem;
}
.vl-form__error[data-v-97867cb6] {
  color: #d2373c;
}
.vl-form__success[data-v-97867cb6] {
  color: #007a37;
}
.vl-form__annotation[data-v-97867cb6] {
  font-size: 1.6rem;
  font-weight: 500;
  color: #333332;
}
@media screen and (max-width: 767px) {
.vl-form__annotation[data-v-97867cb6] {
    font-size: 1.6rem;
}
}
.vl-form__annotation[data-v-97867cb6] {
  font-size: 1.4rem;
  line-height: 2rem;
  font-weight: normal;
}
@media screen and (max-width: 767px) {
.vl-form__annotation[data-v-97867cb6] {
    font-size: 1.3rem;
}
}
.vl-form__annotation--block[data-v-97867cb6] {
  display: block;
}
.vl-form[data-v-97867cb6] {
  font-size: 1.6rem;
}
@media screen and (max-width: 767px) {
.vl-form[data-v-97867cb6] {
    font-size: 1.6rem;
}
}
.vl-form__group[data-v-97867cb6] {
  background-color: #f7f9fc;
  padding: 2rem 1.5rem;
  margin: 2rem 0 0;
}
@media screen and (max-width: 767px) {
.vl-form__group[data-v-97867cb6] {
    padding: 1.5rem 1rem;
}
}
@media screen and (max-width: 767px) {
.vl-form__group--mobile-full-width[data-v-97867cb6] {
    padding-left: 3%;
    padding-right: 3%;
    position: relative;
    width: 100vw;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
}
}
.vl-form__row + .vl-form__row[data-v-97867cb6] {
  margin-top: 1.5rem;
}
@media screen and (max-width: 767px) {
.vl-form__row .vl-form__row__group + .vl-form__row__group[data-v-97867cb6] {
    margin-top: 1.5rem;
}
}
.vl-form__row--addon[data-v-97867cb6] {
  display: flex;
  flex-direction: row;
}
.vl-form__row--addon .vl-form__addon[data-v-97867cb6] {
  flex-grow: 0;
}
.vl-form__row--inline[data-v-97867cb6]::before, .vl-form__row--inline[data-v-97867cb6]::after {
  content: "";
  display: table;
}
.vl-form__row--inline[data-v-97867cb6]::after {
  clear: both;
}
.vl-form__row--inline[data-v-97867cb6] {
  display: flex;
  margin-left: -3rem;
}
@media screen and (max-width: 767px) {
.vl-form__row--inline[data-v-97867cb6] {
    display: block;
    margin-left: -1.5rem;
}
}
.vl-form__row--inline .vl-form__label[data-v-97867cb6] {
  float: left;
  width: 25%;
  min-width: 25%;
  max-width: 25%;
  flex-basis: 25%;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-top: 0.4rem;
  padding-left: 3rem;
}
@media screen and (max-width: 767px) {
.vl-form__row--inline .vl-form__label[data-v-97867cb6] {
    display: block;
    width: auto;
    max-width: none;
    padding-left: 1.5rem;
}
}
.vl-form__row--inline .vl-form__input[data-v-97867cb6] {
  float: right;
  width: 75%;
  margin-left: 3rem;
}
@media screen and (max-width: 767px) {
.vl-form__row--inline .vl-form__input[data-v-97867cb6] {
    width: auto;
    margin-left: 1.5rem;
}
}
.vl-form__row--inline .vl-form__input .vl-radio[data-v-97867cb6],
.vl-form__row--inline .vl-form__input .vl-checkbox[data-v-97867cb6],
.vl-form__row--inline .vl-form__input input[type=file][data-v-97867cb6] {
  margin-top: 0.6rem;
}
@media screen and (max-width: 767px) {
.vl-form__row--inline .vl-form__input[data-v-97867cb6],
  .vl-form__row--inline .vl-form__label[data-v-97867cb6] {
    float: none;
    width: auto;
}
}

/*@import "~@govflanders/vl-ui-form-validation/src/scss/form-validation"; */
.vl-functional-header[data-v-97867cb6] {
  margin-bottom: 2rem;
  color: #333332;
  position: relative;
  min-width: 768px;
  background-color: #f7f9fc;
  padding: 1.5rem 0;
  min-height: 6.5rem;
}
@media screen and (max-width: 767px) {
.vl-functional-header[data-v-97867cb6] {
    min-width: 0;
    margin-bottom: 0;
    padding: 0.8rem 0;
    min-height: 0;
}
}
.vl-functional-header--has-actions[data-v-97867cb6]::before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 0.3rem;
  background-color: rgb(79.4081996435%, 84.5561497326%, 92.2780748663%);
  z-index: 2;
}
.vl-functional-header__row[data-v-97867cb6] {
  display: flex;
  justify-content: space-between;
}
.vl-functional-header .vl-layout[data-v-97867cb6] {
  position: static;
}
@media screen and (max-width: 767px) {
.vl-functional-header .vl-layout[data-v-97867cb6] {
    padding: 0;
}
}
.vl-functional-header .vl-title[data-v-97867cb6] {
  margin-bottom: 0;
  font-size: 2rem;
  line-height: 1;
  margin-bottom: 0.5rem;
}
@media screen and (max-width: 767px) {
.vl-functional-header .vl-title[data-v-97867cb6] {
    margin-bottom: 0;
}
}
.vl-functional-header__actions[data-v-97867cb6] {
  margin-top: -1.2rem;
  padding: 1.5rem 0.5rem 1rem;
  background: rgb(79.4081996435%, 84.5561497326%, 92.2780748663%);
}
@media screen and (max-width: 767px) {
.vl-functional-header__actions[data-v-97867cb6] {
    margin-top: -0.8rem;
}
}
.vl-functional-header__action[data-v-97867cb6] {
  float: left;
  padding: 0 0.5rem;
  font-size: 1.4rem;
  line-height: 1;
  color: #333332;
}
.vl-functional-header__action + .vl-functional-header__action[data-v-97867cb6] {
  border-left: 1px solid #333332;
}
.vl-functional-header__action > a[data-v-97867cb6],
.vl-functional-header__action > button[data-v-97867cb6] {
  line-height: inherit;
  color: #333332;
  margin: 0;
}
.vl-functional-header__title[data-v-97867cb6] {
  font-size: 2rem;
  font-weight: 500;
  text-transform: uppercase;
  text-decoration: none;
}
.vl-functional-header__title[href][data-v-97867cb6] {
  color: inherit;
}
.vl-functional-header__title[href][data-v-97867cb6]:hover, .vl-functional-header__title[href][data-v-97867cb6]:focus {
  color: #05c;
}
@media screen and (max-width: 767px) {
.vl-functional-header__title[data-v-97867cb6] {
    font-size: 1.8rem;
}
}
@media screen and (max-width: 767px) {
.vl-functional-header__content[data-v-97867cb6], .vl-functional-header__menu[data-v-97867cb6], .vl-functional-header__search[data-v-97867cb6], .vl-functional-header__sub__actions[data-v-97867cb6] {
    padding: 0 1rem;
}
}
.vl-functional-header__content[data-v-97867cb6] {
  display: flex;
  align-items: center;
}
.vl-functional-header__sub[data-v-97867cb6] {
  margin-top: 0.5rem;
  clear: both;
  position: relative;
  border-top: 1px solid #cbd2da;
}
@media screen and (max-width: 767px) {
.vl-functional-header__sub[data-v-97867cb6] {
    margin-top: 0.8rem;
}
}
.vl-functional-header__sub__actions[data-v-97867cb6] {
  display: flex;
  align-items: flex-start;
  font-size: 0;
  padding-top: 1rem;
}
.vl-functional-header__sub__action[data-v-97867cb6] {
  font-size: 1.6rem;
  display: inline-flex;
  vertical-align: middle;
  position: relative;
}
@media screen and (max-width: 767px) {
.vl-functional-header__sub__action[data-v-97867cb6] {
    font-size: 1.6rem;
}
}
.vl-functional-header__sub__action + .vl-functional-header__sub__action[data-v-97867cb6]::before {
  content: "";
  height: 2.4rem;
  width: 1px;
  margin: 0 1rem;
  background-color: #cbd2da;
  flex: 0 0 auto;
}
@media screen and (max-width: 767px) {
.vl-functional-header__sub__action + .vl-functional-header__sub__action[data-v-97867cb6]::before {
    height: 2rem;
    margin: 0 0.6rem 0 0.8rem;
}
}
.vl-functional-header__sub__title[data-v-97867cb6] {
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 700;
  font-size: 1.6rem;
  display: inline-block;
}
@media screen and (max-width: 767px) {
.vl-functional-header__sub__title[data-v-97867cb6] {
    font-size: 1.5rem;
}
}
.vl-functional-header__search[data-v-97867cb6] {
  margin: 0;
  display: flex;
  justify-content: flex-end;
}
@media screen and (max-width: 767px) {
.vl-functional-header__search[data-v-97867cb6] {
    margin: 1rem 0 0.5rem;
    text-align: left;
}
}
.vl-functional-header__search .vl-search[data-v-97867cb6] {
  padding: 0;
  top: 0.7rem;
}
.vl-functional-header__search__input[data-v-97867cb6] {
  display: inline-block;
  vertical-align: middle;
  font-size: 1.4rem;
  font-weight: 400;
  width: 100%;
  padding-right: 3.2rem;
  transition: max-width 0.3s ease-in-out;
}
.vl-functional-header__search__input.vl-input-field[data-v-97867cb6] {
  max-width: 20rem;
}
@media screen and (max-width: 767px) {
.vl-functional-header__search__input.vl-input-field[data-v-97867cb6] {
    max-width: 100%;
}
}
.vl-functional-header__search__input.vl-input-field[data-v-97867cb6]:focus {
  max-width: 24rem;
}
@media screen and (max-width: 767px) {
.vl-functional-header__search__input.vl-input-field[data-v-97867cb6]:focus {
    max-width: 100%;
}
}
.vl-functional-header__search__input.vl-input-field:focus + .vl-functional-header__search__submit[data-v-97867cb6] {
  opacity: 1;
}
@media screen and (max-width: 767px) {
.vl-functional-header__search__input[data-v-97867cb6] {
    transition: max-width 0s ease-in-out;
    max-width: 100%;
}
.vl-functional-header__search__input[data-v-97867cb6]:focus {
    max-width: 100%;
}
}
.vl-functional-header__search__submit[data-v-97867cb6] {
  position: absolute;
  top: 0;
  right: 0;
  color: #333332;
  border: 0;
  background: none;
  font-size: 1.6rem;
  outline: none;
  margin: 0.6rem 0 0;
  padding: 0.8rem 1.1rem;
  cursor: pointer;
  transition: opacity 0.1s, color 0.2s ease-in-out;
  opacity: 0.7;
}
.vl-functional-header__search__submit[data-v-97867cb6]:hover, .vl-functional-header__search__submit[data-v-97867cb6]:focus {
  color: #05c;
  opacity: 1;
}
@media screen and (max-width: 767px) {
.vl-functional-header__search__submit[data-v-97867cb6] {
    margin: 0.1rem 0 0;
    right: 1rem;
    top: 1rem;
}
}
.vl-functional-header__menu[data-v-97867cb6] {
  position: relative;
  border-bottom: 1px solid #cbd2da;
}
.vl-functional-header__menu--open .vl-functional-header__menu__list[data-v-97867cb6] {
  max-height: 100%;
  height: auto;
}
.vl-functional-header__menu--open .vl-functional-header__menu__toggle[data-v-97867cb6]::before {
  content: "\\f17f";
}
.vl-functional-header__menu--open .vl-functional-header__menu__toggle[data-v-97867cb6] {
  font-size: 1.3rem;
  border: 0;
}
.vl-functional-header__menu__list[data-v-97867cb6] {
  width: calc(100% - 5rem);
  max-height: 4.2rem;
  height: 4.2rem;
  overflow: hidden;
}
.vl-functional-header__menu__item[data-v-97867cb6]:first-child {
  margin: 0.3rem 0 0;
}
.vl-functional-header__menu__item[data-v-97867cb6]:last-child {
  margin: 0 0 0.3rem;
}
.vl-functional-header__menu__cta[data-v-97867cb6] {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0.8rem 0;
  text-decoration: none;
  font-size: 1.5rem;
}
.vl-functional-header__menu__cta[data-v-97867cb6]:hover {
  text-decoration: underline;
}
.vl-functional-header__menu__toggle[data-v-97867cb6]::before, .vl-functional-header__menu__toggle[data-v-97867cb6]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-functional-header__menu__toggle[data-v-97867cb6]::before {
  content: "\\f125";
}
.vl-functional-header__menu__toggle[data-v-97867cb6] {
  position: absolute;
  top: 0;
  right: 0;
  padding: 1rem 1.3rem;
  font-size: 1.5rem;
  border-left: 1px solid #cbd2da;
  color: #333332;
  cursor: pointer;
}
.vl-functional-header__menu__toggle[data-v-97867cb6]::before {
  display: inline-block;
  transform: rotate(90deg);
  position: relative;
  top: 1px;
}
.vl-icon-wrapper[data-v-97867cb6] {
  display: flex;
}
.vl-icon-wrapper .vl-icon[data-v-97867cb6] {
  display: inline-block;
}
.vl-icon[data-v-97867cb6] {
  font-size: 1em;
  display: inline;
  color: inherit;
}
.vl-icon svg[data-v-97867cb6] {
  height: 1em;
  width: auto;
  fill: currentColor;
  display: inline-block;
  font-size: inherit;
  overflow: visible;
  vertical-align: middle;
}
.vl-icon--small[data-v-97867cb6] {
  font-size: 0.8em;
}
.vl-icon--small svg[data-v-97867cb6] {
  height: 0.8em;
  width: auto;
}
.vl-icon--large[data-v-97867cb6] {
  font-size: 1.2em;
}
.vl-icon--large svg[data-v-97867cb6] {
  height: 1.2em;
  width: auto;
}
.vl-icon--light[data-v-97867cb6] {
  color: #8695a8;
}
.vl-icon--before[data-v-97867cb6] {
  margin-right: 0.5em;
}
.vl-icon--after[data-v-97867cb6] {
  margin-left: 0.5em;
}
.vl-icon--inline-svg[data-v-97867cb6]:before {
  display: none;
}
.vl-icon-list__item[data-v-97867cb6] {
  padding-left: 3rem;
  margin-bottom: 1rem;
  position: relative;
  line-height: 1.3;
}
.vl-icon-list__item .vl-vi[data-v-97867cb6] {
  font-size: 2rem;
  position: absolute;
  left: 0;
  top: -0.3rem;
}
.vl-icon-list__item .vl-vi[data-v-97867cb6]::before, .vl-icon-list__item .vl-vi[data-v-97867cb6]::after {
  color: #b2b2b2;
}
.vl-icon-list__item .vl-vi svg[data-v-97867cb6] {
  fill: #b2b2b2;
}
.vl-icon-list--small .vl-icon-list__item[data-v-97867cb6] {
  font-size: 1.6rem;
}
.vl-icon-list--small .vl-icon-list__item .vl-vi[data-v-97867cb6] {
  font-size: 1.8rem;
  top: -0.2rem;
}
.vl-icon-list--xsmall .vl-icon-list__item[data-v-97867cb6] {
  padding-left: 2.5rem;
  font-size: 1.4rem;
}
.vl-icon-list--xsmall .vl-icon-list__item .vl-vi[data-v-97867cb6] {
  font-size: 1.6rem;
  top: -0.1rem;
}
.vl-infoblock--border[data-v-97867cb6] {
  border: 1px solid #cbd2da;
  padding: 5rem;
}
@media screen and (max-width: 1023px) {
.vl-infoblock--border[data-v-97867cb6] {
    padding: 3rem;
}
}
@media screen and (max-width: 767px) {
.vl-infoblock--border[data-v-97867cb6] {
    padding: 2rem;
}
}
.vl-infoblock__header[data-v-97867cb6]::before, .vl-infoblock__header[data-v-97867cb6]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-infoblock__header[data-v-97867cb6] {
  position: relative;
  display: flex;
  align-items: center;
  line-height: 4.2rem;
  overflow-wrap: break-word;
}
@media screen and (max-width: 767px) {
.vl-infoblock__header[data-v-97867cb6] {
    line-height: 3.6rem;
}
}
.vl-infoblock__header__icon-wrapper[data-v-97867cb6] {
  position: relative;
}
.vl-infoblock__header__icon.vl-icon[data-v-97867cb6], .vl-infoblock__header__icon[data-v-97867cb6] {
  display: block;
  flex: 0 0 auto;
  background-color: transparent;
  background: var(--vl-theme-primary-color);
  font-size: 2rem;
  border-radius: 50%;
  color: var(--vlw-theme-primary-fg-color, #333332);
  width: 4.2rem;
  height: 4.2rem;
  text-align: center;
  margin-right: 2.7rem;
  align-self: start;
}
@media screen and (max-width: 767px) {
.vl-infoblock__header__icon.vl-icon[data-v-97867cb6], .vl-infoblock__header__icon[data-v-97867cb6] {
    font-size: 1.5rem;
    width: 3.6rem;
    height: 3.6rem;
    margin-right: 1.5rem;
}
}
.vl-infoblock__header__icon.vl-icon[data-v-97867cb6]::before, .vl-infoblock__header__icon[data-v-97867cb6]::before {
  display: block;
}
.vl-infoblock--alt .vl-infoblock__header__icon[data-v-97867cb6] {
  background-color: #f7f9fc;
  border: 1px solid #cbd2da;
}
.vl-infoblock--contact .vl-infoblock__header__icon[data-v-97867cb6]::before, .vl-infoblock--contact .vl-infoblock__header__icon[data-v-97867cb6]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-infoblock--contact .vl-infoblock__header__icon[data-v-97867cb6]::before {
  content: "\\f102";
}
.vl-infoblock--publications .vl-infoblock__header__icon[data-v-97867cb6]::before, .vl-infoblock--publications .vl-infoblock__header__icon[data-v-97867cb6]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-infoblock--publications .vl-infoblock__header__icon[data-v-97867cb6]::before {
  content: "\\f134";
}
.vl-infoblock--faq .vl-infoblock__header__icon[data-v-97867cb6]::before, .vl-infoblock--faq .vl-infoblock__header__icon[data-v-97867cb6]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-infoblock--faq .vl-infoblock__header__icon[data-v-97867cb6]::before {
  content: "\\f1a4";
}
.vl-infoblock--news .vl-infoblock__header__icon[data-v-97867cb6]::before, .vl-infoblock--news .vl-infoblock__header__icon[data-v-97867cb6]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-infoblock--news .vl-infoblock__header__icon[data-v-97867cb6]::before {
  content: "\\f223";
}
.vl-infoblock--timeline .vl-infoblock__header__icon[data-v-97867cb6]::before, .vl-infoblock--timeline .vl-infoblock__header__icon[data-v-97867cb6]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-infoblock--timeline .vl-infoblock__header__icon[data-v-97867cb6]::before {
  content: "\\f29c";
}
.vl-infoblock--question .vl-infoblock__header__icon[data-v-97867cb6]::before, .vl-infoblock--question .vl-infoblock__header__icon[data-v-97867cb6]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-infoblock--question .vl-infoblock__header__icon[data-v-97867cb6]::before {
  content: "\\f252";
}
@media screen and (max-width: 767px) {
.vl-infoblock__header__icon[data-v-97867cb6] {
    font-size: 1.5rem;
    width: 3.6rem;
    height: 3.6rem;
    margin-right: 1.5rem;
}
}
.vl-infoblock__header__badge[data-v-97867cb6] {
  position: absolute;
  top: 0;
  right: 0;
  margin-right: 2.2rem;
}
@media screen and (max-width: 767px) {
.vl-infoblock__header__badge[data-v-97867cb6] {
    margin-right: 0.9rem;
}
}
.vl-infoblock__title[data-v-97867cb6] {
  font-size: 2rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 1.6rem;
  line-height: 1.4;
}
@media screen and (max-width: 767px) {
.vl-infoblock__title[data-v-97867cb6] {
    font-size: 1.8rem;
    margin-bottom: 1.2rem;
}
}
.vl-infoblock__title[data-v-97867cb6] {
  margin-bottom: 0;
}
@media screen and (max-width: 767px) {
.vl-infoblock__title[data-v-97867cb6] {
    font-size: 1.8rem;
    font-family: "Flanders Art Sans", sans-serif;
    font-weight: 500;
    margin-bottom: 1.4rem;
    line-height: 1.44;
    margin-bottom: 0;
}
}
@media screen and (max-width: 767px) and (max-width: 767px) {
.vl-infoblock__title[data-v-97867cb6] {
    font-size: 1.8rem;
    margin-bottom: 1rem;
}
}
@media screen and (max-width: 500px) {
.vl-infoblock__title[data-v-97867cb6] {
    margin-bottom: 0;
}
}
.vl-infoblock__content[data-v-97867cb6] {
  padding-top: 1.5rem;
  margin-left: 7rem;
}
@media screen and (max-width: 767px) {
.vl-infoblock__content[data-v-97867cb6] {
    padding-top: 0.75rem;
    margin-left: 5.2rem;
}
}
.vl-info-tile[data-v-97867cb6] {
  display: block;
  position: relative;
  border: 1px solid #cbd2da;
  padding: 1.7rem;
}
@media screen and (max-width: 767px) {
.vl-info-tile[data-v-97867cb6] {
    padding: 1rem;
}
}
.vl-info-tile--alt[data-v-97867cb6] {
  background-color: #f7f9fc;
}
.vl-info-tile--clickable[data-v-97867cb6] {
  text-decoration: none;
  cursor: pointer;
  text-align: left;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border-radius: 0;
  color: var(--vl-theme-action-color, #05c);
}
.vl-info-tile--clickable[data-v-97867cb6]:hover, .vl-info-tile--clickable[data-v-97867cb6]:focus {
  background-color: #f7f9fc;
  color: var(--vl-theme-action-hover-color, #003bb0);
}
.vl-info-tile--clickable:hover .vl-info-tile__header__title[data-v-97867cb6], .vl-info-tile--clickable:focus .vl-info-tile__header__title[data-v-97867cb6] {
  text-decoration: underline;
}
.vl-info-tile--clickable:hover.vl-info-tile--date .vl-info-tile__date[data-v-97867cb6], .vl-info-tile--clickable:focus.vl-info-tile--date .vl-info-tile__date[data-v-97867cb6] {
  background: var(--vl-theme-action-hover-color, #003bb0);
}
.vl-info-tile--clickable.vl-info-tile--date .vl-info-tile__date[data-v-97867cb6] {
  background: var(--vl-theme-action-hover-color, #003bb0);
}
.vl-info-tile--clickable:visited.vl-info-tile--date .vl-info-tile__date[data-v-97867cb6] {
  background: #660599;
}
.vl-info-tile--m[data-v-97867cb6] {
  padding: 2.5rem;
}
@media screen and (max-width: 767px) {
.vl-info-tile--m[data-v-97867cb6] {
    padding: 2rem;
}
}
.vl-info-tile--l[data-v-97867cb6] {
  padding: 4.5rem;
}
@media screen and (max-width: 767px) {
.vl-info-tile--l[data-v-97867cb6] {
    padding: 2rem;
}
}
.vl-info-tile--center[data-v-97867cb6] {
  text-align: center;
}
.vl-info-tile--center .vl-info-tile__header[data-v-97867cb6] {
  display: block;
  margin-bottom: 1.6rem;
}
.vl-info-tile--center .vl-info-tile__header__wrapper[data-v-97867cb6] {
  width: 100%;
}
.vl-info-tile--center .vl-info-tile__header__icon[data-v-97867cb6]:not(.vl-badge) {
  color: #cbd2da;
  font-size: 3rem;
  line-height: 1;
  display: inline-block;
}
.vl-info-tile--center .vl-info-tile__footer[data-v-97867cb6] {
  margin-top: 2rem;
}
.vl-info-tile--v-center[data-v-97867cb6] {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.vl-info-tile.vl-js-equal-height[data-v-97867cb6] {
  height: 100%;
}
.vl-info-tile--date[data-v-97867cb6] {
  padding: 0;
  display: flex;
  align-items: stretch;
}
.vl-info-tile--date[href] .vl-info-tile__date[data-v-97867cb6] {
  color: #fff;
}
.vl-info-tile--date .vl-info-tile__date[data-v-97867cb6] {
  background-color: #f7f9fc;
  padding: 1.7rem;
}
@media screen and (max-width: 767px) {
.vl-info-tile--date .vl-info-tile__date[data-v-97867cb6] {
    padding: 1rem;
}
}
.vl-info-tile--date .vl-info-tile__date__main[data-v-97867cb6] {
  text-align: center;
  font-weight: bold;
}
.vl-info-tile--date .vl-info-tile__date__sub[data-v-97867cb6] {
  text-align: center;
  font-size: 1.4rem;
}
.vl-info-tile--date .vl-info-tile__date__wrapper[data-v-97867cb6] {
  padding: 1.7rem;
  flex: 1;
}
@media screen and (max-width: 767px) {
.vl-info-tile--date .vl-info-tile__date__wrapper[data-v-97867cb6] {
    padding: 1rem;
}
}
.vl-info-tile--badge-bottom .vl-info-tile__content[data-v-97867cb6] {
  display: flex;
}
.vl-info-tile__badges[data-v-97867cb6] {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-left: 1.7rem;
}
.vl-info-tile__badges__badge[data-v-97867cb6]:not(:first-of-type) {
  margin-top: 0.5rem;
}
.vl-info-tile--highlight[data-v-97867cb6] {
  box-shadow: inset 0 0.5rem 0 0 var(--vl-theme-accent-color, var(--vl-theme-primary-color));
}
.vl-info-tile__header[data-v-97867cb6] {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex: 1;
}
.vl-info-tile__header .vl-info-tile__badge__wrapper[data-v-97867cb6] {
  margin-right: 1.4rem;
  flex-shrink: 0;
}
.vl-info-tile__header__title[data-v-97867cb6] {
  font-weight: 500;
  line-height: 1.25;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.8rem;
}
@media screen and (max-width: 767px) {
.vl-info-tile__header__title[data-v-97867cb6] {
    font-size: 1.5rem;
}
}
.vl-info-tile__header__subtitle[data-v-97867cb6] {
  color: #687483;
  line-height: 1.3;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.4rem;
  margin-top: 0.3rem;
}
.vl-info-tile__content[data-v-97867cb6] {
  font-size: 1.6rem;
  margin-top: 1rem;
  flex: 1;
  color: #333332;
}
@media screen and (max-width: 767px) {
.vl-info-tile__content[data-v-97867cb6] {
    font-size: 1.5rem;
}
}
.vl-info-tile__content__wrapper[data-v-97867cb6] {
  flex: 1;
}
.vl-input-addon[data-v-97867cb6] {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 3.5rem;
  line-height: 3.5rem;
  min-width: 3.5rem;
  border: 0.1rem solid #8695a8;
  text-decoration: none;
  padding: 0 1rem;
  font-weight: 500;
  font-size: 1.6rem;
  color: #333332;
  background: #fff;
  margin: 0;
}
.vl-input-addon[type=button] .vl-vi[data-v-97867cb6], .vl-input-addon[href] .vl-vi[data-v-97867cb6] {
  color: #05c;
}
.vl-input-addon[type=button][data-v-97867cb6]:hover, .vl-input-addon[href][data-v-97867cb6]:hover {
  box-shadow: inset 0 0 0 0.1rem rgba(0, 85, 204, 0.65);
  border-color: rgba(0, 85, 204, 0.65);
  background: rgba(179, 207, 245, 0.3);
}
.vl-input-addon[type=button]:hover .vl-vi[data-v-97867cb6], .vl-input-addon[type=button]:focus .vl-vi[data-v-97867cb6], .vl-input-addon[href]:hover .vl-vi[data-v-97867cb6], .vl-input-addon[href]:focus .vl-vi[data-v-97867cb6] {
  color: #003bb0;
}
.vl-input-addon[type=button][data-v-97867cb6]:focus, .vl-input-addon[href][data-v-97867cb6]:focus {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.vl-input-addon[type=button][data-v-97867cb6]:focus, .vl-input-addon[href][data-v-97867cb6]:focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
@supports (outline-offset: 2px) {
.vl-input-addon[type=button][data-v-97867cb6]:focus, .vl-input-addon[href][data-v-97867cb6]:focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
.vl-input-addon[type=button][data-v-97867cb6]:hover:focus, .vl-input-addon[href][data-v-97867cb6]:hover:focus {
  box-shadow: inset 0 0 0 0.1rem rgba(0, 85, 204, 0.65), 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
}
.vl-input-addon--disabled[type=button][data-v-97867cb6], .vl-input-addon--disabled[href][data-v-97867cb6] {
  background-color: #cbd2d9;
  cursor: not-allowed;
}
.vl-input-addon--disabled[type=button] .vl-vi[data-v-97867cb6], .vl-input-addon--disabled[href] .vl-vi[data-v-97867cb6] {
  color: #687483;
}
.vl-input-addon--disabled[type=button][data-v-97867cb6]:hover, .vl-input-addon--disabled[type=button][data-v-97867cb6]:active, .vl-input-addon--disabled[href][data-v-97867cb6]:hover, .vl-input-addon--disabled[href][data-v-97867cb6]:active {
  background-color: #cbd2d9;
  border-color: #cbd2d9;
}
.vl-input-addon--disabled[type=button]:hover .vl-vi[data-v-97867cb6], .vl-input-addon--disabled[type=button]:active .vl-vi[data-v-97867cb6], .vl-input-addon--disabled[href]:hover .vl-vi[data-v-97867cb6], .vl-input-addon--disabled[href]:active .vl-vi[data-v-97867cb6] {
  color: #687483;
}
.vl-input-addon--disabled[type=button]:focus .vl-vi[data-v-97867cb6], .vl-input-addon--disabled[href]:focus .vl-vi[data-v-97867cb6] {
  color: #687483;
}
.vl-input-addon .vl-vi[data-v-97867cb6] {
  display: inline-flex;
  color: inherit;
}
.vl-input-addon .vl-vi[data-v-97867cb6]::before, .vl-input-addon .vl-vi[data-v-97867cb6]::after {
  font-size: 1.8rem;
}
.vl-input-field[data-v-97867cb6] {
  display: inline-block;
  background: #fff;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.6rem;
  color: #333332;
  max-width: 100%;
  height: 3.5rem;
  line-height: 3.5rem;
  border-radius: 0.3rem;
  border: 0.1rem solid #8695a8;
  -webkit-appearance: none;
  -moz-appearance: textfield;
  padding: 0 1rem;
  transition: background-color 0.2s;
}
@media screen and (max-width: 767px) {
.vl-input-field[data-v-97867cb6] {
    font-size: 1.6rem;
}
}
.vl-input-field[data-v-97867cb6]:hover {
  border: 0.2rem solid rgba(0, 85, 204, 0.65);
  padding: 0 0.9rem;
}
.vl-input-field:hover.vl-input-field--error[data-v-97867cb6], .vl-input-field:hover.invalid.validated[data-v-97867cb6] {
  border-color: #d2373c;
}
.vl-input-field:hover.vl-input-field--success[data-v-97867cb6] {
  border-color: #009e47;
}
.vl-input-field:hover.vl-input-field--small[data-v-97867cb6] {
  padding: 0 0.7rem;
}
.vl-input-field[data-v-97867cb6]:focus, .vl-input-field--focus[data-v-97867cb6] {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.vl-input-field[data-v-97867cb6]:focus, .vl-input-field--focus[data-v-97867cb6] {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
.vl-input-field[data-v-97867cb6]:focus, .vl-input-field--focus[data-v-97867cb6] {
  border: 0.1rem solid #8695a8;
  padding: 0 1rem;
}
.vl-input-field:focus.vl-input-field--error[data-v-97867cb6], .vl-input-field:focus.invalid.validated[data-v-97867cb6], .vl-input-field--focus.vl-input-field--error[data-v-97867cb6], .vl-input-field--focus.invalid.validated[data-v-97867cb6] {
  border-color: #d2373c;
}
.vl-input-field:focus.vl-input-field--success[data-v-97867cb6], .vl-input-field--focus.vl-input-field--success[data-v-97867cb6] {
  border-color: #009e47;
}
.vl-input-field[data-v-97867cb6]:focus:hover, .vl-input-field--focus[data-v-97867cb6]:hover {
  padding: 0 1rem;
}
.vl-input-field:focus.vl-input-field--small[data-v-97867cb6], .vl-input-field--focus.vl-input-field--small[data-v-97867cb6] {
  padding: 0 0.8rem;
}
.vl-input-field[data-v-97867cb6]::-moz-placeholder {
  color: #687483;
}
.vl-input-field[data-v-97867cb6]::placeholder {
  color: #687483;
}
.vl-input-field[data-v-97867cb6]::-webkit-search-cancel-button {
  -webkit-appearance: none;
}
.vl-input-field--block[data-v-97867cb6] {
  display: block;
  width: 100%;
}
.vl-input-field--small[data-v-97867cb6] {
  max-width: 6rem;
  padding: 0 0.8rem;
}
.vl-input-field--error[data-v-97867cb6], .vl-input-field.invalid.validated[data-v-97867cb6] {
  border-color: #d2373c;
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
  display: inline;
}
.vl-input-field--error .vl-select[data-v-97867cb6], .vl-input-field.invalid.validated .vl-select[data-v-97867cb6] {
  border-color: #d2373c;
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
}
.vl-input-field--error .js-vl-select[data-type*=select-one][data-v-97867cb6], .vl-input-field--error .js-vl-select[data-type*=select-multiple][data-v-97867cb6], .vl-input-field.invalid.validated .js-vl-select[data-type*=select-one][data-v-97867cb6], .vl-input-field.invalid.validated .js-vl-select[data-type*=select-multiple][data-v-97867cb6] {
  border-color: #d2373c;
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
}
.vl-input-field--error .js-vl-select[data-type*=select-one] .vl-select__inner[data-v-97867cb6], .vl-input-field--error .js-vl-select[data-type*=select-multiple] .vl-select__inner[data-v-97867cb6], .vl-input-field.invalid.validated .js-vl-select[data-type*=select-one] .vl-select__inner[data-v-97867cb6], .vl-input-field.invalid.validated .js-vl-select[data-type*=select-multiple] .vl-select__inner[data-v-97867cb6] {
  border-color: #d2373c;
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
  background-color: transparent;
}
.vl-input-field--success[data-v-97867cb6] {
  border-color: #009e47;
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
  display: inline;
}
.vl-input-field--success .vl-select[data-v-97867cb6] {
  border-color: #009e47;
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
}
.vl-input-field--success .js-vl-select[data-type*=select-one][data-v-97867cb6], .vl-input-field--success .js-vl-select[data-type*=select-multiple][data-v-97867cb6] {
  border-color: #009e47;
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
}
.vl-input-field--success .js-vl-select[data-type*=select-one] .vl-select__inner[data-v-97867cb6], .vl-input-field--success .js-vl-select[data-type*=select-multiple] .vl-select__inner[data-v-97867cb6] {
  border-color: #009e47;
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
  background-color: transparent;
}
.vl-input-field--disabled[data-v-97867cb6], .vl-input-field[disabled][data-v-97867cb6] {
  background-color: #f3f5f6;
  border-color: #8695a8;
}
.vl-input-field--disabled[data-v-97867cb6]:hover, .vl-input-field[disabled][data-v-97867cb6]:hover {
  border-width: 0.1rem;
  padding: 0 1rem;
}
.vl-input-field--inline[data-v-97867cb6] {
  position: relative;
  display: block;
  max-width: 100%;
}
@media screen and (max-width: 767px) {
.vl-input-field--inline[data-v-97867cb6] {
    display: block;
    width: auto;
}
}
.vl-input-field--inline .vl-input-field__submit[data-v-97867cb6] {
  position: absolute;
  display: block;
  color: #fff;
  width: 4.3rem;
  height: 3.5rem;
  opacity: 0;
  padding: 0;
  margin-bottom: -2rem;
  transform: translateX(100%);
  top: 0;
  right: 0;
  z-index: -1;
}
.vl-input-field--inline .vl-input-field__submit[data-v-97867cb6]:focus {
  transform: translateX(0%);
  transition: opacity 0.2s, transform 0.2s;
  opacity: 1;
  z-index: 1;
}
.vl-input-field--inline .vl-input-field__submit[data-v-97867cb6]::before {
  position: absolute;
  font-size: 1.7rem;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
}
.vl-input-field--inline .vl-input-field__input[data-v-97867cb6] {
  display: block;
  width: 100%;
  text-align: left;
  padding-right: 5rem;
}
.vl-input-field--inline .vl-input-field__input[data-v-97867cb6]:focus, .vl-input-field--inline .vl-input-field__input--focus[data-v-97867cb6] {
  width: calc(100% - 5.2rem);
  padding-right: 0;
  transition: width 0.2s;
}
.vl-input-field--inline .vl-input-field__input:focus + .vl-input-field__submit[data-v-97867cb6], .vl-input-field--inline .vl-input-field__input--focus + .vl-input-field__submit[data-v-97867cb6] {
  transform: translateX(0%);
  transition: opacity 0.2s, transform 0.2s;
  opacity: 1;
  z-index: 1;
}
.vl-input-group[data-v-97867cb6] {
  display: flex;
  align-items: stretch;
}
.vl-input-group .vl-button[data-v-97867cb6],
.vl-input-group .vl-input-addon[data-v-97867cb6] {
  flex-shrink: 0;
}
.vl-input-group .vl-button[data-v-97867cb6]:focus,
.vl-input-group .vl-input-addon[data-v-97867cb6]:focus {
  z-index: 1;
}
.vl-input-group[data-v-97867cb6] :first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
  border-right-width: 0;
}
.vl-input-group[data-v-97867cb6] :first-child:focus {
  z-index: 1;
  border-right-width: 1px;
}
.vl-input-group .vl-input-field + .vl-input-addon[data-v-97867cb6],
.vl-input-group .vl-input-field + .vl-button[data-v-97867cb6] {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
  margin-left: -0.1rem;
}
.vl-input-group .vl-input-addon + .vl-input-field[data-v-97867cb6],
.vl-input-group .vl-button + .vl-input-field[data-v-97867cb6] {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}
.vl-input-group .vl-button + .vl-input-field[data-v-97867cb6] {
  border-left-width: 0;
  padding-left: 1.1rem;
}
.vl-input-group .vl-button + .vl-input-field[data-v-97867cb6]:focus {
  padding-left: 1rem;
}
.vl-input-group .vl-input-field[data-v-97867cb6],
.vl-input-group .vl-input-addon[data-v-97867cb6] {
  position: relative;
}
.vl-input-group .vl-input-field[data-v-97867cb6]:focus,
.vl-input-group .vl-input-addon[data-v-97867cb6]:focus {
  z-index: 1;
  border-left-width: 1px;
}
.vl-input-group--inline[data-v-97867cb6] {
  display: inline-flex;
}
[type=submit].vl-link.vl-link--icon[data-v-97867cb6], .vl-sidebar-panel-list-item__button [type=submit].vl-link--icon.vl-icon[data-v-97867cb6], [type=submit].vl-link--icon.vl-sidebar-header__toggle[data-v-97867cb6] {
  padding-left: 1.8rem;
}
button.vl-link[data-v-97867cb6], .vl-sidebar-panel-list-item__button button.vl-icon[data-v-97867cb6], button.vl-sidebar-header__toggle[data-v-97867cb6] {
  cursor: default;
}
.vl-link[data-v-97867cb6], .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6], .vl-sidebar-header__toggle[data-v-97867cb6] {
  border-radius: 0;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  border: 0;
  background-color: transparent;
  padding: 0;
  text-decoration: underline;
}
.vl-link[data-v-97867cb6]:hover, .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6]:hover, .vl-sidebar-header__toggle[data-v-97867cb6]:hover {
  text-decoration: none;
}
.vl-link[data-v-97867cb6]:focus, .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6]:focus, .vl-sidebar-header__toggle[data-v-97867cb6]:focus, .vl-link[data-v-97867cb6]:active, .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6]:active, .vl-sidebar-header__toggle[data-v-97867cb6]:active {
  text-decoration: none;
}
.vl-link[data-v-97867cb6], .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6], .vl-sidebar-header__toggle[data-v-97867cb6] {
  display: inline-block;
  cursor: pointer;
  font-weight: inherit;
  text-align: left;
  font-family: inherit;
  font-size: inherit;
  color: var(--vl-theme-action-color, #05c);
  position: relative;
  word-break: break-word;
  line-height: inherit;
}
.vl-link[data-v-97867cb6]:hover, .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6]:hover, .vl-sidebar-header__toggle[data-v-97867cb6]:hover, .vl-link[data-v-97867cb6]:focus, .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6]:focus, .vl-sidebar-header__toggle[data-v-97867cb6]:focus, .vl-link[data-v-97867cb6]:active, .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6]:active, .vl-sidebar-header__toggle[data-v-97867cb6]:active {
  color: var(--vl-theme-action-hover-color, #003bb0);
  text-decoration: none;
}
.vl-link[data-v-97867cb6]:focus, .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6]:focus, .vl-sidebar-header__toggle[data-v-97867cb6]:focus, .vl-link[data-v-97867cb6]:active, .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6]:active, .vl-sidebar-header__toggle[data-v-97867cb6]:active {
  color: var(--vl-theme-action-active-color, rgb(0%, 25%, 60%));
}
.vl-link[data-v-97867cb6]:visited, .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6]:visited, .vl-sidebar-header__toggle[data-v-97867cb6]:visited {
  color: #660599;
}
.vl-link:visited .vl-link__icon[data-v-97867cb6], .vl-sidebar-panel-list-item__button .vl-icon:visited .vl-link__icon[data-v-97867cb6], .vl-sidebar-header__toggle:visited .vl-link__icon[data-v-97867cb6] {
  color: #660599;
}
.vl-link--bold[data-v-97867cb6] {
  font-weight: 500;
  text-decoration: none;
}
.vl-link--bold[data-v-97867cb6]:hover, .vl-link--bold[data-v-97867cb6]:focus, .vl-link--bold[data-v-97867cb6]:active {
  text-decoration: underline;
}
.vl-link--small[data-v-97867cb6] {
  font-size: 1.6rem;
}
@media screen and (max-width: 767px) {
.vl-link--small[data-v-97867cb6] {
    font-size: 1.5rem;
}
}
.vl-link--large[data-v-97867cb6] {
  font-size: 2rem;
}
@media screen and (max-width: 767px) {
.vl-link--large[data-v-97867cb6] {
    font-size: 1.8rem;
}
}
.vl-link--block[data-v-97867cb6] {
  display: block;
}
.vl-link--inline[data-v-97867cb6] {
  display: inline;
}
.vl-link--flex[data-v-97867cb6] {
  display: flex;
  align-items: center;
}
.vl-link--error[data-v-97867cb6] {
  color: #d2373c;
}
.vl-link--error[data-v-97867cb6]:hover, .vl-link--error[data-v-97867cb6]:focus, .vl-link--error[data-v-97867cb6]:active, .vl-link--error[data-v-97867cb6]:visited {
  color: #aa2729;
}
.vl-link__icon[data-v-97867cb6] {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  line-height: 1;
  margin-top: -0.1em;
  flex-shrink: 0;
}
.vl-link__icon[data-v-97867cb6]::before, .vl-link__icon[data-v-97867cb6]::after {
  display: inline-block;
}
.vl-link__icon--before[data-v-97867cb6] {
  padding-right: 0.4rem;
}
.vl-link__icon--after[data-v-97867cb6] {
  padding-left: 0.4rem;
}
.vl-link__icon--standalone[data-v-97867cb6] {
  padding: 0;
  float: none;
  position: relative;
}
.vl-link__icon--light[data-v-97867cb6] {
  color: #687483;
}
.vl-link__icon--borderless[data-v-97867cb6] {
  overflow: visible;
}
.vl-link__icon--borderless[data-v-97867cb6]::after {
  position: absolute;
  display: block;
  height: 0.1rem;
  left: 0;
  width: 100%;
  bottom: 0;
  margin-bottom: -0.3rem;
  background-color: #fff;
  content: "";
}
.vl-link__icon.vl-vi-external[data-v-97867cb6] {
  font-size: 1em;
}
.vl-loader[data-v-97867cb6] {
  display: inline-block;
  position: relative;
  width: 3rem;
  height: 1.8rem;
}
.vl-loader[data-v-97867cb6]::before {
  animation: loader-wave-97867cb6 infinite 1s linear;
}
@keyframes loader-wave-97867cb6 {
0% {
    box-shadow: 10px -0px #687483, 20px -0px #687483, 30px 0px #687483;
}
10% {
    box-shadow: 10px -3px #687483, 20px -0px #687483, 30px -0px #687483;
}
20% {
    box-shadow: 10px -6px #687483, 20px -3px #687483, 30px -0px #687483;
}
30% {
    box-shadow: 10px -3px #687483, 20px -6px #687483, 30px -3px #687483;
}
40% {
    box-shadow: 10px -0px #687483, 20px -3px #687483, 30px -6px #687483;
}
50% {
    box-shadow: 10px -0px #687483, 20px -0px #687483, 30px -3px #687483;
}
60% {
    box-shadow: 10px -0px #687483, 20px -0px #687483, 30px -0px #687483;
}
100% {
    box-shadow: 10px -0px #687483, 20px -0px #687483, 30px -0px #687483;
}
}
.vl-loader[data-v-97867cb6]::before {
  position: absolute;
  display: block;
  content: "";
  width: 0.4rem;
  height: 0.4rem;
  box-shadow: 1rem 0 #687483, 2rem 0 #687483, 3rem 0 #687483;
  border-radius: 50%;
  margin-top: -0.2rem;
  margin-left: -2.2rem;
  top: 50%;
  left: 50%;
}
.vl-loader--light[data-v-97867cb6]::before {
  animation: loader-light-wave-97867cb6 infinite 1s linear;
}
@keyframes loader-light-wave-97867cb6 {
0% {
    box-shadow: 10px -0px #fff, 20px -0px #fff, 30px 0px #fff;
}
10% {
    box-shadow: 10px -3px #fff, 20px -0px #fff, 30px -0px #fff;
}
20% {
    box-shadow: 10px -6px #fff, 20px -3px #fff, 30px -0px #fff;
}
30% {
    box-shadow: 10px -3px #fff, 20px -6px #fff, 30px -3px #fff;
}
40% {
    box-shadow: 10px -0px #fff, 20px -3px #fff, 30px -6px #fff;
}
50% {
    box-shadow: 10px -0px #fff, 20px -0px #fff, 30px -3px #fff;
}
60% {
    box-shadow: 10px -0px #fff, 20px -0px #fff, 30px -0px #fff;
}
100% {
    box-shadow: 10px -0px #fff, 20px -0px #fff, 30px -0px #fff;
}
}
.vl-loader--small[data-v-97867cb6]::before {
  width: 0.3rem;
  height: 0.3rem;
}
.vl-loader + p[data-v-97867cb6] {
  font-style: 1.6rem;
}
.vl-loader-alert--inline[data-v-97867cb6] {
  display: inline-flex;
  vertical-align: middle;
}
.vl-loader-alert .vl-loader[data-v-97867cb6]::before {
  margin-top: 0;
}
.vl-modal .backdrop[data-v-97867cb6],
.vl-modal .vl-modal__backdrop[data-v-97867cb6] {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10008;
  background-color: rgba(232, 235, 238, 0.95);
  opacity: 0.95;
}
.vl-modal .vl-modal-dialog__title[data-v-97867cb6] {
  font-size: 2.6rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 2rem;
  line-height: 1.3;
}
@media screen and (max-width: 767px) {
.vl-modal .vl-modal-dialog__title[data-v-97867cb6] {
    font-size: 2.2rem;
    margin-bottom: 1.5rem;
}
}
.vl-modal .vl-modal-dialog__title[data-v-97867cb6] {
  font-family: "Flanders Art Serif", serif;
  margin-bottom: 1.5rem;
}
.vl-modal-backdrop[data-v-97867cb6] {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10008;
  background-color: rgba(232, 235, 238, 0.95);
  opacity: 0.95;
}
.vl-modal-backdrop--hidden[data-v-97867cb6] {
  display: none;
}
.vl-modal-dialog[data-v-97867cb6] {
  display: none;
  position: fixed;
  width: 60rem;
  max-width: 95vw;
  max-height: 85vh;
  top: 50%;
  left: 50%;
  margin: 0;
  padding: 0;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border: 0;
  box-shadow: 0 0 2.1rem 0 rgba(0, 0, 0, 0.3);
  z-index: 10010;
}
.vl-modal-dialog[data-v-97867cb6]::backdrop {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10008;
  background-color: rgba(232, 235, 238, 0.95);
  opacity: 0.95;
}
.vl-modal-dialog[open][data-v-97867cb6], .vl-modal-dialog.vl-modal-dialog--opened[data-v-97867cb6] {
  display: flex;
  flex-direction: column;
}
.vl-modal-dialog[open][data-v-97867cb6]:focus, .vl-modal-dialog.vl-modal-dialog--opened[data-v-97867cb6]:focus {
  outline: auto #ffc515 3px;
}
@media screen and (max-width: 767px) {
.vl-modal-dialog[data-v-97867cb6] {
    left: 0;
    right: 0;
    top: initial;
    transform: initial;
    max-width: initial;
    width: 100vw;
    bottom: 0;
}
}
.vl-modal-dialog--static[data-v-97867cb6] {
  position: static;
  transform: none;
}
.vl-modal-dialog--medium[data-v-97867cb6] {
  width: 80rem;
}
.vl-modal-dialog--large[data-v-97867cb6] {
  width: 100rem;
}
.vl-modal-dialog--right[data-v-97867cb6], .vl-modal-dialog--left[data-v-97867cb6] {
  left: initial;
  right: initial;
  top: 0;
  transform: initial;
  max-height: initial;
  height: 100vh;
}
@media screen and (max-width: 767px) {
.vl-modal-dialog--right[data-v-97867cb6], .vl-modal-dialog--left[data-v-97867cb6] {
    left: 0;
    right: 0;
    top: initial;
    transform: initial;
    max-width: initial;
    width: 100vw;
    height: auto;
    bottom: 0;
}
}
@media screen and (max-width: 767px) {
.vl-modal-dialog--right.vl-modal-dialog--mobile-left[data-v-97867cb6], .vl-modal-dialog--right.vl-modal-dialog--mobile-right[data-v-97867cb6], .vl-modal-dialog--left.vl-modal-dialog--mobile-left[data-v-97867cb6], .vl-modal-dialog--left.vl-modal-dialog--mobile-right[data-v-97867cb6] {
    height: 100vh;
}
}
.vl-modal-dialog--bottom[data-v-97867cb6], .vl-modal-dialog--top[data-v-97867cb6] {
  left: 0;
  right: 0;
  top: initial;
  transform: initial;
  max-width: initial;
  width: 100vw;
}
.vl-modal-dialog--right[data-v-97867cb6] {
  right: 0;
}
.vl-modal-dialog--left[data-v-97867cb6] {
  left: 0;
}
.vl-modal-dialog--bottom[data-v-97867cb6] {
  bottom: 0;
}
.vl-modal-dialog--top[data-v-97867cb6] {
  top: 0;
}
@media screen and (max-width: 767px) {
.vl-modal-dialog--top[data-v-97867cb6]:not(.vl-modal-dialog--mobile-top) {
    top: initial;
}
}
.vl-modal-dialog__header[data-v-97867cb6] {
  margin-bottom: 2rem;
}
@media screen and (max-width: 767px) {
.vl-modal-dialog__header[data-v-97867cb6] {
    margin-bottom: 1.5rem;
}
}
.vl-modal-dialog__footer[data-v-97867cb6] {
  margin-top: 3rem;
}
@media screen and (max-width: 767px) {
.vl-modal-dialog__footer[data-v-97867cb6] {
    margin-top: 1.5rem;
}
}
.modal-fade-leave-active[data-v-97867cb6],
.modal-fade-enter-active[data-v-97867cb6] {
  transition: opacity 0.3s ease-in-out;
}
@media screen and (max-width: 767px) {
.modal-fade-leave-active[data-v-97867cb6],
  .modal-fade-enter-active[data-v-97867cb6] {
    transition: transform 0.3s ease-in-out;
}
}
.modal-fade-enter[data-v-97867cb6] {
  opacity: 0;
}
@media screen and (max-width: 767px) {
.modal-fade-enter[data-v-97867cb6] {
    opacity: 1;
    transform: translate(0, 100%);
}
}
.modal-fade-leave-to[data-v-97867cb6] {
  opacity: 0;
}
@media screen and (max-width: 767px) {
.modal-fade-leave-to[data-v-97867cb6] {
    opacity: 1;
    transform: translate(0, 100%);
}
}
.modal-slide-from-right-leave-active[data-v-97867cb6],
.modal-slide-from-right-enter-active[data-v-97867cb6],
.modal-slide-from-left-leave-active[data-v-97867cb6],
.modal-slide-from-left-enter-active[data-v-97867cb6],
.modal-slide-from-top-leave-active[data-v-97867cb6],
.modal-slide-from-top-enter-active[data-v-97867cb6],
.modal-slide-from-bottom-leave-active[data-v-97867cb6],
.modal-slide-from-bottom-enter-active[data-v-97867cb6] {
  transition: transform 0.3s ease-in-out;
}
.modal-slide-from-right-enter[data-v-97867cb6],
.modal-slide-from-right-leave-to[data-v-97867cb6] {
  transform: translate(100%, 0);
}
@media screen and (max-width: 767px) {
.modal-slide-from-right-enter[data-v-97867cb6]:not(.vl-modal-dialog--mobile-right),
  .modal-slide-from-right-leave-to[data-v-97867cb6]:not(.vl-modal-dialog--mobile-right) {
    transform: translate(0, 100%);
}
}
.modal-slide-from-left-enter[data-v-97867cb6],
.modal-slide-from-left-leave-to[data-v-97867cb6] {
  transform: translate(-100%, 0);
}
@media screen and (max-width: 767px) {
.modal-slide-from-left-enter[data-v-97867cb6]:not(.vl-modal-dialog--mobile-left),
  .modal-slide-from-left-leave-to[data-v-97867cb6]:not(.vl-modal-dialog--mobile-left) {
    transform: translate(0, 100%);
}
}
.modal-slide-from-top-enter[data-v-97867cb6],
.modal-slide-from-top-leave-to[data-v-97867cb6] {
  transform: translate(0, -100%);
}
@media screen and (max-width: 767px) {
.modal-slide-from-top-enter[data-v-97867cb6]:not(.vl-modal-dialog--mobile-top),
  .modal-slide-from-top-leave-to[data-v-97867cb6]:not(.vl-modal-dialog--mobile-top) {
    transform: translate(0, 100%);
}
}
.modal-slide-from-bottom-enter[data-v-97867cb6],
.modal-slide-from-bottom-leave-to[data-v-97867cb6] {
  transform: translate(0, 100%);
}
.vl-modal-dialog__wrapper[data-v-97867cb6] {
  overflow: auto;
  padding: 3rem;
}
@media screen and (max-width: 767px) {
.vl-modal-dialog__wrapper[data-v-97867cb6] {
    padding: 1.5rem;
}
}
.vl-modal-dialog--mobile-left .vl-modal-dialog__mobile-close[data-v-97867cb6],
.vl-modal-dialog--mobile-right .vl-modal-dialog__mobile-close[data-v-97867cb6],
.vl-modal-dialog--mobile-top .vl-modal-dialog__mobile-close[data-v-97867cb6] {
  display: none;
}
@media screen and (max-width: 767px) {
.vl-modal-dialog--mobile-left .vl-modal-dialog__close[data-v-97867cb6],
  .vl-modal-dialog--mobile-right .vl-modal-dialog__close[data-v-97867cb6],
  .vl-modal-dialog--mobile-top .vl-modal-dialog__close[data-v-97867cb6] {
    display: block;
}
}
.vl-modal-dialog__close[data-v-97867cb6] {
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0.6rem;
  right: 0.6rem;
  padding: 1rem;
  border: 0;
  background: none;
  line-height: 1;
  overflow: hidden;
  color: var(--vl-theme-action-color, #05c);
}
.vl-modal-dialog__close:hover .vl-modal-dialog__close__icon[data-v-97867cb6], .vl-modal-dialog__close:focus .vl-modal-dialog__close__icon[data-v-97867cb6] {
  color: var(--vl-theme-action-color, #05c);
}
@media screen and (max-width: 767px) {
.vl-modal-dialog__close[data-v-97867cb6] {
    display: none;
}
}
.vl-modal-dialog__close__icon[data-v-97867cb6]::before, .vl-modal-dialog__close__icon[data-v-97867cb6]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-modal-dialog__close__icon[data-v-97867cb6]::before {
  content: "\\f160";
}
.vl-modal-dialog__close__icon[data-v-97867cb6] {
  display: flex;
  font-size: 1.4rem;
  line-height: 1;
}
.vl-modal-dialog__close__icon[data-v-97867cb6]::before {
  font-weight: bold;
}
.vl-modal-dialog__mobile-close[data-v-97867cb6] {
  display: none;
  position: absolute;
  right: 0.5rem;
  top: 0;
  font-size: 1.4rem;
}
@media screen and (max-width: 767px) {
.vl-modal-dialog__mobile-close[data-v-97867cb6] {
    display: inline-flex;
    top: -4.5rem;
}
}
.vl-modal-dialog__footer .vl-action-group[data-v-97867cb6] {
  margin-top: 1.5rem;
}
.vl-pill[data-v-97867cb6] {
  display: inline-flex;
  max-width: 100%;
  align-items: center;
  background-color: #fff;
  font-size: 1.4rem;
  font-weight: 500;
  color: #687483;
  text-decoration: none;
  vertical-align: middle;
  border-radius: 0.3rem;
  border: 0.1rem solid #8695a8;
  transition: color 0.2s, background-color 0.2s, box-shadow 0.2s;
  padding: 0 1.4rem;
  line-height: calc(2.4rem - 0.2rem);
  min-width: 0;
}
.vl-pill__text[data-v-97867cb6] {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}
.vl-pill__close[data-v-97867cb6] {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #05c;
  width: 2.4rem;
  height: 2.4rem;
  border: 0.1rem solid #8695a8;
  text-decoration: none;
  margin-left: 1.4rem;
  padding: 0;
  border-radius: 0 0.3rem 0.3rem 0;
  transition: color 0.2s, background-color 0.2s, box-shadow 0.2s;
  margin-top: -0.1rem;
  margin-right: -0.1rem;
  margin-bottom: -0.1rem;
  min-width: 2.4rem;
}
.vl-pill__close[data-v-97867cb6]:hover:not([disabled]) {
  color: #003bb0;
  box-shadow: inset 0 0 0 0.1rem #05c;
  border: #05c 0.1rem solid;
  background-color: rgb(90%, 93.3333333333%, 98%);
}
.vl-pill__close[data-v-97867cb6]:focus {
  outline: transparent solid 0.2rem;
  border: #05c 0.1rem solid;
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65), inset 0 0 0 0.1rem #05c;
}
[dir=rtl] .vl-pill__close[data-v-97867cb6] {
  border-left: 0;
  border-right: #8695a8 0.1rem solid;
}
.is-disabled .vl-pill__close[data-v-97867cb6], .vl-pill__close[disabled][data-v-97867cb6] {
  color: #687483;
  cursor: default;
}
.vl-pill__close__icon[data-v-97867cb6]::before, .vl-pill__close__icon[data-v-97867cb6]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-pill__close__icon[data-v-97867cb6]::before {
  content: "\\f160";
}
.vl-pill__close__icon[data-v-97867cb6] {
  line-height: 0;
}
.vl-pill__close__icon[data-v-97867cb6]::before {
  display: inline-block;
  font-size: 0.8rem;
  text-indent: 0;
  line-height: 1;
  font-weight: bold;
}
.vl-pill--success[data-v-97867cb6] {
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
  border-color: #009e47;
  color: #007a37;
}
.vl-pill--warning[data-v-97867cb6] {
  background-color: rgb(100%, 96.3137254902%, 90.3921568627%);
  border-color: #ffA10a;
  color: #9f5804;
}
.vl-pill--error[data-v-97867cb6] {
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
  border-color: #d2373c;
  color: #aa2729;
}
.vl-pill--disabled[data-v-97867cb6]:not(.vl-pill--checkable):not(.vl-pill--closable) {
  background-color: #cbd2d9;
}
.vl-pill--closable[data-v-97867cb6] {
  padding-right: 0;
}
.vl-pill--closable.vl-pill--disabled .vl-pill__close[data-v-97867cb6] {
  background-color: #cbd2d9;
}
.vl-pill--clickable[data-v-97867cb6]:not(.vl-pill--disabled) {
  color: #05c;
}
.vl-pill--clickable[data-v-97867cb6]:not(.vl-pill--disabled):hover {
  background-color: rgb(90%, 93.3333333333%, 98%);
  color: #003bb0;
  border-color: #05c;
  box-shadow: inset 0 0 0 0.1rem #05c;
}
.vl-pill--clickable[data-v-97867cb6]:not(.vl-pill--disabled):focus {
  outline: transparent solid 0.2rem;
  border-color: #05c;
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65), inset 0 0 0 0.1rem #05c;
}
.vl-pill--checkable[data-v-97867cb6] {
  position: relative;
  padding-left: 3.6rem;
  margin-bottom: 0.3rem;
}
.vl-pill--checkable[data-v-97867cb6]:not(.vl-pill--disabled) {
  cursor: pointer;
  color: #05c;
}
.vl-pill--checkable[data-v-97867cb6]:not(.vl-pill--disabled):hover {
  box-shadow: inset 0 0 0 0.1rem #05c;
  border: #05c 0.1rem solid;
  background-color: rgb(90%, 93.3333333333%, 98%);
}
.vl-pill--checkable__checkbox[data-v-97867cb6] {
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  width: 0.1rem;
  height: 0.1rem;
  padding: 0;
  margin: -0.1rem;
}
.vl-pill--checkable__checkbox[disabled] + span[data-v-97867cb6] {
  background-color: #cbd2d9;
  color: #687483;
}
.vl-pill--checkable__checkbox:not([disabled]):focus + span[data-v-97867cb6] {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65), inset 0 0 0 0.1rem #05c;
  border: #05c 0.1rem solid;
}
.vl-pill--checkable__checkbox:not([disabled]):active + span[data-v-97867cb6] {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65), inset 0 0 0 0.1rem #05c;
  border: #05c 0.1rem solid;
}
.vl-pill--checkable__checkbox:not([disabled]):checked + span[data-v-97867cb6] {
  background: #05c;
}
.vl-pill--checkable__checkbox:not([disabled]):checked + span[data-v-97867cb6]::before {
  transform: translateZ(0) translate(-50%, -50%) scale(1);
}
.vl-pill--checkable__checkbox + span[data-v-97867cb6]::before, .vl-pill--checkable__checkbox + span[data-v-97867cb6]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-pill--checkable__checkbox + span[data-v-97867cb6]::before {
  content: "\\f15a";
}
.vl-pill--checkable__checkbox + span[data-v-97867cb6] {
  position: absolute;
  display: inline-block;
  background: #fff;
  width: 2.4rem;
  height: 2.4rem;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
  transition: background-color 0.2s, box-shadow 0.2s;
  margin: 0 1.4rem 0 0;
  left: -0.1rem;
  top: -0.1rem;
  border: 0.1rem solid #8695a8;
}
.vl-pill--checkable__checkbox + span[data-v-97867cb6]::before {
  position: absolute;
  display: block;
  font-size: 0.8rem;
  color: #fff;
  line-height: 1;
  text-align: center;
  transition: all 0.3s cubic-bezier(1, 0.1, 0, 0.9) 0.1s, background-color 0.2, box-shadow 0.2s;
  transform: translateZ(0) translate(-50%, -50%) scale(0);
  top: 50%;
  left: 50%;
}
.vl-pill--checkable__checkbox[disabled] + span[data-v-97867cb6] {
  cursor: auto;
}
.vl-pill-input__inner[data-v-97867cb6] {
  display: inline-block;
  width: 100%;
  max-width: 100%;
  height: auto;
  min-height: 3.5rem;
  padding: 0 0.5rem;
  line-height: calc(3.5rem - 0.3rem);
  border: 1px solid #8695a8;
  border-radius: 0.3rem;
  color: #666;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.6rem;
  overflow: hidden;
  vertical-align: top;
}
.vl-pill-input__inner .vl-pill__input[data-v-97867cb6] {
  border: 0;
  outline: 0;
  background: transparent;
  max-width: 100%;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.6rem;
  transform: translateY(1px);
}
.vl-pill-input__inner .vl-pill__input.is-hidden[data-v-97867cb6] {
  display: none;
}
.is-disabled .vl-pill-input__inner[data-v-97867cb6] {
  background-color: #f3f5f6;
  border-color: #8695a8;
  pointer-events: none;
}
.is-focused .vl-pill-input__inner[data-v-97867cb6] {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.is-focused .vl-pill-input__inner[data-v-97867cb6] {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
[dir=rtl] .vl-pill-input__inner[data-v-97867cb6] {
  padding: 0 1rem 0 6rem;
}
.vl-pill-input__list[data-v-97867cb6] {
  line-height: 1;
}
.vl-pill-input__list--multiple[data-v-97867cb6] {
  display: inline;
}
.vl-pill-input__list--multiple .vl-pill[data-v-97867cb6] {
  vertical-align: middle;
  word-break: break-all;
  margin-right: 0.5rem;
}
.vl-pill-input__list--multiple .vl-pill[data-deletable][data-v-97867cb6] {
  padding-right: 0;
}
[dir=rtl] .vl-pill-input__list--multiple .vl-pill[data-deletable][data-v-97867cb6] {
  padding-right: 0.7rem;
  padding-left: 0;
}
[dir=rtl] .vl-pill-input__list--multiple .vl-pill[data-v-97867cb6] {
  margin: 0.3rem 0 0 0.5rem;
}
.vl-ol-map[data-v-97867cb6] {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 450px;
  overflow: hidden;
  display: flex;
  font-size: 1.6rem;
}
.vl-ol-map--boxed[data-v-97867cb6] {
  border: 1px #cbd2da solid;
}
.vl-ol-map__body[data-v-97867cb6] {
  display: flex;
  flex: 1;
  height: 100%;
  overflow: hidden;
  position: relative;
}
.vl-ol-map__content[data-v-97867cb6] {
  position: relative;
  width: 100%;
  flex: 1;
}
.vl-ol-map__map[data-v-97867cb6] {
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  background-color: #f7f9fc;
}
.vl-ol-map__view-tools[data-v-97867cb6], .vl-ol-map__action-tools[data-v-97867cb6], .vl-ol-map__search[data-v-97867cb6] {
  position: absolute;
  z-index: 10;
}
.vl-ol-map__view-tools[data-v-97867cb6] {
  right: 2.5rem;
  bottom: 2.5rem;
}
@media screen and (max-width: 500px) {
.vl-ol-map__view-tools[data-v-97867cb6] {
    right: 1rem;
    bottom: 1rem;
}
}
.vl-ol-map__action-tools[data-v-97867cb6] {
  top: 2.5rem;
  right: 2.5rem;
}
@media screen and (max-width: 500px) {
.vl-ol-map__action-tools[data-v-97867cb6] {
    top: 1rem;
    right: 1rem;
}
}
.vl-ol-map__info[data-v-97867cb6] {
  position: absolute;
  z-index: 10;
  bottom: 0;
  left: 0;
}
.vl-ol-map__search[data-v-97867cb6] {
  top: 2.5rem;
  left: 2.5rem;
}
@media screen and (max-width: 500px) {
.vl-ol-map__search[data-v-97867cb6] {
    top: 1rem;
    left: 1rem;
}
}
.vl-ol-map .vl-ol-map__toaster[data-v-97867cb6] {
  position: absolute;
  overflow: hidden;
  margin: 15px;
}
.vl-ol-map__base-layer[data-v-97867cb6] {
  position: absolute;
  bottom: 2.5rem;
  right: 7.7rem;
  z-index: 9;
}
@media screen and (max-width: 500px) {
.vl-ol-map__base-layer[data-v-97867cb6] {
    bottom: 1rem;
    right: 6.2rem;
}
}
@media print {
.vl-ol-map[data-v-97867cb6],
  .vl-ol-map canvas[data-v-97867cb6] {
    display: block !important;
}
}
.vl-ol-map-info[data-v-97867cb6] {
  display: flex;
  flex-wrap: wrap;
  padding: 2px 6px;
  background: rgba(255, 255, 255, 0.8);
  font-size: 13px;
  line-height: 1.2;
}
.vl-ol-map-info > *[data-v-97867cb6]:not(:last-child) {
  margin-right: 10px;
}
.vl-ol-map-search--offset[data-v-97867cb6] {
  margin-left: 3.5rem;
}
.vl-ol-map-loader--blocking[data-v-97867cb6] {
  display: flex;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(2px);
  z-index: 2;
  justify-content: center;
  align-items: center;
  text-align: center;
  z-index: 10800;
}
.vl-ol-map-loader--overlay[data-v-97867cb6] {
  display: flex;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(2px);
  z-index: 2;
  justify-content: center;
  align-items: center;
  text-align: center;
  pointer-events: none;
}
.vl-ol-map-tools-bar[data-v-97867cb6] {
  display: flex;
}
.vl-ol-map-tools-bar .vl-ol-map-tools-action-group[data-v-97867cb6]:not(:last-child) {
  margin-right: 15px;
}
.vl-ol-map-tools-bar--vertical[data-v-97867cb6] {
  display: flex;
  flex-direction: column;
}
.vl-ol-map-tools-bar--vertical .vl-ol-map-tools-action-group[data-v-97867cb6]:not(:last-child) {
  margin-right: 0;
  margin-bottom: 1.5rem;
}
.vl-ol-map-tools-action[data-v-97867cb6] {
  border-radius: 0;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  border: 0;
  background-color: transparent;
  padding: 0;
  display: block;
  width: 3.5rem;
  height: 3.5rem;
  background-color: #fff;
  border: 0;
  border-radius: 2px;
  font-size: 16px;
  line-height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.vl-ol-map-tools-action[data-v-97867cb6]:hover {
  background: #f7f9fc;
  color: #333332;
}
.vl-ol-map-tools-action--active[data-v-97867cb6] {
  background-color: #05c;
  color: #fff;
}
.vl-ol-map-tools-action--active[data-v-97867cb6]:hover {
  background: #003bb0;
  color: #fff;
}
.vl-ol-map-tools-action--disabled[data-v-97867cb6] {
  background-color: #cbd2d9;
  color: var(--vl-theme-fg-color-70);
}
.vl-ol-map-tools-action--disabled[data-v-97867cb6]:hover {
  background-color: #cbd2d9;
  color: var(--vl-theme-fg-color-70);
}
.vl-ol-map-tools-action[data-v-97867cb6] {
  box-shadow: 0px 2px 12px rgba(106, 118, 134, 0.35);
  border-radius: 0px 0.3rem 0.3rem 0px;
  color: #05c;
  background-color: #fff;
  border: none;
  box-shadow: none;
}
.vl-ol-map-tools-action[disabled][data-v-97867cb6] {
  cursor: not-allowed;
}
.vl-ol-map-tools-action[disabled] .vl-ol-map-tools-action__button[data-v-97867cb6] {
  cursor: not-allowed;
}
.vl-ol-map-tools-action--active[data-v-97867cb6] {
  background-color: #05c;
}
.vl-ol-map-tools-action--active .vl-ol-map-tools-action__svg-icon svg[data-v-97867cb6] {
  color: #fff;
  fill: #fff;
}
.vl-ol-map-tools-action--disabled .vl-ol-map-tools-action__svg-icon svg[data-v-97867cb6] {
  color: var(--vl-theme-fg-color-70);
  fill: var(--vl-theme-fg-color-70);
}
.vl-ol-map-tools-action[data-v-97867cb6]:focus {
  z-index: 1;
}
.vl-ol-map-tools-action__text[data-v-97867cb6] {
  position: absolute !important;
  top: 0;
  left: 0;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
}
.vl-ol-map-tools-action__svg-icon svg[data-v-97867cb6] {
  width: 14px;
  height: auto;
  color: #333332;
  fill: #333332;
}
@media screen and (max-width: 767px) {
.vl-ol-map .vl-sidebar__toggle[data-v-97867cb6] {
    transform: none;
    top: 1rem;
    left: calc(100% + 1rem);
}
}
.vl-ol-map-tools-action-group[data-v-97867cb6] {
  display: flex;
  background: #fff;
  border-radius: 2px;
  box-shadow: 0px 2px 12px rgba(106, 118, 134, 0.35);
}
.vl-ol-map-tools-action-group .vl-ol-map-tools-action[data-v-97867cb6] {
  border-radius: 0;
}
.vl-ol-map-tools-action-group--vertical[data-v-97867cb6] {
  flex-direction: column;
}
.vl-ol-map-base-layer[data-v-97867cb6] {
  display: flex;
  background: #fff;
  border-radius: 0.3rem;
  height: 7.2rem;
  overflow: hidden;
  min-width: 10.3rem;
  border: 1px #8695a8 solid;
  position: relative;
}
.vl-ol-map-base-layer--toggle[data-v-97867cb6] {
  min-width: 7.3rem;
}
.vl-ol-map-base-layer--toggle[data-v-97867cb6]:hover {
  background-color: #f7f9fc;
}
.vl-ol-map-base-layer-toggle[data-v-97867cb6] {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
  box-shadow: 0;
  display: inline-block;
  width: 6.55rem;
  flex: 0 0 6.55rem;
  margin: 0.3rem;
  background: #fff;
}
.vl-ol-map-base-layer--open .vl-ol-map-base-layer-toggle[data-v-97867cb6] {
  position: relative;
  right: 0;
}
.vl-ol-map-base-layer--open .vl-ol-map-base-layer-toggle[data-v-97867cb6]:hover {
  opacity: 0.8;
}
.vl-ol-map-base-layer-toggle__radio[data-v-97867cb6] {
  position: absolute !important;
  top: 0;
  left: 0;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
}
.vl-ol-map-base-layer-toggle__radio:checked + .vl-ol-map-base-layer-toggle__body[data-v-97867cb6] {
  z-index: 3;
}
.vl-ol-map-base-layer--toggle .vl-ol-map-base-layer-toggle__radio:checked + .vl-ol-map-base-layer-toggle__body[data-v-97867cb6] {
  z-index: 1;
}
.vl-ol-map-base-layer-toggle__body[data-v-97867cb6] {
  position: relative;
  height: 100%;
  z-index: 2;
  border-radius: 0.3rem;
  overflow: hidden;
}
.vl-ol-map-base-layer-toggle__body__label[data-v-97867cb6] {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  color: #333332;
  font-size: 12px;
  text-align: center;
  z-index: 2;
}
.vl-ol-map-base-layer-toggle__body__label[data-v-97867cb6]::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.9) 20%, rgba(255, 255, 255, 0) 100%);
  height: 40px;
}
.vl-ol-map-base-layer-toggle__body__label span[data-v-97867cb6] {
  display: block;
  position: relative;
  z-index: 2;
  padding: 0 2px;
  text-shadow: 0 1px 1px #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vl-ol-map-base-layer-toggle__body__image[data-v-97867cb6] {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.vl-ol-map-base-layer__more[data-v-97867cb6] {
  display: inline-flex;
  background: #fff;
  border: none;
  width: 3rem;
  margin-right: 0.3rem;
}
.vl-ol-map-base-layer__more[data-v-97867cb6]:hover {
  box-shadow: 0;
}
.vl-ol-map-base-layer__more[data-v-97867cb6]:focus {
  box-shadow: inset 0 0 0 2px rgba(0, 85, 204, 0.65);
}
.vl-ol-map-base-layer__more:hover .vl-ol-map-base-layer__more__icon[data-v-97867cb6] {
  color: #05c;
}
.vl-ol-map-base-layer__more__icon[data-v-97867cb6] {
  display: inline-flex;
  font-size: 1.8rem;
  transition: transform 0.2s ease-in-out;
  align-self: center;
}
.vl-ol-map-base-layer--open .vl-ol-map-base-layer__more__icon[data-v-97867cb6] {
  transform: rotate(180deg);
}

/* @import "~@govflanders/vl-ui-pattern/src/scss/pattern"; */
.vl-person-info[data-v-97867cb6] {
  display: block;
}
.vl-person-info__img[data-v-97867cb6] {
  position: relative;
  width: 14rem;
  height: 14rem;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
  margin-bottom: -7rem;
}
.vl-person-info__img img[data-v-97867cb6] {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.vl-person-info__content[data-v-97867cb6] {
  background-color: #f7f9fc;
  padding: 9rem 2rem 2rem;
}
.vl-person-info__data[data-v-97867cb6] {
  font-size: 1.6rem;
  line-height: 1.25;
}
@media screen and (max-width: 767px) {
.vl-person-info__data[data-v-97867cb6] {
    font-size: 1.6rem;
}
}
.vl-person-info__data .vl-person-info__value[data-v-97867cb6] {
  margin-bottom: 1.5rem;
  font-weight: 500;
}
.vl-person-info--quote .vl-quote[data-v-97867cb6] {
  overflow: visible;
}
.vl-person-info--quote .vl-quote__content[data-v-97867cb6] {
  overflow: visible;
}
.vl-person-info--quote .vl-quote__content[data-v-97867cb6]::before {
  position: absolute;
  transform: translateX(-100%);
  top: -8rem;
  left: 50%;
}
.vl-person-info--quote .vl-quote__text[data-v-97867cb6], .vl-person-info--quote .vl-quote__author[data-v-97867cb6], .vl-person-info--quote .vl-quote__reference[data-v-97867cb6] {
  margin-left: 0;
}
@keyframes slideIn-97867cb6 {
0% {
    display: none;
}
1% {
    display: block;
    opacity: 0;
}
100% {
    opacity: 1;
    transform: translateY(0%);
}
}
@keyframes slideOut-97867cb6 {
0% {
    transform: translateY(0%);
    opacity: 1;
    display: block;
}
99% {
    opacity: 0;
    transform: translateY(120%);
}
100% {
    display: none;
}
}
.vl-popover[data-v-97867cb6] {
  display: inline-block;
  position: relative;
}
.vl-popover .vl-popover__arrow[data-v-97867cb6] {
  display: none;
  position: absolute;
  right: 0.5rem;
  bottom: -1.4rem;
  border: 0.9rem solid transparent;
  border-bottom-color: #cfd5dd;
  border-top-width: 0;
  z-index: 99999;
}
.vl-popover .vl-popover__arrow[data-v-97867cb6]::before {
  content: "";
  position: absolute;
  border: 0.9rem solid transparent;
  border-bottom-color: #fff;
  border-top-width: 0;
  transform: translate(-50%, 1px);
}
@media screen and (max-width: 767px) {
.vl-popover .vl-popover__arrow[data-v-97867cb6] {
    display: none;
}
}
.vl-popover--static[data-v-97867cb6] {
  position: static;
}
.vl-popover--static .vl-popover__arrow[data-v-97867cb6] {
  position: relative;
}
.vl-popover--align-left .vl-popover__arrow[data-v-97867cb6] {
  left: 0.4rem;
  right: auto;
}
.vl-popover--align-center .vl-popover__arrow[data-v-97867cb6] {
  left: 50%;
  transform: translateX(-50%);
  right: auto;
  margin: auto;
}
.vl-popover--align-top .vl-popover__arrow[data-v-97867cb6] {
  top: -1.1rem;
  bottom: auto;
  transform: scale(-1);
}
.vl-popover .vl-popover__toggle[data-v-97867cb6] {
  border-radius: 0;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  border: 0;
  background-color: transparent;
  padding: 0;
  text-decoration: none;
  display: inline-block;
  font-size: 1.6rem;
  font-family: "Flanders Art Sans", sans-serif;
}
.vl-popover .vl-popover__toggle .vl-vi-arrow[data-v-97867cb6] {
  transition: cubic-bezier(1, 0.1, 0, 0.9) 0.2s transform;
}
.vl-popover .vl-popover__toggle .vl-popover__toggle-icon[data-v-97867cb6] {
  margin-left: 0.8rem;
}
.vl-popover .vl-popover__toggle .vl-badge[data-v-97867cb6] {
  margin-top: 0.5rem;
}
.vl-popover.js-vl-popover--open .vl-popover__arrow[data-v-97867cb6] {
  display: block;
}
@media screen and (max-width: 767px) {
.vl-popover.js-vl-popover--open .vl-popover__arrow[data-v-97867cb6] {
    display: none;
}
}
@media screen and (max-width: 767px) {
.vl-popover.js-vl-popover--open .vl-popover__content[data-v-97867cb6] {
    display: block;
    opacity: 0;
    animation: slideIn-97867cb6 0.5s cubic-bezier(1, 0.1, 0, 0.9);
    animation-fill-mode: forwards;
}
}
@media screen and (min-width: 767px) {
.vl-popover.js-vl-popover--open .vl-popover__content[data-v-97867cb6] {
    visibility: visible;
    opacity: 1;
}
}
.vl-popover.js-vl-popover--open .vl-vi-arrow[data-v-97867cb6] {
  transform: rotate(-180deg);
}
@media screen and (max-width: 767px) {
.vl-popover.js-vl-popover--closing .vl-popover__content[data-v-97867cb6] {
    will-change: transform;
    display: block;
    animation: slideOut-97867cb6 0.5s cubic-bezier(1, 0.1, 0, 0.9);
    animation-fill-mode: forwards;
}
}
.vl-popover--closable .vl-popover__close-btn[data-v-97867cb6] {
  display: inline-flex;
}
.vl-popover--closable .vl-popover__close-btn[data-v-97867cb6]:hover {
  color: #05c;
}
.vl-popover--closable .vl-popover__close-btn[data-v-97867cb6]:focus {
  color: rgb(0%, 25%, 60%);
}
@media screen and (min-width: 767px) {
.vl-popover--closable .vl-popover__close-btn[data-v-97867cb6] {
    padding: 1.5rem;
    right: 0;
    width: auto;
}
.vl-popover--closable .vl-popover__close-btn .vl-button__icon[data-v-97867cb6] {
    margin: 0;
}
}
.vl-popover__close-btn[data-v-97867cb6] {
  display: none;
  position: absolute;
  right: 0.5rem;
  top: 0;
  font-size: 1.4rem;
}
@media screen and (max-width: 767px) {
.vl-popover__close-btn[data-v-97867cb6] {
    display: inline-flex;
    top: -4.5rem;
}
}
.vl-backdrop[data-v-97867cb6] {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10008;
  background-color: rgba(232, 235, 238, 0.95);
  opacity: 0.95;
  opacity: 0;
  z-index: -1;
  transition: cubic-bezier(1, 0.1, 0, 0.9) 0.4s opacity, cubic-bezier(1, 0.1, 0, 0.9) 0.4s z-index;
  will-change: opacity;
}
@media screen and (max-width: 767px) {
.vl-backdrop--active[data-v-97867cb6] {
    opacity: 1;
    z-index: 10008;
}
}
.vl-popover__content-overflow[data-v-97867cb6] {
  max-height: 30rem;
  overflow-y: auto;
  padding: 2rem;
}
@media screen and (max-width: 767px) {
.vl-popover__content-overflow[data-v-97867cb6] {
    max-height: 65vh;
}
}
@media screen and (min-width: 767px) {
.vl-popover--closable .vl-popover__content-overflow[data-v-97867cb6] {
    padding-right: 5rem;
}
}
.vl-popover__content[data-v-97867cb6] {
  background-color: #fff;
  box-shadow: 0 0 2.1rem 0 rgba(0, 0, 0, 0.1);
  width: 23rem;
  min-width: 23rem;
  max-width: 90vw;
  z-index: 10003;
  border: 0.1rem solid #cfd5dd;
}
@media screen and (max-width: 767px) {
.vl-popover__content[data-v-97867cb6] {
    width: 100%;
    max-width: 100%;
    margin: 0;
    position: fixed;
    bottom: 0;
    left: 0;
    top: auto;
    display: none;
    z-index: 10009;
    transform: translateY(120%);
}
}
@media screen and (min-width: 767px) {
.vl-popover__content[data-v-97867cb6] {
    visibility: hidden;
    opacity: 0;
    margin: 0;
    margin-top: 0.3rem;
}
}
@media screen and (min-width: 767px) {
.vl-popover--large .vl-popover__content[data-v-97867cb6] {
    width: 45rem;
}
}
.vl-popover .vl-link-list[data-v-97867cb6],
.vl-popover__link-list[data-v-97867cb6] {
  padding: 0;
}
.vl-popover .vl-link-list li[data-v-97867cb6],
.vl-popover .vl-link-list .vl-link-list__item[data-v-97867cb6],
.vl-popover__link-list li[data-v-97867cb6],
.vl-popover__link-list .vl-link-list__item[data-v-97867cb6] {
  padding: 0.6rem 0;
}
.vl-popover .vl-link-list li[data-v-97867cb6]:first-child,
.vl-popover .vl-link-list .vl-link-list__item[data-v-97867cb6]:first-child,
.vl-popover__link-list li[data-v-97867cb6]:first-child,
.vl-popover__link-list .vl-link-list__item[data-v-97867cb6]:first-child {
  padding-top: 0;
}
.vl-popover--closable .vl-popover .vl-link-list li[data-v-97867cb6]:first-child,
.vl-popover--closable .vl-popover .vl-link-list .vl-link-list__item[data-v-97867cb6]:first-child,
.vl-popover--closable .vl-popover__link-list li[data-v-97867cb6]:first-child,
.vl-popover--closable .vl-popover__link-list .vl-link-list__item[data-v-97867cb6]:first-child {
  max-width: calc(100% - 4.5rem);
}
.vl-popover .vl-link-list li[data-v-97867cb6]:last-of-type,
.vl-popover .vl-link-list .vl-link-list__item[data-v-97867cb6]:last-of-type,
.vl-popover__link-list li[data-v-97867cb6]:last-of-type,
.vl-popover__link-list .vl-link-list__item[data-v-97867cb6]:last-of-type {
  padding-bottom: 0;
  margin-bottom: 0;
}
.vl-popover .vl-link-list li.vl-popover__link-list__separator[data-v-97867cb6],
.vl-popover .vl-link-list .vl-link-list__item.vl-popover__link-list__separator[data-v-97867cb6],
.vl-popover__link-list li.vl-popover__link-list__separator[data-v-97867cb6],
.vl-popover__link-list .vl-link-list__item.vl-popover__link-list__separator[data-v-97867cb6] {
  height: 0.1rem;
  background: #cfd5dd;
  padding: 0;
  margin: 0.5rem 0;
}
.vl-popover .vl-link-list--bordered .vl-popover .vl-link-list__item:not(:last-of-type) .vl-link[data-v-97867cb6], .vl-popover .vl-link-list--bordered .vl-popover .vl-link-list__item:not(:last-of-type) .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6], .vl-sidebar-panel-list-item__button .vl-popover .vl-link-list--bordered .vl-popover .vl-link-list__item:not(:last-of-type) .vl-icon[data-v-97867cb6], .vl-popover .vl-link-list--bordered .vl-popover .vl-link-list__item:not(:last-of-type) .vl-sidebar-header__toggle[data-v-97867cb6],
.vl-popover .vl-link-list--bordered .vl-popover__link-list__item:not(:last-of-type) .vl-link[data-v-97867cb6],
.vl-popover .vl-link-list--bordered .vl-popover__link-list__item:not(:last-of-type) .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6],
.vl-sidebar-panel-list-item__button .vl-popover .vl-link-list--bordered .vl-popover__link-list__item:not(:last-of-type) .vl-icon[data-v-97867cb6],
.vl-popover .vl-link-list--bordered .vl-popover__link-list__item:not(:last-of-type) .vl-sidebar-header__toggle[data-v-97867cb6],
.vl-popover__link-list--bordered .vl-popover .vl-link-list__item:not(:last-of-type) .vl-link[data-v-97867cb6],
.vl-popover__link-list--bordered .vl-popover .vl-link-list__item:not(:last-of-type) .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6],
.vl-sidebar-panel-list-item__button .vl-popover__link-list--bordered .vl-popover .vl-link-list__item:not(:last-of-type) .vl-icon[data-v-97867cb6],
.vl-popover__link-list--bordered .vl-popover .vl-link-list__item:not(:last-of-type) .vl-sidebar-header__toggle[data-v-97867cb6],
.vl-popover__link-list--bordered .vl-popover__link-list__item:not(:last-of-type) .vl-link[data-v-97867cb6],
.vl-popover__link-list--bordered .vl-popover__link-list__item:not(:last-of-type) .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6],
.vl-sidebar-panel-list-item__button .vl-popover__link-list--bordered .vl-popover__link-list__item:not(:last-of-type) .vl-icon[data-v-97867cb6],
.vl-popover__link-list--bordered .vl-popover__link-list__item:not(:last-of-type) .vl-sidebar-header__toggle[data-v-97867cb6] {
  position: relative;
}
.vl-radio[data-v-97867cb6] {
  position: relative;
  display: inline-block;
  margin-top: 0.2rem;
  margin-right: 5rem;
}
.vl-radio[data-v-97867cb6]:not(.vl-radio--block):not(:last-of-type) {
  margin-right: 1.5rem;
}
.vl-radio__label[data-v-97867cb6] {
  position: relative;
  padding: 0 0 0 2.4rem;
  line-height: 2.8rem;
  font-size: 1.6rem;
}
.vl-radio__label[data-v-97867cb6]::before, .vl-radio__label[data-v-97867cb6]::after {
  position: absolute;
  display: block;
  content: "";
  cursor: pointer;
  border-radius: 100%;
}
.vl-radio__label[data-v-97867cb6]::before {
  background-color: #fff;
  height: 6px;
  width: 6px;
  top: 10px;
  left: 6px;
  transform: scale(0);
  transition: border-color 0.2s cubic-bezier(1, 0.1, 0, 0.9);
  z-index: 2;
}
@media screen and (max-width: 767px) {
.vl-radio__label[data-v-97867cb6]::before {
    font-size: 1.6rem;
}
}
.vl-radio__label[data-v-97867cb6]::after {
  background-color: #fff;
  width: 18px;
  height: 18px;
  top: 4px;
  left: 0;
  border: 0.1rem solid #8695a8;
  text-indent: 100%;
  overflow: hidden;
  white-space: nowrap;
  transition: border-color 0.2s cubic-bezier(1, 0.1, 0, 0.9), box-shadow 0.1s cubic-bezier(1, 0.1, 0, 0.9);
  z-index: 1;
}
.vl-radio__toggle[data-v-97867cb6] {
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  width: 0.1rem;
  height: 0.1rem;
  padding: 0;
  margin: -0.1rem;
}
.vl-radio__toggle:focus + .vl-radio__label[data-v-97867cb6]::after {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.vl-radio__toggle:focus + .vl-radio__label[data-v-97867cb6]::after {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
.vl-radio__toggle:checked + .vl-radio__label[data-v-97867cb6]::before {
  transform: scale(1);
  background-color: #fff;
}
.vl-radio__toggle:checked + .vl-radio__label[data-v-97867cb6]::after {
  background: #05c;
  border: 0;
}
.vl-radio--block[data-v-97867cb6] {
  display: block;
  margin: 0;
}
.vl-radio--disabled .vl-radio__label[data-v-97867cb6] {
  color: #687483;
}
.vl-radio--disabled .vl-radio__label[data-v-97867cb6]::after {
  background-color: #8695a8;
  border-color: #8695a8;
}
.vl-radio--disabled .vl-radio__toggle:checked + .vl-radio__label[data-v-97867cb6]::before {
  background-color: #fff;
}
.vl-radio--disabled .vl-radio__toggle:checked + .vl-radio__label[data-v-97867cb6]::after {
  background: #8695a8;
  border: 0.1rem #8695a8 solid;
}
.vl-radio--single[data-v-97867cb6] {
  margin: 0;
}
.vl-radio--single .vl-radio__label[data-v-97867cb6] {
  padding: 0;
}
.vl-radio--single .vl-radio__label[data-v-97867cb6]::after {
  position: relative;
}
.vl-radio--error .vl-radio__label[data-v-97867cb6]::after, .vl-radio.invalid.validated .vl-radio__label[data-v-97867cb6]::after {
  background-color: #fff;
  border-color: #d2373c;
}
.vl-radio--error .vl-radio__toggle:checked + .vl-radio__label[data-v-97867cb6]::before, .vl-radio.invalid.validated .vl-radio__toggle:checked + .vl-radio__label[data-v-97867cb6]::before {
  background-color: #d2373c;
}
.vl-radio--error .vl-radio__toggle:checked + .vl-radio__label[data-v-97867cb6]::after, .vl-radio.invalid.validated .vl-radio__toggle:checked + .vl-radio__label[data-v-97867cb6]::after {
  background-color: #fff;
  border: 0.1rem #d2373c solid;
}
.vl-radio--success .vl-radio__label[data-v-97867cb6]::after {
  background-color: #fff;
  border-color: #009e47;
}
.vl-radio--success .vl-radio__toggle:checked + .vl-radio__label[data-v-97867cb6]::before {
  background-color: #009e47;
}
.vl-radio--success .vl-radio__toggle:checked + .vl-radio__label[data-v-97867cb6]::after {
  background-color: #fff;
  border: 0.1rem #009e47 solid;
}
.vl-radio-tile__label[data-v-97867cb6] {
  display: block;
  position: relative;
  padding: 1.5rem;
  border: 1px solid #cbd2da;
  border-width: 1px 1px 1px 30px;
  background-color: #fff;
  font-size: 1.6rem;
  border-radius: 0.3rem;
}
.vl-radio-tile__label[data-v-97867cb6]::after {
  display: block;
  position: absolute;
  top: 2rem;
  left: -2.2rem;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  background-color: #fff;
  color: #05c;
  content: "";
  z-index: 1;
}
.vl-radio-tile__input[data-v-97867cb6] {
  position: absolute !important;
  top: 0;
  left: 0;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
}
.vl-radio-tile__input:not(:disabled) + .vl-radio-tile__label[data-v-97867cb6] {
  cursor: pointer;
}
.vl-radio-tile__input:not(:disabled) + .vl-radio-tile__label[data-v-97867cb6]:hover, .vl-radio-tile__input:not(:disabled) + .vl-radio-tile__label[data-v-97867cb6]:focus {
  padding: 1.4rem 1.4rem 1.4rem 1.5rem;
  border: 2px solid #003bb0;
  border-width: 2px 2px 2px 30px;
}
.vl-radio-tile__input:not(:disabled) + .vl-radio-tile__label[data-v-97867cb6]:hover::after, .vl-radio-tile__input:not(:disabled) + .vl-radio-tile__label[data-v-97867cb6]:focus::after {
  top: 1.9rem;
}
.vl-radio-tile__input:not(:disabled) + .vl-radio-tile__label[data-v-97867cb6]:hover::before, .vl-radio-tile__input:not(:disabled) + .vl-radio-tile__label[data-v-97867cb6]:focus::before {
  top: 2rem;
}
.vl-radio-tile__input:checked + .vl-radio-tile__label[data-v-97867cb6] {
  padding: 1.4rem 1.4rem 1.4rem 1.5rem;
  border: 2px solid #05c;
  border-width: 2px 2px 2px 30px;
}
.vl-radio-tile__input:checked + .vl-radio-tile__label[data-v-97867cb6]::after {
  border-color: #05c;
}
.vl-radio-tile__input:checked + .vl-radio-tile__label[data-v-97867cb6]::before {
  display: block;
  position: absolute;
  top: 2.1rem;
  left: -2.1rem;
  width: 1.3rem;
  height: 1.3rem;
  border: 4px solid #05c;
  border-radius: 50%;
  background-color: #fff;
  color: #05c;
  content: "";
  z-index: 2;
}
.vl-radio-tile__input:checked + .vl-radio-tile__label[data-v-97867cb6]:hover, .vl-radio-tile__input:checked + .vl-radio-tile__label[data-v-97867cb6]:focus {
  border-color: #003bb0;
}
.vl-radio-tile__input:checked + .vl-radio-tile__label[data-v-97867cb6]:hover::after, .vl-radio-tile__input:checked + .vl-radio-tile__label[data-v-97867cb6]:focus::after {
  top: 2rem;
}
.vl-radio-tile__input:checked + .vl-radio-tile__label[data-v-97867cb6]:hover::before, .vl-radio-tile__input:checked + .vl-radio-tile__label[data-v-97867cb6]:focus::before {
  top: 2.1rem;
}
.vl-radio-tile__input:focus + .vl-radio-tile__label[data-v-97867cb6] {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.vl-radio-tile__input:focus + .vl-radio-tile__label[data-v-97867cb6] {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
.vl-radio-tile__input[type=checkbox] + .vl-radio-tile__label[data-v-97867cb6]::before, .vl-radio-tile__input[type=checkbox] + .vl-radio-tile__label[data-v-97867cb6]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-radio-tile__input[type=checkbox] + .vl-radio-tile__label[data-v-97867cb6]::before {
  content: "\\f15a";
}
.vl-radio-tile__input[type=checkbox] + .vl-radio-tile__label[data-v-97867cb6]::after {
  border-radius: 0;
}
.vl-radio-tile__input[type=checkbox] + .vl-radio-tile__label[data-v-97867cb6]::before {
  display: none;
  border: 0;
  border-radius: 0;
  font-size: 1rem;
}
.vl-radio-tile__input[type=checkbox]:checked + .vl-radio-tile__label[data-v-97867cb6]::before, .vl-radio-tile__input[type=checkbox]:checked + .vl-radio-tile__label[data-v-97867cb6]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-radio-tile__input[type=checkbox]:checked + .vl-radio-tile__label[data-v-97867cb6]::before {
  content: "\\f15a";
}
.vl-radio-tile__input[type=checkbox]:checked + .vl-radio-tile__label[data-v-97867cb6]::before {
  display: block;
}
.vl-radio-tile__input:disabled + .vl-radio-tile__label[data-v-97867cb6] {
  background-color: #cbd2d9;
}
.vl-radio-tile__input:disabled + .vl-radio-tile__label .vl-checkbox-tile__title[data-v-97867cb6] {
  color: var(--vl-theme-fg-color-70);
}
.vl-radio-tile__title[data-v-97867cb6] {
  font-size: 2rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 1.6rem;
  line-height: 1.4;
}
@media screen and (max-width: 767px) {
.vl-radio-tile__title[data-v-97867cb6] {
    font-size: 1.8rem;
    margin-bottom: 1.2rem;
}
}
.vl-radio-tile__title[data-v-97867cb6] {
  display: block;
}
.vl-radio-tile__icon[data-v-97867cb6] {
  font-size: 2.8rem;
  line-height: 1;
}
.vl-radio-tile__image[data-v-97867cb6] {
  margin-top: 0.5rem;
}
.vl-radio-tile__info[data-v-97867cb6] {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  display: block;
  color: #687483;
}
.vl-radio-tile--error .vl-radio-tile__label[data-v-97867cb6] {
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
  border-color: #d2373c;
}
.vl-radio-tile--error .vl-radio-tile__input:checked + .vl-radio-tile__label[data-v-97867cb6] {
  border-color: #d2373c;
}
.vl-radio-tile--error .vl-radio-tile__input:checked + .vl-radio-tile__label[data-v-97867cb6]::before {
  color: #d2373c;
}
.vl-radio-tile--success .vl-radio-tile__label[data-v-97867cb6] {
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
  border-color: #009e47;
}
.vl-radio-tile--success .vl-radio-tile__input:checked + .vl-radio-tile__label[data-v-97867cb6] {
  border-color: #009e47;
}
.vl-radio-tile--success .vl-radio-tile__input:checked + .vl-radio-tile__label[data-v-97867cb6]::before {
  color: #009e47;
}
.vl-radio-tile--disabled .vl-radio-tile__label[data-v-97867cb6] {
  background-color: #f3f5f6;
  border-color: #8695a8;
}
.vl-radio-tile + .vl-radio-tile[data-v-97867cb6] {
  margin-top: 10px;
}
.vl-radio-tile--error .vl-radio-tile__input:checked + .vl-radio-tile__label[data-v-97867cb6]::before {
  background-color: #d2373c;
  border-color: #f3f5f6;
}
.vl-radio-tile--success .vl-radio-tile__input:checked + .vl-radio-tile__label[data-v-97867cb6]::before {
  background-color: #009e47;
  border-color: #f3f5f6;
}
.vl-search[data-v-97867cb6] {
  position: relative;
}
.vl-search .vl-search__reset[data-v-97867cb6] {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0px;
  z-index: 1;
  background: none;
  border: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 10px 11px;
  min-height: 2.5rem;
  width: 2.5rem;
}
.vl-search[data-v-97867cb6] {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2rem 1.5rem;
  background-color: #f7f9fc;
}
@media screen and (max-width: 767px) {
.vl-search[data-v-97867cb6] {
    display: block;
    padding: 1.5rem 1rem;
}
}
.vl-search .vl-search__label[data-v-97867cb6] {
  color: #687483;
  font-weight: 400;
  font-size: 1.6rem;
  line-height: 1;
}
@media screen and (max-width: 767px) {
.vl-search .vl-search__label[data-v-97867cb6] {
    font-size: 1.6rem;
}
}
.vl-search .vl-search__label[data-v-97867cb6] {
  white-space: nowrap;
}
.vl-search .vl-search__input-wrapper[data-v-97867cb6] {
  display: flex;
  width: 100%;
  align-items: center;
  position: relative;
}
@media screen and (max-width: 767px) {
.vl-search .vl-search__input-wrapper[data-v-97867cb6] {
    flex-direction: column;
    align-items: flex-start;
}
}
.vl-search .vl-search__input[data-v-97867cb6] {
  flex: 6;
  margin: 0 2rem;
}
@media screen and (max-width: 1023px) {
.vl-search .vl-search__input[data-v-97867cb6] {
    margin: 0 1rem;
    flex: 4;
}
}
@media screen and (max-width: 767px) {
.vl-search .vl-search__input[data-v-97867cb6] {
    margin: 0;
    width: 100%;
    margin-bottom: 1.5rem;
}
}
.vl-search .vl-search__reset[data-v-97867cb6] {
  right: 25px;
}
@media screen and (max-width: 1023px) {
.vl-search .vl-search__reset[data-v-97867cb6] {
    right: 15px;
}
}
@media screen and (max-width: 767px) {
.vl-search .vl-search__reset[data-v-97867cb6] {
    right: 5px;
    top: calc(50% - 0.75rem);
}
}
.vl-search.vl-search--alt[data-v-97867cb6] {
  background-color: transparent;
  padding: 0;
  background: none;
}
@media screen and (max-width: 767px) {
.vl-search.vl-search--alt[data-v-97867cb6] {
    padding: 0;
}
}
@media screen and (max-width: 767px) {
.vl-search--inline[data-v-97867cb6] {
    display: block;
    width: auto;
}
}
.vl-search--inline .vl-search__label[data-v-97867cb6] {
  display: block;
  padding: 0;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 4.3rem;
  color: #fff;
  font-size: 0 !important;
}
.vl-search--inline .vl-search__submit[data-v-97867cb6] {
  padding: 0;
  position: absolute;
  right: 5px;
  font-size: 1.9rem;
  z-index: 1;
  top: 50%;
  min-height: 2.5rem;
  width: 2.5rem;
  transform: translateY(-50%);
}
.vl-search--inline .vl-search__label[data-v-97867cb6] {
  color: #333332;
}
.vl-search--inline .vl-search__reset[data-v-97867cb6] {
  right: 35px;
  top: 50%;
}
.vl-search--inline .vl-search__input[data-v-97867cb6] {
  padding-right: 30px;
  flex: unset;
  margin: 0;
  text-overflow: ellipsis;
  width: 100%;
}
.vl-search--inline .vl-search__input[data-v-97867cb6]:focus, .vl-search--inline .vl-search__input[data-v-97867cb6]:hover {
  padding-right: 30px;
}
.vl-search--inline.vl-search--has-input-value .vl-search__input[data-v-97867cb6] {
  padding-right: 60px;
}
.vl-search--inline.vl-search--has-input-value .vl-search__input[data-v-97867cb6]:focus, .vl-search--inline.vl-search--has-input-value .vl-search__input[data-v-97867cb6]:hover {
  padding-right: 60px;
}
.vl-search--inline .vl-search__submit[data-v-97867cb6]:focus {
  transition: none;
}
.vl-search--inline .vl-search__input-wrapper[data-v-97867cb6] {
  display: block;
  width: 100%;
  text-align: left;
  position: relative;
}
.vl-select[data-v-97867cb6] {
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: 9px 5px;
  background-position: calc(100% - 1.5rem) 50%;
  -moz-appearance: none;
       appearance: none;
  display: inline-block;
  position: relative;
  padding: 0 4rem 0 1.5rem;
  max-width: 100%;
  height: 3.5rem;
  line-height: calc(3.5rem - 0.2rem);
  border: 1px solid #8695a8;
  border-radius: 0.3rem;
  text-decoration: none;
  color: #333332;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.6rem;
  -webkit-appearance: none;
}
.vl-select[data-v-97867cb6]:focus::-ms-value {
  background: inherit;
  color: inherit;
}
.vl-select[data-v-97867cb6]::-ms-expand {
  display: none;
}
.vl-select[data-v-97867cb6]:hover:not([disabled]) {
  border: 0.2rem solid rgba(0, 85, 204, 0.65);
  padding: 0 3.9rem 0 1.4rem;
  line-height: 3.2rem;
  background-position: calc(100% - 1.4rem) 50%;
}
.vl-select:hover:not([disabled]).vl-select--error[data-v-97867cb6], .vl-select:hover:not([disabled]).invalid.validated[data-v-97867cb6] {
  border-color: #d2373c;
}
.vl-select:hover:not([disabled]).vl-select--success[data-v-97867cb6], .vl-select:hover:not([disabled]).valid.validated[data-v-97867cb6] {
  border-color: #009e47;
}
.vl-select[data-v-97867cb6]:focus {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.vl-select[data-v-97867cb6]:focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
.vl-select[disabled][data-v-97867cb6], .vl-select--disabled[data-v-97867cb6] {
  border-color: #8695a8;
  background-color: #f3f5f6;
  color: var(--vl-theme-fg-color-70);
}
.vl-select--error[data-v-97867cb6], .vl-select.invalid.validated[data-v-97867cb6] {
  border-color: #d2373c;
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.vl-select--success[data-v-97867cb6], .vl-select.valid.validated[data-v-97867cb6] {
  border-color: #009e47;
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.vl-select--block[data-v-97867cb6] {
  display: block;
  width: 100%;
}
@media screen and (max-width: 767px) {
.vl-select[data-v-97867cb6] {
    height: 3.5rem;
    line-height: 3.5rem;
    font-size: 1.6rem;
}
}
@media all and (min-width: 0�) and (min-resolution: 0.001dpcm) {
.vl-select[data-v-97867cb6] {
    padding-right: 0;
    background-image: none;
}
}
.no-js [data-vl-select][data-v-97867cb6] {
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: 9px 5px;
  background-position: calc(100% - 1.5rem) 50%;
  -moz-appearance: none;
       appearance: none;
  display: inline-block;
  position: relative;
  padding: 0 4rem 0 1.5rem;
  max-width: 100%;
  height: 3.5rem;
  line-height: calc(3.5rem - 0.2rem);
  border: 1px solid #8695a8;
  border-radius: 0.3rem;
  text-decoration: none;
  color: #333332;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.6rem;
  -webkit-appearance: none;
}
.no-js [data-vl-select][data-v-97867cb6]:focus::-ms-value {
  background: inherit;
  color: inherit;
}
.js-vl-select[data-v-97867cb6] {
  position: relative;
  border-radius: 0.3rem;
  z-index: 999;
}
.js-vl-select.is-disabled[data-v-97867cb6] {
  border-color: #687483;
  background-color: #f3f5f6 !important;
  outline: 0;
}
.js-vl-select.is-disabled .vl-select__inner[data-v-97867cb6] {
  border-color: #8695a8;
}
.js-vl-select.is-disabled .vl-select__item[data-v-97867cb6] {
  color: var(--vl-theme-fg-color-70);
  cursor: default;
}
.js-vl-select.is-focused[data-v-97867cb6] {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.js-vl-select.is-focused[data-v-97867cb6] {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
.js-vl-select.is-open[data-v-97867cb6] {
  z-index: 1000;
}
.js-vl-select.is-open .vl-select__inner[data-v-97867cb6] {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.js-vl-select.is-open[data-v-97867cb6]::after {
  transform: translateY(-0.75rem);
  border-color: transparent transparent #000;
}
.js-vl-select.is-flipped .vl-select__inner[data-v-97867cb6] {
  border-radius: 0 0 0.3rem 0.3rem;
}
.js-vl-select.is-flipped .vl-select__list--dropdown[data-v-97867cb6] {
  top: auto;
  bottom: 100%;
  transform: translateY(0.1rem);
  border-radius: 0.3rem 0.3rem 0 0;
}
.js-vl-select:hover:not(.is-disabled) .vl-select__inner[data-v-97867cb6] {
  border-color: rgba(0, 85, 204, 0.65);
  box-shadow: inset 0 0 0 0.1rem rgba(0, 85, 204, 0.65);
}
.js-vl-select[data-type*=select-one][data-v-97867cb6] {
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: 9px 5px;
  background-position: calc(100% - 1.5rem) 50%;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.js-vl-select[data-type*=select-one] .vl-input-field[data-v-97867cb6] {
  display: block;
  padding: 0;
  color: #333332;
  overflow: hidden;
  white-space: nowrap;
}
.js-vl-select[data-type*=select-one] .vl-select__list--dropdown .vl-input-field[data-v-97867cb6] {
  width: calc(100% - 2 * 2rem);
  margin: 2rem;
  padding: 0 1rem;
  border: 0.1rem solid #8695a8;
}
.js-vl-select[data-type*=select-one] .vl-select__item--selectable[data-v-97867cb6] {
  min-height: calc(3.5rem - 1.2rem);
  height: calc(3.5rem - 1.2rem);
}
.js-vl-select[data-type*=select-one] .vl-select__inner[data-v-97867cb6] {
  height: 3.5rem;
  line-height: 3.5rem;
  padding-right: 3.5rem;
}
.js-vl-select[data-type*=select-one][dir=rtl][data-v-97867cb6]::after {
  right: auto;
  left: 1.15rem;
}
.js-vl-select[data-type*=select-one][dir=rtl] .vl-select__button[data-v-97867cb6] {
  right: auto;
  left: 0;
  margin-right: 0;
  margin-left: 2.5rem;
}
.js-vl-select[data-type*=select-one][dir=rtl] .vl-pill__close[data-v-97867cb6] {
  margin-right: auto;
  margin-left: 0;
}
.js-vl-select[data-type*=select-one] .vl-select__button[data-v-97867cb6] {
  border: 0;
}
.js-vl-select[data-type*=select-one] .vl-pill__close[data-v-97867cb6]::before, .js-vl-select[data-type*=select-one] .vl-pill__close[data-v-97867cb6]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.js-vl-select[data-type*=select-one] .vl-pill__close[data-v-97867cb6]::before {
  content: "\\f17f";
}
.js-vl-select[data-type*=select-one] .vl-pill__close[data-v-97867cb6] {
  border: 0;
  display: inline-flex;
  margin-left: auto;
}
.js-vl-select[data-type*=select-one] .vl-pill__close[data-v-97867cb6]:hover, .js-vl-select[data-type*=select-one] .vl-pill__close[data-v-97867cb6]:focus, .js-vl-select[data-type*=select-one] .vl-pill__close[data-v-97867cb6]:active {
  color: #003bb0;
}
.js-vl-select[data-type*=select-one].is-disabled .vl-pill__close[data-v-97867cb6],
.js-vl-select[data-type*=select-one] .vl-select__placeholder .vl-pill__close[data-v-97867cb6] {
  display: none;
}
.js-vl-select[data-type*=select-multiple][data-v-97867cb6] {
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: 9px 5px;
  background-position: calc(100% - 1.5rem) 50%;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.js-vl-select[data-type*=select-multiple][data-v-97867cb6], .js-vl-select[data-type*=text][data-v-97867cb6] {
  background-color: #fff;
}
.js-vl-select[data-type*=select-multiple] .vl-select__inner[data-v-97867cb6], .js-vl-select[data-type*=text] .vl-select__inner[data-v-97867cb6] {
  cursor: text;
}
.js-vl-select[data-type*=select-multiple] .vl-select__button[data-v-97867cb6]::before, .js-vl-select[data-type*=select-multiple] .vl-select__button[data-v-97867cb6]::after, .js-vl-select[data-type*=text] .vl-select__button[data-v-97867cb6]::before, .js-vl-select[data-type*=text] .vl-select__button[data-v-97867cb6]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.js-vl-select[data-type*=select-multiple] .vl-select__button[data-v-97867cb6]::before, .js-vl-select[data-type*=text] .vl-select__button[data-v-97867cb6]::before {
  content: "\\f17f";
}
.js-vl-select[data-type*=select-multiple] .vl-select__button[data-v-97867cb6], .js-vl-select[data-type*=text] .vl-select__button[data-v-97867cb6] {
  display: inline-block;
  width: 2.2rem;
  height: 2.3rem;
  margin-left: 0.5rem;
  transform: translateY(-0.1rem);
  border-left: 0.1rem solid #8695a8;
  color: #666;
  text-align: center;
  text-decoration: none;
}
.js-vl-select[data-type*=select-multiple] .vl-select__button[data-v-97867cb6]::before, .js-vl-select[data-type*=text] .vl-select__button[data-v-97867cb6]::before {
  padding: 0 0.4rem;
  font-size: 1.1rem;
  text-indent: 0;
}
.js-vl-select[data-type*=select-multiple] .vl-select__button[data-v-97867cb6]:hover, .js-vl-select[data-type*=select-multiple] .vl-select__button[data-v-97867cb6]:focus, .js-vl-select[data-type*=text] .vl-select__button[data-v-97867cb6]:hover, .js-vl-select[data-type*=text] .vl-select__button[data-v-97867cb6]:focus {
  opacity: 1;
}
.js-vl-select[data-type*=select-multiple] .vl-input-field[data-v-97867cb6], .js-vl-select[data-type*=text] .vl-input-field[data-v-97867cb6] {
  display: inline;
  padding: 0;
  line-height: 2.2rem;
  height: 2.4rem;
}
.js-vl-select[data-type*=select-multiple] .vl-input-field[data-v-97867cb6]:focus, .js-vl-select[data-type*=text] .vl-input-field[data-v-97867cb6]:focus {
  outline: 0;
  box-shadow: none;
}
.js-vl-select__group[data-v-97867cb6] {
  padding: 0.3rem 0.5rem 0.3rem 0;
  border-top: 0.1rem solid #8695a8;
  text-decoration: none;
}
.js-vl-select .vl-select__inner[data-v-97867cb6] {
  padding: 0.5rem 6rem 0.4rem 1rem;
  border: 0.1rem solid #8695a8;
  border-radius: 0.3rem;
  color: #666;
  font-family: "Flanders Art Sans", sans-serif;
  overflow: hidden;
}
.is-open .js-vl-select .vl-select__inner[data-v-97867cb6] {
  border-bottom: 0;
}
.js-vl-select .vl-select__list[data-v-97867cb6] {
  margin: 0;
  padding: 0;
  list-style: none;
}
.js-vl-select .vl-select__list--single[data-v-97867cb6] {
  display: inline-block;
  width: 100%;
}
[dir=rtl] .js-vl-select .vl-select__list--single[data-v-97867cb6] {
  padding-right: 0.5rem;
  padding-left: 1.5rem;
}
.js-vl-select .vl-select__list--multiple[data-v-97867cb6] {
  display: inline-flex;
  align-content: center;
  max-width: 100%;
}
.js-vl-select .vl-select__list--multiple .vl-select__item[data-v-97867cb6] {
  margin: 0.2rem 0.6rem 0.5rem 0;
  display: inline-flex;
}
.js-vl-select .vl-select__list--multiple .vl-select__item[data-deletable][data-v-97867cb6] {
  padding-right: 0;
}
[dir=rtl] .js-vl-select .vl-select__list--multiple--multiple[data-v-97867cb6] {
  margin-right: 0;
  margin-left: 0.375rem;
}
.js-vl-select .vl-select__list--multiple .vl-input-field[data-v-97867cb6] {
  padding: 0.4rem 0 0.4rem 0.2rem;
}
.js-vl-select .vl-select__list--dropdown[data-v-97867cb6] {
  display: none;
  position: absolute;
  top: 100%;
  width: 100%;
  transform: translateY(-0.1rem);
  border: 0.1rem #8695a8 solid;
  background-color: #fff;
  z-index: 1;
  border-bottom-left-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}
.js-vl-select .vl-select__list--dropdown.is-active[data-v-97867cb6] {
  display: block;
}
.js-vl-select .vl-select__list--dropdown .vl-select__list[data-v-97867cb6] {
  position: relative;
  max-height: 35vh;
  overflow: auto;
  will-change: scroll-position;
  -webkit-overflow-scrolling: touch;
}
.js-vl-select .vl-select__list--dropdown .vl-input-field + .vl-select__list[data-v-97867cb6] {
  border-top: 0.1rem solid #8695a8;
}
.js-vl-select .vl-select__list--dropdown .vl-select__item[data-v-97867cb6] {
  width: 100%;
  min-height: 0;
  height: auto;
  padding-top: 0.8rem;
  padding-bottom: 0.8rem;
  padding-left: 3rem;
  border: 0;
  color: #000;
  font-weight: normal;
  text-decoration: none;
}
.js-vl-select .vl-select__list--dropdown .vl-select__item[data-v-97867cb6]:not(:first-of-type) {
  border-top: 0.1rem #cbd2da solid;
}
[dir=rtl] .js-vl-select .vl-select__list--dropdown .vl-select__item[data-v-97867cb6] {
  text-align: right;
}
@media screen and (min-width: 767px) {
.js-vl-select .vl-select__list--dropdown .vl-select__item--selectable[data-v-97867cb6] {
    padding-right: 10rem;
}
.js-vl-select .vl-select__list--dropdown .vl-select__item--selectable[data-v-97867cb6]::after {
    position: absolute;
    top: 50%;
    right: 1rem;
    transform: translateY(-50%);
    content: attr("data-select-text");
    opacity: 0.5;
}
[dir=rtl] .js-vl-select .vl-select__list--dropdown .vl-select__item--selectable[data-v-97867cb6] {
    padding-right: 1rem;
    padding-left: 10rem;
    text-align: right;
}
[dir=rtl] .js-vl-select .vl-select__list--dropdown .vl-select__item--selectable[data-v-97867cb6]::after {
    right: auto;
    left: 1rem;
}
}
.js-vl-select .vl-select__list--dropdown .vl-select__item--selectable.is-highlighted[data-v-97867cb6] {
  position: relative;
  background-color: rgba(179, 207, 245, 0.3);
}
.js-vl-select .vl-select__list--dropdown .vl-select__item[aria-selected=true][data-v-97867cb6] {
  background-color: rgba(179, 207, 245, 0.3);
}
.js-vl-select .vl-select__item[data-v-97867cb6] {
  cursor: default;
  display: flex;
  align-items: center;
}
.js-vl-select .vl-select__item--disabled[data-v-97867cb6] {
  background-color: #f3f5f6 !important;
  border-color: #8695a8;
  color: var(--vl-theme-fg-color-70) !important;
  cursor: not-allowed;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.js-vl-select .vl-select__item--disabled[data-v-97867cb6]:hover {
  background-color: #f3f5f6;
}
.js-vl-select .vl-select__item span[data-v-97867cb6] {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.js-vl-select .vl-input-field[data-v-97867cb6] {
  display: inline-block;
  max-width: 100%;
  border: 0;
  background-color: transparent;
  vertical-align: baseline;
}
[dir=rtl] .js-vl-select .vl-input-field[data-v-97867cb6] {
  padding-right: 0.2rem;
  padding-left: 0;
}
.js-vl-select .vl-select__placeholder[data-v-97867cb6] {
  opacity: 0.5;
}
.js-vl-select .vl-select__group[data-v-97867cb6] {
  display: block;
}
.js-vl-select .vl-select__group[data-v-97867cb6]:not(:first-of-type) {
  border-top: 0.1rem solid #8695a8;
}
.js-vl-select .vl-select__group .vl-select__heading[data-v-97867cb6] {
  padding: 0.6rem 2rem;
  color: #687483;
  font-weight: 500;
}
.vl-select--error .js-vl-select[data-v-97867cb6] {
  background-color: #d2373c;
  border: 0.2rem solid #d2373c;
  box-shadow: inset 0 0 0 0.1rem #d2373c;
}
.vl-select--error .js-vl-select[data-v-97867cb6]:focus {
  background-color: #fff;
}
.vl-select--success .js-vl-select[data-v-97867cb6] {
  border-color: #009e47;
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
  border-width: 0.2rem;
  border-style: solid;
}
.vl-spotlight[data-v-97867cb6] {
  display: block;
  text-decoration: none;
  position: relative;
  padding: 2rem 0rem;
}
.vl-spotlight[data-v-97867cb6]::before {
  display: block;
  content: "";
  height: 0.2rem;
  left: 0;
  right: 0;
  position: absolute;
  top: 0;
  background-color: #cbd2da;
  z-index: 3;
}
.vl-spotlight.vl-spotlight--alt-focus .vl-spotlight__link-wrapper[data-v-97867cb6] {
  box-shadow: none;
  text-decoration: none;
}
.vl-spotlight--link[data-v-97867cb6]::before {
  background-color: #05c;
}
.vl-spotlight--alt[data-v-97867cb6] {
  background-color: #f7f9fc;
  padding: 2rem;
}
.vl-spotlight--alt.vl-spotlight--no-border[data-v-97867cb6] {
  padding: 2rem;
}
.vl-spotlight--alt.vl-spotlight--no-border.vl-spotlight--image[data-v-97867cb6] {
  padding-top: 0;
}
.vl-region--alt .vl-spotlight--alt[data-v-97867cb6] {
  background-color: #fff;
}
.vl-spotlight--image-icon[data-v-97867cb6]::before {
  top: 85px;
  z-index: 0;
}
@media screen and (max-width: 500px) {
.vl-spotlight--image-icon[data-v-97867cb6]::before {
    top: 60px;
}
}
.vl-spotlight--image-icon .vl-spotlight__image--icon[data-v-97867cb6] {
  margin-bottom: 2rem;
  padding-top: 0;
}
.vl-spotlight--image-icon .vl-spotlight__image--icon .vl-badge[data-v-97867cb6] {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}
@media screen and (max-width: 500px) {
.vl-spotlight--image-icon .vl-spotlight__image--icon[data-v-97867cb6] {
    margin-bottom: 1rem;
}
.vl-spotlight--image-icon .vl-spotlight__image--icon .vl-badge[data-v-97867cb6] {
    width: 75px;
    height: 75px;
}
}
.vl-spotlight--horizontal .vl-spotlight__main[data-v-97867cb6] {
  display: flex;
  align-items: center;
}
.vl-spotlight--horizontal .vl-spotlight__container[data-v-97867cb6] {
  flex: 1;
}
.vl-spotlight--horizontal .vl-spotlight__header[data-v-97867cb6] {
  overflow: visible;
}
.vl-spotlight--horizontal .vl-spotlight__color-block--rounded[data-v-97867cb6] {
  background: transparent;
}
.vl-spotlight--horizontal .vl-spotlight__transparent-block[data-v-97867cb6],
.vl-spotlight--horizontal .vl-spotlight__color-block[data-v-97867cb6],
.vl-spotlight--horizontal .vl-spotlight__image[data-v-97867cb6]:not(.vl-spotlight__image--icon) {
  max-width: 15rem;
  width: 15rem;
}
@media screen and (max-width: 500px) {
.vl-spotlight--horizontal .vl-spotlight__transparent-block[data-v-97867cb6],
  .vl-spotlight--horizontal .vl-spotlight__color-block[data-v-97867cb6],
  .vl-spotlight--horizontal .vl-spotlight__image[data-v-97867cb6]:not(.vl-spotlight__image--icon) {
    max-width: 7.5rem;
}
}
.vl-spotlight--horizontal .vl-spotlight__transparent-block .vl-icon[data-v-97867cb6],
.vl-spotlight--horizontal .vl-spotlight__color-block .vl-icon[data-v-97867cb6],
.vl-spotlight--horizontal .vl-spotlight__image:not(.vl-spotlight__image--icon) .vl-icon[data-v-97867cb6] {
  font-size: 6rem;
}
.vl-spotlight--horizontal .vl-spotlight__transparent-block .vl-badge[data-v-97867cb6],
.vl-spotlight--horizontal .vl-spotlight__color-block .vl-badge[data-v-97867cb6],
.vl-spotlight--horizontal .vl-spotlight__image:not(.vl-spotlight__image--icon) .vl-badge[data-v-97867cb6] {
  height: 100%;
  font-size: 0;
}
@media screen and (max-width: 500px) {
.vl-spotlight--horizontal .vl-spotlight__transparent-block .vl-badge[data-v-97867cb6],
  .vl-spotlight--horizontal .vl-spotlight__color-block .vl-badge[data-v-97867cb6],
  .vl-spotlight--horizontal .vl-spotlight__image:not(.vl-spotlight__image--icon) .vl-badge[data-v-97867cb6] {
    width: 100%;
    height: auto;
}
}
.vl-spotlight--horizontal .vl-spotlight__transparent-block[data-v-97867cb6],
.vl-spotlight--horizontal .vl-spotlight__color-block[data-v-97867cb6],
.vl-spotlight--horizontal .vl-spotlight__image[data-v-97867cb6] {
  margin-right: 3rem;
  margin-bottom: 0;
}
@media screen and (max-width: 767px) {
.vl-spotlight--horizontal .vl-spotlight__transparent-block[data-v-97867cb6],
  .vl-spotlight--horizontal .vl-spotlight__color-block[data-v-97867cb6],
  .vl-spotlight--horizontal .vl-spotlight__image[data-v-97867cb6] {
    margin-bottom: 0rem;
    margin-right: 1.8rem;
}
}
.vl-spotlight--horizontal .vl-spotlight__image:not(.vl-spotlight__image--icon).vl-spotlight__image--square[data-v-97867cb6] {
  padding-top: 77%;
}
.vl-spotlight--horizontal .vl-spotlight__image:not(.vl-spotlight__image--icon).vl-spotlight__image--vertical[data-v-97867cb6] {
  padding-top: 100%;
}
.vl-spotlight--horizontal .vl-spotlight__image:not(.vl-spotlight__image--icon).vl-spotlight__color-block[data-v-97867cb6] {
  background: transparent;
}
.vl-spotlight--horizontal.vl-spotlight--s .vl-spotlight__transparent-block[data-v-97867cb6],
.vl-spotlight--horizontal.vl-spotlight--s .vl-spotlight__color-block[data-v-97867cb6],
.vl-spotlight--horizontal.vl-spotlight--s .vl-spotlight__image[data-v-97867cb6], .vl-spotlight--horizontal.vl-spotlight--xs .vl-spotlight__transparent-block[data-v-97867cb6],
.vl-spotlight--horizontal.vl-spotlight--xs .vl-spotlight__color-block[data-v-97867cb6],
.vl-spotlight--horizontal.vl-spotlight--xs .vl-spotlight__image[data-v-97867cb6] {
  margin-bottom: 0rem;
  margin-right: 1.8rem;
}
.vl-spotlight--no-border[data-v-97867cb6] {
  padding: 0;
}
@media screen and (max-width: 767px) {
.vl-spotlight--no-border[data-v-97867cb6] {
    padding: 0.6rem 0;
}
}
.vl-spotlight--no-border[data-v-97867cb6]::before {
  display: none;
}
.vl-spotlight--no-visual-border .vl-spotlight__transparent-block--visual[data-v-97867cb6] {
  border: 0;
  padding: 0;
}
.vl-spotlight--no-visual-border .vl-spotlight__image__transparent[data-v-97867cb6] {
  box-shadow: 0 1px 6px 0 #cfd5dd;
}
.vl-spotlight--inline[data-v-97867cb6] {
  display: inline-block;
}
.vl-spotlight__link-wrapper[data-v-97867cb6] {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
}
.vl-spotlight__link-wrapper .vl-link__icon[data-v-97867cb6] {
  display: none;
}
.vl-spotlight__link-wrapper:hover ~ .vl-spotlight__main .vl-link[data-v-97867cb6], .vl-spotlight__link-wrapper:hover ~ .vl-spotlight__main .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6], .vl-sidebar-panel-list-item__button .vl-spotlight__link-wrapper:hover ~ .vl-spotlight__main .vl-icon[data-v-97867cb6], .vl-spotlight__link-wrapper:hover ~ .vl-spotlight__main .vl-sidebar-header__toggle[data-v-97867cb6], .vl-spotlight__link-wrapper:focus ~ .vl-spotlight__main .vl-link[data-v-97867cb6], .vl-spotlight__link-wrapper:focus ~ .vl-spotlight__main .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6], .vl-sidebar-panel-list-item__button .vl-spotlight__link-wrapper:focus ~ .vl-spotlight__main .vl-icon[data-v-97867cb6], .vl-spotlight__link-wrapper:focus ~ .vl-spotlight__main .vl-sidebar-header__toggle[data-v-97867cb6] {
  text-decoration: underline;
}
.vl-spotlight__header[data-v-97867cb6] {
  position: relative;
  overflow: hidden;
  margin-top: -2rem;
  margin-left: 0;
  margin-right: 0;
}
.vl-spotlight--no-border .vl-spotlight__header[data-v-97867cb6] {
  margin-top: 0;
}
.vl-spotlight--alt .vl-spotlight__header[data-v-97867cb6] {
  margin-left: -2rem;
  margin-right: -2rem;
}
.vl-spotlight__image[data-v-97867cb6],
.vl-spotlight__color-block[data-v-97867cb6],
.vl-spotlight__transparent-block[data-v-97867cb6] {
  padding-top: 56.25%;
  position: relative;
  margin-bottom: 2rem;
}
@media screen and (max-width: 767px) {
.vl-spotlight__image[data-v-97867cb6],
  .vl-spotlight__color-block[data-v-97867cb6],
  .vl-spotlight__transparent-block[data-v-97867cb6] {
    margin-bottom: 1rem;
}
}
.vl-spotlight__color-block[data-v-97867cb6],
.vl-spotlight__transparent-block[data-v-97867cb6] {
  text-align: center;
}
.vl-spotlight__color-block .vl-icon[data-v-97867cb6],
.vl-spotlight__color-block .vl-badge[data-v-97867cb6],
.vl-spotlight__transparent-block .vl-icon[data-v-97867cb6],
.vl-spotlight__transparent-block .vl-badge[data-v-97867cb6] {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
}
.vl-spotlight__color-block .vl-icon[data-v-97867cb6],
.vl-spotlight__transparent-block .vl-icon[data-v-97867cb6] {
  font-size: 6rem;
}
@supports (-webkit-background-clip: text) {
.vl-spotlight__color-block .vl-icon[data-v-97867cb6]::before,
  .vl-spotlight__transparent-block .vl-icon[data-v-97867cb6]::before {
    background: var(--vl-spotlight-accent-fg-color, var(--vl-theme-primary-color)) url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-size: 12px;
    -webkit-background-clip: text;
    background-clip: text;
    color: var(--vl-spotlight-accent-fg-color, var(--vl-theme-primary-color));
    -webkit-text-fill-color: transparent;
    text-fill-color: transparent;
}
}
@supports ((-webkit-background-clip: text) or (background-clip: text)) {
.vl-spotlight__color-block .vl-icon[data-v-97867cb6]::before,
  .vl-spotlight__transparent-block .vl-icon[data-v-97867cb6]::before {
    background: var(--vl-spotlight-accent-fg-color, var(--vl-theme-primary-color)) url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-size: 12px;
    -webkit-background-clip: text;
    background-clip: text;
    color: var(--vl-spotlight-accent-fg-color, var(--vl-theme-primary-color));
    -webkit-text-fill-color: transparent;
    text-fill-color: transparent;
}
}
.vl-spotlight__color-block .vl-badge[data-v-97867cb6],
.vl-spotlight__transparent-block .vl-badge[data-v-97867cb6] {
  width: auto;
  height: calc(100% - 4rem);
  border-radius: 50%;
  aspect-ratio: 1;
}
.vl-spotlight__color-block .vl-badge.vl-badge--initials span[data-v-97867cb6],
.vl-spotlight__transparent-block .vl-badge.vl-badge--initials span[data-v-97867cb6] {
  font-size: inherit;
}
.vl-spotlight__color-block[data-v-97867cb6] {
  background-color: var(--vl-spotlight-accent-color, var(--vl-theme-primary-color));
}
.vl-spotlight__color-block--rounded[data-v-97867cb6] {
  background-color: rgb(89.5900178253%, 92.192513369%, 96.0962566845%);
}
.vl-spotlight__color-block.vl-spotlight__image[data-v-97867cb6] {
  background-color: rgb(89.5900178253%, 92.192513369%, 96.0962566845%);
}
@supports (-webkit-background-clip: text) {
.vl-spotlight__color-block.vl-spotlight__image .vl-icon[data-v-97867cb6]::before {
    background: rgb(38.6809269162%, 54.0106951872%, 77.0053475936%) url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-size: 12px;
    -webkit-background-clip: text;
    background-clip: text;
    color: rgb(38.6809269162%, 54.0106951872%, 77.0053475936%);
    -webkit-text-fill-color: transparent;
    text-fill-color: transparent;
}
}
@supports ((-webkit-background-clip: text) or (background-clip: text)) {
.vl-spotlight__color-block.vl-spotlight__image .vl-icon[data-v-97867cb6]::before {
    background: rgb(38.6809269162%, 54.0106951872%, 77.0053475936%) url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-size: 12px;
    -webkit-background-clip: text;
    background-clip: text;
    color: rgb(38.6809269162%, 54.0106951872%, 77.0053475936%);
    -webkit-text-fill-color: transparent;
    text-fill-color: transparent;
}
}
.vl-spotlight__transparent-block[data-v-97867cb6] {
  background: transparent;
  border: 1px solid #cbd2da;
}
.vl-spotlight__transparent-block .vl-icon[data-v-97867cb6] {
  font-size: 12rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
}
@supports (-webkit-background-clip: text) {
.vl-spotlight__transparent-block .vl-icon[data-v-97867cb6]::before {
    background: #cbd2da url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-size: 12px;
    -webkit-background-clip: text;
    background-clip: text;
    color: #cbd2da;
    -webkit-text-fill-color: transparent;
    text-fill-color: transparent;
}
}
@supports ((-webkit-background-clip: text) or (background-clip: text)) {
.vl-spotlight__transparent-block .vl-icon[data-v-97867cb6]::before {
    background: #cbd2da url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-size: 12px;
    -webkit-background-clip: text;
    background-clip: text;
    color: #cbd2da;
    -webkit-text-fill-color: transparent;
    text-fill-color: transparent;
}
}
@media screen and (max-width: 1023px) {
.vl-spotlight__transparent-block .vl-icon[data-v-97867cb6] {
    font-size: 10rem;
}
}
.vl-spotlight__transparent-block--visual[data-v-97867cb6]:not(.vl-spotlight__image) {
  padding: 1rem;
  line-height: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.vl-spotlight__transparent-block--hidden[data-v-97867cb6] {
  display: none;
}
.vl-spotlight__image__img[data-v-97867cb6] {
  position: absolute;
  top: -9999px;
  bottom: -9999px;
  left: -9999px;
  right: -9999px;
  margin: auto;
  width: auto;
  height: auto;
  min-width: 100%;
  min-height: 100%;
}
@supports ((-o-object-fit: cover) or (object-fit: cover)) {
.vl-spotlight__image__img[data-v-97867cb6] {
    -o-object-fit: cover;
       object-fit: cover;
    -o-object-position: center;
       object-position: center;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
}
.vl-spotlight__image__img[data-v-97867cb6] {
  transition: transform 0.2s;
  backface-visibility: hidden;
  transform: translate3d(0, 0, 0);
}
.vl-spotlight__image--focus-center-right .vl-spotlight__image__img[data-v-97867cb6], .vl-spotlight__image--focus-top-right .vl-spotlight__image__img[data-v-97867cb6], .vl-spotlight__image--focus-bottom-right .vl-spotlight__image__img[data-v-97867cb6] {
  right: 0;
  left: auto;
  margin-left: 0;
  margin-right: 0;
}
.vl-spotlight__image--focus-center-left .vl-spotlight__image__img[data-v-97867cb6], .vl-spotlight__image--focus-top-left .vl-spotlight__image__img[data-v-97867cb6], .vl-spotlight__image--focus-bottom-left .vl-spotlight__image__img[data-v-97867cb6] {
  right: auto;
  left: 0;
  margin-left: 0;
  margin-right: 0;
}
.vl-spotlight__image--focus-top-right .vl-spotlight__image__img[data-v-97867cb6], .vl-spotlight__image--focus-top-center .vl-spotlight__image__img[data-v-97867cb6], .vl-spotlight__image--focus-top-left .vl-spotlight__image__img[data-v-97867cb6] {
  top: 0;
  bottom: auto;
  margin-top: 0;
  margin-bottom: 0;
}
.vl-spotlight__image--focus-bottom-right .vl-spotlight__image__img[data-v-97867cb6], .vl-spotlight__image--focus-bottom-center .vl-spotlight__image__img[data-v-97867cb6], .vl-spotlight__image--focus-bottom-left .vl-spotlight__image__img[data-v-97867cb6] {
  bottom: 0;
  top: auto;
  margin-top: 0;
  margin-bottom: 0;
}
.vl-spotlight__image--contained .vl-spotlight__image__img[data-v-97867cb6] {
  -o-object-fit: contain;
     object-fit: contain;
}
.vl-spotlight__title-wrapper[data-v-97867cb6] {
  display: flex;
  align-items: flex-start;
  position: relative;
}
.vl-spotlight--alt .vl-spotlight__title-wrapper .vl-spotlight__title[data-v-97867cb6], .vl-region--alt .vl-spotlight__title-wrapper .vl-spotlight__title[data-v-97867cb6] {
  padding-left: 2rem;
  background-color: #f7f9fc;
}
.vl-spotlight--alt .vl-spotlight__title-wrapper .vl-spotlight__title[data-v-97867cb6]::before, .vl-region--alt .vl-spotlight__title-wrapper .vl-spotlight__title[data-v-97867cb6]::before {
  background-color: #f7f9fc;
}
.vl-spotlight__container .vl-spotlight__title-wrapper .vl-spotlight__title[data-v-97867cb6] {
  padding-left: 0;
}
.vl-region--alt .vl-spotlight--alt .vl-spotlight__title-wrapper .vl-spotlight__title[data-v-97867cb6], .vl-region--alt .vl-spotlight--alt .vl-spotlight__title-wrapper[data-v-97867cb6]::before {
  background-color: #fff;
}
.vl-spotlight__title-wrapper[data-v-97867cb6]::before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 0rem;
  background-color: #fff;
}
.vl-spotlight__title-wrapper .vl-spotlight__title[data-v-97867cb6] {
  display: inline-flex;
  max-width: calc(100% - 1rem);
  padding-right: 0.5rem;
  word-break: normal;
  hyphens: auto;
}
@supports (overflow-wrap: break-word) {
.vl-spotlight__title-wrapper .vl-spotlight__title[data-v-97867cb6] {
    overflow-wrap: break-word;
}
}
.vl-spotlight__title[data-v-97867cb6] {
  line-height: 1.25;
  position: relative;
  font-size: 2rem;
  font-weight: 500;
  transition: color 0.2s;
}
@media screen and (max-width: 767px) {
.vl-spotlight__title[data-v-97867cb6] {
    font-size: 1.8rem;
}
}
.vl-spotlight__title.vl-link[data-v-97867cb6], .vl-sidebar-panel-list-item__button .vl-spotlight__title.vl-icon[data-v-97867cb6], .vl-spotlight__title.vl-sidebar-header__toggle[data-v-97867cb6] {
  font-weight: 500;
}
.vl-spotlight--xs .vl-spotlight__title[data-v-97867cb6] {
  font-size: 1.6rem;
}
.vl-spotlight--s .vl-spotlight__title[data-v-97867cb6] {
  font-size: 1.8rem;
}
@media screen and (max-width: 767px) {
.vl-spotlight--s .vl-spotlight__title[data-v-97867cb6] {
    font-size: 1.6rem;
}
}
.vl-spotlight--l .vl-spotlight__title[data-v-97867cb6] {
  font-size: 2.6rem;
}
.vl-spotlight__subtitle[data-v-97867cb6] {
  font-size: 1.5rem;
  text-transform: uppercase;
  font-weight: 500;
  color: #687483;
  margin-top: 0.6rem;
}
@media screen and (max-width: 767px) {
.vl-spotlight__subtitle[data-v-97867cb6] {
    font-size: 1.3rem;
}
}
.vl-spotlight--xs .vl-spotlight__subtitle[data-v-97867cb6] {
  font-size: 1.2rem;
}
.vl-spotlight--s .vl-spotlight__subtitle[data-v-97867cb6] {
  font-size: 1.3rem;
}
.vl-spotlight--l .vl-spotlight__subtitle[data-v-97867cb6] {
  font-size: 1.5rem;
}
.vl-spotlight__content .vl-document__type[data-v-97867cb6] {
  padding: 3.6rem 0 0 2rem;
}
.vl-spotlight__annotation.vl-typography[data-v-97867cb6] {
  margin-top: 1rem;
  font-size: 1.8rem;
  line-height: 1.5;
}
@media screen and (max-width: 767px) {
.vl-spotlight__annotation.vl-typography[data-v-97867cb6] {
    margin-top: 0.5rem;
    font-size: 1.6rem;
}
}
.vl-spotlight--xs .vl-spotlight__annotation.vl-typography[data-v-97867cb6] {
  margin-top: 0.5rem;
  font-size: 1.4rem;
}
.vl-spotlight--s .vl-spotlight__annotation.vl-typography[data-v-97867cb6] {
  margin-top: 0.5rem;
  font-size: 1.6rem;
}
.vl-spotlight__data[data-v-97867cb6] {
  margin: 0.7rem 0;
  color: #687483;
}
.vl-spotlight__text[data-v-97867cb6] {
  margin-top: 1rem;
  font-size: 1.8rem;
  line-height: 1.5;
  color: #333332;
  text-decoration: none;
}
@media screen and (max-width: 767px) {
.vl-spotlight__text[data-v-97867cb6] {
    margin-top: 0.5rem;
    font-size: 1.6rem;
}
}
.vl-spotlight--xs .vl-spotlight__text[data-v-97867cb6] {
  margin-top: 0.5rem;
  font-size: 1.4rem;
}
.vl-spotlight--s .vl-spotlight__text[data-v-97867cb6] {
  font-size: 1.6rem;
}
.vl-spotlight--l .vl-spotlight__text[data-v-97867cb6] {
  font-size: 1.8rem;
}
.vl-tabs[data-v-97867cb6] {
  margin-bottom: 3rem;
  border-bottom: 1px #cbd2da solid;
  font-size: 0;
  text-align: left;
}
.vl-tabs--overflow[data-v-97867cb6] {
  position: relative;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  background-repeat: no-repeat;
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
}
.vl-tabs--overflow[data-v-97867cb6]::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
}
.vl-tabs--visible-overflow[data-v-97867cb6] {
  overflow: visible;
}
.vl-tabs__wrapper[data-v-97867cb6] {
  position: relative;
}
.vl-tabs__wrapper--fit-to-content[data-v-97867cb6] {
  display: inline-flex;
}
.vl-tabs__wrapper--overflow[data-v-97867cb6]::after, .vl-tabs__wrapper--overflow[data-v-97867cb6]::before {
  content: "";
  position: absolute;
  width: 35px;
  height: calc(100% + 1px);
  display: block;
  pointer-events: none;
  top: 0;
  opacity: 0;
  transition: opacity 0.25s;
  z-index: 1;
}
.vl-tabs__wrapper--overflow[data-v-97867cb6]::before {
  left: -1px;
  right: auto;
  background-image: linear-gradient(to left, rgba(255, 255, 255, 0) 0%, white 70%, white 100%);
}
.vl-tabs__wrapper--overflow[data-v-97867cb6]::after {
  right: -1px;
  left: auto;
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, white 70%, white 100%);
}
.vl-tabs__wrapper--overflow-right[data-v-97867cb6]::after {
  opacity: 1;
}
.vl-tabs__wrapper--overflow-left[data-v-97867cb6]::before {
  opacity: 1;
}
.no-js .vl-tabs[data-v-97867cb6] {
  display: none;
}
@media screen and (max-width: 767px) {
[data-vl-tabs] .vl-tabs[data-v-97867cb6]:not(.vl-tabs--overflow) {
    display: none;
    position: relative;
    left: -1.5rem;
    width: calc(100% + 3rem);
    margin: 0 0 1rem;
    padding: 0.4rem 0;
    border-top: 1px #f7f9fc solid;
    border-bottom: 1px #f7f9fc solid;
}
[data-vl-tabs] .vl-tabs:not(.vl-tabs--overflow)[data-vl-show=true][data-v-97867cb6] {
    display: block;
}
.vl-functional-header [data-vl-tabs] .vl-tabs[data-v-97867cb6]:not(.vl-tabs--overflow) {
    left: 0;
    width: 100%;
}
}
.vl-functional-header .vl-tabs[data-v-97867cb6] {
  margin: 0 0 -1.5rem 0;
  border: 0;
}
@media screen and (max-width: 767px) {
.vl-functional-header .vl-tabs[data-v-97867cb6] {
    border-bottom: 1px #cbd2da solid;
}
}
.vl-tabs--alt[data-v-97867cb6] {
  position: relative;
}
.vl-tabs--alt[data-v-97867cb6]::before {
  position: absolute;
  bottom: -1px;
  left: -200%;
  width: 500%;
  height: 1px;
  background: #cbd2da;
  content: "";
}
.vl-tab[data-v-97867cb6] {
  display: inline-block;
  position: relative;
  text-align: left;
  vertical-align: top;
  top: 1px;
  padding: 1rem 0;
  margin: 0 1.3rem;
  transition: all 0.2s;
  border-bottom: 3px solid transparent;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.6rem;
  font-weight: 500;
  text-decoration: none;
}
.vl-tab:first-child .vl-tab__link[data-v-97867cb6] {
  margin-left: 0;
}
.vl-tab:last-child .vl-tab__link[data-v-97867cb6] {
  margin-right: 0;
}
.vl-tab[data-v-97867cb6]:hover, .vl-tab[data-v-97867cb6]:focus {
  background-color: transparent;
  border-bottom-color: #333332;
}
.vl-tab--active[data-v-97867cb6] {
  color: #333332;
  border-bottom: 3px solid #333332;
  background-color: transparent;
}
.vl-tab--active[data-v-97867cb6]:visited {
  color: #333332;
}
@media screen and (max-width: 767px) {
[data-vl-tabs] .vl-tabs:not(.vl-tabs--overflow) .vl-tab--active[data-v-97867cb6] {
    border: 0;
}
}
@media screen and (max-width: 767px) {
.vl-functional-header .vl-tab--active[data-v-97867cb6] {
    border: 0;
}
}
@media screen and (max-width: 767px) {
.vl-tab[data-v-97867cb6] {
    font-size: 1.4rem;
    margin: 0 0.8rem;
}
.vl-tabs:not(.vl-tabs--overflow) .vl-tab[data-v-97867cb6] {
    margin: 0;
}
[data-vl-tabs] .vl-tabs:not(.vl-tabs--overflow) .vl-tab[data-v-97867cb6] {
    display: block;
    top: 0;
    padding: 0.7rem 1.5rem;
    border: 0;
    font-size: 1.5rem;
}
[data-vl-tabs] .vl-tabs:not(.vl-tabs--overflow) .vl-tab[data-v-97867cb6]:first-of-type {
    width: calc(100% - 4.2rem);
}
}
.vl-tab__pane[data-v-97867cb6] {
  display: none;
}
.vl-tab__pane[data-vl-show=true][data-v-97867cb6] {
  display: block;
}
.vl-tab__pane[role=tabpanel][data-v-97867cb6]:focus {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.vl-tab__pane[role=tabpanel][data-v-97867cb6]:focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
@supports (outline-offset: 2px) {
.vl-tab__pane[role=tabpanel][data-v-97867cb6]:focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
.no-js .vl-tab__pane[data-v-97867cb6] {
  display: block;
}
.vl-functional-header .vl-tab[data-v-97867cb6] {
  top: 0;
  margin: 0 2rem 0 0;
  padding: 0;
}
.vl-functional-header .vl-tab .vl-tab__link[data-v-97867cb6] {
  padding: 1rem 0;
  border: 0;
  border-top: 3px solid transparent;
  text-decoration: none;
}
.vl-functional-header .vl-tab .vl-tab__link[data-v-97867cb6]:visited, .vl-functional-header .vl-tab .vl-tab__link .vl-link__icon[data-v-97867cb6] {
  color: #05c;
}
@media screen and (max-width: 767px) {
.vl-functional-header .vl-tab .vl-tab__link[data-v-97867cb6] {
    padding: 0.7rem 1rem;
    border: 0 !important;
}
}
.vl-functional-header .vl-tab--active .vl-tab__link[data-v-97867cb6] {
  color: #333332;
}
.vl-functional-header .vl-tab--active .vl-tab__link[data-v-97867cb6]:visited {
  color: #333332;
}
.vl-tabs__toggle[data-v-97867cb6] {
  display: none;
  position: relative;
  left: -1.5rem;
  width: calc(100% + 3rem);
  height: 4.2rem;
  margin: 0 auto 1rem;
  padding: 0 0 0 1.5rem;
  border: 0;
  border-top: 1px #cbd2da solid;
  border-bottom: 1px #cbd2da solid;
  background: none;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.5rem;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
}
.vl-functional-header .vl-tabs__toggle[data-v-97867cb6] {
  border-top: 0px;
}
@media screen and (max-width: 767px) {
.vl-functional-header .vl-tabs__toggle[data-v-97867cb6] {
    left: 0;
    width: 100%;
    margin: 0;
    border-bottom: 1px #cbd2da solid;
}
}
.vl-tabs__toggle span[data-v-97867cb6] {
  display: block;
  width: calc(100% - 6rem);
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.vl-tabs__toggle[data-v-97867cb6]::before, .vl-tabs__toggle[data-v-97867cb6]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-tabs__toggle[data-v-97867cb6]::before {
  content: "\\f125";
}
.vl-tabs__toggle[data-v-97867cb6]::before {
  position: absolute;
  font-size: 1.4rem;
}
.vl-tabs__toggle[data-v-97867cb6]::before {
  top: 0;
  right: 0;
  padding: 1.2rem 1.4rem;
  transform: rotate(90deg);
  transition: color 0.2s ease-in-out;
  font-size: 1.5rem;
}
.vl-tabs__toggle[data-v-97867cb6]:hover, .vl-tabs__toggle[data-v-97867cb6]:focus {
  text-decoration: underline;
}
.vl-tabs__toggle[data-v-97867cb6]:hover::before, .vl-tabs__toggle[data-v-97867cb6]:focus::before {
  color: #05c;
}
.vl-tabs__toggle[data-v-97867cb6]:hover::after, .vl-tabs__toggle[data-v-97867cb6]:focus::after {
  background: #cbd2da;
}
.vl-tabs__toggle[data-v-97867cb6]::after {
  position: absolute;
  top: 0;
  right: 4.2rem;
  width: 1px;
  height: 100%;
  background: #cbd2da;
  content: "";
}
.vl-tabs__toggle[data-v-97867cb6]:focus {
  outline: thin dotted;
}
.vl-tabs__toggle[data-vl-close=true][data-v-97867cb6] {
  position: absolute;
  top: 0;
  right: -1.5rem;
  left: auto;
  width: 4.2rem;
  height: 4.2rem;
  border: 0;
  z-index: 2;
}
.vl-tabs__toggle[data-vl-close=true][data-v-97867cb6]::after {
  display: none;
}
.vl-tabs__toggle[data-vl-close=true][data-v-97867cb6]::before {
  content: "\\f17f";
}
.vl-tabs__toggle[data-vl-close=true][data-v-97867cb6]::before {
  padding: 1.4rem;
  font-size: 1.3rem;
}
.vl-tabs__toggle[data-vl-close=true] span[data-v-97867cb6] {
  display: none;
}
.vl-functional-header .vl-tabs__toggle[data-vl-close=true][data-v-97867cb6] {
  right: 0;
  left: auto;
  width: 4.2rem;
  border: 0;
  border-bottom: 1px #cbd2da solid;
}
@media screen and (max-width: 767px) {
.vl-tabs__toggle[data-v-97867cb6] {
    display: block;
}
}
.vl-textarea[data-v-97867cb6] {
  display: inline-block;
  background: #fff;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.6rem;
  color: #333332;
  max-width: 100%;
  height: auto;
  line-height: normal;
  border-radius: 0.3rem;
  border: 0.1rem solid #8695a8;
  -webkit-appearance: none;
  padding: 1rem;
  transition: background-color 0.2s;
  margin: 0.5rem 0;
}
@media screen and (max-width: 767px) {
.vl-textarea[data-v-97867cb6] {
    font-size: 1.6rem;
}
}
.vl-textarea[data-v-97867cb6]:hover {
  border: 0.2rem solid rgba(0, 85, 204, 0.65);
  padding: 0.9rem;
}
.vl-textarea:hover.vl-textarea--error[data-v-97867cb6], .vl-textarea:hover.invalid.validated[data-v-97867cb6] {
  border-color: #d2373c;
}
.vl-textarea:hover.vl-textarea--success[data-v-97867cb6], .vl-textarea:hover.valid.validated[data-v-97867cb6] {
  border-color: #009e47;
}
.vl-textarea[data-v-97867cb6]:focus, .vl-textarea--focus[data-v-97867cb6] {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.vl-textarea[data-v-97867cb6]:focus, .vl-textarea--focus[data-v-97867cb6] {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
.vl-textarea[data-v-97867cb6]:focus, .vl-textarea--focus[data-v-97867cb6] {
  border: 0.1rem solid #687483;
  padding: 1rem;
}
.vl-textarea:focus.vl-textarea--error[data-v-97867cb6], .vl-textarea:focus.invalid.validated[data-v-97867cb6], .vl-textarea--focus.vl-textarea--error[data-v-97867cb6], .vl-textarea--focus.invalid.validated[data-v-97867cb6] {
  border-color: #d2373c;
}
.vl-textarea:focus.vl-textarea--success[data-v-97867cb6], .vl-textarea:focus.valid.validated[data-v-97867cb6], .vl-textarea--focus.vl-textarea--success[data-v-97867cb6], .vl-textarea--focus.valid.validated[data-v-97867cb6] {
  border-color: #009e47;
}
.vl-textarea[data-v-97867cb6]::-moz-placeholder {
  color: #687483;
}
.vl-textarea[data-v-97867cb6]::placeholder {
  color: #687483;
}
.vl-textarea--block[data-v-97867cb6] {
  display: block;
  width: 100%;
  box-sizing: border-box;
}
.vl-textarea--error[data-v-97867cb6], .vl-textarea.invalid.validated[data-v-97867cb6] {
  border-color: #d2373c;
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
}
.vl-textarea--error[data-v-97867cb6]:focus, .vl-textarea.invalid.validated[data-v-97867cb6]:focus {
  background-color: #fff;
}
.vl-textarea--success[data-v-97867cb6], .vl-textarea.valid.validated[data-v-97867cb6] {
  border-color: #009e47;
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
  display: inline;
}
.vl-textarea--disabled[data-v-97867cb6], .vl-textarea[disabled][data-v-97867cb6] {
  background-color: #f3f5f6;
  border-color: #8695a8;
  color: var(--vl-theme-fg-color-70);
}
.vl-textarea--disabled[data-v-97867cb6]:hover, .vl-textarea[disabled][data-v-97867cb6]:hover {
  border-width: 0.1rem;
  padding: 1rem;
}
.vl-title--alt[data-v-97867cb6] {
  text-transform: uppercase;
  font-weight: 500;
  border-bottom: 3px solid #e8ebee;
  font-size: 1.8rem;
  padding: 0 0 0.7rem;
  margin: 0 0 2rem;
  padding-top: 1.3rem;
}
.vl-title--has-border[data-v-97867cb6] {
  border-bottom: 1px solid #cbd2da;
  margin-bottom: 1.5rem;
}
@media screen and (max-width: 767px) {
.vl-title--has-border[data-v-97867cb6] {
    margin-bottom: 1rem;
}
}
.vl-title a[data-v-97867cb6] {
  text-decoration: none;
}
.vl-title a[data-v-97867cb6]:not(.vl-link):not(.vl-sidebar-header__toggle):hover, .vl-title a[data-v-97867cb6]:not(.vl-link):not(.vl-sidebar-header__toggle):focus {
  text-decoration: underline;
}
.vl-title--h1[data-v-97867cb6] {
  font-size: 4.4rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 6rem;
  line-height: 1.18;
}
@media screen and (max-width: 1023px) {
.vl-title--h1[data-v-97867cb6] {
    font-size: 4rem;
    margin-bottom: 4.5rem;
}
}
@media screen and (max-width: 767px) {
.vl-title--h1[data-v-97867cb6] {
    font-size: 3rem;
    margin-bottom: 3rem;
}
}
.vl-title--h2[data-v-97867cb6] {
  font-size: 3.2rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 2rem;
  line-height: 1.24;
}
@media screen and (max-width: 767px) {
.vl-title--h2[data-v-97867cb6] {
    font-size: 2.6rem;
    margin-bottom: 1.5rem;
}
}
.vl-title--h3[data-v-97867cb6] {
  font-size: 2.6rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 2rem;
  line-height: 1.3;
}
@media screen and (max-width: 767px) {
.vl-title--h3[data-v-97867cb6] {
    font-size: 2.2rem;
    margin-bottom: 1.5rem;
}
}
.vl-title--h4[data-v-97867cb6] {
  font-size: 2.2rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 1.8rem;
  line-height: 1.36;
}
@media screen and (max-width: 767px) {
.vl-title--h4[data-v-97867cb6] {
    font-size: 2rem;
    margin-bottom: 1.4rem;
}
}
.vl-title--h5[data-v-97867cb6] {
  font-size: 2rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 1.6rem;
  line-height: 1.4;
}
@media screen and (max-width: 767px) {
.vl-title--h5[data-v-97867cb6] {
    font-size: 1.8rem;
    margin-bottom: 1.2rem;
}
}
.vl-title--h6[data-v-97867cb6] {
  font-size: 1.8rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 1.4rem;
  line-height: 1.44;
}
@media screen and (max-width: 767px) {
.vl-title--h6[data-v-97867cb6] {
    font-size: 1.8rem;
    margin-bottom: 1rem;
}
}
.vl-typography h1[data-v-97867cb6] {
  font-size: 4.4rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 6rem;
  line-height: 1.18;
}
@media screen and (max-width: 1023px) {
.vl-typography h1[data-v-97867cb6] {
    font-size: 4rem;
    margin-bottom: 4.5rem;
}
}
@media screen and (max-width: 767px) {
.vl-typography h1[data-v-97867cb6] {
    font-size: 3rem;
    margin-bottom: 3rem;
}
}
.vl-typography h1[data-v-97867cb6]:not(:first-child) {
  margin-top: 12rem;
}
.vl-typography h2[data-v-97867cb6] {
  font-size: 3.2rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 2rem;
  line-height: 1.24;
}
@media screen and (max-width: 767px) {
.vl-typography h2[data-v-97867cb6] {
    font-size: 2.6rem;
    margin-bottom: 1.5rem;
}
}
.vl-typography h2[data-v-97867cb6]:not(:first-child) {
  margin-top: 4rem;
}
.vl-typography h3[data-v-97867cb6] {
  font-size: 2.6rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 2rem;
  line-height: 1.3;
}
@media screen and (max-width: 767px) {
.vl-typography h3[data-v-97867cb6] {
    font-size: 2.2rem;
    margin-bottom: 1.5rem;
}
}
.vl-typography h3[data-v-97867cb6]:not(:first-child) {
  margin-top: 4rem;
}
.vl-typography h4[data-v-97867cb6] {
  font-size: 2.2rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 1.8rem;
  line-height: 1.36;
}
@media screen and (max-width: 767px) {
.vl-typography h4[data-v-97867cb6] {
    font-size: 2rem;
    margin-bottom: 1.4rem;
}
}
.vl-typography h4[data-v-97867cb6]:not(:first-child) {
  margin-top: 3.6rem;
}
.vl-typography h5[data-v-97867cb6] {
  font-size: 2rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 1.6rem;
  line-height: 1.4;
}
@media screen and (max-width: 767px) {
.vl-typography h5[data-v-97867cb6] {
    font-size: 1.8rem;
    margin-bottom: 1.2rem;
}
}
.vl-typography h5[data-v-97867cb6]:not(:first-child) {
  margin-top: 3.2rem;
}
.vl-typography h6[data-v-97867cb6] {
  font-size: 1.8rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 1.4rem;
  line-height: 1.44;
}
@media screen and (max-width: 767px) {
.vl-typography h6[data-v-97867cb6] {
    font-size: 1.8rem;
    margin-bottom: 1rem;
}
}
.vl-typography h6[data-v-97867cb6]:not(:first-child) {
  margin-top: 2.8rem;
}
.vl-title-wrapper__title[data-v-97867cb6] {
  margin-bottom: 0;
}
@media screen and (max-width: 767px) {
.vl-title-wrapper__vl-title[data-v-97867cb6] {
    margin-bottom: 0;
}
}
.vl-title-wrapper--h1[data-v-97867cb6] {
  margin-bottom: 6rem;
}
@media screen and (max-width: 767px) {
.vl-title-wrapper--h1[data-v-97867cb6] {
    margin-bottom: 3rem;
}
}
.vl-title-wrapper--h2[data-v-97867cb6] {
  margin-bottom: 2rem;
}
@media screen and (max-width: 767px) {
.vl-title-wrapper--h2[data-v-97867cb6] {
    margin-bottom: 1.5rem;
}
}
.vl-title-wrapper--h3[data-v-97867cb6] {
  margin-bottom: 2rem;
}
@media screen and (max-width: 767px) {
.vl-title-wrapper--h3[data-v-97867cb6] {
    margin-bottom: 1.5rem;
}
}
.vl-title-wrapper--h4[data-v-97867cb6] {
  margin-bottom: 1.8rem;
}
@media screen and (max-width: 767px) {
.vl-title-wrapper--h4[data-v-97867cb6] {
    margin-bottom: 1.4rem;
}
}
.vl-title-wrapper--h5[data-v-97867cb6] {
  margin-bottom: 1.6rem;
}
@media screen and (max-width: 767px) {
.vl-title-wrapper--h5[data-v-97867cb6] {
    margin-bottom: 1.2rem;
}
}
.vl-title-wrapper--h6[data-v-97867cb6] {
  margin-bottom: 1.4rem;
}
@media screen and (max-width: 767px) {
.vl-title-wrapper--h6[data-v-97867cb6] {
    margin-bottom: 1rem;
}
}
.vl-title-wrapper--cta[data-v-97867cb6] {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3rem;
}
@media screen and (max-width: 767px) {
.vl-title-wrapper--cta__title[data-v-97867cb6] {
    float: none;
}
}
.vl-title-wrapper--cta__cta--small[data-v-97867cb6] {
  font-size: 1.4rem;
  margin: 0.8rem 0 0;
}
.vl-title-wrapper--sublink .vl-title[data-v-97867cb6],
.vl-title-wrapper--cta .vl-title[data-v-97867cb6] {
  margin-bottom: 0;
}
.vl-title--no-space-bottom[data-v-97867cb6] {
  margin-bottom: 0;
}
.vl-toggle[data-v-97867cb6] {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  overflow: hidden;
  width: 100%;
}
.vl-toggle--align-top[data-v-97867cb6] {
  align-items: flex-start;
}
.vl-toggle--icon-right[data-v-97867cb6] {
  flex-direction: row-reverse;
}
.vl-toggle--icon-right .vl-accordion__title[data-v-97867cb6] {
  flex-grow: 1;
}
.vl-toggle > .vl-vi[data-v-97867cb6]::before {
  transition: transform 0.2s;
}
.vl-toggle > .vl-vi.vl-vi-arrow-right-fat[data-v-97867cb6]::before, .vl-toggle > .vl-vi.vl-vi-arrow-right-thin[data-v-97867cb6]::before {
  transform: rotate(90deg);
}
.js-vl-accordion--open > .vl-toggle .vl-vi-plus[data-v-97867cb6]::before,
.js-vl-accordion--open > .vl-toggle .vl-vi-minus[data-v-97867cb6]::before {
  transform: rotate(0);
}
.js-vl-accordion--open > .vl-toggle > .vl-vi-arrow-right-fat[data-v-97867cb6]::before, .js-vl-accordion--open > .vl-accordion__summary > .vl-toggle > .vl-vi-arrow-right-fat[data-v-97867cb6]::before, .js-vl-toggle--open > .vl-toggle > .vl-vi-arrow-right-fat[data-v-97867cb6]::before, [aria-expanded=true] > .vl-toggle > .vl-vi-arrow-right-fat[data-v-97867cb6]::before,
.js-vl-accordion--open > .vl-toggle > .vl-vi-arrow-right-thin[data-v-97867cb6]::before,
.js-vl-accordion--open > .vl-accordion__summary > .vl-toggle > .vl-vi-arrow-right-thin[data-v-97867cb6]::before,
.js-vl-toggle--open > .vl-toggle > .vl-vi-arrow-right-thin[data-v-97867cb6]::before,
[aria-expanded=true] > .vl-toggle > .vl-vi-arrow-right-thin[data-v-97867cb6]::before {
  transform: rotate(-90deg);
}
.vl-toggle.js-vl-drawer-active-item .vl-vi-arrow-right-fat[data-v-97867cb6]::before,
.vl-toggle.js-vl-drawer-active-item .vl-vi-arrow-right-thin[data-v-97867cb6]::before, .vl-toggle.js-vl-dynamic-drawer-active-item .vl-vi-arrow-right-fat[data-v-97867cb6]::before,
.vl-toggle.js-vl-dynamic-drawer-active-item .vl-vi-arrow-right-thin[data-v-97867cb6]::before {
  transform: rotate(-90deg);
}
.js-vl-toggle[data-v-97867cb6] {
  position: relative;
}
.js-vl-toggle--flex-reverse[data-v-97867cb6] {
  display: flex;
  flex-direction: column-reverse;
}
summary[data-v-97867cb6] {
  display: block;
}
summary[data-v-97867cb6]::-webkit-details-marker {
  display: none;
}
.vl-toggle-wrapper--more-button[data-v-97867cb6] {
  text-align: center;
  position: relative;
  overflow: hidden;
  transition: margin 0.2s;
}
.js-vl-accordion--open .vl-toggle-wrapper--more-button[data-v-97867cb6] {
  margin-top: 3rem;
}
.vl-toggle-wrapper--more-button + .vl-accordion__content[data-v-97867cb6] {
  display: block;
}
.vl-toggle--more-button[data-v-97867cb6] {
  display: flex;
  align-items: center;
  margin: 0 auto;
  position: relative;
  overflow: visible;
  line-height: 2.3rem;
  width: initial;
}
.vl-toggle--more-button[data-v-97867cb6]::before, .vl-toggle--more-button[data-v-97867cb6]::after {
  display: block;
  position: absolute;
  content: "";
  top: 50%;
  margin-top: -1px;
  height: 1px;
  width: 100vw;
  background-color: #cbd2da;
}
.vl-toggle--more-button[data-v-97867cb6]::before {
  right: calc(100% + 3px);
}
.vl-toggle--more-button[data-v-97867cb6]::after {
  left: calc(100% + 3px);
}
.vl-toggle--more-button[data-v-97867cb6]:hover, .vl-toggle--more-button[data-v-97867cb6]:focus {
  color: #05c;
}
.vl-toggle--more-button .vl-toggle__icon[data-v-97867cb6]:first-child {
  margin-right: 1rem;
}
.vl-toggle--more-button .vl-toggle__icon[data-v-97867cb6]:last-child {
  margin-left: 1rem;
}
.vl-toggle--more-button .vl-toggle__icon[data-v-97867cb6]::before {
  font-size: 1.2rem;
  color: currentColor;
  transition: transform 0.2s;
}
.js-vl-accordion--open .vl-toggle--more-button .vl-toggle__icon[data-v-97867cb6]::before {
  transform: rotate(-180deg);
}
.vl-typography ul[data-v-97867cb6],
.ul[data-v-97867cb6] {
  list-style-type: disc;
}
.vl-typography ol[data-v-97867cb6],
.ol[data-v-97867cb6] {
  list-style-type: decimal;
}
.vl-typography ol ol[data-v-97867cb6],
.vl-typography ol .ol[data-v-97867cb6],
.ol ol[data-v-97867cb6],
.ol .ol[data-v-97867cb6] {
  list-style-type: lower-latin;
}
.vl-typography ol[data-v-97867cb6],
.ol[data-v-97867cb6],
.vl-typography ul[data-v-97867cb6],
.ul[data-v-97867cb6] {
  display: block;
  margin: 1.8rem 0 2rem 1rem;
  padding-left: 2rem;
}
.vl-typography ol[data-v-97867cb6]:first-child,
.ol[data-v-97867cb6]:first-child,
.vl-typography ul[data-v-97867cb6]:first-child,
.ul[data-v-97867cb6]:first-child {
  margin-top: 0;
}
.vl-typography ol[data-v-97867cb6]:last-child,
.ol[data-v-97867cb6]:last-child,
.vl-typography ul[data-v-97867cb6]:last-child,
.ul[data-v-97867cb6]:last-child {
  margin-bottom: 0;
}
.vl-typography ol li[data-v-97867cb6],
.ol li[data-v-97867cb6],
.vl-typography ul li[data-v-97867cb6],
.ul li[data-v-97867cb6] {
  display: list-item;
  margin-bottom: 0.5em;
}
.vl-typography ol li[data-v-97867cb6]:last-child,
.ol li[data-v-97867cb6]:last-child,
.vl-typography ul li[data-v-97867cb6]:last-child,
.ul li[data-v-97867cb6]:last-child {
  margin-bottom: 0;
}
.vl-typography ol ul[data-v-97867cb6],
.ol ul[data-v-97867cb6],
.vl-typography ul ul[data-v-97867cb6],
.ul ul[data-v-97867cb6] {
  list-style-type: circle;
}
.vl-typography ol ul[data-v-97867cb6],
.vl-typography ol ol[data-v-97867cb6],
.ol ul[data-v-97867cb6],
.ol ol[data-v-97867cb6],
.vl-typography ul ul[data-v-97867cb6],
.vl-typography ul ol[data-v-97867cb6],
.ul ul[data-v-97867cb6],
.ul ol[data-v-97867cb6] {
  margin: 0.5em 0 0.5rem 1.5em;
}
.vl-typography ol ul[data-v-97867cb6]:first-child,
.vl-typography ol ol[data-v-97867cb6]:first-child,
.ol ul[data-v-97867cb6]:first-child,
.ol ol[data-v-97867cb6]:first-child,
.vl-typography ul ul[data-v-97867cb6]:first-child,
.vl-typography ul ol[data-v-97867cb6]:first-child,
.ul ul[data-v-97867cb6]:first-child,
.ul ol[data-v-97867cb6]:first-child {
  margin-top: 0;
}
.vl-typography ol ul[data-v-97867cb6]:last-child,
.vl-typography ol ol[data-v-97867cb6]:last-child,
.ol ul[data-v-97867cb6]:last-child,
.ol ol[data-v-97867cb6]:last-child,
.vl-typography ul ul[data-v-97867cb6]:last-child,
.vl-typography ul ol[data-v-97867cb6]:last-child,
.ul ul[data-v-97867cb6]:last-child,
.ul ol[data-v-97867cb6]:last-child {
  margin-bottom: 0;
}
.vl-typography p[data-v-97867cb6],
.p[data-v-97867cb6] {
  margin-bottom: 1.8rem;
}
.vl-typography p[data-v-97867cb6]:last-child,
.p[data-v-97867cb6]:last-child {
  margin-bottom: 0;
}
.vl-typography ul li p[data-v-97867cb6]:last-child,
.vl-typography ul li .p[data-v-97867cb6]:last-child {
  margin-bottom: 1.8rem;
}
.vl-typography strong[data-v-97867cb6],
.vl-typography b[data-v-97867cb6] {
  font-weight: 500;
}
.vl-typography em[data-v-97867cb6],
.vl-typography i[data-v-97867cb6] {
  font-style: italic;
}
.vl-typography strike[data-v-97867cb6],
.vl-typography s[data-v-97867cb6] {
  text-decoration: line-through;
}
.vl-typography hr[data-v-97867cb6] {
  display: block;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  margin-left: auto;
  margin-right: auto;
  border: 0;
  border-top: 1px solid #cbd2da;
}
.vl-typography table[data-v-97867cb6] {
  width: 100%;
  max-width: 100%;
}
.vl-typography table thead tr[data-v-97867cb6] {
  border-bottom: 3px #cbd2da solid;
}
.vl-typography table tbody tr[data-v-97867cb6] {
  border-bottom: 1px #cbd2da solid;
}
.vl-typography table tbody tr[data-vl-table-selectable][data-v-97867cb6] {
  transition: background 0.2s ease-in-out;
  cursor: pointer;
}
.vl-typography table tbody tr[data-vl-table-selectable][data-v-97867cb6]:hover {
  background: #f3f5f6;
}
.vl-typography table tbody tr.vl-data-table__grouped-row[data-v-97867cb6]:not(.vl-data-table__grouped-row--last) {
  border-bottom: 0;
}
.vl-typography table td[data-v-97867cb6],
.vl-typography table th[data-v-97867cb6] {
  text-align: left;
  font-size: 1.6rem;
  line-height: 1.3;
  vertical-align: top;
  padding: 1.2rem 1rem;
}
@media screen and (max-width: 767px) {
.vl-typography table td[data-v-97867cb6],
  .vl-typography table th[data-v-97867cb6] {
    padding: 1rem;
}
}
@media screen and (max-width: 767px) {
.vl-typography table td[data-v-97867cb6],
  .vl-typography table th[data-v-97867cb6] {
    font-size: 1.4rem;
}
}
.vl-typography table td[data-v-97867cb6]:first-child,
.vl-typography table th[data-v-97867cb6]:first-child {
  border-left: 0;
}
.vl-typography table th[data-v-97867cb6] {
  font-weight: 500;
}
.vl-typography table .vl-data-table__grouped-row td[data-v-97867cb6] {
  padding: 0.3rem 1rem 0.3rem 0;
}
@media screen and (max-width: 767px) {
.vl-typography table .vl-data-table__grouped-row td[data-v-97867cb6] {
    padding: 0.3rem 1rem 0.3rem 0;
}
}
.vl-typography table .vl-data-table__grouped-row--first td[data-v-97867cb6] {
  padding-top: 1.2rem;
}
@media screen and (max-width: 767px) {
.vl-typography table .vl-data-table__grouped-row--first td[data-v-97867cb6] {
    padding-top: 1rem;
}
}
.vl-typography table .vl-data-table__grouped-row--last td[data-v-97867cb6] {
  padding-bottom: 1.2rem;
}
@media screen and (max-width: 767px) {
.vl-typography table .vl-data-table__grouped-row--last td[data-v-97867cb6] {
    padding-bottom: 1rem;
}
}
.vl-typography table__header-title--sortable[data-v-97867cb6] {
  text-decoration: none;
}
.vl-typography table__header-title--sortable .vl-data-table__header-title__sort-icon[data-v-97867cb6] {
  opacity: 0;
}
.vl-typography table__header-title--sortable[data-v-97867cb6]:hover, .vl-typography table__header-title--sortable[data-v-97867cb6]:focus {
  text-decoration: underline;
}
.vl-typography table__header-title--sortable:hover .vl-data-table__header-title__sort-icon[data-v-97867cb6], .vl-typography table__header-title--sortable:focus .vl-data-table__header-title__sort-icon[data-v-97867cb6] {
  opacity: 0.5;
}
.vl-typography table__header-title--sortable-active .vl-data-table__header-title__sort-icon[data-v-97867cb6] {
  opacity: 1;
}
.vl-typography table__body-title[data-v-97867cb6] {
  max-width: 30rem;
}
.vl-typography table--alt tr td[data-v-97867cb6]:not(:first-child) {
  padding: 1.2rem;
}
.vl-typography table--alt tr th[data-v-97867cb6]:not(:first-child) {
  padding: 0 1.2rem 1.2rem;
}
.vl-typography table--alt tr th[data-v-97867cb6]:first-child,
.vl-typography table--alt tr td[data-v-97867cb6]:first-child {
  border-right: 1px #cbd2da solid;
}
.vl-typography table.vl-data-table--no-header tbody tr[data-v-97867cb6]:first-child {
  border-top: 3px #cbd2da solid;
}
.vl-typography table .vl-pill[data-v-97867cb6] {
  vertical-align: middle;
}
@media screen and (max-width: 767px) {
.vl-typography table .vl-pill[data-v-97867cb6] {
    height: 2rem;
    line-height: 2rem;
    padding: 0 0.5rem;
    font-size: 1.4rem;
}
}
.vl-typography table[data-v-97867cb6] {
  margin-bottom: 2rem;
}
.vl-typography blockquote[data-v-97867cb6] {
  position: relative;
  padding-left: 9rem;
  font-size: 3.4rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 400;
  margin-bottom: 2rem;
  line-height: 1.5;
}
@media screen and (max-width: 767px) {
.vl-typography blockquote[data-v-97867cb6] {
    padding-left: 5rem;
}
}
.vl-typography blockquote[data-v-97867cb6]::before {
  position: absolute;
  content: "“";
  font-size: 9rem;
  left: 0;
  top: 0;
  padding-top: 1rem;
  padding-left: 1rem;
  width: 7rem;
  height: 6rem;
  line-height: 1;
  color: #333332;
  background: linear-gradient(-110deg, transparent 20px, var(--vl-theme-primary-color) 20px);
}
@media screen and (max-width: 767px) {
.vl-typography blockquote[data-v-97867cb6]::before {
    width: 4.6rem;
    font-size: 6rem;
    height: 3.6rem;
    padding-right: 1.5rem;
    padding-top: 0.5rem;
    padding-left: 0.5rem;
    margin-right: 0rem;
}
}
.vl-typography pre[data-v-97867cb6]:not([class*=language]) {
  padding: 1.5rem;
  background-color: #333332;
  color: #fff;
  display: block;
  white-space: pre;
  overflow-x: scroll;
  -moz-tab-size: 2;
    -o-tab-size: 2;
       tab-size: 2;
  word-break: normal;
  hyphens: none;
}
.vl-typography pre:not([class*=language]) code[data-v-97867cb6],
.vl-typography pre:not([class*=language]) kdb[data-v-97867cb6],
.vl-typography pre:not([class*=language]) samp[data-v-97867cb6] {
  background-color: transparent;
  padding: 0;
}
.vl-typography code[data-v-97867cb6],
.vl-typography kdb[data-v-97867cb6],
.vl-typography samp[data-v-97867cb6] {
  font-family: monospace;
  background: #e8ebee;
  padding: 0.2rem;
}
.vl-typography a[data-v-97867cb6],
.vl-typography .vl-link[data-v-97867cb6],
.vl-typography .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6],
.vl-sidebar-panel-list-item__button .vl-typography .vl-icon[data-v-97867cb6],
.vl-typography .vl-sidebar-header__toggle[data-v-97867cb6] {
  display: inline;
  text-decoration: underline;
}
.vl-typography a[data-v-97867cb6]:hover,
.vl-typography .vl-link[data-v-97867cb6]:hover,
.vl-typography .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6]:hover,
.vl-sidebar-panel-list-item__button .vl-typography .vl-icon[data-v-97867cb6]:hover,
.vl-typography .vl-sidebar-header__toggle[data-v-97867cb6]:hover {
  text-decoration: none;
}
.vl-typography a[data-v-97867cb6]:focus, .vl-typography a[data-v-97867cb6]:active,
.vl-typography .vl-link[data-v-97867cb6]:focus,
.vl-typography .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6]:focus,
.vl-sidebar-panel-list-item__button .vl-typography .vl-icon[data-v-97867cb6]:focus,
.vl-typography .vl-sidebar-header__toggle[data-v-97867cb6]:focus,
.vl-typography .vl-link[data-v-97867cb6]:active,
.vl-typography .vl-sidebar-panel-list-item__button .vl-icon[data-v-97867cb6]:active,
.vl-sidebar-panel-list-item__button .vl-typography .vl-icon[data-v-97867cb6]:active,
.vl-typography .vl-sidebar-header__toggle[data-v-97867cb6]:active {
  text-decoration: none;
}
.vl-typography--prewrapped[data-v-97867cb6] {
  white-space: pre-wrap;
}
.vl-upload[data-v-97867cb6] {
  position: relative;
  margin-bottom: 1rem;
  transition: background-color 0.3s ease-out;
}
.vl-upload--basic .vl-upload__element__input[data-v-97867cb6] {
  width: 100%;
  height: auto;
  margin: 0;
  opacity: 1;
  pointer-events: auto;
  position: relative;
  overflow: auto;
}
.vl-upload--error .vl-upload__element[data-v-97867cb6], .vl-upload--error .vl-upload__element[data-v-97867cb6]:hover {
  border-color: #d2373c;
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
}
.vl-upload--error .vl-upload__element .vl-upload__element__label[data-v-97867cb6]:hover, .vl-upload--error .vl-upload__element:hover .vl-upload__element__label[data-v-97867cb6]:hover {
  background-color: transparent;
}
.vl-upload--success .vl-upload__element[data-v-97867cb6], .vl-upload--success .vl-upload__element[data-v-97867cb6]:hover {
  border-color: #009e47;
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
}
.vl-upload--success .vl-upload__element .vl-upload__element__label[data-v-97867cb6]:hover, .vl-upload--success .vl-upload__element:hover .vl-upload__element__label[data-v-97867cb6]:hover {
  background-color: transparent;
}
.vl-upload--disabled .vl-upload__element[data-v-97867cb6] {
  background-color: #cbd2d9;
}
.vl-upload--disabled .vl-upload__element[data-v-97867cb6]:hover, .vl-upload--disabled .vl-upload__element[data-v-97867cb6]:focus {
  background-color: #cbd2d9;
  border: 0.1rem dashed #8695a8;
}
.vl-upload--disabled .vl-upload__element:hover .vl-upload__element__label[data-v-97867cb6], .vl-upload--disabled .vl-upload__element:focus .vl-upload__element__label[data-v-97867cb6] {
  background-color: transparent;
  padding: 1rem;
}
.vl-upload--disabled .vl-upload__element .vl-upload__element__label[data-v-97867cb6] {
  cursor: not-allowed;
}
.vl-upload--disabled .vl-upload__element .vl-upload__element__label .vl-upload__element__button[data-v-97867cb6] {
  color: #687483;
  text-decoration: none;
  cursor: not-allowed;
}
.vl-upload__overlay[data-v-97867cb6] {
  position: absolute;
  display: none;
  pointer-events: none;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border: 0.1rem dashed #05c;
  z-index: 10;
  opacity: 0.9;
  font-family: "Flanders Art Sans", sans-serif;
}
.vl-upload__overlay__text[data-v-97867cb6] {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 80%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 1.4rem;
}
.vl-upload__overlay__text .vl-vi[data-v-97867cb6] {
  font-size: 2rem;
  display: block;
  color: #05c;
}
.vl-upload__files[data-v-97867cb6]::before, .vl-upload__files[data-v-97867cb6]::after {
  content: "";
  display: table;
}
.vl-upload__files[data-v-97867cb6]::after {
  clear: both;
}
.vl-upload__files[data-v-97867cb6] {
  margin-bottom: 2rem;
  display: none;
  position: relative;
}
.vl-upload__files--has-files[data-v-97867cb6] {
  display: block;
}
.vl-upload__files__close[data-v-97867cb6] {
  margin: 1rem 0 0;
  float: right;
}
.vl-upload__files__close .vl-vi[data-v-97867cb6] {
  margin-right: 0.5rem;
}
@media screen and (max-width: 767px) {
.vl-upload__files__close[data-v-97867cb6] {
    float: none;
}
}
.vl-upload__file[data-v-97867cb6] {
  position: relative;
  margin-bottom: 0.2rem;
  padding: 1rem 1.5rem;
  z-index: 5;
  font-family: "Flanders Art Sans", sans-serif;
  border: 0;
}
.vl-upload__file[data-v-97867cb6]:last-child {
  border-bottom: 0;
}
.vl-upload__file[data-v-97867cb6]:hover {
  background-color: rgba(179, 207, 245, 0.3);
}
.vl-upload__file__size[data-v-97867cb6] {
  color: #687483;
}
.vl-upload__file__name[data-v-97867cb6] {
  color: #333332;
  max-width: calc(100% - 2rem);
  word-break: break-all;
}
@supports (overflow-wrap: break-word) {
.vl-upload__file__name[data-v-97867cb6] {
    overflow-wrap: break-word;
    word-break: normal;
}
}
.vl-upload__file__name__icon[data-v-97867cb6] {
  display: inline-block;
  transform: translateY(-1px);
  line-height: 2rem;
  padding-right: 1rem;
  color: #687483;
}
.vl-upload__file__close[data-v-97867cb6] {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  padding: 1rem;
  margin-right: 1rem;
  color: #05c;
  box-shadow: none;
  overflow: hidden;
}
.vl-upload__file__close .vl-vi[data-v-97867cb6] {
  height: 1.1rem;
  width: 1.1rem;
  font-size: 1.6rem;
}
@media screen and (max-width: 1023px) {
.vl-upload__file__close .vl-vi[data-v-97867cb6] {
    font-size: 1.4rem;
}
}
.vl-upload__file__close[data-v-97867cb6]:hover {
  box-shadow: none;
}
.vl-upload__file__close[data-v-97867cb6]:focus {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
}
.vl-upload__file.dz-error[data-v-97867cb6], .vl-upload__file--error[data-v-97867cb6] {
  border: 0.1rem solid #edafb1;
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
  padding-left: 6.5rem;
}
@media screen and (max-width: 767px) {
.vl-upload__file.dz-error[data-v-97867cb6], .vl-upload__file--error[data-v-97867cb6] {
    padding-left: 5rem;
}
}
.vl-upload__file.dz-error[data-v-97867cb6]::before, .vl-upload__file--error[data-v-97867cb6]::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  position: absolute;
  display: inline-flex;
  top: 50%;
  left: 2rem;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
}
@media screen and (max-width: 767px) {
.vl-upload__file.dz-error[data-v-97867cb6]::before, .vl-upload__file--error[data-v-97867cb6]::before {
    left: 1.5rem;
    width: 18px;
    height: 18px;
}
}
.vl-upload__file.dz-error .vl-upload__file__name[data-v-97867cb6], .vl-upload__file--error .vl-upload__file__name[data-v-97867cb6] {
  font-weight: 500;
}
.vl-upload__file.dz-error .vl-upload__file__error[data-v-97867cb6],
.vl-upload__file.dz-error .dz-error-message[data-v-97867cb6], .vl-upload__file--error .vl-upload__file__error[data-v-97867cb6],
.vl-upload__file--error .dz-error-message[data-v-97867cb6] {
  font-size: 0.9em;
}
.vl-upload__file.dz-error .vl-upload__file__name__icon[data-v-97867cb6], .vl-upload__file--error .vl-upload__file__name__icon[data-v-97867cb6] {
  display: none;
}
.vl-upload__file.dz-error .vl-upload__file__close[data-v-97867cb6], .vl-upload__file--error .vl-upload__file__close[data-v-97867cb6] {
  cursor: pointer;
}
.vl-upload__file.dz-error .vl-upload__file__close .vl-vi[data-v-97867cb6], .vl-upload__file--error .vl-upload__file__close .vl-vi[data-v-97867cb6] {
  color: #333332;
}
.vl-upload__file.dz-error .vl-upload__file__close[data-v-97867cb6]:focus, .vl-upload__file--error .vl-upload__file__close[data-v-97867cb6]:focus {
  box-shadow: 0 0 0 2px rgb(98.2352941176%, 92.1568627451%, 92.3529411765%), 0 0 0 5px rgba(0, 85, 204, 0.65);
}
.vl-upload__file.dz-error.vl-upload__file--error-size .vl-upload__file__size[data-v-97867cb6], .vl-upload__file--error.vl-upload__file--error-size .vl-upload__file__size[data-v-97867cb6] {
  color: #333332;
}
.vl-upload__file.dz-error[data-v-97867cb6]:hover, .vl-upload__file--error[data-v-97867cb6]:hover {
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
}
.vl-upload.upload--dragging .vl-upload__overlay[data-v-97867cb6] {
  opacity: 1;
  display: block;
}
.vl-upload.upload--dragging .vl-upload__element[data-v-97867cb6] {
  min-height: 8.75rem;
}
.vl-upload__element[data-v-97867cb6] {
  font-family: "Flanders Art Sans", sans-serif;
  border: 0.1rem dashed #8695a8;
  border-radius: 0.3rem;
  text-align: center;
  position: relative;
  z-index: 4;
  min-height: 100%;
}
.vl-upload__element[data-v-97867cb6]:hover {
  border-width: 0.2rem;
  border-color: rgba(0, 85, 204, 0.65);
}
.vl-upload__element:hover .vl-upload__element__label[data-v-97867cb6] {
  background-color: rgba(179, 207, 245, 0.3);
  padding: 0.9rem;
}
.vl-upload__element__input[data-v-97867cb6] {
  opacity: 0;
  pointer-events: none;
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 1rem;
  overflow: hidden;
}
.vl-upload__element__input[data-v-97867cb6]:focus {
  outline: none;
}
.vl-upload__element__input:focus + label[data-v-97867cb6] {
  background-color: rgba(179, 207, 245, 0.3);
}
.vl-upload__element__label[data-v-97867cb6] {
  color: #05c;
  display: block;
  padding: 1rem;
  cursor: pointer;
  background-color: transparent;
  transition: background-color 0.3s ease-out;
  height: 100%;
}
.vl-upload__element__label .vl-vi[data-v-97867cb6] {
  display: inline-block;
  font-size: 1.4rem;
  margin-right: 0.5rem;
  line-height: 2.4rem;
  top: 1px;
}
.vl-upload__element__label small[data-v-97867cb6] {
  font-size: 1.4rem;
  color: #687483;
  display: none;
  text-decoration: none;
  text-align: center;
  line-height: 1.5;
  margin-top: 0.5rem;
}
.vl-upload .vl-upload__element__label small[data-v-97867cb6] {
  display: block;
}
.vl-upload .vl-upload__element__label__error[data-v-97867cb6] {
  color: #d2373c;
  font-size: 0.9em;
}
.vl-upload--dragging .vl-upload__overlay[data-v-97867cb6] {
  opacity: 1;
  display: block;
}
.no-js .vl-upload__element__label[data-v-97867cb6] {
  display: none;
}
.dz-image-preview[data-v-97867cb6] {
  overflow: hidden;
}
.vl-upload__element__button[data-v-97867cb6] {
  border-radius: 0;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  border: 0;
  background-color: transparent;
  padding: 0;
  display: inline-flex;
  color: inherit;
  font-size: inherit;
  line-height: 2.4rem;
}
.vl-upload--dragging [data-vl-upload-full-body-drop][data-v-97867cb6] {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  min-height: 100vh;
  z-index: 10006;
  margin: 0;
}
.dropzone .dz-message .dz-button[data-v-97867cb6] {
  border-radius: 0;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  border: 0;
  background-color: transparent;
  padding: 0;
  width: 100%;
  font-size: inherit;
}
.dropzone .dz-message .dz-button[data-v-97867cb6]:focus::after {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  background-color: rgba(179, 207, 245, 0.3);
  content: "";
}
.js-vl-autocomplete[data-v-97867cb6] {
  position: relative;
}
.js-vl-autocomplete input[data-v-97867cb6],
.js-vl-autocomplete select[data-v-97867cb6] {
  position: relative;
  z-index: 2;
}
.js-vl-autocomplete .vl-autocomplete[data-v-97867cb6] {
  position: absolute;
  z-index: 3;
  top: calc(100% + 0.7rem);
  right: 0;
  left: 0;
  background: #fff;
  border: 0.1rem solid #8695a8;
  border-radius: 0.3rem;
}
.js-vl-autocomplete .vl-autocomplete[data-vl-position=up][data-v-97867cb6] {
  top: auto;
  bottom: calc(100% + 0.7rem);
}
.no-js .js-vl-autocomplete .vl-autocomplete[data-v-97867cb6], .js-vl-autocomplete .vl-autocomplete[data-vl-show=false][data-v-97867cb6] {
  display: none !important;
}
.js-vl-autocomplete .vl-autocomplete__list-wrapper[data-v-97867cb6] {
  max-height: 35vh;
  overflow: auto;
}
.js-vl-autocomplete .vl-autocomplete__cta[data-v-97867cb6] {
  display: block;
  padding: 1rem;
  transition: background 0.1s ease-in-out;
  border-top: 1px #cbd2da solid;
  text-decoration: none;
}
.js-vl-autocomplete .vl-autocomplete__cta[data-v-97867cb6]:hover, .js-vl-autocomplete .vl-autocomplete__cta[data-v-97867cb6]:focus, .js-vl-autocomplete .vl-autocomplete__cta.vl-autocomplete__cta--focus[data-v-97867cb6] {
  background: rgba(179, 207, 245, 0.3);
}
.js-vl-autocomplete .vl-autocomplete__cta[data-v-97867cb6]:focus, .js-vl-autocomplete .vl-autocomplete__cta.vl-autocomplete__cta--focus[data-v-97867cb6] {
  outline: 0;
}
.js-vl-autocomplete .vl-autocomplete__cta__sub[data-v-97867cb6] {
  display: block;
  color: #687483;
  font-size: 1.4rem;
}
.js-vl-autocomplete .vl-autocomplete__cta__title[data-v-97867cb6] {
  display: block;
  color: #333332;
}
.js-vl-autocomplete .vl-autocomplete__cta__title--location[data-v-97867cb6]::before, .js-vl-autocomplete .vl-autocomplete__cta__title--location[data-v-97867cb6]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.js-vl-autocomplete .vl-autocomplete__cta__title--location[data-v-97867cb6]::before {
  content: "\\f1fb";
}
.js-vl-autocomplete .vl-autocomplete__cta__title--location[data-v-97867cb6] {
  color: #05c;
  text-decoration: underline;
}
.js-vl-autocomplete .vl-autocomplete__cta__title--location[data-v-97867cb6]::before {
  display: inline-block;
  margin: 0 1rem 0 0.3rem;
  transform: scale(1.5);
  color: #333332;
  font-size: 0.7em;
  vertical-align: middle;
}
.js-vl-autocomplete .vl-autocomplete__item:first-child .vl-autocomplete__cta[data-v-97867cb6] {
  border: 0;
}
.js-vl-autocomplete .vl-autocomplete__alert[data-v-97867cb6] {
  display: block;
  padding: 1rem;
  font-weight: 400;
  text-decoration: none;
}
.js-vl-autocomplete .vl-autocomplete__alert__title[data-v-97867cb6] {
  display: block;
  line-height: 1.2;
}
.js-vl-autocomplete .vl-autocomplete__alert__subtitle[data-v-97867cb6] {
  display: block;
  color: #687483;
  font-size: 1.4rem;
}
.js-vl-autocomplete .vl-autocomplete__loader[data-v-97867cb6] {
  position: absolute;
  top: 0;
  right: 0;
  width: 5rem;
  height: 3.5rem;
  z-index: 2;
}
.js-vl-autocomplete .vl-autocomplete__loader[data-v-97867cb6]::before {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 4px;
  height: 4px;
  margin-top: -2px;
  margin-left: -22px;
  border-radius: 50%;
  box-shadow: 10px -0px #cbd2da, 20px -0px #cbd2da, 30px 0px #cbd2da;
  content: "";
  animation: "waving-dark" infinite 1s linear;
}
@keyframes waving-dark-97867cb6 {
0% {
    box-shadow: 10px -0px #687483, 20px -0px #687483, 30px 0px #687483;
}
10% {
    box-shadow: 10px -3px #687483, 20px -0px #687483, 30px -0px #687483;
}
20% {
    box-shadow: 10px -6px #687483, 20px -3px #687483, 30px -0px #687483;
}
30% {
    box-shadow: 10px -3px #687483, 20px -6px #687483, 30px -3px #687483;
}
40% {
    box-shadow: 10px -0px #687483, 20px -3px #687483, 30px -6px #687483;
}
50% {
    box-shadow: 10px -0px #687483, 20px -0px #687483, 30px -3px #687483;
}
60% {
    box-shadow: 10px -0px #687483, 20px -0px #687483, 30px -0px #687483;
}
100% {
    box-shadow: 10px -0px #687483, 20px -0px #687483, 30px -0px #687483;
}
}
.js-vl-autocomplete .vl-autocomplete__loader[data-vl-show=false][data-v-97867cb6] {
  display: none;
}
.vl-progress-bar[data-v-97867cb6] {
  display: table;
  table-layout: fixed;
  width: 100%;
  height: 2.2rem;
  margin-bottom: 2.7rem;
}
@media screen and (max-width: 767px) {
.vl-progress-bar[data-v-97867cb6] {
    height: 1.8rem;
    margin-bottom: 0px;
}
}
.vl-progress-bar__step[data-v-97867cb6] {
  position: relative;
  display: table-cell;
}
.vl-progress-bar__step[data-v-97867cb6]::before {
  display: block;
  position: absolute;
  background-color: #8695a8;
  content: "";
  height: 0.3rem;
  top: 50%;
  right: 2.3rem;
  left: 0.2rem;
  transform: translate(0%, -50%);
}
@media screen and (max-width: 767px) {
.vl-progress-bar__step[data-v-97867cb6]::before {
    right: 1.9rem;
}
}
.vl-progress-bar__step--active[data-v-97867cb6]::before {
  background: #8695a8;
  right: 2.7rem;
}
@media screen and (max-width: 767px) {
.vl-progress-bar__step--active[data-v-97867cb6]::before {
    right: 2.3rem;
}
}
.vl-progress-bar__step--active .vl-progress-bar__bullet[data-v-97867cb6] {
  background-color: #8695a8;
  border-color: #8695a8;
  width: 2.2rem;
  height: 2.2rem;
}
@media screen and (max-width: 767px) {
.vl-progress-bar__step--active .vl-progress-bar__bullet[data-v-97867cb6] {
    width: 1.8rem;
    height: 1.8rem;
}
}
.vl-progress-bar__step--active ~ .vl-progress-bar__step .vl-progress-bar__bullet[data-v-97867cb6], .vl-progress-bar__step--active ~ .vl-progress-bar__step[data-v-97867cb6]::before {
  background-color: #cfd5dd;
  border-color: #cfd5dd;
}
.vl-region--alt .vl-progress-bar__step--active ~ .vl-progress-bar__step .vl-progress-bar__bullet[data-v-97867cb6], .vl-region--alt .vl-progress-bar__step--active ~ .vl-progress-bar__step[data-v-97867cb6]::before {
  background-color: #cfd5dd;
}
.vl-progress-bar__step--active ~ .vl-progress-bar__step .vl-progress-bar__bullet[data-v-97867cb6]::after {
  color: #687483;
}
.vl-progress-bar__step--active ~ .vl-progress-bar__step .vl-progress-bar__bullet__text[data-v-97867cb6] {
  color: #687483;
}
.vl-progress-bar__step:last-child .vl-progress-bar__bullet__text[data-v-97867cb6] {
  max-width: 8rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vl-progress-bar__bullet[data-v-97867cb6] {
  position: absolute;
  background-color: #8695a8;
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 50%;
  top: 50%;
  right: 0.2rem;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border-style: solid;
  border-color: #8695a8;
  padding: 0;
  transform: translate(0%, -50%);
}
@media screen and (max-width: 767px) {
.vl-progress-bar__bullet[data-v-97867cb6] {
    width: 1.4rem;
    height: 1.4rem;
}
}
.vl-progress-bar__bullet[data-v-97867cb6]::after {
  color: #333332;
}
.vl-progress-bar__bullet__text[data-v-97867cb6] {
  position: absolute;
  transform: translate(-50%, 1.6rem);
  font-size: 1.6rem;
  white-space: nowrap;
}
.vl-progress-bar a .vl-progress-bar__bullet[data-v-97867cb6]:hover::after {
  color: #003bb0;
}
.vl-progress-bar--numeric[data-v-97867cb6] {
  counter-reset: progressbar-counter;
  height: 4.2rem;
  margin-bottom: 2.6rem;
}
@media screen and (max-width: 767px) {
.vl-progress-bar--numeric[data-v-97867cb6] {
    height: 3.5rem;
    margin-bottom: 0px;
}
}
.vl-progress-bar--numeric .vl-progress-bar__step[data-v-97867cb6]::before {
  right: 3.7rem;
}
@media screen and (max-width: 767px) {
.vl-progress-bar--numeric .vl-progress-bar__step[data-v-97867cb6]::before {
    right: 3rem;
}
}
.vl-progress-bar--numeric .vl-progress-bar__step .vl-progress-bar__bullet[data-v-97867cb6] {
  width: 3.2rem;
  height: 3.2rem;
  text-decoration: none;
  background-color: var(--vl-theme-primary-color);
  border-color: var(--vl-theme-primary-color);
}
@media screen and (max-width: 767px) {
.vl-progress-bar--numeric .vl-progress-bar__step .vl-progress-bar__bullet[data-v-97867cb6] {
    width: 2.5rem;
    height: 2.5rem;
}
}
.vl-progress-bar--numeric .vl-progress-bar__step .vl-progress-bar__bullet[data-v-97867cb6]::after {
  position: absolute;
  content: counter(progressbar-counter);
  counter-increment: progressbar-counter;
  font-family: "Flanders Art Serif", serif;
  font-size: 1.8rem;
  font-weight: 500;
  width: 100%;
  height: 100%;
  text-align: center;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media screen and (max-width: 767px) {
.vl-progress-bar--numeric .vl-progress-bar__step .vl-progress-bar__bullet[data-v-97867cb6]::after {
    font-size: 1.4rem;
}
}
.vl-progress-bar--numeric .vl-progress-bar__step .vl-progress-bar__bullet__text[data-v-97867cb6] {
  transform: translate(-50%, 2.6rem);
}
.vl-progress-bar--numeric .vl-progress-bar__step--active[data-v-97867cb6]::before {
  right: 4.7rem;
}
@media screen and (max-width: 767px) {
.vl-progress-bar--numeric .vl-progress-bar__step--active[data-v-97867cb6]::before {
    right: 4rem;
}
}
.vl-progress-bar--numeric .vl-progress-bar__step--active .vl-progress-bar__bullet[data-v-97867cb6] {
  width: 4.2rem;
  height: 4.2rem;
}
@media screen and (max-width: 767px) {
.vl-progress-bar--numeric .vl-progress-bar__step--active .vl-progress-bar__bullet[data-v-97867cb6] {
    width: 3.5rem;
    height: 3.5rem;
}
}
.vl-progress-bar--numeric .vl-progress-bar__step--active .vl-progress-bar__bullet[data-v-97867cb6]::after {
  font-size: 2.2rem;
}
@media screen and (max-width: 767px) {
.vl-progress-bar--numeric .vl-progress-bar__step--active .vl-progress-bar__bullet[data-v-97867cb6]::after {
    font-size: 1.8rem;
}
}
.vl-progress-bar--numeric .vl-progress-bar__step--active ~ .vl-progress-bar__step .vl-progress-bar__bullet[data-v-97867cb6], .vl-progress-bar--numeric .vl-progress-bar__step--active ~ .vl-progress-bar__step[data-v-97867cb6]::before {
  background-color: #cfd5dd;
  border-color: #cfd5dd;
}
.vl-tooltip[data-v-97867cb6] {
  max-width: 27rem;
  background: #fff;
  border: 1px #cfd5dd solid;
  text-align: center;
  font-size: 1.6rem;
  line-height: 1.25;
  font-weight: 400;
  color: #333332;
  font-family: "Flanders Art Sans", sans-serif;
  padding: 0.3rem 1rem;
  z-index: 10009;
  position: relative;
  box-shadow: 0 0 2rem 0 rgba(51, 51, 50, 0.15);
}
.vl-tooltip[data-v-97867cb6]::before {
  content: "";
  position: absolute;
  top: -0.9rem;
  right: -0.9rem;
  bottom: -0.9rem;
  left: -0.9rem;
  z-index: 0;
}
.vl-tooltip--static[data-v-97867cb6] {
  display: block;
  pointer-events: auto;
}
.vl-tooltip--static[x-placement^=top][data-v-97867cb6], .vl-tooltip--static[data-popper-placement^=top][data-v-97867cb6] {
  transform: translate(-50%, -100%);
  margin-left: 50%;
}
.vl-tooltip--static[x-placement^=left][data-v-97867cb6], .vl-tooltip--static[data-popper-placement^=left][data-v-97867cb6] {
  transform: translate(-100%, 0%);
}
.vl-tooltip--static[x-placement^=bottom][data-v-97867cb6], .vl-tooltip--static[data-popper-placement^=bottom][data-v-97867cb6] {
  transform: translate(-50%, 0%);
  margin-left: 50%;
  top: 100%;
}
.vl-tooltip--static[x-placement^=right][data-v-97867cb6], .vl-tooltip--static[data-popper-placement^=right][data-v-97867cb6] {
  margin-left: calc(100% + 10px);
}
.vl-tooltip .tooltip__inner[data-v-97867cb6] {
  position: relative;
  z-index: 1;
}
.vl-tooltip.vl-tooltip--large[data-v-97867cb6] {
  font-weight: 400;
  font-size: 1.4rem;
  padding: 2rem 3.2rem 2rem 2rem;
}
.vl-tooltip.vl-tooltip--large .tooltip__inner[data-v-97867cb6] {
  text-align: left;
}
.vl-tooltip__title[data-v-97867cb6] {
  margin: 0 0 0.5rem;
  border-bottom: 1px solid rgb(74.1520803443%, 77.3830703013%, 81.6910569106%);
  font-size: 1.6rem;
}
.vl-tooltip__close[data-v-97867cb6] {
  margin: 5px;
  padding: 3px;
  position: absolute;
  right: 0px;
  top: 0px;
  border: 0;
  font-size: 1.6rem;
}
.vl-tooltip__close[data-v-97867cb6]:hover {
  color: #05c;
}
.vl-tooltip__close[data-v-97867cb6]:focus {
  color: rgb(0%, 25%, 60%);
}
@media screen and (max-width: 767px) {
.vl-tooltip__close[data-v-97867cb6] {
    font-size: 1.4rem;
}
}
.vl-tooltip[x-placement^=top] .vl-tooltip__arrow[data-v-97867cb6], .vl-tooltip[data-popper-placement^=top] .vl-tooltip__arrow[data-v-97867cb6] {
  left: 50%;
  margin-left: -0.6rem;
  border-bottom-width: 0;
  border-top-color: #cfd5dd;
  bottom: -0.6rem;
}
.vl-tooltip[x-placement^=top] .vl-tooltip__arrow[data-v-97867cb6]::after, .vl-tooltip[data-popper-placement^=top] .vl-tooltip__arrow[data-v-97867cb6]::after {
  content: " ";
  bottom: 1px;
  margin-left: -0.5rem;
  border-bottom-width: 0;
  border-top-color: #fff;
}
.vl-tooltip[x-placement^=right] .vl-tooltip__arrow[data-v-97867cb6], .vl-tooltip[data-popper-placement^=right] .vl-tooltip__arrow[data-v-97867cb6] {
  top: 50%;
  left: -0.6rem;
  margin-top: -0.6rem;
  border-left-width: 0;
  border-right-color: #cfd5dd;
}
.vl-tooltip[x-placement^=right] .vl-tooltip__arrow[data-v-97867cb6]::after, .vl-tooltip[data-popper-placement^=right] .vl-tooltip__arrow[data-v-97867cb6]::after {
  content: " ";
  left: 1px;
  bottom: -0.5rem;
  border-left-width: 0;
  border-right-color: #fff;
}
.vl-tooltip[x-placement^=bottom] .vl-tooltip__arrow[data-v-97867cb6], .vl-tooltip[data-popper-placement^=bottom] .vl-tooltip__arrow[data-v-97867cb6] {
  left: 50%;
  margin-left: -0.6rem;
  border-top-width: 0;
  border-bottom-color: #cfd5dd;
  top: -0.6rem;
}
.vl-tooltip[x-placement^=bottom] .vl-tooltip__arrow[data-v-97867cb6]::after, .vl-tooltip[data-popper-placement^=bottom] .vl-tooltip__arrow[data-v-97867cb6]::after {
  content: " ";
  top: 1px;
  margin-left: -0.5rem;
  border-top-width: 0;
  border-bottom-color: #fff;
}
.vl-tooltip[x-placement^=left] .vl-tooltip__arrow[data-v-97867cb6], .vl-tooltip[data-popper-placement^=left] .vl-tooltip__arrow[data-v-97867cb6] {
  top: 50%;
  right: -0.6rem;
  margin-top: -0.6rem;
  border-right-width: 0;
  border-left-color: #cfd5dd;
}
.vl-tooltip[x-placement^=left] .vl-tooltip__arrow[data-v-97867cb6]::after, .vl-tooltip[data-popper-placement^=left] .vl-tooltip__arrow[data-v-97867cb6]::after {
  content: " ";
  right: 1px;
  border-right-width: 0;
  border-left-color: #fff;
  bottom: -0.5rem;
}
.vl-tooltip__arrow[data-v-97867cb6] {
  border-width: 0.6rem;
}
.vl-tooltip__arrow[data-v-97867cb6], .vl-tooltip__arrow[data-v-97867cb6]::after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
  border-width: 0.5rem;
  content: "";
}
.vl-side-navigation[data-v-97867cb6] {
  max-height: 90vh;
  overflow: auto;
  padding: 5px;
  padding-left: 12px;
}
@media screen and (min-width: 767px) {
.vl-side-navigation[data-v-97867cb6]::-webkit-scrollbar {
    width: 16px;
    height: 20px;
}
.vl-side-navigation[data-v-97867cb6]::-webkit-scrollbar-thumb {
    height: 8px;
    border: 6px solid rgba(0, 0, 0, 0);
    border-radius: 7px;
    background-clip: padding-box;
    background-color: #e8ebee;
}
.vl-side-navigation[data-v-97867cb6]::-webkit-scrollbar-button {
    display: none;
    width: 0;
    height: 0;
}
.vl-side-navigation[data-v-97867cb6]::-webkit-scrollbar-corner {
    background-color: transparent;
}
}
@media screen and (max-width: 767px) {
.vl-side-navigation[data-v-97867cb6] {
    display: none;
    min-height: 10rem;
    max-height: calc(100vh - 15rem);
    padding: 1.5rem 1rem 1.5rem 1.5rem;
    background: #fff;
    box-shadow: 0 0 2.1rem rgba(0, 0, 0, 0.3);
    animation: fade-transition-97867cb6 0.3s;
}
}
.vl-side-navigation a[data-v-97867cb6] {
  text-decoration: none;
}
.vl-side-navigation a[data-v-97867cb6]:hover, .vl-side-navigation a[data-v-97867cb6]:focus {
  text-decoration: underline;
}
.js-vl-scrollspy-mobile--active .vl-side-navigation[data-v-97867cb6] {
  display: block !important;
}
.vl-side-navigation .js-vl-scrollspy-active[data-v-97867cb6] {
  color: #333332;
  position: relative;
}
.vl-side-navigation .js-vl-scrollspy-active[data-v-97867cb6]::before {
  content: "";
  height: 90%;
  display: block;
  position: absolute;
  left: -12px;
  top: 1px;
  bottom: 0;
  width: 3px;
  background-color: #5990de;
}
@media screen and (min-width: 767px) {
.vl-side-navigation[data-vl-side-navigation-scrollable][data-v-97867cb6] {
    max-height: none;
}
}
.vl-side-navigation__content[data-v-97867cb6] {
  font-size: 1.6rem;
}
@media screen and (max-width: 767px) {
.vl-side-navigation__content[data-v-97867cb6] {
    font-size: 1.6rem;
}
}
.vl-side-navigation__group[data-v-97867cb6] {
  margin-bottom: 2rem;
}
@media screen and (max-width: 767px) {
.vl-side-navigation__group[data-v-97867cb6] {
    padding: 0;
    border: 0 !important;
}
}
.vl-side-navigation__group[data-v-97867cb6]:last-child {
  margin-bottom: 0;
}
.vl-side-navigation__group--has-title[data-v-97867cb6] {
  padding-top: 3rem;
  border-top-width: 3px;
}
@media screen and (max-width: 767px) {
.vl-side-navigation__group--has-title[data-v-97867cb6] {
    padding-top: 1.5rem;
}
}
.vl-side-navigation__title[data-v-97867cb6] {
  margin-bottom: 20px;
  font-size: 15px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #687483;
  font-weight: 500;
}
@media screen and (max-width: 767px) {
.vl-side-navigation__item[data-v-97867cb6] {
    padding: 0;
    font-size: 1.4rem;
}
}
.vl-side-navigation__group--spaced .vl-side-navigation__item[data-v-97867cb6]:not(:last-child) {
  margin-bottom: 1.5rem;
}
.vl-side-navigation__group--has-title .vl-side-navigation__item + .vl-side-navigation__item[data-v-97867cb6] {
  margin-top: 0.5rem;
}
@media screen and (max-width: 767px) {
.vl-side-navigation__item > a[data-v-97867cb6] {
    display: block;
    margin: 0.7rem 0 1.4rem;
}
}
.vl-side-navigation__item a[data-v-97867cb6] {
  font-weight: 500;
}
@media screen and (max-width: 767px) {
.vl-side-navigation__item:last-child > a[data-v-97867cb6] {
    margin-bottom: 0.7rem;
}
}
.vl-side-navigation__item > ul[data-v-97867cb6] {
  display: none;
  padding: 0 0 0.15rem 2rem;
}
@media screen and (max-width: 767px) {
.vl-side-navigation__item > ul[data-v-97867cb6] {
    padding: 0 1rem 0.15rem 1.3rem;
}
}
.vl-side-navigation__item > ul.vl-side-navigation__subgroup--active[data-v-97867cb6] {
  display: block;
}
.vl-side-navigation__toggle[data-v-97867cb6] {
  display: block;
  position: relative;
  font-weight: 500;
  box-shadow: none;
  margin: 13px 0;
}
.vl-side-navigation__toggle[aria-expanded=true] .vl-vi[data-v-97867cb6]::before {
  transform: rotate(90deg);
}
.vl-side-navigation__toggle[aria-expanded=true] + ul[data-v-97867cb6] {
  display: block;
  animation: side-navigation-transition-97867cb6 0.3s;
}
.vl-side-navigation__toggle[aria-expanded=true] + ul .vl-side-navigation__toggle[data-v-97867cb6]:first-child {
  margin-top: 0;
}
.vl-side-navigation__toggle .vl-vi[data-v-97867cb6] {
  font-size: 1.6rem;
  position: absolute;
  top: 50%;
  right: 0.4rem;
  transform: translateY(-50%);
}
.vl-side-navigation__toggle .vl-vi[data-v-97867cb6]::before {
  transition: transform 0.1s ease-in-out;
}
@keyframes side-navigation-transition-97867cb6 {
0% {
    display: none;
    transform: translateX(-10px);
}
1% {
    display: block;
    transform: translateX(-10px);
}
100% {
    display: block;
    transform: translateX(0);
    opacity: 1;
}
}
.js-vl-scrollspy__content[data-v-97867cb6] {
  border-radius: 5rem;
}
@media screen and (max-width: 767px) {
.js-vl-scrollspy__content[data-v-97867cb6] {
    position: relative;
    padding: 4rem 0 0;
}
}
.js-vl-scrollspy__content .js-vl-scrollspy__toggle[data-v-97867cb6]::before, .js-vl-scrollspy__content .js-vl-scrollspy__toggle[data-v-97867cb6]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.js-vl-scrollspy__content .js-vl-scrollspy__toggle[data-v-97867cb6]::before {
  content: "\\f13e";
}
.js-vl-scrollspy__content .js-vl-scrollspy__toggle[data-v-97867cb6] {
  display: none;
  cursor: pointer;
}
.js-vl-scrollspy__content .js-vl-scrollspy__toggle[data-v-97867cb6]::before {
  position: absolute;
  top: 50%;
  right: 1rem;
  transform: translateY(-50%);
  color: #fff;
  font-size: 1.1rem;
}
@media screen and (max-width: 767px) {
.js-vl-scrollspy__content .js-vl-scrollspy__toggle[data-v-97867cb6] {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
}
}
.js-vl-scrollspy__content .js-vl-scrollspy__toggle.js-vl-scrollspy__toggle--fixed[data-v-97867cb6] {
  position: fixed;
  top: auto;
  right: auto;
  bottom: 4rem;
  left: calc(100% - 6rem);
  height: 5rem;
  border-radius: 5rem;
  font-size: 0;
  z-index: 3;
}
.js-vl-scrollspy__content .js-vl-scrollspy__toggle.js-vl-scrollspy__toggle--fixed[data-v-97867cb6]::before {
  right: auto;
  left: 2rem;
  line-height: 2.7rem;
}
.js-vl-scrollspy-placeholder[data-v-97867cb6] {
  display: none;
  position: fixed;
  top: auto;
  bottom: 1.5rem;
  left: 1.5rem;
  width: calc(100% - 3rem);
  outline: none;
  z-index: 4;
}
@media screen and (max-width: 767px) {
.js-vl-scrollspy-placeholder[data-v-97867cb6] {
    height: auto;
}
}
.js-vl-scrollspy-placeholder.js-vl-scrollspy-mobile--active[data-v-97867cb6] {
  display: block;
}
.js-vl-scrollspy__close[data-v-97867cb6]::before, .js-vl-scrollspy__close[data-v-97867cb6]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.js-vl-scrollspy__close[data-v-97867cb6]::before {
  content: "\\f17f";
}
.js-vl-scrollspy__close[data-v-97867cb6] {
  position: absolute;
  top: -1.8rem;
  right: 0;
  left: 0;
  width: 3rem;
  height: 3rem;
  margin: auto;
  border: 0;
  border-radius: 3rem;
  background-color: #05c;
  color: #fff;
  font-size: 0;
  cursor: pointer;
  z-index: 5;
}
.js-vl-scrollspy__close[data-v-97867cb6]::before {
  font-size: 1.2rem;
  line-height: 2.6rem;
}
.js-vl-scrollspy__close[data-v-97867cb6]:focus {
  outline: thin dotted;
}
.js-vl-sticky[data-v-97867cb6] {
  position: relative;
  transform: translate3d(0, 0, 0);
  will-change: position, transform;
  z-index: 2;
}
.js-vl-sticky--viewport-top[data-v-97867cb6], .js-vl-sticky--viewport-bottom[data-v-97867cb6] {
  position: fixed;
}
.js-vl-sticky--container-bottom[data-v-97867cb6], .js-vl-sticky--viewport-unbottom[data-v-97867cb6] {
  position: relative;
}
.js-vl-sticky--placeholder[data-v-97867cb6] {
  position: relative;
  width: 100%;
  will-change: min-height;
}
.vl-toaster[data-v-97867cb6] {
  position: fixed;
  width: 30rem;
  z-index: 10012;
  top: 0;
  right: 0;
}
.vl-toaster[class*=left][data-v-97867cb6] {
  right: auto;
  left: 0;
}
.vl-toaster[class*=bottom][data-v-97867cb6] {
  top: auto;
  bottom: 0;
}
.vl-toaster--fade[data-v-97867cb6] {
  opacity: 0 !important;
}
.vl-toaster .vl-alert[data-v-97867cb6] {
  opacity: 1;
  transition: opacity 0.3s;
  margin: 1rem;
}
.vl-toaster .vl-alert--fade-out[data-v-97867cb6] {
  opacity: 0;
}
.vl-sidebar[data-v-97867cb6] {
  position: relative;
  height: 100%;
  width: 100%;
  max-width: 426.6666666667px;
  transition: margin 0.2s ease-out;
  background-color: #fff;
  flex: 1;
  z-index: 100;
}
@media screen and (max-width: 767px) {
.vl-sidebar[data-v-97867cb6] {
    max-width: 50%;
}
}
.vl-sidebar--collapsible[data-v-97867cb6] {
  margin-left: -426.6666666667px;
  min-height: 3.5rem;
}
@media screen and (max-width: 767px) {
.vl-sidebar--collapsible[data-v-97867cb6] {
    margin-left: -50%;
}
}
.vl-sidebar--collapsible.vl-sidebar--opened[data-v-97867cb6] {
  margin-left: 0;
}
@media screen and (max-width: 500px) {
.vl-sidebar--collapsible.vl-sidebar--opened[data-v-97867cb6] {
    position: fixed !important;
}
}
.vl-sidebar--collapsible:not(.vl-sidebar--opened) .vl-sidebar__container[data-v-97867cb6] {
  display: none;
}
.vl-sidebar--collapsible.vl-sidebar--right[data-v-97867cb6] {
  margin-left: 0;
  margin-right: -426.6666666667px;
}
@media screen and (max-width: 767px) {
.vl-sidebar--collapsible.vl-sidebar--right[data-v-97867cb6] {
    margin-right: -50%;
}
}
.vl-sidebar--collapsible.vl-sidebar--right.vl-sidebar--opened[data-v-97867cb6] {
  margin-right: 0;
}
@media screen and (max-width: 767px) {
.vl-sidebar--collapsible[data-v-97867cb6] {
    min-height: 3.5rem;
}
.vl-sidebar--collapsible.vl-sidebar--opened[data-v-97867cb6] {
    margin-left: -50%;
    z-index: 10009;
}
.vl-sidebar--collapsible.vl-sidebar--opened.vl-sidebar--right[data-v-97867cb6] {
    margin-right: -50%;
}
.vl-sidebar--collapsible.vl-sidebar--opened .vl-sidebar__container[data-v-97867cb6] {
    display: block;
    opacity: 0;
    animation: slideIn-97867cb6 0.5s cubic-bezier(1, 0.1, 0, 0.9);
    animation-fill-mode: forwards;
    overflow: initial;
}
.vl-sidebar--collapsible.vl-sidebar--opened .vl-sidebar__toggle[data-v-97867cb6] {
    display: none;
}
.vl-sidebar--collapsible.vl-sidebar--closing .vl-sidebar__container[data-v-97867cb6] {
    will-change: transform;
    display: block;
    animation: slideOut-97867cb6 0.5s cubic-bezier(1, 0.1, 0, 0.9);
    animation-fill-mode: forwards;
}
.vl-sidebar--collapsible .vl-sidebar__container[data-v-97867cb6] {
    width: 100%;
    max-width: 100%;
    margin: 0;
    position: fixed;
    bottom: 0;
    left: 0;
    top: auto;
    display: none;
    z-index: 10009;
    transform: translateY(120%);
    height: auto;
    max-height: 85vh;
    background: #fff;
    display: block;
}
}
.vl-sidebar--flyout[data-v-97867cb6] {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
}
.vl-sidebar--flyout.vl-sidebar--right[data-v-97867cb6] {
  left: auto;
  right: 0;
}
.vl-sidebar__container[data-v-97867cb6] {
  height: 100%;
  max-height: 100%;
  overflow: auto;
  background-color: #fff;
  box-shadow: 0px 2px 12px rgba(106, 118, 134, 0.35);
}
.vl-sidebar__toggle[data-v-97867cb6] {
  border-radius: 0;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  border: 0;
  background-color: transparent;
  padding: 0;
  display: block;
  width: 3.5rem;
  height: 3.5rem;
  background-color: #fff;
  border: 0;
  border-radius: 2px;
  font-size: 16px;
  line-height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.vl-sidebar__toggle[data-v-97867cb6]:hover {
  background: #f7f9fc;
  color: #333332;
}
.vl-sidebar__toggle--active[data-v-97867cb6] {
  background-color: #05c;
  color: #fff;
}
.vl-sidebar__toggle--active[data-v-97867cb6]:hover {
  background: #003bb0;
  color: #fff;
}
.vl-sidebar__toggle--disabled[data-v-97867cb6] {
  background-color: #cbd2d9;
  color: var(--vl-theme-fg-color-70);
}
.vl-sidebar__toggle--disabled[data-v-97867cb6]:hover {
  background-color: #cbd2d9;
  color: var(--vl-theme-fg-color-70);
}
.vl-sidebar__toggle[data-v-97867cb6] {
  box-shadow: 0px 2px 12px rgba(106, 118, 134, 0.35);
  border-radius: 0px 0.3rem 0.3rem 0px;
  color: #05c;
  background-color: #fff;
  border: none;
  position: absolute;
  top: 50%;
  left: 100%;
  transform: translateY(-50%) translateX(-2px);
  z-index: -1;
  font-size: 18px;
}
.vl-sidebar--right .vl-sidebar__toggle[data-v-97867cb6] {
  left: auto;
  right: 100%;
  transform: translateY(-50%) translateX(2px);
}
.vl-sidebar__wrapper[data-v-97867cb6] {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: column;
  z-index: 101;
  overflow: auto;
  background-color: #fff;
}
.vl-sidebar__close-btn[data-v-97867cb6] {
  display: none;
  position: absolute;
  right: 0.5rem;
  top: 0;
  font-size: 1.4rem;
}
@media screen and (max-width: 767px) {
.vl-sidebar__close-btn[data-v-97867cb6] {
    display: inline-flex;
    top: -4.5rem;
}
}
.vl-sidebar-content[data-v-97867cb6] {
  flex-grow: 1;
  overflow: auto;
  padding: 1.8rem 1.5rem;
}
.vl-sidebar-content--container[data-v-97867cb6] {
  padding: 0;
  overflow: hidden;
  max-width: 100%;
  position: relative;
}
@media screen and (max-width: 767px) {
.vl-sidebar-content[data-v-97867cb6] {
    max-height: 65vh;
}
}
.vl-sidebar-content .vl-sidebar__image-container .vl-image--full-width[data-v-97867cb6] {
  margin-left: -1.5rem;
  width: calc(100% + 1.5rem * 2);
  max-width: calc(100% + 1.5rem * 2);
  margin-top: -1.5rem;
  margin-bottom: 1.5rem;
}
.vl-sidebar-content > .vl-sidebar-accordion-list > .vl-sidebar-accordion-list-item > .vl-accordion__wrapper > .vl-accordion > .vl-accordion__summary[data-v-97867cb6] {
  background: #f7f9fc;
}
.vl-sidebar-panel[data-v-97867cb6] {
  padding: 1.8rem 1.5rem;
}
.vl-sidebar-panel-list[data-v-97867cb6] {
  width: 100%;
  max-height: 100%;
  padding: 8px 0;
}
.vl-sidebar-panel-list--sub[data-v-97867cb6] {
  padding: 0;
  transform: translateX(20px);
  opacity: 0;
  transition: transform 0.35s ease-in-out, opacity 0.25s linear 0.1s;
  pointer-events: none;
}
.vl-sidebar-panel-list-item[data-v-97867cb6] {
  display: flex;
  flex-direction: column;
}
.vl-sidebar-panel-list-item--has-children[data-v-97867cb6] {
  display: block;
}
.vl-sidebar-panel-list-item--full[data-v-97867cb6] {
  height: 100%;
}
.vl-sidebar-panel-list-item--active .vl-sidebar-panel-list--sub[data-v-97867cb6] {
  pointer-events: all;
  visibility: visible;
  opacity: 1;
  transform: translateX(0);
  transition: transform 0.35s ease-in-out, opacity 0.25s linear 0.1s;
}
.vl-sidebar-panel-list-item[data-v-97867cb6]:last-child {
  border-bottom: 0;
}
.vl-sidebar-panel-list-item__header[data-v-97867cb6] {
  display: flex;
  padding: 1.8rem 1.5rem;
  border-bottom: 1px solid #cbd2da;
  margin-bottom: 8px;
  align-items: center;
}
.vl-sidebar-panel-list-item__header__title[data-v-97867cb6] {
  font-size: 16px;
}
.vl-sidebar-panel-list-item__image-container .vl-image--full-width[data-v-97867cb6] {
  width: 100%;
  max-width: 100%;
  margin-top: -8px;
  margin-bottom: 8px;
}
.vl-sidebar-panel-list-item__content[data-v-97867cb6] {
  padding: 0 1.5rem;
}
.vl-sidebar-panel-list-item__footer[data-v-97867cb6] {
  padding: 1.8rem 1.5rem;
  border-top: 1px solid #cbd2da;
  margin-top: 1.5rem;
}
.vl-sidebar-footer[data-v-97867cb6] {
  display: flex;
  padding: 1.5rem;
  border-top: 1px solid #cbd2da;
  min-height: 72px;
}
.vl-sidebar-header[data-v-97867cb6] {
  display: flex;
  padding: 1.5rem;
  border-bottom: 1px solid #cbd2da;
  margin-top: 1px;
  min-height: 72px;
  align-items: center;
  background: #f7f9fc;
}
.vl-sidebar-header__toggle[data-v-97867cb6] {
  margin-right: 1.5rem;
  padding-right: 1.5rem;
  border-right: 1px solid #cbd2da;
  cursor: pointer;
}
.vl-sidebar-header__title[data-v-97867cb6] {
  margin: 0;
}
.vl-sidebar-panel-list-item__button[data-v-97867cb6] {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  cursor: pointer;
  width: 100%;
  font-size: inherit;
  text-align: initial;
  border: none;
  line-height: inherit;
}
.vl-sidebar-panel-list-item__back-link[data-v-97867cb6] {
  margin-right: 1.5rem;
}
.vl-sidebar-panel-list-item__link[data-v-97867cb6] {
  border-bottom: 1px solid #cbd2da;
}
.vl-sidebar-accordion-list[data-v-97867cb6] {
  margin: -1.8rem -1.5rem !important;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list[data-v-97867cb6] {
  margin: -1.8rem 0 !important;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item[data-v-97867cb6]:first-child {
  border-top: none;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item[data-v-97867cb6]:last-child {
  border-bottom: none;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item.vl-accordion-list__item[data-v-97867cb6] {
  padding: 0;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item--no-title .vl-accordion__summary[data-v-97867cb6] {
  display: none;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item .vl-accordion__wrapper .vl-accordion__panel[data-v-97867cb6] {
  padding: 1.5rem;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item .vl-accordion__wrapper .vl-accordion__panel[data-v-97867cb6]:not(.vl-accordion__panel--with-footer) {
  padding-bottom: 1.5rem;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item .vl-accordion__wrapper .vl-accordion__summary[data-v-97867cb6] {
  padding: 1.5rem;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item .vl-accordion__wrapper .vl-accordion__summary[data-v-97867cb6]:focus {
  outline-offset: -3px;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item .vl-accordion__wrapper .vl-accordion__summary[aria-expanded=true][data-v-97867cb6] {
  border-bottom: 1px solid #cbd2da;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item .vl-accordion__wrapper .vl-accordion__content .vl-sidebar-panel-list[data-v-97867cb6] {
  padding: 0px;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item .vl-accordion__wrapper .vl-accordion__content .vl-sidebar-panel-list .vl-sidebar-panel-list-item__content[data-v-97867cb6] {
  padding: 0px;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item .vl-accordion__wrapper .vl-accordion__content .vl-accordion__image-container .vl-image--full-width[data-v-97867cb6] {
  width: 100%;
  max-width: 100%;
  margin-top: -0px;
  margin-bottom: 0px;
}
@media screen and (max-width: 767px) {
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item .vl-accordion__wrapper .vl-accordion__content .vl-accordion__image-container .vl-image--full-width[data-v-97867cb6] {
    width: 100%;
    max-width: 100%;
    margin-top: -0px;
    margin-bottom: 0px;
}
}
.vl-accordion__panel .vl-sidebar-panel-list-item__image-container .vl-image--full-width[data-v-97867cb6] {
  margin-left: -2.2rem;
  width: calc(100% + 2.2rem * 2);
  max-width: calc(100% + 2.2rem * 2);
  margin-top: -2.2rem;
  margin-bottom: 2.2rem;
}
@media screen and (max-width: 767px) {
.vl-accordion__panel .vl-sidebar-panel-list-item__image-container .vl-image--full-width[data-v-97867cb6] {
    margin-left: -1rem;
    width: calc(100% + 1rem * 2);
    max-width: calc(100% + 1rem * 2);
    margin-top: -1rem;
    margin-bottom: 1rem;
}
}
.vl-multiselect .multiselect__spinner[data-v-97867cb6] {
  position: absolute;
  top: 1px;
  bottom: 1px;
  width: 32px;
  height: calc(100% - 2px);
  display: block;
  background: #fff;
}
.vl-multiselect .multiselect__spinner[data-v-97867cb6]:after, .vl-multiselect .multiselect__spinner[data-v-97867cb6]:before {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  margin: -8px 0 0 -8px;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  border: 2px solid transparent;
  border-top-color: #b2b2b2;
  box-shadow: 0 0 0 1px transparent;
}
.vl-multiselect .multiselect__spinner[data-v-97867cb6]:before {
  animation: spinning-97867cb6 2.4s cubic-bezier(0.41, 0.26, 0.2, 0.62);
  animation-iteration-count: infinite;
}
.vl-multiselect .multiselect__spinner[data-v-97867cb6]:after {
  animation: spinning-97867cb6 2.4s cubic-bezier(0.51, 0.09, 0.21, 0.8);
  animation-iteration-count: infinite;
}
.vl-multiselect .multiselect__loading-enter-active[data-v-97867cb6], .vl-multiselect .multiselect__loading-leave-active[data-v-97867cb6] {
  transition: opacity 0.4s ease-in-out;
  opacity: 1;
}
.vl-multiselect .multiselect__loading-enter[data-v-97867cb6], .vl-multiselect .multiselect__loading-leave-active[data-v-97867cb6] {
  opacity: 0;
}
.vl-multiselect .multiselect__spinner[data-v-97867cb6] {
  right: 4px;
  left: auto;
}
@keyframes spinning-97867cb6 {
0% {
    transform: rotate(0);
}
to {
    transform: rotate(2turn);
}
}
.vl-multiselect .multiselect[data-v-97867cb6],
.vl-multiselect .multiselect__input[data-v-97867cb6],
.vl-multiselect .multiselect__single[data-v-97867cb6] {
  font-size: 1.6rem;
  touch-action: manipulation;
}
.vl-multiselect .multiselect--disabled[data-v-97867cb6] {
  opacity: 0.6;
}
.vl-multiselect .multiselect--active[data-v-97867cb6] {
  z-index: 10013;
}
.vl-multiselect .multiselect--active .multiselect__input[data-v-97867cb6] {
  position: relative !important;
  border: 0.1rem solid #8695a8;
}
.vl-multiselect .multiselect--active .multiselect__tags[data-v-97867cb6] {
  border-radius: 0.3rem 0.3rem 0 0;
  border-bottom: 1px solid #8695a8;
}
.vl-multiselect .multiselect[data-v-97867cb6] {
  display: block;
  position: relative;
  max-width: 100%;
  text-decoration: none;
  color: #333332;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.6rem;
  -webkit-appearance: none;
}
.vl-multiselect .multiselect[data-v-97867cb6]:focus::-ms-value {
  background: inherit;
  color: inherit;
}
.vl-multiselect .multiselect--active:not(.multiselect--above) .multiselect__current[data-v-97867cb6],
.vl-multiselect .multiselect--active:not(.multiselect--above) .multiselect__tags[data-v-97867cb6] {
  padding: 6px 45px 0 10px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.vl-multiselect .multiselect--above--active .multiselect__current[data-v-97867cb6],
.vl-multiselect .multiselect--above--active .multiselect__input[data-v-97867cb6],
.vl-multiselect .multiselect--above--active .multiselect__tags[data-v-97867cb6] {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.vl-multiselect .multiselect--above--active .multiselect__input[data-v-97867cb6] {
  display: inline-block;
}
.vl-multiselect .multiselect--disabled[data-v-97867cb6] {
  pointer-events: none;
}
.vl-multiselect .multiselect--disabled .multiselect__tags[data-v-97867cb6] {
  border-color: #8695a8;
  background-color: #f3f5f6;
}
.vl-multiselect .multiselect__input[data-v-97867cb6] {
  margin: 10px 5px 15px 2px;
  display: inline-block;
  background: #fff;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.6rem;
  color: #333332;
  max-width: 100%;
  height: 3.5rem;
  line-height: 3.5rem;
  border-radius: 0.3rem;
  border: 0;
  padding: 0 1rem;
  transition: background-color 0.2s;
}
@media screen and (max-width: 767px) {
.vl-multiselect .multiselect__input[data-v-97867cb6] {
    font-size: 1.6rem;
}
}
.multiselect--active .vl-multiselect .multiselect__input[data-v-97867cb6]:hover {
  border: 0.2rem solid rgba(0, 85, 204, 0.65);
  padding: 0 0.9rem;
}
.vl-multiselect .multiselect__input:hover.vl-input-field--error[data-v-97867cb6], .vl-multiselect .multiselect__input:hover.invalid.validated[data-v-97867cb6] {
  border-color: #d2373c;
}
.vl-multiselect .multiselect__input:hover.vl-input-field--success[data-v-97867cb6] {
  border-color: #009e47;
}
.vl-multiselect .multiselect__input:hover.vl-input-field--small[data-v-97867cb6] {
  padding: 0 0.7rem;
}
.vl-multiselect .multiselect__input[data-v-97867cb6]:focus, .vl-multiselect .multiselect__input--focus[data-v-97867cb6] {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.vl-multiselect .multiselect__input[data-v-97867cb6]:focus, .vl-multiselect .multiselect__input--focus[data-v-97867cb6] {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
.vl-multiselect .multiselect__input[data-v-97867cb6]:focus, .vl-multiselect .multiselect__input--focus[data-v-97867cb6] {
  border: 0.1rem solid #8695a8;
  padding: 0 1rem;
}
.vl-multiselect .multiselect__input:focus.vl-input-field--error[data-v-97867cb6], .vl-multiselect .multiselect__input:focus.invalid.validated[data-v-97867cb6], .vl-multiselect .multiselect__input--focus.vl-input-field--error[data-v-97867cb6], .vl-multiselect .multiselect__input--focus.invalid.validated[data-v-97867cb6] {
  border-color: #d2373c;
}
.vl-multiselect .multiselect__input:focus.vl-input-field--success[data-v-97867cb6], .vl-multiselect .multiselect__input--focus.vl-input-field--success[data-v-97867cb6] {
  border-color: #009e47;
}
.vl-multiselect .multiselect__input[data-v-97867cb6]:focus:hover, .vl-multiselect .multiselect__input--focus[data-v-97867cb6]:hover {
  padding: 0 1rem;
}
.vl-multiselect .multiselect__input:focus.vl-input-field--small[data-v-97867cb6], .vl-multiselect .multiselect__input--focus.vl-input-field--small[data-v-97867cb6] {
  padding: 0 0.8rem;
}
.vl-multiselect .multiselect__input[data-v-97867cb6]::-moz-placeholder {
  color: #687483;
}
.vl-multiselect .multiselect__input[data-v-97867cb6]::placeholder {
  color: #687483;
}
.vl-multiselect .multiselect__input[data-v-97867cb6]::-webkit-search-cancel-button {
  -webkit-appearance: none;
}
.vl-multiselect .multiselect__single[data-v-97867cb6] {
  position: relative;
  display: inline-block;
  min-height: 20px;
  line-height: 20px;
  border: 0;
  border-radius: 5px;
  padding: 0 0 0 5px;
  margin-bottom: 8px;
  width: 100%;
  transition: border 0.1s ease;
  box-sizing: border-box;
  vertical-align: top;
  color: #687483;
}
.multiselect__tag ~ .vl-multiselect .multiselect__single[data-v-97867cb6] {
  width: auto;
}
.vl-multiselect .multiselect__single[data-v-97867cb6]:focus {
  outline: 0;
}
.vl-multiselect--single .multiselect__single[data-v-97867cb6] {
  padding-top: 3px;
  min-height: 17px;
  line-height: 17px;
  color: #333332;
}
.vl-multiselect .multiselect__tags-wrap[data-v-97867cb6] {
  display: inline;
}
.vl-multiselect .multiselect--active .multiselect__tags-wrap[data-v-97867cb6] {
  margin: 0 -4px;
}
.vl-multiselect .multiselect__tags[data-v-97867cb6] {
  min-height: 35px;
  display: block;
  padding: 6px 45px 0 6px;
  border: 1px solid #8695a8;
  background-color: #fff;
  font-size: 14px;
  border-radius: 3px;
}
.vl-multiselect .multiselect__tag[data-v-97867cb6] {
  position: relative;
  display: inline-block;
  padding: 4px 30px 4px 10px;
  border-radius: 0.3rem;
  margin-right: 6px;
  line-height: 1;
  background: #fff;
  margin-bottom: 5px;
  white-space: nowrap;
  max-width: 100%;
  text-overflow: ellipsis;
  color: #333332;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  font-size: 1.4rem;
  vertical-align: middle;
  border: 1px solid #8695a8;
  transition: color 0.2s, background-color 0.2s, box-shadow 0.2s;
}
.vl-multiselect .multiselect__tag-icon[data-v-97867cb6]::before, .vl-multiselect .multiselect__tag-icon[data-v-97867cb6]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-multiselect .multiselect__tag-icon[data-v-97867cb6]::before {
  content: "\\f17f";
}
.vl-multiselect .multiselect__tag-icon[data-v-97867cb6] {
  cursor: pointer;
  margin-left: 1.4rem;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  font-weight: 700;
  font-style: normal;
  width: 22px;
  text-align: center;
  line-height: 22px;
  transition: background-color 0.2s ease;
  border-left: 1px solid #8695a8;
  color: #05c;
  font-size: 0.8rem;
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}
.vl-multiselect .multiselect__tag-icon[data-v-97867cb6]:hover {
  color: #003bb0;
  box-shadow: inset 0 0 0 0.1rem #05c;
  border: #05c 0.1rem solid;
  background-color: rgb(90%, 93.3333333333%, 98%);
  top: -0.1rem;
  right: -0.1rem;
  bottom: -0.1rem;
  width: 22px;
  margin-left: 1.2rem;
}
.vl-multiselect .multiselect__tag-icon[data-v-97867cb6]:focus {
  outline: transparent solid 0.2rem;
  border: #05c 0.1rem solid;
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65), inset 0 0 0 0.1rem #05c;
  top: -0.1rem;
  right: -0.1rem;
  bottom: -0.1rem;
  width: 22px;
  margin-left: 1.3rem;
}
.vl-multiselect .multiselect__current[data-v-97867cb6] {
  min-height: 40px;
  overflow: hidden;
  padding: 8px 12px 0;
  padding-right: 30px;
  white-space: nowrap;
  border-radius: 5px;
  border: 1px solid #e8ebee;
}
.vl-multiselect .multiselect__current[data-v-97867cb6],
.vl-multiselect .multiselect__select[data-v-97867cb6] {
  line-height: 16px;
  box-sizing: border-box;
  display: block;
  margin: 0;
  text-decoration: none;
  cursor: pointer;
}
.vl-multiselect .multiselect__select[data-v-97867cb6] {
  position: absolute;
  width: 40px;
  right: 0;
  top: 0;
  height: 100%;
  padding: 4px 8px;
  text-align: center;
  transition: transform 0.2s ease;
}
.vl-multiselect .multiselect__select[data-v-97867cb6]::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: 9px 5px;
  background-position: calc(100% - 1.5rem) center;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  position: absolute;
  display: block;
  right: 0;
  top: 0;
  bottom: 0;
  content: "";
  width: 100%;
}
.vl-multiselect .multiselect__placeholder[data-v-97867cb6] {
  display: inline-block;
  padding: 0 0 0 5px;
  color: #687483;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.6rem;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.multiselect--active .vl-multiselect .multiselect__placeholder[data-v-97867cb6] {
  display: none;
}
.vl-multiselect .multiselect__content-wrapper[data-v-97867cb6] {
  position: absolute;
  display: block;
  background: #fff;
  width: 100%;
  max-height: 240px;
  overflow: auto;
  border: 1px solid #8695a8;
  border-top: 0;
  border-bottom-left-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
  z-index: 1;
  -webkit-overflow-scrolling: touch;
}
.vl-multiselect .multiselect__content[data-v-97867cb6] {
  list-style: none;
  display: inline-block;
  padding: 0;
  margin: -1px 0;
  min-width: 100%;
  vertical-align: top;
}
.vl-multiselect .multiselect__content[data-v-97867cb6]::webkit-scrollbar {
  display: none;
}
.vl-multiselect .multiselect--above .multiselect__content-wrapper[data-v-97867cb6] {
  bottom: 100%;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom: none;
  border-top: 1px solid #f7f9fc;
}
.vl-multiselect .multiselect__element[data-v-97867cb6] {
  display: block;
}
.vl-multiselect .multiselect__element:hover .multiselect__option[data-v-97867cb6] {
  position: relative;
  border-top: 1px solid rgba(179, 207, 245, 0.3);
  border-bottom: 1px solid rgba(179, 207, 245, 0.3);
  box-shadow: 0 2px 0 #a1beec, 0px -2px 0 #a1beec;
  z-index: 2;
}
.vl-multiselect .multiselect__element:hover .multiselect__option--disabled[data-v-97867cb6] {
  box-shadow: none;
}
.vl-multiselect .multiselect__option[data-v-97867cb6]::before {
  content: "\\f15a";
}
.vl-multiselect .multiselect__option[data-v-97867cb6] {
  display: block;
  position: relative;
  padding: 12px;
  padding-left: 40px;
  min-height: 40px;
  line-height: 16px;
  text-decoration: none;
  text-transform: none;
  cursor: pointer;
  white-space: nowrap;
  border-top: 1px solid transparent;
  border-bottom: 1px solid #f7f9fc;
}
.vl-multiselect .multiselect__option[data-v-97867cb6]::before {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
  display: none;
  position: absolute;
  font-size: 12px;
  left: 0;
  width: 40px;
  text-align: center;
}
.vl-multiselect .multiselect__option[data-v-97867cb6]::after {
  display: none;
  top: 0;
  right: 0;
  position: absolute;
  line-height: 40px;
  padding-right: 12px;
  padding-left: 20px;
  font-size: 13px;
}
.vl-multiselect .multiselect__option--highlight[data-v-97867cb6] {
  background: rgba(179, 207, 245, 0.3);
  outline: none;
  color: #333332;
}
.vl-multiselect .multiselect__option--highlight[data-v-97867cb6]::after {
  content: attr(data-select);
  color: #333332;
}
.vl-multiselect .multiselect__option--selected[data-v-97867cb6] {
  background: #fff;
}
.vl-multiselect .multiselect__option--selected.multiselect__option--highlight[data-v-97867cb6] {
  background: rgba(179, 207, 245, 0.3);
  outline: none;
  color: #333332;
}
.vl-multiselect .multiselect__option--selected[data-v-97867cb6]::before {
  display: block;
}
.vl-multiselect .multiselect__option--selected[data-v-97867cb6]::after {
  content: attr(data-selected);
  color: #333332;
}
.vl-multiselect .multiselect__option--disabled[data-v-97867cb6] {
  background: #e8ebee;
  color: #b2b2b2;
  cursor: text;
  pointer-events: none;
}
.vl-multiselect .multiselect__option--disabled.multiselect__option--highlight[data-v-97867cb6] {
  background: #d3d9e0;
}
.vl-multiselect .multiselect__option--group[data-v-97867cb6] {
  background: #687483;
  color: #fff;
}
.vl-multiselect .multiselect__option--group.multiselect__option--highlight[data-v-97867cb6] {
  background: rgb(36.3587818106%, 40.5540258657%, 45.7980809345%);
  color: #fff;
}
.vl-multiselect .multiselect__option--group.multiselect__option--highlight[data-v-97867cb6]::after {
  display: block;
  content: attr(data-select);
  background: rgb(36.3587818106%, 40.5540258657%, 45.7980809345%);
  color: #fff;
}
.vl-multiselect .multiselect__option--group-selected.multiselect__option--highlight[data-v-97867cb6] {
  background: rgb(31.9332498957%, 35.6178556529%, 40.2236128494%);
  color: #fff;
}
.vl-multiselect .multiselect__option--group-selected.multiselect__option--highlight[data-v-97867cb6]::after {
  display: block;
  content: attr(data-deselect);
  background: rgb(31.9332498957%, 35.6178556529%, 40.2236128494%);
  color: #fff;
}
.vl-multiselect .multiselect__strong[data-v-97867cb6] {
  margin-bottom: 8px;
  line-height: 20px;
  display: inline-block;
  vertical-align: top;
}
.vl-multiselect [dir=rtl] .multiselect[data-v-97867cb6] {
  text-align: right;
}
.vl-multiselect [dir=rtl] .multiselect__select[data-v-97867cb6] {
  right: auto;
  left: 1px;
}
.vl-multiselect [dir=rtl] .multiselect__tags[data-v-97867cb6] {
  padding: 8px 8px 0 40px;
}
.vl-multiselect [dir=rtl] .multiselect__content[data-v-97867cb6] {
  text-align: right;
}
.vl-multiselect [dir=rtl] .multiselect__option[data-v-97867cb6]::after {
  right: auto;
  left: 0;
}
.vl-multiselect [dir=rtl] .multiselect__clear[data-v-97867cb6] {
  right: auto;
  left: 12px;
}
.vl-multiselect--error .multiselect__current[data-v-97867cb6], .vl-multiselect--error .multiselect__tags[data-v-97867cb6], .vl-multiselect.invalid.validated .multiselect__current[data-v-97867cb6], .vl-multiselect.invalid.validated .multiselect__tags[data-v-97867cb6] {
  border-color: #d2373c;
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
}
.vl-multiselect--success .multiselect__current[data-v-97867cb6], .vl-multiselect--success .multiselect__tags[data-v-97867cb6], .vl-multiselect.valid.validated .multiselect__current[data-v-97867cb6], .vl-multiselect.valid.validated .multiselect__tags[data-v-97867cb6] {
  border-color: #009e47;
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
}
.vl-u-visually-hidden[data-v-97867cb6] {
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  margin: -1px;
  padding: 0;
  border: 0;
  left: 0;
  top: 0;
}
@media screen and (min-width: 1023px) {
.vl-u-visually-hidden--l[data-v-97867cb6] {
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px, 1px, 1px, 1px);
    margin: -1px;
    padding: 0;
    border: 0;
    left: 0;
    top: 0;
}
}
@media screen and (max-width: 1023px) {
.vl-u-visually-hidden--m[data-v-97867cb6] {
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px, 1px, 1px, 1px);
    margin: -1px;
    padding: 0;
    border: 0;
    left: 0;
    top: 0;
}
}
@media screen and (max-width: 767px) {
.vl-u-visually-hidden--s[data-v-97867cb6] {
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px, 1px, 1px, 1px);
    margin: -1px;
    padding: 0;
    border: 0;
    left: 0;
    top: 0;
}
}
@media screen and (max-width: 500px) {
.vl-u-visually-hidden--xs[data-v-97867cb6] {
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px, 1px, 1px, 1px);
    margin: -1px;
    padding: 0;
    border: 0;
    left: 0;
    top: 0;
}
}
@keyframes fade-transition-97867cb6 {
0% {
    transform: translateY(20px);
    opacity: 0;
}
100% {
    transform: translateY(0);
    opacity: 1;
}
}
@keyframes bounce-97867cb6 {
0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
}
40% {
    transform: translateY(-12px);
}
60% {
    transform: translateY(-5px);
}
90% {
    transform: translateY(-2px);
}
}
.vl-u-align-left[data-v-97867cb6] {
  text-align: left !important;
}
.vl-u-align-center[data-v-97867cb6] {
  text-align: center !important;
}
.vl-u-align-right[data-v-97867cb6] {
  text-align: right !important;
}
@media screen and (min-width: 1023px) {
.vl-u-align-left--l[data-v-97867cb6] {
    text-align: left !important;
}
.vl-u-align-center--l[data-v-97867cb6] {
    text-align: center !important;
}
.vl-u-align-right--l[data-v-97867cb6] {
    text-align: right !important;
}
}
@media screen and (max-width: 1023px) {
.vl-u-align-left--m[data-v-97867cb6] {
    text-align: left !important;
}
.vl-u-align-center--m[data-v-97867cb6] {
    text-align: center !important;
}
.vl-u-align-right--m[data-v-97867cb6] {
    text-align: right !important;
}
}
@media screen and (max-width: 767px) {
.vl-u-align-left--s[data-v-97867cb6] {
    text-align: left !important;
}
.vl-u-align-center--s[data-v-97867cb6] {
    text-align: center !important;
}
.vl-u-align-right--s[data-v-97867cb6] {
    text-align: right !important;
}
}
@media screen and (max-width: 500px) {
.vl-u-align-left--xs[data-v-97867cb6] {
    text-align: left !important;
}
.vl-u-align-center--xs[data-v-97867cb6] {
    text-align: center !important;
}
.vl-u-align-right--xs[data-v-97867cb6] {
    text-align: right !important;
}
}
.vl-u-flex-v-left[data-v-97867cb6],
.vl-u-flex-v-flex-start[data-v-97867cb6] {
  align-items: flex-start !important;
}
.vl-u-flex-v-center[data-v-97867cb6] {
  align-items: center !important;
}
.vl-u-flex-v-right[data-v-97867cb6],
.vl-u-flex-v-flex-end[data-v-97867cb6] {
  align-items: flex-end !important;
}
.vl-u-flex-v-baseline[data-v-97867cb6] {
  align-items: baseline !important;
}
.vl-u-flex-v-stretch[data-v-97867cb6] {
  align-items: stretch !important;
}
.vl-u-flex-align-top[data-v-97867cb6],
.vl-u-flex-align-flex-start[data-v-97867cb6] {
  justify-content: flex-start !important;
}
.vl-u-flex-align-center[data-v-97867cb6] {
  justify-content: center !important;
}
.vl-u-flex-align-bottom[data-v-97867cb6],
.vl-u-flex-align-flex-end[data-v-97867cb6] {
  justify-content: flex-end !important;
}
.vl-u-flex-align-space-between[data-v-97867cb6] {
  justify-content: space-between !important;
}
.vl-u-flex-align-space-around[data-v-97867cb6] {
  justify-content: space-around !important;
}
.vl-u-flex-direction-row[data-v-97867cb6] {
  flex-direction: row !important;
}
.vl-u-flex-direction-column[data-v-97867cb6] {
  flex-direction: column !important;
}
.vl-u-flex-direction-row-reverse[data-v-97867cb6] {
  flex-direction: row-reverse !important;
}
.vl-u-flex-direction-column-reverse[data-v-97867cb6] {
  flex-direction: column-reverse !important;
}
.vl-u-flex-wrap-wrap[data-v-97867cb6] {
  flex-wrap: wrap !important;
}
.vl-u-flex-wrap-nowrap[data-v-97867cb6] {
  flex-wrap: nowrap !important;
}
.vl-u-flex-wrap-reverse[data-v-97867cb6] {
  flex-wrap: wrap-reverse !important;
}
@media screen and (min-width: 1023px) {
.vl-u-flex-align-left--l[data-v-97867cb6] {
    align-items: flex-start !important;
}
.vl-u-flex-align-left--l[data-v-97867cb6],
  .vl-u-flex-align-flex-start--l[data-v-97867cb6] {
    align-items: flex-start !important;
}
.vl-u-flex-align-center--l[data-v-97867cb6] {
    align-items: center !important;
}
.vl-u-flex-align-right--l[data-v-97867cb6],
  .vl-u-flex-align-flex-end--l[data-v-97867cb6] {
    align-items: flex-end !important;
}
.vl-u-flex-align-baseline--l[data-v-97867cb6] {
    align-items: baseline !important;
}
.vl-u-flex-align-stretch--l[data-v-97867cb6] {
    align-items: stretch !important;
}
.vl-u-flex-v-top--l[data-v-97867cb6],
  .vl-u-flex-v-flex-start--l[data-v-97867cb6] {
    justify-content: flex-start !important;
}
.vl-u-flex-v-center--l[data-v-97867cb6] {
    justify-content: center !important;
}
.vl-u-flex-v-bottom--l[data-v-97867cb6],
  .vl-u-flex-v-flex-end--l[data-v-97867cb6] {
    justify-content: flex-end !important;
}
.vl-u-flex-v-space-between--l[data-v-97867cb6] {
    justify-content: space-between !important;
}
.vl-u-flex-v-space-around--l[data-v-97867cb6] {
    justify-content: space-around !important;
}
.vl-u-flex-direction-row--l[data-v-97867cb6] {
    flex-direction: row !important;
}
.vl-u-flex-direction-column--l[data-v-97867cb6] {
    flex-direction: column !important;
}
.vl-u-flex-direction-row-reverse--l[data-v-97867cb6] {
    flex-direction: row-reverse !important;
}
.vl-u-flex-direction-column-reverse--l[data-v-97867cb6] {
    flex-direction: column-reverse !important;
}
.vl-u-flex-wrap-wrap--l[data-v-97867cb6] {
    flex-wrap: wrap !important;
}
.vl-u-flex-wrap-nowrap--l[data-v-97867cb6] {
    flex-wrap: nowrap !important;
}
.vl-u-flex-wrap-reverse--l[data-v-97867cb6] {
    flex-wrap: wrap-reverse !important;
}
}
@media screen and (max-width: 1023px) {
.vl-u-flex-align-left--m[data-v-97867cb6] {
    align-items: flex-start !important;
}
.vl-u-flex-align-left--m[data-v-97867cb6],
  .vl-u-flex-align-flex-start--m[data-v-97867cb6] {
    align-items: flex-start !important;
}
.vl-u-flex-align-center--m[data-v-97867cb6] {
    align-items: center !important;
}
.vl-u-flex-align-right--m[data-v-97867cb6],
  .vl-u-flex-align-flex-end--m[data-v-97867cb6] {
    align-items: flex-end !important;
}
.vl-u-flex-align-baseline--m[data-v-97867cb6] {
    align-items: baseline !important;
}
.vl-u-flex-align-stretch--m[data-v-97867cb6] {
    align-items: stretch !important;
}
.vl-u-flex-v-top--m[data-v-97867cb6],
  .vl-u-flex-v-flex-start--m[data-v-97867cb6] {
    justify-content: flex-start !important;
}
.vl-u-flex-v-center--m[data-v-97867cb6] {
    justify-content: center !important;
}
.vl-u-flex-v-bottom--m[data-v-97867cb6],
  .vl-u-flex-v-flex-end--m[data-v-97867cb6] {
    justify-content: flex-end !important;
}
.vl-u-flex-v-space-between--m[data-v-97867cb6] {
    justify-content: space-between !important;
}
.vl-u-flex-v-space-around--m[data-v-97867cb6] {
    justify-content: space-around !important;
}
.vl-u-flex-direction-row--m[data-v-97867cb6] {
    flex-direction: row !important;
}
.vl-u-flex-direction-column--m[data-v-97867cb6] {
    flex-direction: column !important;
}
.vl-u-flex-direction-row-reverse--m[data-v-97867cb6] {
    flex-direction: row-reverse !important;
}
.vl-u-flex-direction-column-reverse--m[data-v-97867cb6] {
    flex-direction: column-reverse !important;
}
.vl-u-flex-wrap-wrap--m[data-v-97867cb6] {
    flex-wrap: wrap !important;
}
.vl-u-flex-wrap-nowrap--m[data-v-97867cb6] {
    flex-wrap: nowrap !important;
}
.vl-u-flex-wrap-reverse--m[data-v-97867cb6] {
    flex-wrap: wrap-reverse !important;
}
}
@media screen and (max-width: 767px) {
.vl-u-flex-align-left--s[data-v-97867cb6] {
    align-items: flex-start !important;
}
.vl-u-flex-align-left--s[data-v-97867cb6],
  .vl-u-flex-align-flex-start--s[data-v-97867cb6] {
    align-items: flex-start !important;
}
.vl-u-flex-align-center--s[data-v-97867cb6] {
    align-items: center !important;
}
.vl-u-flex-align-right--s[data-v-97867cb6],
  .vl-u-flex-align-flex-end--s[data-v-97867cb6] {
    align-items: flex-end !important;
}
.vl-u-flex-align-baseline--s[data-v-97867cb6] {
    align-items: baseline !important;
}
.vl-u-flex-align-stretch--s[data-v-97867cb6] {
    align-items: stretch !important;
}
.vl-u-flex-v-top--s[data-v-97867cb6],
  .vl-u-flex-v-flex-start--s[data-v-97867cb6] {
    justify-content: flex-start !important;
}
.vl-u-flex-v-center--s[data-v-97867cb6] {
    justify-content: center !important;
}
.vl-u-flex-v-bottom--s[data-v-97867cb6],
  .vl-u-flex-v-flex-end--s[data-v-97867cb6] {
    justify-content: flex-end !important;
}
.vl-u-flex-v-space-between--s[data-v-97867cb6] {
    justify-content: space-between !important;
}
.vl-u-flex-v-space-around--s[data-v-97867cb6] {
    justify-content: space-around !important;
}
.vl-u-flex-direction-row--s[data-v-97867cb6] {
    flex-direction: row !important;
}
.vl-u-flex-direction-column--s[data-v-97867cb6] {
    flex-direction: column !important;
}
.vl-u-flex-direction-row-reverse--s[data-v-97867cb6] {
    flex-direction: row-reverse !important;
}
.vl-u-flex-direction-column-reverse--s[data-v-97867cb6] {
    flex-direction: column-reverse !important;
}
.vl-u-flex-wrap-wrap--s[data-v-97867cb6] {
    flex-wrap: wrap !important;
}
.vl-u-flex-wrap-nowrap--s[data-v-97867cb6] {
    flex-wrap: nowrap !important;
}
.vl-u-flex-wrap-reverse--s[data-v-97867cb6] {
    flex-wrap: wrap-reverse !important;
}
}
@media screen and (max-width: 500px) {
.vl-u-flex-align-left--xs[data-v-97867cb6] {
    align-items: flex-start !important;
}
.vl-u-flex-align-left--xs[data-v-97867cb6],
  .vl-u-flex-align-flex-start--xs[data-v-97867cb6] {
    align-items: flex-start !important;
}
.vl-u-flex-align-center--xs[data-v-97867cb6] {
    align-items: center !important;
}
.vl-u-flex-align-right--xs[data-v-97867cb6],
  .vl-u-flex-align-flex-end--xs[data-v-97867cb6] {
    align-items: flex-end !important;
}
.vl-u-flex-align-baseline--xs[data-v-97867cb6] {
    align-items: baseline !important;
}
.vl-u-flex-align-stretch--xs[data-v-97867cb6] {
    align-items: stretch !important;
}
.vl-u-flex-v-top--xs[data-v-97867cb6],
  .vl-u-flex-v-flex-start--xs[data-v-97867cb6] {
    justify-content: flex-start !important;
}
.vl-u-flex-v-center--xs[data-v-97867cb6] {
    justify-content: center !important;
}
.vl-u-flex-v-bottom--xs[data-v-97867cb6],
  .vl-u-flex-v-flex-end--xs[data-v-97867cb6] {
    justify-content: flex-end !important;
}
.vl-u-flex-v-space-between--xs[data-v-97867cb6] {
    justify-content: space-between !important;
}
.vl-u-flex-v-space-around--xs[data-v-97867cb6] {
    justify-content: space-around !important;
}
.vl-u-flex-direction-row--xs[data-v-97867cb6] {
    flex-direction: row !important;
}
.vl-u-flex-direction-column--xs[data-v-97867cb6] {
    flex-direction: column !important;
}
.vl-u-flex-direction-row-reverse--xs[data-v-97867cb6] {
    flex-direction: row-reverse !important;
}
.vl-u-flex-direction-column-reverse--xs[data-v-97867cb6] {
    flex-direction: column-reverse !important;
}
.vl-u-flex-wrap-wrap--xs[data-v-97867cb6] {
    flex-wrap: wrap !important;
}
.vl-u-flex-wrap-nowrap--xs[data-v-97867cb6] {
    flex-wrap: nowrap !important;
}
.vl-u-flex-wrap-reverse--xs[data-v-97867cb6] {
    flex-wrap: wrap-reverse !important;
}
}
.vl-u-bg[data-v-97867cb6] {
  background-color: #fff;
}
.vl-u-bg-alt[data-v-97867cb6] {
  background-color: #f7f9fc;
}
.vl-u-bg-error[data-v-97867cb6] {
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
}
.vl-u-bg-warning[data-v-97867cb6] {
  background-color: rgb(100%, 96.3137254902%, 90.3921568627%);
}
.vl-u-bg-success[data-v-97867cb6] {
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
}
.vl-u-border[data-v-97867cb6] {
  padding-left: 3.5rem;
  position: relative;
}
@media screen and (max-width: 767px) {
.vl-u-border[data-v-97867cb6] {
    padding-left: 1.75rem;
}
}
.vl-u-border[data-v-97867cb6]:after {
  content: "";
  width: 0.5rem;
  height: 100%;
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  background: var(--vl-theme-primary-color);
}
.vl-u-border.vl-grid[data-v-97867cb6]:after {
  height: 100%;
  bottom: 0;
  top: auto;
  left: 3rem;
}
@media screen and (max-width: 767px) {
.vl-u-border.vl-grid[data-v-97867cb6]:after {
    left: 1.5rem;
}
}
.vl-u-border.vl-grid--is-stacked[data-v-97867cb6]:after {
  height: calc(100% - 3rem);
}
@media screen and (max-width: 767px) {
.vl-u-border.vl-grid--is-stacked[data-v-97867cb6]:after {
    height: calc(100% - 1.5rem);
}
}
.vl-u-highlight-content[data-v-97867cb6] {
  padding: 4.1666666667%;
  border: 1px #cbd2da solid;
}
.vl-u-highlight-content--alt[data-v-97867cb6] {
  background: #f7f9fc;
  border: none;
}
button.vl-vi[data-v-97867cb6] {
  border: 0;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  padding: 0;
  outline: none;
}
a.vl-vi[data-v-97867cb6] {
  text-decoration: none;
}
.vl-vi.vl-vi-u-hidden-text[data-v-97867cb6] {
  font-size: 0;
}
.vl-vi.vl-vi-u-xs[data-v-97867cb6]::before {
  font-size: 0.8rem;
}
.vl-vi.vl-vi-u-s[data-v-97867cb6]::before {
  font-size: 1.3rem;
}
.vl-vi.vl-vi-u-m[data-v-97867cb6]::before {
  font-size: 1.7rem;
}
.vl-vi.vl-vi-u-l[data-v-97867cb6]::before {
  font-size: 2rem;
}
.vl-vi.vl-vi-u-xl[data-v-97867cb6]::before {
  font-size: 2.2rem;
}
.vl-vi.vl-vi-u-90deg[data-v-97867cb6]::before {
  display: inline-block;
  transform: rotate(90deg);
}
.vl-vi.vl-vi-u-180deg[data-v-97867cb6]::before {
  display: inline-block;
  transform: rotate(180deg);
}
.vl-vi.vl-vi-u-link[data-v-97867cb6]::before {
  display: inline-block;
  margin-right: 1rem;
  color: #000;
  font-size: 1.3rem;
  text-decoration: none;
}
.vl-vi.vl-vi-u-color-grey[data-v-97867cb6] {
  color: #cbd2da;
}
.vl-vi.vl-vi-u-badge[data-v-97867cb6] {
  display: inline-block;
  border-radius: 50%;
  text-align: center;
  vertical-align: middle;
}
.vl-vi.vl-vi-u-badge[data-v-97867cb6]::before {
  margin: 0;
  vertical-align: middle;
  display: block;
}
.vl-vi.vl-vi-u-badge--link[data-v-97867cb6] {
  margin-right: 1rem;
}
.vl-vi.vl-vi-u-badge--link-after[data-v-97867cb6] {
  margin-left: 1rem;
}
.vl-vi.vl-vi-u-badge--positive[data-v-97867cb6] {
  background-color: #007a37;
  color: #fff;
}
.vl-vi.vl-vi-u-badge--positive[data-v-97867cb6]:hover, .vl-vi.vl-vi-u-badge--positive[data-v-97867cb6]:focus, a:hover .vl-vi.vl-vi-u-badge--positive[data-v-97867cb6], a:focus .vl-vi.vl-vi-u-badge--positive[data-v-97867cb6] {
  background-color: #009e47;
  color: #fff;
}
.vl-vi.vl-vi-u-badge--action[data-v-97867cb6] {
  background-color: #05c;
  color: rgb(90%, 93.3333333333%, 98%);
}
.vl-vi.vl-vi-u-badge--action[data-v-97867cb6]:hover, .vl-vi.vl-vi-u-badge--action[data-v-97867cb6]:focus, a:hover .vl-vi.vl-vi-u-badge--action[data-v-97867cb6], a:focus .vl-vi.vl-vi-u-badge--action[data-v-97867cb6] {
  background-color: #003bb0;
  color: rgb(90%, 93.3333333333%, 98%);
}
.vl-vi.vl-vi-u-badge--negative[data-v-97867cb6] {
  background-color: #d2373c;
  color: #fff;
}
.vl-vi.vl-vi-u-badge--negative[data-v-97867cb6]:hover, .vl-vi.vl-vi-u-badge--negative[data-v-97867cb6]:focus, a:hover .vl-vi.vl-vi-u-badge--negative[data-v-97867cb6], a:focus .vl-vi.vl-vi-u-badge--negative[data-v-97867cb6] {
  background-color: #aa2729;
  color: #fff;
}
.vl-vi.vl-vi-u-badge--warning[data-v-97867cb6] {
  background-color: #ffA10a;
  color: #333332;
}
.vl-vi.vl-vi-u-badge--neutral[data-v-97867cb6] {
  background-color: #f7f9fc;
  color: #333332;
}
.vl-vi.vl-vi-u-badge--neutral[data-v-97867cb6]:hover, .vl-vi.vl-vi-u-badge--neutral[data-v-97867cb6]:focus, a:hover .vl-vi.vl-vi-u-badge--neutral[data-v-97867cb6], a:focus .vl-vi.vl-vi-u-badge--neutral[data-v-97867cb6] {
  background-color: #05c;
  color: rgb(90%, 93.3333333333%, 98%);
}
.vl-vi.vl-vi-u-badge--light[data-v-97867cb6] {
  background-color: #fff;
  color: #333332;
}
.vl-vi.vl-vi-u-badge--light[data-v-97867cb6]:hover, .vl-vi.vl-vi-u-badge--light[data-v-97867cb6]:focus, a:hover .vl-vi.vl-vi-u-badge--light[data-v-97867cb6], a:focus .vl-vi.vl-vi-u-badge--light[data-v-97867cb6] {
  background-color: #05c;
  color: rgb(90%, 93.3333333333%, 98%);
}
.vl-vi.vl-vi-u-badge--xxsmall[data-v-97867cb6] {
  width: 1.8rem;
  height: 1.8rem;
  line-height: 1.8rem;
}
.vl-vi.vl-vi-u-badge--xxsmall[data-v-97867cb6]::before {
  font-size: 0.8rem;
}
@media screen and (max-width: 767px) {
.vl-vi.vl-vi-u-badge--xxsmall[data-v-97867cb6] {
    width: 1.5rem;
    height: 1.5rem;
    line-height: 1.5rem;
}
.vl-vi.vl-vi-u-badge--xxsmall[data-v-97867cb6]::before {
    font-size: 0.7rem;
}
}
.vl-vi.vl-vi-u-badge--xsmall[data-v-97867cb6] {
  width: 1.8rem;
  height: 1.8rem;
  line-height: 1.8rem;
}
.vl-vi.vl-vi-u-badge--xsmall[data-v-97867cb6]::before {
  font-size: 1.3rem;
}
@media screen and (max-width: 767px) {
.vl-vi.vl-vi-u-badge--xsmall[data-v-97867cb6] {
    width: 1.5rem;
    height: 1.5rem;
    line-height: 1.5rem;
}
.vl-vi.vl-vi-u-badge--xsmall[data-v-97867cb6]::before {
    font-size: 1.1rem;
}
}
.vl-vi.vl-vi-u-badge--small[data-v-97867cb6] {
  width: 2.6rem;
  height: 2.6rem;
  line-height: 2.6rem;
}
.vl-vi.vl-vi-u-badge--small[data-v-97867cb6]::before {
  font-size: 1.3rem;
}
@media screen and (max-width: 767px) {
.vl-vi.vl-vi-u-badge--small[data-v-97867cb6] {
    width: 2.2rem;
    height: 2.2rem;
    line-height: 2.2rem;
}
.vl-vi.vl-vi-u-badge--small[data-v-97867cb6]::before {
    font-size: 1.2rem;
}
}
.vl-vi.vl-vi-u-badge--medium[data-v-97867cb6] {
  width: 4rem;
  height: 4rem;
  line-height: 4rem;
}
.vl-vi.vl-vi-u-badge--medium[data-v-97867cb6]::before {
  font-size: 2rem;
}
@media screen and (max-width: 767px) {
.vl-vi.vl-vi-u-badge--medium[data-v-97867cb6] {
    width: 3rem;
    height: 3rem;
    line-height: 3rem;
}
.vl-vi.vl-vi-u-badge--medium[data-v-97867cb6]::before {
    font-size: 1.5rem;
}
}
.vl-vi.vl-vi-u-badge--large[data-v-97867cb6] {
  width: 5rem;
  height: 5rem;
  line-height: 5rem;
}
.vl-vi.vl-vi-u-badge--large[data-v-97867cb6]::before {
  font-size: 2.5rem;
}
@media screen and (max-width: 767px) {
.vl-vi.vl-vi-u-badge--large[data-v-97867cb6] {
    width: 4rem;
    height: 4rem;
    line-height: 4rem;
}
.vl-vi.vl-vi-u-badge--large[data-v-97867cb6]::before {
    font-size: 2rem;
}
}
.vl-u-mark[data-v-97867cb6] {
  background-color: transparent;
  box-shadow: inset 0 -10px 0 0 rgba(255, 197, 21, 0.3);
}
.vl-u-mark--accent[data-v-97867cb6] {
  background-color: transparent;
  box-shadow: inset 0 -10px 0 0 rgba(var(--vl-theme-primary-color-rgb, 255, 230, 21), 0.3);
}
.vl-u-mark--info[data-v-97867cb6] {
  background-color: transparent;
  box-shadow: inset 0 -10px 0 0 rgba(203, 210, 218, 0.4);
}
.vl-u-mark--success[data-v-97867cb6] {
  background-color: transparent;
  box-shadow: inset 0 -10px 0 0 rgba(0, 158, 71, 0.2);
}
.vl-u-mark--warning[data-v-97867cb6] {
  background-color: transparent;
  box-shadow: inset 0 -10px 0 0 rgba(255, 161, 10, 0.2);
}
.vl-u-mark--error[data-v-97867cb6] {
  background-color: transparent;
  box-shadow: inset 0 -10px 0 0 rgba(210, 55, 60, 0.2);
}
@media screen and (max-width: 767px) {
.vl-u-mobile-no-equal-height[data-v-97867cb6] {
    min-height: 0 !important;
}
}
.js-vl-clamp-useless[data-v-97867cb6] {
  display: none !important;
}
.js .js-vl-show-checked[data-v-97867cb6] {
  display: none;
}
.js .js-vl-show-checked--open[data-v-97867cb6] {
  display: block;
}
.js.vl-flexbox .js-vl-col-float-right[data-v-97867cb6] {
  position: absolute;
  z-index: 1;
  padding-bottom: 3rem;
  right: 0;
}
@media screen and (max-width: 767px) {
.js.vl-flexbox .js-vl-col-float-right[data-v-97867cb6] {
    position: static;
    padding-bottom: 0;
    margin-top: 1.5rem;
}
}
@media screen and (max-width: 767px) {
.js-vl-col-float-right--pushed[data-v-97867cb6] {
    margin-top: 0 !important;
}
}
[data-vl-show-on-select-content][data-v-97867cb6] {
  display: none;
}
[data-vl-show-on-select-content][data-vl-show=true][data-v-97867cb6] {
  display: block;
}
.vl-u-offset--spacing[data-v-97867cb6] {
  padding: 0 4.1666666667% 1rem;
}
.vl-u-offset--left[data-v-97867cb6] {
  margin-left: 3rem;
}
@media screen and (min-width: 1600px) {
.vl-u-offset--left[data-v-97867cb6] {
    margin-left: -4.1666666667%;
}
}
@media screen and (max-width: 1023px) {
.vl-u-offset--left[data-v-97867cb6] {
    margin-left: 0;
    margin-right: 0;
}
}
.vl-u-offset--left.vl-u-offset--spacing[data-v-97867cb6] {
  padding-left: 0;
}
.vl-u-offset--right[data-v-97867cb6] {
  margin-right: 3rem;
}
@media screen and (min-width: 1600px) {
.vl-u-offset--right[data-v-97867cb6] {
    margin-right: -4.1666666667%;
}
}
@media screen and (max-width: 1023px) {
.vl-u-offset--right[data-v-97867cb6] {
    margin-left: 0;
    margin-right: 0;
}
}
.vl-u-offset--right.vl-u-offset--spacing[data-v-97867cb6] {
  padding-right: 0;
}
.vl-u-float-right[data-v-97867cb6] {
  float: right !important;
}
.vl-u-float-left[data-v-97867cb6] {
  float: left !important;
}
.vl-u-float-none[data-v-97867cb6] {
  float: none !important;
}
.vl-u-display-block[data-v-97867cb6] {
  display: block !important;
}
.vl-u-display-inline-block[data-v-97867cb6] {
  display: inline-block !important;
}
.vl-u-display-flex[data-v-97867cb6],
.vl-u-flex[data-v-97867cb6] {
  display: flex !important;
}
.vl-u-display-inline-flex[data-v-97867cb6] {
  display: inline-flex !important;
}
.vl-u-clearfix[data-v-97867cb6]::before, .vl-u-clearfix[data-v-97867cb6]::after {
  content: "";
  display: table;
}
.vl-u-clearfix[data-v-97867cb6]::after {
  clear: both;
}
.vl-u-no-overflow[data-v-97867cb6] {
  overflow: hidden;
}
.vl-u-position-relative[data-v-97867cb6] {
  position: relative;
}
.vl-u-named-target[data-v-97867cb6]::before,
.vl-u-offset[data-v-97867cb6]::before {
  content: "";
  display: block;
  height: -90px;
  margin: 90px 0 0;
  z-index: -1;
  position: relative;
}
.vl-u-named-target-wrapper[data-v-97867cb6] {
  position: relative;
}
.vl-u-named-target-dummy[data-v-97867cb6]:empty,
.vl-u-offset-dummy[data-v-97867cb6]:empty {
  display: block;
  position: absolute;
  top: 0;
  margin-top: 90px;
  height: 1px;
  width: 1px;
  visibility: hidden;
  opacity: 0;
}
.vl-u-inline-list[data-v-97867cb6] {
  display: inline-block;
  vertical-align: top;
}
@media print {
.vl-u-hide-on-print[data-v-97867cb6] {
    display: none;
}
.vl-u-show-on-print[data-v-97867cb6] {
    display: block;
}
header[data-v-97867cb6],
  footer[data-v-97867cb6] {
    display: none;
}
.vl-main-content header[data-v-97867cb6], [role=main] header[data-v-97867cb6], main header[data-v-97867cb6],
  .vl-main-content footer[data-v-97867cb6],
  [role=main] footer[data-v-97867cb6],
  main footer[data-v-97867cb6] {
    display: block;
}
.iwgh3[data-v-97867cb6],
  .iwgh2[data-v-97867cb6],
  .iwgf3[data-v-97867cb6],
  .iwgf2[data-v-97867cb6] {
    display: none;
}
}
.vl-u-hr[data-v-97867cb6] {
  border: 0;
  border-bottom: 1px solid #cbd2da;
  margin-top: 0;
  margin-bottom: 0;
}
.vl-u-hr--wave[data-v-97867cb6] {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) repeat-x;
  background-size: 20px 4px;
  height: 4px;
  border-bottom: 0;
}
.vl-u-hr--dashed[data-v-97867cb6] {
  min-height: 6px;
  border: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) repeat-x;
  background-size: 6px 6px;
}
[data-v-97867cb6]::-moz-selection {
  background-color: var(--vl-theme-primary-color-rgba-30);
}
[data-v-97867cb6]::selection {
  background-color: var(--vl-theme-primary-color-rgba-30);
}
[data-v-97867cb6]::-moz-selection {
  background-color: var(--vl-theme-primary-color-rgba-30);
}
.vl-u-spacer[data-v-97867cb6] {
  margin-bottom: 2rem;
}
.vl-u-spacer--xsmall[data-v-97867cb6] {
  margin-bottom: 1rem;
}
.vl-u-spacer--small[data-v-97867cb6] {
  margin-bottom: 1.5rem;
}
.vl-u-spacer--medium[data-v-97867cb6] {
  margin-bottom: 3rem;
}
.vl-u-spacer--large[data-v-97867cb6] {
  margin-bottom: 6rem;
}
@media screen and (max-width: 767px) {
.vl-u-spacer--large[data-v-97867cb6] {
    margin-bottom: 3rem;
}
}
.vl-u-spacer--none[data-v-97867cb6] {
  margin-bottom: 0;
}
.vl-u-spacer-top[data-v-97867cb6] {
  margin-top: 2rem;
}
.vl-u-spacer-top--xsmall[data-v-97867cb6] {
  margin-top: 1rem;
}
.vl-u-spacer-top--small[data-v-97867cb6] {
  margin-top: 1.5rem;
}
.vl-u-spacer-top--medium[data-v-97867cb6] {
  margin-top: 3rem;
}
.vl-u-spacer-top--large[data-v-97867cb6] {
  margin-top: 6rem;
}
@media screen and (max-width: 767px) {
.vl-u-spacer-top--large[data-v-97867cb6] {
    margin-top: 3rem;
}
}
.vl-u-spacer-top--none[data-v-97867cb6] {
  margin-top: 0;
}
.vl-u-spacer-right[data-v-97867cb6] {
  margin-right: 2rem;
}
.vl-u-spacer-right--xsmall[data-v-97867cb6] {
  margin-right: 1rem;
}
.vl-u-spacer-right--small[data-v-97867cb6] {
  margin-right: 1.5rem;
}
.vl-u-spacer-right--medium[data-v-97867cb6] {
  margin-right: 3rem;
}
.vl-u-spacer-right--large[data-v-97867cb6] {
  margin-right: 6rem;
}
@media screen and (max-width: 767px) {
.vl-u-spacer-right--large[data-v-97867cb6] {
    margin-right: 3rem;
}
}
.vl-u-spacer-right--none[data-v-97867cb6] {
  margin-right: 0;
}
.vl-u-spacer-bottom[data-v-97867cb6] {
  margin-bottom: 2rem;
}
.vl-u-spacer-bottom--xsmall[data-v-97867cb6] {
  margin-bottom: 1rem;
}
.vl-u-spacer-bottom--small[data-v-97867cb6] {
  margin-bottom: 1.5rem;
}
.vl-u-spacer-bottom--medium[data-v-97867cb6] {
  margin-bottom: 3rem;
}
.vl-u-spacer-bottom--large[data-v-97867cb6] {
  margin-bottom: 6rem;
}
@media screen and (max-width: 767px) {
.vl-u-spacer-bottom--large[data-v-97867cb6] {
    margin-bottom: 3rem;
}
}
.vl-u-spacer-bottom--none[data-v-97867cb6] {
  margin-bottom: 0;
}
.vl-u-spacer-left[data-v-97867cb6] {
  margin-left: 2rem;
}
.vl-u-spacer-left--xsmall[data-v-97867cb6] {
  margin-left: 1rem;
}
.vl-u-spacer-left--small[data-v-97867cb6] {
  margin-left: 1.5rem;
}
.vl-u-spacer-left--medium[data-v-97867cb6] {
  margin-left: 3rem;
}
.vl-u-spacer-left--large[data-v-97867cb6] {
  margin-left: 6rem;
}
@media screen and (max-width: 767px) {
.vl-u-spacer-left--large[data-v-97867cb6] {
    margin-left: 3rem;
}
}
.vl-u-spacer-left--none[data-v-97867cb6] {
  margin-left: 0;
}
.vl-u-scroll-offset__parent[data-v-97867cb6] {
  position: relative;
  height: 0;
  width: 0;
  overflow: hidden;
  opacity: 0;
}
.vl-u-scroll-offset[data-v-97867cb6] {
  position: absolute;
  left: 0;
  top: 0;
  margin-top: -90px;
  width: 1px;
  height: 1px;
}
.js-vl-sticky-placeholder[data-v-97867cb6] {
  position: relative;
}
@media screen and (max-width: 767px) {
.js-vl-sticky-placeholder[data-v-97867cb6] {
    height: auto !important;
}
}
.js-vl-sticky--absolute[data-v-97867cb6] {
  position: absolute;
}
.js-vl-sticky--fixed[data-v-97867cb6] {
  position: fixed;
}
.vl-u-sticky[data-v-97867cb6] {
  top: 0;
  position: sticky;
}
.vl-u-sticky-gf[data-v-97867cb6] {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
.vl-u-sticky-gf[data-v-97867cb6] {
    display: block;
}
}
.vl-u-sticky-gf .vl-page[data-v-97867cb6] {
  flex: 1;
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
.vl-u-sticky-gf .vl-page[data-v-97867cb6] {
    overflow: hidden;
}
}
.vl-u-text--ellipse[data-v-97867cb6] {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vl-u-text--uppercase[data-v-97867cb6] {
  text-transform: uppercase;
}
.vl-u-text--lowercase[data-v-97867cb6] {
  text-transform: lowercase;
}
.vl-u-text--capitalize[data-v-97867cb6]::first-letter {
  text-transform: uppercase;
}
.vl-u-text--success[data-v-97867cb6] {
  color: #007a37;
}
.vl-u-text--warning[data-v-97867cb6] {
  color: #9f5804;
}
.vl-u-text--error[data-v-97867cb6] {
  color: #d2373c;
}
.vl-u-text--bold[data-v-97867cb6], .vl-progress-bar__step--active .vl-progress-bar__bullet__text[data-v-97867cb6] {
  font-weight: 500;
}
.vl-u-text--italic[data-v-97867cb6] {
  font-style: italic;
}
.vl-u-text--small[data-v-97867cb6] {
  font-size: 1.4rem !important;
}
.vl-u-text--medium[data-v-97867cb6] {
  font-size: 1.6rem !important;
}
.vl-u-text--xsmall[data-v-97867cb6] {
  font-size: 1.2rem !important;
}
.vl-u-text--xxsmall[data-v-97867cb6] {
  font-size: 1rem !important;
}
mark[data-v-97867cb6],
.vl-u-text--marked[data-v-97867cb6] {
  background-color: transparent;
  box-shadow: inset 0 -10px 0 0 rgba(255, 197, 21, 0.3);
}
@media screen and (min-width: 1023px) {
.vl-u-visible--l[data-v-97867cb6] {
    display: block !important;
}
}
@media screen and (max-width: 1023px) {
.vl-u-visible--m[data-v-97867cb6] {
    display: block !important;
}
}
@media screen and (max-width: 767px) {
.vl-u-visible--s[data-v-97867cb6] {
    display: block !important;
}
}
@media screen and (max-width: 500px) {
.vl-u-visible--xs[data-v-97867cb6] {
    display: block !important;
}
}
.vl-u-hidden[data-v-97867cb6] {
  display: none;
}
@media screen and (min-width: 1023px) {
.vl-u-hidden--l[data-v-97867cb6] {
    display: none !important;
}
}
@media screen and (max-width: 1023px) {
.vl-u-hidden--m[data-v-97867cb6] {
    display: none !important;
}
}
@media screen and (max-width: 767px) {
.vl-u-hidden--s[data-v-97867cb6] {
    display: none !important;
}
}
@media screen and (max-width: 500px) {
.vl-u-hidden--xs[data-v-97867cb6] {
    display: none !important;
}
}
.vl-u-whitespace[data-v-97867cb6] {
  white-space: normal;
}
.vl-u-whitespace--nowrap[data-v-97867cb6] {
  white-space: nowrap;
}
.vl-u-whitespace--pre[data-v-97867cb6] {
  white-space: pre;
}
.vl-u-whitespace--pre-line[data-v-97867cb6] {
  white-space: pre-line;
}
.vl-u-whitespace--pre-wrap[data-v-97867cb6] {
  white-space: prewrap;
}
.vl-u-whitespace--unset[data-v-97867cb6] {
  white-space: unset;
}
.vl-u-whitespace--break-spaces[data-v-97867cb6] {
  white-space: break-spaces;
}
body a[data-v-97867cb6]:visited {
  color: #05c;
}
body[data-v-97867cb6] {
  font-size: 1.6rem !important;
}
a.ippro-datatable__cell[data-v-97867cb6]:visited {
  color: #333332;
}
.vl-title[data-v-97867cb6] {
  word-break: break-word;
  word-wrap: break-word;
}
.vl-ol-map-search .vl-input-field[data-v-97867cb6] {
  width: 335px !important;
}
.vl-tooltip[data-v-97867cb6] {
  pointer-events: none;
}
.vl-button[data-v-97867cb6]:not(:disabled):not(.vl-button--disabled) {
  cursor: pointer;
}
.vl-button.vl-button--text[data-v-97867cb6] {
  border: 0;
  background-color: transparent;
}
.vl-button.vl-button--text[data-v-97867cb6]:hover {
  border: 0;
  box-shadow: none;
  text-decoration: underline;
}
button.vl-vi[data-v-97867cb6] {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 3.5rem;
  height: 3.5rem;
  line-height: 3.5rem;
}
.vl-accordion__panel[data-v-97867cb6] {
  padding: 0 0 0 2.1rem;
  margin: 1rem 0 2rem 0;
}
.vl-accordion-list__item[data-v-97867cb6] {
  margin-bottom: 1rem;
}
.vl-accordion-list__item[data-v-97867cb6]:last-child {
  margin-bottom: 0;
}
.vl-toggle.vl-link[data-v-97867cb6], .vl-toggle.vl-sidebar-header__toggle[data-v-97867cb6], .vl-sidebar-panel-list-item__button .vl-toggle.vl-icon[data-v-97867cb6] {
  text-decoration: none;
}
.vl-toggle.vl-link[data-v-97867cb6]:hover, .vl-toggle.vl-sidebar-header__toggle[data-v-97867cb6]:hover, .vl-sidebar-panel-list-item__button .vl-toggle.vl-icon[data-v-97867cb6]:hover {
  text-decoration: underline;
}
.vl-tab__pane[data-v-97867cb6] {
  outline: none;
}
.vl-progress-bar__step--disabled .vl-progress-bar__bullet[data-v-97867cb6] {
  cursor: default;
}
.vl-progress-bar__step--disabled .vl-progress-bar__bullet[data-v-97867cb6]:focus {
  outline: none;
}
.vl-tab__pane[data-v-97867cb6] {
  outline: none;
}
.vl-upload__files__close[data-v-97867cb6] {
  display: none;
}
.vl-modal--fullscreen .vl-modal-dialog[open][data-v-97867cb6] {
  width: calc(100vw - 40px);
  max-width: calc(100vw - 40px);
  height: calc(100vh - 40px);
  max-height: calc(100vh - 40px);
  overflow: visible;
}
.vl-modal--fullscreen .vl-modal-dialog[open] .ippro-map .vl-ol-map--boxed[data-v-97867cb6] {
  height: calc(100vh - 22rem);
}
.js-vl-select .vl-input-field[data-v-97867cb6] {
  height: 24px;
  line-height: 2.3rem;
}
.js-vl-select[data-v-97867cb6] {
  position: inherit;
}
.js-vl-select.is-open.is-focused[data-v-97867cb6] {
  z-index: 2000 !important;
  position: relative;
}
.vl-text--alt[data-v-97867cb6] {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  display: block;
}
.ippro-datatable th button span.vl-icon[data-v-97867cb6] {
  margin-top: -0.8em !important;
}
.vl-sidebar__btn-close[data-v-97867cb6] {
  display: flex;
  position: absolute;
  right: 0.5rem;
  top: 0;
  z-index: 9999;
}
.vl-sidebar__close-btn[data-v-97867cb6] {
  display: none;
}
.vl-input-field[data-v-97867cb6]::-moz-placeholder {
  color: #d3d9e0;
}
.vl-input-field[data-v-97867cb6]::placeholder {
  color: #d3d9e0;
}
.vl-pill-input__inner[data-v-97867cb6] {
  border: 0 !important;
}
.is-focused .vl-pill-input__inner[data-v-97867cb6] {
  box-shadow: none !important;
}
.vl-input-field[data-v-97867cb6] {
  width: 100%;
}
.vl-input-field--error[data-v-97867cb6] {
  display: inline-block !important;
}
.choices__list--dropdown[data-v-97867cb6] {
  display: none !important;
}
.mo-pill--error[data-v-97867cb6] {
  color: #d2373c !important;
  border-color: #d2373c !important;
}
.mo-pill--error .vl-pill__close[data-v-97867cb6] {
  color: #d2373c !important;
  border-color: #d2373c !important;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
